var _1 = Object.defineProperty;
var M1 = (t, e, n) => e in t ? _1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var ge = (t, e, n) => (M1(t, typeof e != "symbol" ? e + "" : e, n), n);
import { jsxs as ae, jsx as w, Fragment as on } from "react/jsx-runtime";
import * as Yi from "react";
import re, { useMemo as ne, useEffect as Fe, useLayoutEffect as O1, useRef as Se, useState as Be, forwardRef as or, Fragment as ri, isValidElement as D1, cloneElement as P1, createElement as Id, createContext as zt, useContext as Et, useReducer as Rd, createRef as F1, useCallback as le, useDebugValue as Rl, Children as Ji, Suspense as T1 } from "react";
import { useLocation as I1, Link as To } from "react-router-dom";
import Io from "react-dom";
var ei = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ut(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Bd = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var s = "", a = 0; a < arguments.length; a++) {
        var o = arguments[a];
        o && (s = r(s, i(o)));
      }
      return s;
    }
    function i(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return n.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var a = "";
      for (var o in s)
        e.call(s, o) && s[o] && (a = r(a, o));
      return a;
    }
    function r(s, a) {
      return a ? s ? s + " " + a : s + a : s;
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(Bd);
var R1 = Bd.exports;
const de = /* @__PURE__ */ Ut(R1);
function B1(t) {
  const e = ne(
    () => de("button", {
      "button-primary": !t.disabled && !t.outlined && !t.plain && (!t.color || t.color === "primary"),
      "button-white": !t.disabled && !t.outlined && !t.plain && t.color === "white",
      "button-red": !t.disabled && !t.outlined && !t.plain && t.color === "red",
      "button-do-red": !t.disabled && !t.outlined && !t.plain && t.color === "do-red",
      "button-yellow": !t.disabled && !t.outlined && !t.plain && t.color === "yellow",
      "button-black": !t.disabled && !t.outlined && !t.plain && t.color === "black",
      "button-green": !t.disabled && !t.outlined && !t.plain && t.color === "green",
      "button-do-green": !t.disabled && !t.outlined && !t.plain && t.color === "do-green",
      "button-plain-primary": !t.disabled && t.plain && (!t.color || t.color === "primary"),
      "button-plain-white": !t.disabled && t.plain && t.color === "white",
      "button-plain-red": !t.disabled && t.plain && t.color === "red",
      "button-plain-do-red": !t.disabled && t.plain && t.color === "do-red",
      "button-plain-yellow": !t.disabled && t.plain && t.color === "yellow",
      "button-plain-green": !t.disabled && t.plain && t.color === "green",
      "button-plain-do-green": !t.disabled && t.plain && t.color === "do-green",
      "button-outlined-primary": !t.disabled && t.outlined && (!t.color || t.color === "primary"),
      "button-outlined-white": !t.disabled && t.outlined && t.color === "white",
      "button-outlined-black": !t.disabled && t.outlined && t.color === "black",
      "button-outlined-red": !t.disabled && t.outlined && t.color === "red",
      "button-outlined-do-red": !t.disabled && t.outlined && t.color === "do-red",
      "button-outlined-yellow": !t.disabled && t.outlined && t.color === "yellow",
      "button-outlined-green": !t.disabled && t.outlined && t.color === "green",
      "button-outlined-do-green": !t.disabled && t.outlined && t.color === "do-green",
      "button-disabled": t.disabled && !t.plain,
      "button-disabled-plain": t.disabled && t.plain,
      "w-full text-center": t.fullWidth,
      "button-light": t.light
    }),
    [t.outlined, t.plain, t.disabled, t.fullWidth, t.light, t.color]
  );
  return /* @__PURE__ */ ae("button", { type: t.type, disabled: t.disabled, onClick: t.onClick, className: e, children: [
    t.startIcon && /* @__PURE__ */ w("span", { className: "text-xl leading-5", children: t.startIcon }),
    t.label && /* @__PURE__ */ w("span", { children: t.label }),
    t.endIcon && /* @__PURE__ */ w("span", { className: "text-xl leading-5", children: t.endIcon })
  ] });
}
const L1 = ({ logoImg: t }) => /* @__PURE__ */ w(
  "div",
  {
    className: "flex items-center flex-1 cursor-pointer",
    onClick: () => {
      window.location.href = "/";
    },
    children: /* @__PURE__ */ w(
      "img",
      {
        className: "w-auto h-16 object-contain",
        src: t,
        alt: "Header logo"
      }
    )
  }
), N1 = ({ username: t, logout: e }) => /* @__PURE__ */ ae("section", { className: "hidden md:flex flex-col items-center bg-primary-darker px-6 py-3.5 ml-6", children: [
  /* @__PURE__ */ ae("p", { className: "mb-1", children: [
    "Hello, ",
    /* @__PURE__ */ w("strong", { children: t })
  ] }),
  /* @__PURE__ */ w(
    "button",
    {
      className: "text-neutral-300 block ml-auto border-none text-sm",
      onClick: e,
      children: "Log out"
    }
  )
] });
var V1 = Object.defineProperty, H1 = (t, e, n) => e in t ? V1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, ia = (t, e, n) => (H1(t, typeof e != "symbol" ? e + "" : e, n), n);
let j1 = class {
  constructor() {
    ia(this, "current", this.detect()), ia(this, "handoffState", "pending"), ia(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, _n = new j1(), mt = (t, e) => {
  _n.isServer ? Fe(t, e) : O1(t, e);
};
function Tt(t) {
  let e = Se(t);
  return mt(() => {
    e.current = t;
  }, [t]), e;
}
function Ld(t, e) {
  let [n, i] = Be(t), r = Tt(t);
  return mt(() => i(r.current), [r, i, ...e]), n;
}
let Ce = function(t) {
  let e = Tt(t);
  return re.useCallback((...n) => e.current(...n), [e]);
};
function $1(t, e, n) {
  let [i, r] = Be(n), s = t !== void 0, a = Se(s), o = Se(!1), l = Se(!1);
  return s && !a.current && !o.current ? (o.current = !0, a.current = s, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !s && a.current && !l.current && (l.current = !0, a.current = s, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [s ? t : i, Ce((c) => (s || r(c), e == null ? void 0 : e(c)))];
}
function W1(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function fn() {
  let t = [], e = { addEventListener(n, i, r, s) {
    return n.addEventListener(i, r, s), e.add(() => n.removeEventListener(i, r, s));
  }, requestAnimationFrame(...n) {
    let i = requestAnimationFrame(...n);
    return e.add(() => cancelAnimationFrame(i));
  }, nextFrame(...n) {
    return e.requestAnimationFrame(() => e.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let i = setTimeout(...n);
    return e.add(() => clearTimeout(i));
  }, microTask(...n) {
    let i = { current: !0 };
    return W1(() => {
      i.current && n[0]();
    }), e.add(() => {
      i.current = !1;
    });
  }, style(n, i, r) {
    let s = n.style.getPropertyValue(i);
    return Object.assign(n.style, { [i]: r }), this.add(() => {
      Object.assign(n.style, { [i]: s });
    });
  }, group(n) {
    let i = fn();
    return n(i), this.add(() => i.dispose());
  }, add(n) {
    return t.push(n), () => {
      let i = t.indexOf(n);
      if (i >= 0)
        for (let r of t.splice(i, 1))
          r();
    };
  }, dispose() {
    for (let n of t.splice(0))
      n();
  } };
  return e;
}
function di() {
  let [t] = Be(fn);
  return Fe(() => () => t.dispose(), [t]), t;
}
function Y1() {
  let t = typeof document > "u";
  return "useSyncExternalStore" in Yi ? ((e) => e.useSyncExternalStore)(Yi)(() => () => {
  }, () => !1, () => !t) : !1;
}
function Ro() {
  let t = Y1(), [e, n] = Yi.useState(_n.isHandoffComplete);
  return e && _n.isHandoffComplete === !1 && n(!1), Yi.useEffect(() => {
    e !== !0 && n(!0);
  }, [e]), Yi.useEffect(() => _n.handoff(), []), t ? !1 : e;
}
var Bl;
let Ps = (Bl = re.useId) != null ? Bl : function() {
  let t = Ro(), [e, n] = re.useState(t ? () => _n.nextId() : null);
  return mt(() => {
    e === null && n(_n.nextId());
  }, [e]), e != null ? "" + e : void 0;
};
function Xe(t, e, ...n) {
  if (t in e) {
    let r = e[t];
    return typeof r == "function" ? r(...n) : r;
  }
  let i = new Error(`Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((r) => `"${r}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(i, Xe), i;
}
function Nd(t) {
  return _n.isServer ? null : t instanceof Node ? t.ownerDocument : t != null && t.hasOwnProperty("current") && t.current instanceof Node ? t.current.ownerDocument : document;
}
let Ll = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((t) => `${t}:not([tabindex='-1'])`).join(",");
var z1 = ((t) => (t[t.First = 1] = "First", t[t.Previous = 2] = "Previous", t[t.Next = 4] = "Next", t[t.Last = 8] = "Last", t[t.WrapAround = 16] = "WrapAround", t[t.NoScroll = 32] = "NoScroll", t))(z1 || {}), U1 = ((t) => (t[t.Error = 0] = "Error", t[t.Overflow = 1] = "Overflow", t[t.Success = 2] = "Success", t[t.Underflow = 3] = "Underflow", t))(U1 || {}), Q1 = ((t) => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(Q1 || {}), Bo = ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(Bo || {});
function Vd(t, e = 0) {
  var n;
  return t === ((n = Nd(t)) == null ? void 0 : n.body) ? !1 : Xe(e, { 0() {
    return t.matches(Ll);
  }, 1() {
    let i = t;
    for (; i !== null; ) {
      if (i.matches(Ll))
        return !0;
      i = i.parentElement;
    }
    return !1;
  } });
}
var K1 = ((t) => (t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(K1 || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (t) => {
  t.metaKey || t.altKey || t.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (t) => {
  t.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : t.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function G1(t, e = (n) => n) {
  return t.slice().sort((n, i) => {
    let r = e(n), s = e(i);
    if (r === null || s === null)
      return 0;
    let a = r.compareDocumentPosition(s);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function q1() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Z1() {
  return /Android/gi.test(window.navigator.userAgent);
}
function J1() {
  return q1() || Z1();
}
function mr(t, e, n) {
  let i = Tt(e);
  Fe(() => {
    function r(s) {
      i.current(s);
    }
    return document.addEventListener(t, r, n), () => document.removeEventListener(t, r, n);
  }, [t, n]);
}
function X1(t, e, n) {
  let i = Tt(e);
  Fe(() => {
    function r(s) {
      i.current(s);
    }
    return window.addEventListener(t, r, n), () => window.removeEventListener(t, r, n);
  }, [t, n]);
}
function e2(t, e, n = !0) {
  let i = Se(!1);
  Fe(() => {
    requestAnimationFrame(() => {
      i.current = n;
    });
  }, [n]);
  function r(a, o) {
    if (!i.current || a.defaultPrevented)
      return;
    let l = o(a);
    if (l === null || !l.getRootNode().contains(l) || !l.isConnected)
      return;
    let c = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(t);
    for (let u of c) {
      if (u === null)
        continue;
      let d = u instanceof HTMLElement ? u : u.current;
      if (d != null && d.contains(l) || a.composed && a.composedPath().includes(d))
        return;
    }
    return !Vd(l, Bo.Loose) && l.tabIndex !== -1 && a.preventDefault(), e(a, l);
  }
  let s = Se(null);
  mr("pointerdown", (a) => {
    var o, l;
    i.current && (s.current = ((l = (o = a.composedPath) == null ? void 0 : o.call(a)) == null ? void 0 : l[0]) || a.target);
  }, !0), mr("mousedown", (a) => {
    var o, l;
    i.current && (s.current = ((l = (o = a.composedPath) == null ? void 0 : o.call(a)) == null ? void 0 : l[0]) || a.target);
  }, !0), mr("click", (a) => {
    J1() || s.current && (r(a, () => s.current), s.current = null);
  }, !0), mr("touchend", (a) => r(a, () => a.target instanceof HTMLElement ? a.target : null), !0), X1("blur", (a) => r(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Nl(t) {
  var e;
  if (t.type)
    return t.type;
  let n = (e = t.as) != null ? e : "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function t2(t, e) {
  let [n, i] = Be(() => Nl(t));
  return mt(() => {
    i(Nl(t));
  }, [t.type, t.as]), mt(() => {
    n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && i("button");
  }, [n, e]), n;
}
let n2 = Symbol();
function Vn(...t) {
  let e = Se(t);
  Fe(() => {
    e.current = t;
  }, [t]);
  let n = Ce((i) => {
    for (let r of e.current)
      r != null && (typeof r == "function" ? r(i) : r.current = i);
  });
  return t.every((i) => i == null || (i == null ? void 0 : i[n2])) ? void 0 : n;
}
function Vl(t) {
  return [t.screenX, t.screenY];
}
function i2() {
  let t = Se([-1, -1]);
  return { wasMoved(e) {
    let n = Vl(e);
    return t.current[0] === n[0] && t.current[1] === n[1] ? !1 : (t.current = n, !0);
  }, update(e) {
    t.current = Vl(e);
  } };
}
function is(...t) {
  return Array.from(new Set(t.flatMap((e) => typeof e == "string" ? e.split(" ") : []))).filter(Boolean).join(" ");
}
var rs = ((t) => (t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static", t))(rs || {}), Xt = ((t) => (t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))(Xt || {});
function mn({ ourProps: t, theirProps: e, slot: n, defaultTag: i, features: r, visible: s = !0, name: a, mergeRefs: o }) {
  o = o ?? r2;
  let l = Hd(e, t);
  if (s)
    return pr(l, n, i, a, o);
  let c = r ?? 0;
  if (c & 2) {
    let { static: u = !1, ...d } = l;
    if (u)
      return pr(d, n, i, a, o);
  }
  if (c & 1) {
    let { unmount: u = !0, ...d } = l;
    return Xe(u ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return pr({ ...d, hidden: !0, style: { display: "none" } }, n, i, a, o);
    } });
  }
  return pr(l, n, i, a, o);
}
function pr(t, e = {}, n, i, r) {
  let { as: s = n, children: a, refName: o = "ref", ...l } = ra(t, ["unmount", "static"]), c = t.ref !== void 0 ? { [o]: t.ref } : {}, u = typeof a == "function" ? a(e) : a;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(e));
  let d = {};
  if (e) {
    let h = !1, g = [];
    for (let [b, m] of Object.entries(e))
      typeof m == "boolean" && (h = !0), m === !0 && g.push(b);
    h && (d["data-headlessui-state"] = g.join(" "));
  }
  if (s === ri && Object.keys(Ga(l)).length > 0) {
    if (!D1(u) || Array.isArray(u) && u.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${i} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(l).map((m) => `  - ${m}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((m) => `  - ${m}`).join(`
`)].join(`
`));
    let h = u.props, g = typeof (h == null ? void 0 : h.className) == "function" ? (...m) => is(h == null ? void 0 : h.className(...m), l.className) : is(h == null ? void 0 : h.className, l.className), b = g ? { className: g } : {};
    return P1(u, Object.assign({}, Hd(u.props, Ga(ra(l, ["ref"]))), d, c, { ref: r(u.ref, c.ref) }, b));
  }
  return Id(s, Object.assign({}, ra(l, ["ref"]), s !== ri && c, s !== ri && d), u);
}
function r2(...t) {
  return t.every((e) => e == null) ? void 0 : (e) => {
    for (let n of t)
      n != null && (typeof n == "function" ? n(e) : n.current = e);
  };
}
function Hd(...t) {
  if (t.length === 0)
    return {};
  if (t.length === 1)
    return t[0];
  let e = {}, n = {};
  for (let i of t)
    for (let r in i)
      r.startsWith("on") && typeof i[r] == "function" ? (n[r] != null || (n[r] = []), n[r].push(i[r])) : e[r] = i[r];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(n).map((i) => [i, void 0])));
  for (let i in n)
    Object.assign(e, { [i](r, ...s) {
      let a = n[i];
      for (let o of a) {
        if ((r instanceof Event || (r == null ? void 0 : r.nativeEvent) instanceof Event) && r.defaultPrevented)
          return;
        o(r, ...s);
      }
    } });
  return e;
}
function Qt(t) {
  var e;
  return Object.assign(or(t), { displayName: (e = t.displayName) != null ? e : t.name });
}
function Ga(t) {
  let e = Object.assign({}, t);
  for (let n in e)
    e[n] === void 0 && delete e[n];
  return e;
}
function ra(t, e = []) {
  let n = Object.assign({}, t);
  for (let i of e)
    i in n && delete n[i];
  return n;
}
let s2 = "div";
var jd = ((t) => (t[t.None = 1] = "None", t[t.Focusable = 2] = "Focusable", t[t.Hidden = 4] = "Hidden", t))(jd || {});
function a2(t, e) {
  var n;
  let { features: i = 1, ...r } = t, s = { ref: e, "aria-hidden": (i & 2) === 2 ? !0 : (n = r["aria-hidden"]) != null ? n : void 0, hidden: (i & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
  return mn({ ourProps: s, theirProps: r, slot: {}, defaultTag: s2, name: "Hidden" });
}
let o2 = Qt(a2), Lo = zt(null);
Lo.displayName = "OpenClosedContext";
var gt = ((t) => (t[t.Open = 1] = "Open", t[t.Closed = 2] = "Closed", t[t.Closing = 4] = "Closing", t[t.Opening = 8] = "Opening", t))(gt || {});
function No() {
  return Et(Lo);
}
function $d({ value: t, children: e }) {
  return re.createElement(Lo.Provider, { value: t }, e);
}
function l2(t) {
  let e = t.parentElement, n = null;
  for (; e && !(e instanceof HTMLFieldSetElement); )
    e instanceof HTMLLegendElement && (n = e), e = e.parentElement;
  let i = (e == null ? void 0 : e.getAttribute("disabled")) === "";
  return i && c2(n) ? !1 : i;
}
function c2(t) {
  if (!t)
    return !1;
  let e = t.previousElementSibling;
  for (; e !== null; ) {
    if (e instanceof HTMLLegendElement)
      return !1;
    e = e.previousElementSibling;
  }
  return !0;
}
function u2(t) {
  throw new Error("Unexpected object: " + t);
}
var ct = ((t) => (t[t.First = 0] = "First", t[t.Previous = 1] = "Previous", t[t.Next = 2] = "Next", t[t.Last = 3] = "Last", t[t.Specific = 4] = "Specific", t[t.Nothing = 5] = "Nothing", t))(ct || {});
function d2(t, e) {
  let n = e.resolveItems();
  if (n.length <= 0)
    return null;
  let i = e.resolveActiveIndex(), r = i ?? -1;
  switch (t.focus) {
    case 0: {
      for (let s = 0; s < n.length; ++s)
        if (!e.resolveDisabled(n[s], s, n))
          return s;
      return i;
    }
    case 1: {
      for (let s = r - 1; s >= 0; --s)
        if (!e.resolveDisabled(n[s], s, n))
          return s;
      return i;
    }
    case 2: {
      for (let s = r + 1; s < n.length; ++s)
        if (!e.resolveDisabled(n[s], s, n))
          return s;
      return i;
    }
    case 3: {
      for (let s = n.length - 1; s >= 0; --s)
        if (!e.resolveDisabled(n[s], s, n))
          return s;
      return i;
    }
    case 4: {
      for (let s = 0; s < n.length; ++s)
        if (e.resolveId(n[s], s, n) === t.id)
          return s;
      return i;
    }
    case 5:
      return null;
    default:
      u2(t);
  }
}
function Wd(t = {}, e = null, n = []) {
  for (let [i, r] of Object.entries(t))
    zd(n, Yd(e, i), r);
  return n;
}
function Yd(t, e) {
  return t ? t + "[" + e + "]" : e;
}
function zd(t, e, n) {
  if (Array.isArray(n))
    for (let [i, r] of n.entries())
      zd(t, Yd(e, i.toString()), r);
  else
    n instanceof Date ? t.push([e, n.toISOString()]) : typeof n == "boolean" ? t.push([e, n ? "1" : "0"]) : typeof n == "string" ? t.push([e, n]) : typeof n == "number" ? t.push([e, `${n}`]) : n == null ? t.push([e, ""]) : Wd(n, e, t);
}
var Qe = ((t) => (t.Space = " ", t.Enter = "Enter", t.Escape = "Escape", t.Backspace = "Backspace", t.Delete = "Delete", t.ArrowLeft = "ArrowLeft", t.ArrowUp = "ArrowUp", t.ArrowRight = "ArrowRight", t.ArrowDown = "ArrowDown", t.Home = "Home", t.End = "End", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Tab = "Tab", t))(Qe || {});
function Vo() {
  let t = Se(!1);
  return mt(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
let Hl = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function jl(t) {
  var e, n;
  let i = (e = t.innerText) != null ? e : "", r = t.cloneNode(!0);
  if (!(r instanceof HTMLElement))
    return i;
  let s = !1;
  for (let o of r.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    o.remove(), s = !0;
  let a = s ? (n = r.innerText) != null ? n : "" : i;
  return Hl.test(a) && (a = a.replace(Hl, "")), a;
}
function h2(t) {
  let e = t.getAttribute("aria-label");
  if (typeof e == "string")
    return e.trim();
  let n = t.getAttribute("aria-labelledby");
  if (n) {
    let i = n.split(" ").map((r) => {
      let s = document.getElementById(r);
      if (s) {
        let a = s.getAttribute("aria-label");
        return typeof a == "string" ? a.trim() : jl(s).trim();
      }
      return null;
    }).filter(Boolean);
    if (i.length > 0)
      return i.join(", ");
  }
  return jl(t).trim();
}
function f2(t) {
  let e = Se(""), n = Se("");
  return Ce(() => {
    let i = t.current;
    if (!i)
      return "";
    let r = i.innerText;
    if (e.current === r)
      return n.current;
    let s = h2(i).trim().toLowerCase();
    return e.current = r, n.current = s, s;
  });
}
var g2 = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(g2 || {}), m2 = ((t) => (t[t.Single = 0] = "Single", t[t.Multi = 1] = "Multi", t))(m2 || {}), p2 = ((t) => (t[t.Pointer = 0] = "Pointer", t[t.Other = 1] = "Other", t))(p2 || {}), b2 = ((t) => (t[t.OpenListbox = 0] = "OpenListbox", t[t.CloseListbox = 1] = "CloseListbox", t[t.GoToOption = 2] = "GoToOption", t[t.Search = 3] = "Search", t[t.ClearSearch = 4] = "ClearSearch", t[t.RegisterOption = 5] = "RegisterOption", t[t.UnregisterOption = 6] = "UnregisterOption", t[t.RegisterLabel = 7] = "RegisterLabel", t))(b2 || {});
function sa(t, e = (n) => n) {
  let n = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, i = G1(e(t.options.slice()), (s) => s.dataRef.current.domRef.current), r = n ? i.indexOf(n) : null;
  return r === -1 && (r = null), { options: i, activeOptionIndex: r };
}
let v2 = { 1(t) {
  return t.dataRef.current.disabled || t.listboxState === 1 ? t : { ...t, activeOptionIndex: null, listboxState: 1 };
}, 0(t) {
  if (t.dataRef.current.disabled || t.listboxState === 0)
    return t;
  let e = t.activeOptionIndex, { isSelected: n } = t.dataRef.current, i = t.options.findIndex((r) => n(r.dataRef.current.value));
  return i !== -1 && (e = i), { ...t, listboxState: 0, activeOptionIndex: e };
}, 2(t, e) {
  var n;
  if (t.dataRef.current.disabled || t.listboxState === 1)
    return t;
  let i = sa(t), r = d2(e, { resolveItems: () => i.options, resolveActiveIndex: () => i.activeOptionIndex, resolveId: (s) => s.id, resolveDisabled: (s) => s.dataRef.current.disabled });
  return { ...t, ...i, searchQuery: "", activeOptionIndex: r, activationTrigger: (n = e.trigger) != null ? n : 1 };
}, 3: (t, e) => {
  if (t.dataRef.current.disabled || t.listboxState === 1)
    return t;
  let n = t.searchQuery !== "" ? 0 : 1, i = t.searchQuery + e.value.toLowerCase(), r = (t.activeOptionIndex !== null ? t.options.slice(t.activeOptionIndex + n).concat(t.options.slice(0, t.activeOptionIndex + n)) : t.options).find((a) => {
    var o;
    return !a.dataRef.current.disabled && ((o = a.dataRef.current.textValue) == null ? void 0 : o.startsWith(i));
  }), s = r ? t.options.indexOf(r) : -1;
  return s === -1 || s === t.activeOptionIndex ? { ...t, searchQuery: i } : { ...t, searchQuery: i, activeOptionIndex: s, activationTrigger: 1 };
}, 4(t) {
  return t.dataRef.current.disabled || t.listboxState === 1 || t.searchQuery === "" ? t : { ...t, searchQuery: "" };
}, 5: (t, e) => {
  let n = { id: e.id, dataRef: e.dataRef }, i = sa(t, (r) => [...r, n]);
  return t.activeOptionIndex === null && t.dataRef.current.isSelected(e.dataRef.current.value) && (i.activeOptionIndex = i.options.indexOf(n)), { ...t, ...i };
}, 6: (t, e) => {
  let n = sa(t, (i) => {
    let r = i.findIndex((s) => s.id === e.id);
    return r !== -1 && i.splice(r, 1), i;
  });
  return { ...t, ...n, activationTrigger: 1 };
}, 7: (t, e) => ({ ...t, labelId: e.id }) }, Ho = zt(null);
Ho.displayName = "ListboxActionsContext";
function lr(t) {
  let e = Et(Ho);
  if (e === null) {
    let n = new Error(`<${t} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, lr), n;
  }
  return e;
}
let jo = zt(null);
jo.displayName = "ListboxDataContext";
function cr(t) {
  let e = Et(jo);
  if (e === null) {
    let n = new Error(`<${t} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, cr), n;
  }
  return e;
}
function y2(t, e) {
  return Xe(e.type, v2, t, e);
}
let x2 = ri;
function A2(t, e) {
  let { value: n, defaultValue: i, form: r, name: s, onChange: a, by: o = (D, V) => D === V, disabled: l = !1, horizontal: c = !1, multiple: u = !1, ...d } = t;
  const h = c ? "horizontal" : "vertical";
  let g = Vn(e), [b = u ? [] : void 0, m] = $1(n, a, i), [p, x] = Rd(y2, { dataRef: F1(), listboxState: 1, options: [], searchQuery: "", labelId: null, activeOptionIndex: null, activationTrigger: 1 }), C = Se({ static: !1, hold: !1 }), M = Se(null), _ = Se(null), A = Se(null), E = Ce(typeof o == "string" ? (D, V) => {
    let z = o;
    return (D == null ? void 0 : D[z]) === (V == null ? void 0 : V[z]);
  } : o), P = le((D) => Xe(I.mode, { 1: () => b.some((V) => E(V, D)), 0: () => E(b, D) }), [b]), I = ne(() => ({ ...p, value: b, disabled: l, mode: u ? 1 : 0, orientation: h, compare: E, isSelected: P, optionsPropsRef: C, labelRef: M, buttonRef: _, optionsRef: A }), [b, l, u, p]);
  mt(() => {
    p.dataRef.current = I;
  }, [I]), e2([I.buttonRef, I.optionsRef], (D, V) => {
    var z;
    x({ type: 1 }), Vd(V, Bo.Loose) || (D.preventDefault(), (z = I.buttonRef.current) == null || z.focus());
  }, I.listboxState === 0);
  let U = ne(() => ({ open: I.listboxState === 0, disabled: l, value: b }), [I, l, b]), Q = Ce((D) => {
    let V = I.options.find((z) => z.id === D);
    V && B(V.dataRef.current.value);
  }), T = Ce(() => {
    if (I.activeOptionIndex !== null) {
      let { dataRef: D, id: V } = I.options[I.activeOptionIndex];
      B(D.current.value), x({ type: 2, focus: ct.Specific, id: V });
    }
  }), Y = Ce(() => x({ type: 0 })), q = Ce(() => x({ type: 1 })), $ = Ce((D, V, z) => D === ct.Specific ? x({ type: 2, focus: ct.Specific, id: V, trigger: z }) : x({ type: 2, focus: D, trigger: z })), N = Ce((D, V) => (x({ type: 5, id: D, dataRef: V }), () => x({ type: 6, id: D }))), R = Ce((D) => (x({ type: 7, id: D }), () => x({ type: 7, id: null }))), B = Ce((D) => Xe(I.mode, { 0() {
    return m == null ? void 0 : m(D);
  }, 1() {
    let V = I.value.slice(), z = V.findIndex((H) => E(H, D));
    return z === -1 ? V.push(D) : V.splice(z, 1), m == null ? void 0 : m(V);
  } })), j = Ce((D) => x({ type: 3, value: D })), y = Ce(() => x({ type: 4 })), v = ne(() => ({ onChange: B, registerOption: N, registerLabel: R, goToOption: $, closeListbox: q, openListbox: Y, selectActiveOption: T, selectOption: Q, search: j, clearSearch: y }), []), k = { ref: g }, S = Se(null), f = di();
  return Fe(() => {
    S.current && i !== void 0 && f.addEventListener(S.current, "reset", () => {
      m == null || m(i);
    });
  }, [S, m]), re.createElement(Ho.Provider, { value: v }, re.createElement(jo.Provider, { value: I }, re.createElement($d, { value: Xe(I.listboxState, { 0: gt.Open, 1: gt.Closed }) }, s != null && b != null && Wd({ [s]: b }).map(([D, V], z) => re.createElement(o2, { features: jd.Hidden, ref: z === 0 ? (H) => {
    var K;
    S.current = (K = H == null ? void 0 : H.closest("form")) != null ? K : null;
  } : void 0, ...Ga({ key: D, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: r, disabled: l, name: D, value: V }) })), mn({ ourProps: k, theirProps: d, slot: U, defaultTag: x2, name: "Listbox" }))));
}
let C2 = "button";
function w2(t, e) {
  var n;
  let i = Ps(), { id: r = `headlessui-listbox-button-${i}`, ...s } = t, a = cr("Listbox.Button"), o = lr("Listbox.Button"), l = Vn(a.buttonRef, e), c = di(), u = Ce((p) => {
    switch (p.key) {
      case Qe.Space:
      case Qe.Enter:
      case Qe.ArrowDown:
        p.preventDefault(), o.openListbox(), c.nextFrame(() => {
          a.value || o.goToOption(ct.First);
        });
        break;
      case Qe.ArrowUp:
        p.preventDefault(), o.openListbox(), c.nextFrame(() => {
          a.value || o.goToOption(ct.Last);
        });
        break;
    }
  }), d = Ce((p) => {
    switch (p.key) {
      case Qe.Space:
        p.preventDefault();
        break;
    }
  }), h = Ce((p) => {
    if (l2(p.currentTarget))
      return p.preventDefault();
    a.listboxState === 0 ? (o.closeListbox(), c.nextFrame(() => {
      var x;
      return (x = a.buttonRef.current) == null ? void 0 : x.focus({ preventScroll: !0 });
    })) : (p.preventDefault(), o.openListbox());
  }), g = Ld(() => {
    if (a.labelId)
      return [a.labelId, r].join(" ");
  }, [a.labelId, r]), b = ne(() => ({ open: a.listboxState === 0, disabled: a.disabled, value: a.value }), [a]), m = { ref: l, id: r, type: t2(t, a.buttonRef), "aria-haspopup": "listbox", "aria-controls": (n = a.optionsRef.current) == null ? void 0 : n.id, "aria-expanded": a.listboxState === 0, "aria-labelledby": g, disabled: a.disabled, onKeyDown: u, onKeyUp: d, onClick: h };
  return mn({ ourProps: m, theirProps: s, slot: b, defaultTag: C2, name: "Listbox.Button" });
}
let S2 = "label";
function E2(t, e) {
  let n = Ps(), { id: i = `headlessui-listbox-label-${n}`, ...r } = t, s = cr("Listbox.Label"), a = lr("Listbox.Label"), o = Vn(s.labelRef, e);
  mt(() => a.registerLabel(i), [i]);
  let l = Ce(() => {
    var u;
    return (u = s.buttonRef.current) == null ? void 0 : u.focus({ preventScroll: !0 });
  }), c = ne(() => ({ open: s.listboxState === 0, disabled: s.disabled }), [s]);
  return mn({ ourProps: { ref: o, id: i, onClick: l }, theirProps: r, slot: c, defaultTag: S2, name: "Listbox.Label" });
}
let k2 = "ul", _2 = rs.RenderStrategy | rs.Static;
function M2(t, e) {
  var n;
  let i = Ps(), { id: r = `headlessui-listbox-options-${i}`, ...s } = t, a = cr("Listbox.Options"), o = lr("Listbox.Options"), l = Vn(a.optionsRef, e), c = di(), u = di(), d = No(), h = d !== null ? (d & gt.Open) === gt.Open : a.listboxState === 0;
  Fe(() => {
    var x;
    let C = a.optionsRef.current;
    C && a.listboxState === 0 && C !== ((x = Nd(C)) == null ? void 0 : x.activeElement) && C.focus({ preventScroll: !0 });
  }, [a.listboxState, a.optionsRef]);
  let g = Ce((x) => {
    switch (u.dispose(), x.key) {
      case Qe.Space:
        if (a.searchQuery !== "")
          return x.preventDefault(), x.stopPropagation(), o.search(x.key);
      case Qe.Enter:
        if (x.preventDefault(), x.stopPropagation(), a.activeOptionIndex !== null) {
          let { dataRef: C } = a.options[a.activeOptionIndex];
          o.onChange(C.current.value);
        }
        a.mode === 0 && (o.closeListbox(), fn().nextFrame(() => {
          var C;
          return (C = a.buttonRef.current) == null ? void 0 : C.focus({ preventScroll: !0 });
        }));
        break;
      case Xe(a.orientation, { vertical: Qe.ArrowDown, horizontal: Qe.ArrowRight }):
        return x.preventDefault(), x.stopPropagation(), o.goToOption(ct.Next);
      case Xe(a.orientation, { vertical: Qe.ArrowUp, horizontal: Qe.ArrowLeft }):
        return x.preventDefault(), x.stopPropagation(), o.goToOption(ct.Previous);
      case Qe.Home:
      case Qe.PageUp:
        return x.preventDefault(), x.stopPropagation(), o.goToOption(ct.First);
      case Qe.End:
      case Qe.PageDown:
        return x.preventDefault(), x.stopPropagation(), o.goToOption(ct.Last);
      case Qe.Escape:
        return x.preventDefault(), x.stopPropagation(), o.closeListbox(), c.nextFrame(() => {
          var C;
          return (C = a.buttonRef.current) == null ? void 0 : C.focus({ preventScroll: !0 });
        });
      case Qe.Tab:
        x.preventDefault(), x.stopPropagation();
        break;
      default:
        x.key.length === 1 && (o.search(x.key), u.setTimeout(() => o.clearSearch(), 350));
        break;
    }
  }), b = Ld(() => {
    var x;
    return (x = a.buttonRef.current) == null ? void 0 : x.id;
  }, [a.buttonRef.current]), m = ne(() => ({ open: a.listboxState === 0 }), [a]), p = { "aria-activedescendant": a.activeOptionIndex === null || (n = a.options[a.activeOptionIndex]) == null ? void 0 : n.id, "aria-multiselectable": a.mode === 1 ? !0 : void 0, "aria-labelledby": b, "aria-orientation": a.orientation, id: r, onKeyDown: g, role: "listbox", tabIndex: 0, ref: l };
  return mn({ ourProps: p, theirProps: s, slot: m, defaultTag: k2, features: _2, visible: h, name: "Listbox.Options" });
}
let O2 = "li";
function D2(t, e) {
  let n = Ps(), { id: i = `headlessui-listbox-option-${n}`, disabled: r = !1, value: s, ...a } = t, o = cr("Listbox.Option"), l = lr("Listbox.Option"), c = o.activeOptionIndex !== null ? o.options[o.activeOptionIndex].id === i : !1, u = o.isSelected(s), d = Se(null), h = f2(d), g = Tt({ disabled: r, value: s, domRef: d, get textValue() {
    return h();
  } }), b = Vn(e, d);
  mt(() => {
    if (o.listboxState !== 0 || !c || o.activationTrigger === 0)
      return;
    let E = fn();
    return E.requestAnimationFrame(() => {
      var P, I;
      (I = (P = d.current) == null ? void 0 : P.scrollIntoView) == null || I.call(P, { block: "nearest" });
    }), E.dispose;
  }, [d, c, o.listboxState, o.activationTrigger, o.activeOptionIndex]), mt(() => l.registerOption(i, g), [g, i]);
  let m = Ce((E) => {
    if (r)
      return E.preventDefault();
    l.onChange(s), o.mode === 0 && (l.closeListbox(), fn().nextFrame(() => {
      var P;
      return (P = o.buttonRef.current) == null ? void 0 : P.focus({ preventScroll: !0 });
    }));
  }), p = Ce(() => {
    if (r)
      return l.goToOption(ct.Nothing);
    l.goToOption(ct.Specific, i);
  }), x = i2(), C = Ce((E) => x.update(E)), M = Ce((E) => {
    x.wasMoved(E) && (r || c || l.goToOption(ct.Specific, i, 0));
  }), _ = Ce((E) => {
    x.wasMoved(E) && (r || c && l.goToOption(ct.Nothing));
  }), A = ne(() => ({ active: c, selected: u, disabled: r }), [c, u, r]);
  return mn({ ourProps: { id: i, ref: b, role: "option", tabIndex: r === !0 ? void 0 : -1, "aria-disabled": r === !0 ? !0 : void 0, "aria-selected": u, disabled: void 0, onClick: m, onFocus: p, onPointerEnter: C, onMouseEnter: C, onPointerMove: M, onMouseMove: M, onPointerLeave: _, onMouseLeave: _ }, theirProps: a, slot: A, defaultTag: O2, name: "Listbox.Option" });
}
let P2 = Qt(A2), F2 = Qt(w2), T2 = Qt(E2), I2 = Qt(M2), R2 = Qt(D2), en = Object.assign(P2, { Button: F2, Label: T2, Options: I2, Option: R2 });
function B2(t = 0) {
  let [e, n] = Be(t), i = Vo(), r = le((l) => {
    i.current && n((c) => c | l);
  }, [e, i]), s = le((l) => !!(e & l), [e]), a = le((l) => {
    i.current && n((c) => c & ~l);
  }, [n, i]), o = le((l) => {
    i.current && n((c) => c ^ l);
  }, [n]);
  return { flags: e, addFlag: r, hasFlag: s, removeFlag: a, toggleFlag: o };
}
function L2(t) {
  let e = { called: !1 };
  return (...n) => {
    if (!e.called)
      return e.called = !0, t(...n);
  };
}
function aa(t, ...e) {
  t && e.length > 0 && t.classList.add(...e);
}
function oa(t, ...e) {
  t && e.length > 0 && t.classList.remove(...e);
}
function N2(t, e) {
  let n = fn();
  if (!t)
    return n.dispose;
  let { transitionDuration: i, transitionDelay: r } = getComputedStyle(t), [s, a] = [i, r].map((l) => {
    let [c = 0] = l.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, d) => d - u);
    return c;
  }), o = s + a;
  if (o !== 0) {
    n.group((c) => {
      c.setTimeout(() => {
        e(), c.dispose();
      }, o), c.addEventListener(t, "transitionrun", (u) => {
        u.target === u.currentTarget && c.dispose();
      });
    });
    let l = n.addEventListener(t, "transitionend", (c) => {
      c.target === c.currentTarget && (e(), l());
    });
  } else
    e();
  return n.add(() => e()), n.dispose;
}
function V2(t, e, n, i) {
  let r = n ? "enter" : "leave", s = fn(), a = i !== void 0 ? L2(i) : () => {
  };
  r === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  let o = Xe(r, { enter: () => e.enter, leave: () => e.leave }), l = Xe(r, { enter: () => e.enterTo, leave: () => e.leaveTo }), c = Xe(r, { enter: () => e.enterFrom, leave: () => e.leaveFrom });
  return oa(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), aa(t, ...e.base, ...o, ...c), s.nextFrame(() => {
    oa(t, ...e.base, ...o, ...c), aa(t, ...e.base, ...o, ...l), N2(t, () => (oa(t, ...e.base, ...o), aa(t, ...e.base, ...e.entered), a()));
  }), s.dispose;
}
function H2({ immediate: t, container: e, direction: n, classes: i, onStart: r, onStop: s }) {
  let a = Vo(), o = di(), l = Tt(n);
  mt(() => {
    t && (l.current = "enter");
  }, [t]), mt(() => {
    let c = fn();
    o.add(c.dispose);
    let u = e.current;
    if (u && l.current !== "idle" && a.current)
      return c.dispose(), r.current(l.current), c.add(V2(u, i.current, l.current === "enter", () => {
        c.dispose(), s.current(l.current);
      })), c.dispose;
  }, [n]);
}
function Kt(t = "") {
  return t.split(/\s+/).filter((e) => e.length > 1);
}
let Fs = zt(null);
Fs.displayName = "TransitionContext";
var j2 = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(j2 || {});
function $2() {
  let t = Et(Fs);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function W2() {
  let t = Et(Ts);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
let Ts = zt(null);
Ts.displayName = "NestingContext";
function Is(t) {
  return "children" in t ? Is(t.children) : t.current.filter(({ el: e }) => e.current !== null).filter(({ state: e }) => e === "visible").length > 0;
}
function Ud(t, e) {
  let n = Tt(t), i = Se([]), r = Vo(), s = di(), a = Ce((g, b = Xt.Hidden) => {
    let m = i.current.findIndex(({ el: p }) => p === g);
    m !== -1 && (Xe(b, { [Xt.Unmount]() {
      i.current.splice(m, 1);
    }, [Xt.Hidden]() {
      i.current[m].state = "hidden";
    } }), s.microTask(() => {
      var p;
      !Is(i) && r.current && ((p = n.current) == null || p.call(n));
    }));
  }), o = Ce((g) => {
    let b = i.current.find(({ el: m }) => m === g);
    return b ? b.state !== "visible" && (b.state = "visible") : i.current.push({ el: g, state: "visible" }), () => a(g, Xt.Unmount);
  }), l = Se([]), c = Se(Promise.resolve()), u = Se({ enter: [], leave: [], idle: [] }), d = Ce((g, b, m) => {
    l.current.splice(0), e && (e.chains.current[b] = e.chains.current[b].filter(([p]) => p !== g)), e == null || e.chains.current[b].push([g, new Promise((p) => {
      l.current.push(p);
    })]), e == null || e.chains.current[b].push([g, new Promise((p) => {
      Promise.all(u.current[b].map(([x, C]) => C)).then(() => p());
    })]), b === "enter" ? c.current = c.current.then(() => e == null ? void 0 : e.wait.current).then(() => m(b)) : m(b);
  }), h = Ce((g, b, m) => {
    Promise.all(u.current[b].splice(0).map(([p, x]) => x)).then(() => {
      var p;
      (p = l.current.shift()) == null || p();
    }).then(() => m(b));
  });
  return ne(() => ({ children: i, register: o, unregister: a, onStart: d, onStop: h, wait: c, chains: u }), [o, a, i, d, h, u, c]);
}
function Y2() {
}
let z2 = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function $l(t) {
  var e;
  let n = {};
  for (let i of z2)
    n[i] = (e = t[i]) != null ? e : Y2;
  return n;
}
function U2(t) {
  let e = Se($l(t));
  return Fe(() => {
    e.current = $l(t);
  }, [t]), e;
}
let Q2 = "div", Qd = rs.RenderStrategy;
function K2(t, e) {
  var n, i;
  let { beforeEnter: r, afterEnter: s, beforeLeave: a, afterLeave: o, enter: l, enterFrom: c, enterTo: u, entered: d, leave: h, leaveFrom: g, leaveTo: b, ...m } = t, p = Se(null), x = Vn(p, e), C = (n = m.unmount) == null || n ? Xt.Unmount : Xt.Hidden, { show: M, appear: _, initial: A } = $2(), [E, P] = Be(M ? "visible" : "hidden"), I = W2(), { register: U, unregister: Q } = I;
  Fe(() => U(p), [U, p]), Fe(() => {
    if (C === Xt.Hidden && p.current) {
      if (M && E !== "visible") {
        P("visible");
        return;
      }
      return Xe(E, { hidden: () => Q(p), visible: () => U(p) });
    }
  }, [E, p, U, Q, M, C]);
  let T = Tt({ base: Kt(m.className), enter: Kt(l), enterFrom: Kt(c), enterTo: Kt(u), entered: Kt(d), leave: Kt(h), leaveFrom: Kt(g), leaveTo: Kt(b) }), Y = U2({ beforeEnter: r, afterEnter: s, beforeLeave: a, afterLeave: o }), q = Ro();
  Fe(() => {
    if (q && E === "visible" && p.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [p, E, q]);
  let $ = A && !_, N = _ && M && A, R = !q || $ ? "idle" : M ? "enter" : "leave", B = B2(0), j = Ce((D) => Xe(D, { enter: () => {
    B.addFlag(gt.Opening), Y.current.beforeEnter();
  }, leave: () => {
    B.addFlag(gt.Closing), Y.current.beforeLeave();
  }, idle: () => {
  } })), y = Ce((D) => Xe(D, { enter: () => {
    B.removeFlag(gt.Opening), Y.current.afterEnter();
  }, leave: () => {
    B.removeFlag(gt.Closing), Y.current.afterLeave();
  }, idle: () => {
  } })), v = Ud(() => {
    P("hidden"), Q(p);
  }, I), k = Se(!1);
  H2({ immediate: N, container: p, classes: T, direction: R, onStart: Tt((D) => {
    k.current = !0, v.onStart(p, D, j);
  }), onStop: Tt((D) => {
    k.current = !1, v.onStop(p, D, y), D === "leave" && !Is(v) && (P("hidden"), Q(p));
  }) });
  let S = m, f = { ref: x };
  return N ? S = { ...S, className: is(m.className, ...T.current.enter, ...T.current.enterFrom) } : k.current && (S.className = is(m.className, (i = p.current) == null ? void 0 : i.className), S.className === "" && delete S.className), re.createElement(Ts.Provider, { value: v }, re.createElement($d, { value: Xe(E, { visible: gt.Open, hidden: gt.Closed }) | B.flags }, mn({ ourProps: f, theirProps: S, defaultTag: Q2, features: Qd, visible: E === "visible", name: "Transition.Child" })));
}
function G2(t, e) {
  let { show: n, appear: i = !1, unmount: r = !0, ...s } = t, a = Se(null), o = Vn(a, e);
  Ro();
  let l = No();
  if (n === void 0 && l !== null && (n = (l & gt.Open) === gt.Open), ![!0, !1].includes(n))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [c, u] = Be(n ? "visible" : "hidden"), d = Ud(() => {
    u("hidden");
  }), [h, g] = Be(!0), b = Se([n]);
  mt(() => {
    h !== !1 && b.current[b.current.length - 1] !== n && (b.current.push(n), g(!1));
  }, [b, n]);
  let m = ne(() => ({ show: n, appear: i, initial: h }), [n, i, h]);
  Fe(() => {
    if (n)
      u("visible");
    else if (!Is(d))
      u("hidden");
    else {
      let M = a.current;
      if (!M)
        return;
      let _ = M.getBoundingClientRect();
      _.x === 0 && _.y === 0 && _.width === 0 && _.height === 0 && u("hidden");
    }
  }, [n, d]);
  let p = { unmount: r }, x = Ce(() => {
    var M;
    h && g(!1), (M = t.beforeEnter) == null || M.call(t);
  }), C = Ce(() => {
    var M;
    h && g(!1), (M = t.beforeLeave) == null || M.call(t);
  });
  return re.createElement(Ts.Provider, { value: d }, re.createElement(Fs.Provider, { value: m }, mn({ ourProps: { ...p, as: ri, children: re.createElement(Kd, { ref: o, ...p, ...s, beforeEnter: x, beforeLeave: C }) }, theirProps: {}, defaultTag: ri, features: Qd, visible: c === "visible", name: "Transition" })));
}
function q2(t, e) {
  let n = Et(Fs) !== null, i = No() !== null;
  return re.createElement(re.Fragment, null, !n && i ? re.createElement(qa, { ref: e, ...t }) : re.createElement(Kd, { ref: e, ...t }));
}
let qa = Qt(G2), Kd = Qt(K2), Z2 = Qt(q2), Za = Object.assign(qa, { Child: Z2, Root: qa });
const J2 = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { id: "add", clipPath: "url(#clip0_376_19769)", children: /* @__PURE__ */ w(
        "path",
        {
          id: "Vector",
          d: "M10.625 9.375V5H9.375V9.375H5V10.625H9.375V15H10.625V10.625H15V9.375H10.625Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_376_19769", children: /* @__PURE__ */ w("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
    ]
  }
), X2 = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_3495_24570)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M14.5819 9.33187L10.3125 13.5956V2.25H9.1875V13.5956L4.91812 9.33187L4.125 10.125L9.75 15.75L15.375 10.125L14.5819 9.33187Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_3495_24570", children: /* @__PURE__ */ w(
        "rect",
        {
          width: "18",
          height: "18",
          fill: "currentColor",
          transform: "translate(0.75)"
        }
      ) }) })
    ]
  }
), eg = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_898_3433)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M11.75 3.75L10.8562 4.62063L15.5938 9.375H3V10.625H15.5938L10.8562 15.3581L11.75 16.25L18 10L11.75 3.75Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_898_3433", children: /* @__PURE__ */ w(
        "rect",
        {
          width: "20",
          height: "20",
          fill: "currentColor",
          transform: "translate(0.5)"
        }
      ) }) })
    ]
  }
), tg = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_487_2588)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M16.25 2.5H13.75V1.25H12.5V2.5H7.5V1.25H6.25V2.5H3.75C3.0625 2.5 2.5 3.0625 2.5 3.75V16.25C2.5 16.9375 3.0625 17.5 3.75 17.5H16.25C16.9375 17.5 17.5 16.9375 17.5 16.25V3.75C17.5 3.0625 16.9375 2.5 16.25 2.5ZM16.25 16.25H3.75V7.5H16.25V16.25ZM16.25 6.25H3.75V3.75H6.25V5H7.5V3.75H12.5V5H13.75V3.75H16.25V6.25Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_487_2588", children: /* @__PURE__ */ w("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
    ]
  }
), ng = () => /* @__PURE__ */ w(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ w("g", { children: /* @__PURE__ */ w(
      "path",
      {
        d: "M8.42843 14L4.5 10.223L5.74987 9.04762L8.42843 11.5966L14.2493 6L15.5 7.20168L8.42843 14Z",
        fill: "currentColor"
      }
    ) })
  }
), Gd = () => /* @__PURE__ */ w(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ w(
      "path",
      {
        d: "M27.1004 2.46154H22.1773V0H19.7157V2.46154H9.86959V0H7.40805V2.46154H2.48498C1.83239 2.46235 1.20676 2.72195 0.745305 3.18341C0.283853 3.64486 0.0242517 4.27049 0.0234375 4.92308V29.5385C0.0242517 30.1911 0.283853 30.8167 0.745305 31.2781C1.20676 31.7396 1.83239 31.9992 2.48498 32H27.1004C27.753 31.9992 28.3786 31.7396 28.84 31.2781C29.3015 30.8167 29.5611 30.1911 29.5619 29.5385V4.92308C29.5611 4.27049 29.3015 3.64486 28.84 3.18341C28.3786 2.72195 27.753 2.46235 27.1004 2.46154ZM2.48498 4.92308H7.40805V7.38462H9.86959V4.92308H19.7157V7.38462H22.1773V4.92308H27.1004V9.84615H2.48498V4.92308ZM2.48498 12.3077H8.63882V19.6923H2.48498V12.3077ZM18.485 29.5385H11.1004V22.1538H18.485V29.5385ZM18.485 19.6923H11.1004V12.3077H18.485V19.6923ZM20.9465 29.5385V22.1538H27.1004L27.1018 29.5385H20.9465Z",
        fill: "currentColor"
      }
    )
  }
), ig = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ ae("g", { clipPath: "url(#clip0_376_19415)", children: [
        /* @__PURE__ */ w(
          "path",
          {
            d: "M8.75 13.8837L5.625 10.7581L6.50813 9.875L8.75 12.1163L13.4906 7.375L14.375 8.25937L8.75 13.8837Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ w(
          "path",
          {
            d: "M10 1.75C8.26942 1.75 6.57769 2.26318 5.13876 3.22464C3.69983 4.1861 2.57832 5.55267 1.91606 7.15152C1.25379 8.75037 1.08051 10.5097 1.41813 12.207C1.75575 13.9044 2.58911 15.4635 3.81282 16.6872C5.03653 17.9109 6.59563 18.7442 8.29296 19.0819C9.9903 19.4195 11.7496 19.2462 13.3485 18.5839C14.9473 17.9217 16.3139 16.8002 17.2754 15.3612C18.2368 13.9223 18.75 12.2306 18.75 10.5C18.75 8.17936 17.8281 5.95376 16.1872 4.31282C14.5462 2.67187 12.3206 1.75 10 1.75ZM10 18C8.51664 18 7.0666 17.5601 5.83323 16.736C4.59986 15.9119 3.63856 14.7406 3.07091 13.3701C2.50325 11.9997 2.35473 10.4917 2.64411 9.03682C2.9335 7.58197 3.64781 6.24559 4.6967 5.1967C5.7456 4.14781 7.08197 3.4335 8.53683 3.14411C9.99168 2.85472 11.4997 3.00325 12.8701 3.5709C14.2406 4.13856 15.4119 5.09985 16.236 6.33322C17.0601 7.56659 17.5 9.01664 17.5 10.5C17.5 12.4891 16.7098 14.3968 15.3033 15.8033C13.8968 17.2098 11.9891 18 10 18Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_376_19415", children: /* @__PURE__ */ w(
        "rect",
        {
          width: "20",
          height: "20",
          fill: "currentColor",
          transform: "translate(0 0.5)"
        }
      ) }) })
    ]
  }
), rg = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_898_3384)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M10 1.25C8.26942 1.25 6.57769 1.76318 5.13876 2.72464C3.69983 3.6861 2.57832 5.05267 1.91606 6.65152C1.25379 8.25037 1.08051 10.0097 1.41813 11.707C1.75575 13.4044 2.58911 14.9635 3.81282 16.1872C5.03653 17.4109 6.59563 18.2442 8.29296 18.5819C9.9903 18.9195 11.7496 18.7462 13.3485 18.0839C14.9473 17.4217 16.3139 16.3002 17.2754 14.8612C18.2368 13.4223 18.75 11.7306 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25ZM8.75 13.4942L5.625 10.3692L6.61913 9.375L8.75 11.5058L13.3813 6.875L14.3786 7.86619L8.75 13.4942Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_898_3384", children: /* @__PURE__ */ w("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
    ]
  }
), Rs = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_1674_19277)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M6.25 10L12.5 3.75L13.375 4.625L8 10L13.375 15.375L12.5 16.25L6.25 10Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_1674_19277", children: /* @__PURE__ */ w("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
    ]
  }
), xi = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_1674_19281)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M13.75 10L7.5 16.25L6.625 15.375L12 10L6.625 4.625L7.5 3.75L13.75 10Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_1674_19281", children: /* @__PURE__ */ w("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
    ]
  }
), sg = () => /* @__PURE__ */ ae(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_1510_24955)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M17.4141 16L26 7.4141L24.5859 6L16 14.5859L7.4143 6L6 7.4141L14.5859 16L6 24.5859L7.4143 26L16 17.4141L24.5859 26L26 24.5859L17.4141 16Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_1510_24955", children: /* @__PURE__ */ w("rect", { width: "32", height: "32", fill: "currentColor" }) }) })
    ]
  }
), qd = () => /* @__PURE__ */ w(
  "svg",
  {
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 33",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ w(
      "path",
      {
        d: "M26.1914 13.608H24.9882V10.7024C25.0356 9.39946 24.8199 8.10034 24.3539 6.88264C23.888 5.66495 23.1814 4.55365 22.2763 3.61514C21.3713 2.67662 20.2864 1.93014 19.0864 1.42028C17.8865 0.910422 16.596 0.647644 15.2922 0.647644C13.9884 0.647644 12.698 0.910422 11.498 1.42028C10.2981 1.93014 9.21318 2.67662 8.30815 3.61514C7.40312 4.55365 6.69653 5.66495 6.23058 6.88264C5.76464 8.10034 5.54889 9.39946 5.59624 10.7024V13.608H4.36744C4.04975 13.608 3.73517 13.6706 3.44165 13.7921C3.14814 13.9137 2.88145 14.0919 2.65681 14.3166C2.43217 14.5412 2.25397 14.8079 2.13239 15.1014C2.01082 15.3949 1.94824 15.7095 1.94824 16.0272V30.5808C1.94824 31.2224 2.20312 31.8377 2.65681 32.2914C3.1105 32.7451 3.72583 33 4.36744 33H26.1914C26.8331 33 27.4484 32.7451 27.9021 32.2914C28.3558 31.8377 28.6106 31.2224 28.6106 30.5808V16.0272C28.6106 15.7095 28.5481 15.3949 28.4265 15.1014C28.3049 14.8079 28.1267 14.5412 27.9021 14.3166C27.6774 14.0919 27.4107 13.9137 27.1172 13.7921C26.8237 13.6706 26.5091 13.608 26.1914 13.608ZM16.6938 24.2448V27.88H13.8522V24.296C13.4166 24.0505 13.0542 23.6935 12.8022 23.2616C12.5503 22.8296 12.4179 22.3384 12.4186 21.8384C12.4186 21.0814 12.7194 20.3553 13.2547 19.82C13.79 19.2847 14.516 18.984 15.273 18.984C16.0301 18.984 16.7561 19.2847 17.2914 19.82C17.8267 20.3553 18.1274 21.0814 18.1274 21.8384C18.1192 22.3297 17.9826 22.8103 17.7311 23.2325C17.4796 23.6546 17.122 24.0036 16.6938 24.2448ZM21.3402 10.7024V13.608H9.21864V10.7024C9.18098 9.88304 9.30984 9.06457 9.59743 8.29643C9.88503 7.52829 10.3254 6.82644 10.8919 6.23329C11.4584 5.64015 12.1393 5.16802 12.8934 4.84546C13.6475 4.5229 14.4592 4.35659 15.2794 4.35659C16.0997 4.35659 16.9114 4.5229 17.6655 4.84546C18.4196 5.16802 19.1005 5.64015 19.667 6.23329C20.2335 6.82644 20.6739 7.52829 20.9615 8.29643C21.249 9.06457 21.3779 9.88304 21.3402 10.7024Z",
        fill: "currentColor"
      }
    )
  }
), ag = () => /* @__PURE__ */ ae(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ ae("g", { clipPath: "url(#clip0_1252_48048)", children: [
        /* @__PURE__ */ w("path", { d: "M28 6H4V8H28V6Z", fill: "#F2F4F8" }),
        /* @__PURE__ */ w("path", { d: "M28 24H4V26H28V24Z", fill: "#F2F4F8" }),
        /* @__PURE__ */ w("path", { d: "M28 12H4V14H28V12Z", fill: "#F2F4F8" }),
        /* @__PURE__ */ w("path", { d: "M28 18H4V20H28V18Z", fill: "#F2F4F8" })
      ] }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_1252_48048", children: /* @__PURE__ */ w("rect", { width: "32", height: "32", fill: "white" }) }) })
    ]
  }
), og = () => /* @__PURE__ */ ae(
  "svg",
  {
    className: "inline-block",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_376_19765)", children: /* @__PURE__ */ w("path", { d: "M15 9.375H5V10.625H15V9.375Z", fill: "currentColor" }) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_376_19765", children: /* @__PURE__ */ w("rect", { width: "20", height: "20", fill: "currentColor" }) }) })
    ]
  }
), lg = () => /* @__PURE__ */ ae(
  "svg",
  {
    width: "2.325em",
    height: "1em",
    viewBox: "0 0 93 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "inline-block",
    children: [
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_376_19530)", children: /* @__PURE__ */ w(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M25.0967 2.59298H25.4813C25.8399 2.59298 26.1093 2.52211 26.2876 2.37965C26.4658 2.2379 26.555 2.03088 26.555 1.76C26.555 1.48632 26.4799 1.28421 26.3311 1.15298C26.1809 1.02246 25.9472 0.956492 25.6279 0.956492H25.0967V2.59298ZM27.7353 1.7186C27.7353 2.31158 27.5493 2.76491 27.1788 3.0786C26.8083 3.39369 26.2813 3.55018 25.5978 3.55018H25.0967V5.51018H23.9283V0H25.6883C26.3564 0 26.8644 0.143158 27.2125 0.431579C27.5606 0.719298 27.7353 1.14807 27.7353 1.7186ZM21.0427 5.51018H19.8932V0H23.0518V0.956492H21.0427V2.37825H22.9122V3.33193H21.0427V5.51018ZM17.8672 5.51018H16.5367L15.7907 2.61544C15.7627 2.51228 15.7157 2.29965 15.649 1.97684C15.6008 1.76186 15.5623 1.54479 15.5339 1.32632C15.5192 1.46246 15.4813 1.6807 15.4216 1.98035C15.3606 2.2807 15.3143 2.49544 15.282 2.62316L14.5388 5.51018H13.2125L11.8062 0H12.9564L13.6609 3.00702C13.7844 3.56281 13.8728 4.04421 13.9283 4.45123C13.9437 4.30807 13.9781 4.08632 14.0321 3.78597C14.0862 3.48491 14.1374 3.25193 14.1851 3.08702L14.9879 0H16.0918L16.8946 3.08702C16.9981 3.53796 17.0825 3.99311 17.1472 4.45123C17.1725 4.25474 17.2125 4.01053 17.2679 3.7179C17.3234 3.42526 17.3732 3.18877 17.4188 3.00702L18.1199 0H19.2693L17.8672 5.51018ZM15.009 24.6772C12.8679 24.6772 11.4939 25.1853 11.1185 25.3432C11.0967 25.353 11.0785 25.3214 11.096 25.3039C13.4483 22.8583 16.2027 22.993 16.8658 22.993H24.6981C25.0932 22.993 25.4132 23.3698 25.4132 23.8358C25.4132 24.3004 25.0932 24.6772 24.6981 24.6772H15.009ZM16.7739 26.8421C14.4665 26.8421 13.7943 25.5312 10.3023 26.3965C10.2785 26.4028 10.2623 26.3698 10.2827 26.3558C12.2293 25.0204 14.3465 25.1418 15.2027 25.1418H24.6981C25.0932 25.1418 25.4132 25.5186 25.4132 25.9832C25.4132 26.4477 25.0932 26.8246 24.6981 26.8246C24.6981 26.8246 18.6006 26.8421 16.7739 26.8421ZM16.9374 28.9733C14.5697 28.9733 14.3802 27.226 10.87 26.8323C10.8455 26.8295 10.8427 26.793 10.8665 26.7874C13.75 26.066 14.823 27.2891 16.5065 27.2891H24.6981C25.0932 27.2891 25.4132 27.666 25.4132 28.1312C25.4132 28.5965 25.0932 28.9733 24.6981 28.9733H16.9374ZM16.4237 22.5291C14.5178 22.5291 12.9374 23.3607 12.5676 23.5705C12.5465 23.5818 12.5262 23.5572 12.5395 23.5383C12.849 23.0828 14.5185 20.8456 17.3886 20.8456H24.6981C25.0932 20.8456 25.4132 21.2225 25.4132 21.6877C25.4132 22.1523 25.0932 22.5291 24.6981 22.5291H16.4237ZM26.9086 17.88C26.8237 17.7987 26.714 17.7481 26.5971 17.7361C26.5112 17.7248 26.4239 17.7352 26.343 17.7663C26.376 17.6968 26.4041 17.6225 26.4146 17.5347C26.4331 17.4119 26.4127 17.2863 26.3564 17.1754C26.1206 16.659 26.7943 15.6253 26.7093 15.579C26.6286 15.534 26.2455 16.6737 25.8736 17.134C25.7947 17.2326 25.746 17.3517 25.7332 17.4772C25.7186 17.6006 25.7398 17.7255 25.7943 17.8372C25.8462 17.9298 25.9248 17.9958 26.0174 18.0014C26.0425 18.0046 26.0679 18.0032 26.0925 17.9972C26.0867 18.0105 26.0825 18.0244 26.0799 18.0386C26.0737 18.0886 26.0795 18.1394 26.0969 18.1867C26.1141 18.2341 26.1425 18.2766 26.1795 18.3109C26.2625 18.3939 26.372 18.4453 26.489 18.4561C26.6084 18.4736 26.7301 18.4507 26.835 18.3909C27.3395 18.1151 28.3858 17.8428 28.3634 17.746C28.343 17.6491 27.3227 18.2477 26.9086 17.88ZM27.6799 17.1263C27.6054 17.0461 27.5039 16.9964 27.395 16.9867C27.3308 16.9835 27.2668 16.9938 27.2069 17.0168C27.216 16.9846 27.2286 16.9572 27.2329 16.9249C27.2456 16.8118 27.2202 16.6977 27.1606 16.6007C26.9044 16.1256 27.5732 15.2281 27.4869 15.1839C27.4006 15.139 27.0336 16.1439 26.6616 16.5411C26.5821 16.6213 26.5333 16.7268 26.5234 16.8393C26.5115 16.9528 26.5361 17.0671 26.5936 17.1656C26.6525 17.2519 26.7332 17.313 26.8307 17.3263C26.8731 17.3286 26.9156 17.3237 26.9564 17.3116C26.9543 17.3165 26.9486 17.3242 26.9508 17.3298C26.9468 17.3806 26.9533 17.4317 26.9702 17.4797C26.987 17.5278 27.0136 17.5719 27.0483 17.6091C27.1185 17.6842 27.2195 17.7361 27.3318 17.746C27.4397 17.7575 27.5482 17.7282 27.6357 17.6639C28.0707 17.3502 29.0651 17.1642 29.0392 17.0632C29.0153 16.9663 28.063 17.4919 27.6799 17.1263ZM28.3564 16.4295C28.2778 16.3717 28.1803 16.3456 28.0834 16.3565C28.0355 16.3596 27.9885 16.3717 27.9451 16.3923C27.9529 16.3712 27.9655 16.3544 27.9732 16.334C27.9995 16.2342 27.9936 16.1286 27.9564 16.0323C27.7943 15.5656 28.5122 14.8758 28.4427 14.8197C28.3725 14.7677 27.9065 15.6035 27.5234 15.8975C27.4431 15.9599 27.386 16.0474 27.3613 16.146C27.3319 16.2448 27.3371 16.3507 27.376 16.4463C27.3922 16.4879 27.4171 16.5253 27.4493 16.5563C27.4814 16.5872 27.5198 16.6107 27.562 16.6253C27.6265 16.6456 27.6911 16.6323 27.7522 16.6063C27.7378 16.6444 27.732 16.6851 27.7353 16.7256C27.7444 16.8211 27.7908 16.9011 27.8665 16.9572C27.9449 17.0155 28.042 17.043 28.1393 17.0343C28.2366 17.0256 28.3274 16.9815 28.3943 16.9102C28.7388 16.5614 29.5971 16.2351 29.5627 16.1516C29.5255 16.0674 28.7543 16.6884 28.3564 16.4295ZM29.6855 14.9319C29.6139 14.826 29.0132 15.4842 28.5697 15.5474C28.4748 15.5619 28.3868 15.6055 28.3178 15.6723C28.2406 15.7382 28.1863 15.8269 28.1627 15.9256C28.1517 15.964 28.1494 16.0044 28.1561 16.0437C28.1628 16.083 28.1782 16.1204 28.2013 16.153C28.2267 16.1827 28.2594 16.2053 28.2962 16.2187C28.3329 16.2321 28.3725 16.2358 28.4111 16.2295C28.508 16.2161 28.598 16.1716 28.6672 16.1025C28.7406 16.0356 28.7931 15.9488 28.8181 15.8526C28.9529 15.4014 29.7388 15.0007 29.6855 14.9319ZM17.2686 15.8232C17.2511 15.8884 17.1213 16.3958 17.1213 16.3958C17.0848 16.4161 16.9304 16.3825 16.8897 16.379C16.5936 16.3509 16.3283 16.0933 16.442 15.786C16.5353 15.5347 16.7255 15.5081 16.9669 15.4968C17.0672 15.4926 17.2476 15.5165 17.3381 15.579C17.3381 15.579 17.3023 15.6947 17.2686 15.8232ZM16.9283 17.3544L16.9009 17.5277C16.7164 17.4119 16.6083 17.1474 16.6967 16.9383C16.7648 16.7797 16.9332 16.7383 17.0574 16.7312C17.0124 16.9385 16.9694 17.1463 16.9283 17.3544ZM16.663 19.2463C16.6399 19.3761 16.4644 19.3937 16.3444 19.4295C15.9964 19.534 15.6665 19.4891 15.5599 19.073C15.4441 18.6281 15.7809 18.4407 16.1423 18.3537C16.3388 18.3074 16.5213 18.346 16.656 18.5123C16.6897 18.5537 16.7297 18.5909 16.7388 18.6302C16.7388 18.6302 16.6848 19.1242 16.663 19.2463ZM15.5676 17.0554C15.8364 16.9909 16.1143 16.8898 16.3206 17.1544C16.5381 17.4323 16.4658 17.8779 16.1164 17.9958C15.8862 18.0737 15.6076 18.1411 15.4111 17.953C15.1529 17.7067 15.1718 17.1474 15.5676 17.0554ZM15.3044 15.6126C15.5872 15.5439 15.8806 15.4393 16.0981 15.7172C16.3241 16.0077 16.249 16.4779 15.882 16.6007C15.6392 16.6807 15.3465 16.7516 15.1402 16.5537C14.8693 16.2968 14.8897 15.7095 15.3044 15.6126ZM15.0406 18.7319C14.9669 18.9916 14.7528 19.0302 14.529 19.0842C14.3816 18.9039 13.9858 18.4463 13.9788 18.3923C13.9768 18.3709 13.9797 18.3493 13.9872 18.3291C14.0055 18.2751 14.0679 18.2232 14.1143 18.193C14.249 18.1053 14.536 18.0407 14.6911 18.0723C14.969 18.1319 15.1143 18.4709 15.0406 18.7319ZM13.6336 17.3993C13.4307 16.6807 14.6357 16.3677 14.8216 17.0723C15.0132 17.7965 13.7978 18.1039 13.6336 17.3993ZM13.4567 15.9649C13.2504 15.2512 14.4609 14.9375 14.6469 15.6386C14.8385 16.3635 13.6209 16.6716 13.4567 15.9649ZM13.2876 14.5551C13.0904 13.8898 14.2265 13.5951 14.3999 14.2512C14.5781 14.9263 13.442 15.2175 13.2876 14.5551ZM13.1711 17.2688C13.1157 17.3018 13.0946 17.3193 13.0757 17.3193L12.5353 16.7312C12.5416 16.7144 12.7086 16.5937 12.7648 16.5614C13.2139 16.3116 13.5837 17.026 13.1711 17.2688ZM12.1458 15.9446C11.8785 15.3551 12.8511 14.7158 13.1458 15.3516C13.416 15.9368 12.4434 16.5874 12.1458 15.9446ZM12.9634 14.0779C13.2707 14.6246 12.3444 15.2344 12.0792 14.6463C11.8434 14.1397 12.6665 13.5481 12.9634 14.0779ZM12.1858 12.8042C12.3227 12.6835 12.4806 12.6182 12.6427 12.6961C12.9023 12.8211 12.91 13.2105 12.6834 13.3656C12.5802 13.4365 12.4055 13.5242 12.2785 13.4926C11.9999 13.4218 11.9465 13.0154 12.1858 12.8042ZM12.2209 11.633C12.3332 11.5572 12.4827 11.4891 12.6118 11.5418C12.8462 11.6379 12.8378 11.9783 12.6483 12.1144C12.5613 12.1761 12.4055 12.2526 12.3002 12.2246C12.063 12.1649 12.0048 11.7797 12.2209 11.633ZM12.8434 9.96421C12.983 9.88913 13.1844 9.85755 13.3093 9.9979C13.3436 10.0353 13.3687 10.0801 13.3828 10.1288C13.3968 10.1776 13.3994 10.2289 13.3903 10.2788C13.3812 10.3287 13.3606 10.3758 13.3303 10.4164C13.2999 10.4571 13.2606 10.4901 13.2153 10.513C13.0665 10.5874 12.8658 10.6154 12.7479 10.4772C12.7157 10.4391 12.6923 10.3942 12.6795 10.346C12.6667 10.2977 12.6648 10.2472 12.674 10.198C12.6831 10.149 12.703 10.1025 12.7323 10.062C12.7616 10.0216 12.7995 9.98821 12.8434 9.96421ZM12.7332 11.2323C12.6202 10.8147 13.3241 10.6175 13.4385 11.0421C13.5655 11.454 12.8455 11.6597 12.7332 11.2323ZM13.8672 11.9614C14.0314 12.4126 13.2672 12.6681 13.1178 12.2225C12.9655 11.7712 13.7332 11.5137 13.8672 11.9614ZM13.9634 9.76281C14.1093 9.70456 14.296 9.64141 14.4588 9.76281C14.6616 9.91439 14.6174 10.2554 14.3851 10.3614C14.2321 10.4309 14.0371 10.4772 13.9009 10.3558C13.7276 10.2014 13.7178 9.86106 13.9634 9.76281ZM13.8286 13.539C13.6223 13.5874 13.4069 13.6695 13.2357 13.4926C13.0167 13.2667 13.0792 12.8716 13.376 12.7635C13.5676 12.6905 13.8104 12.6498 13.9669 12.8098C14.1676 13.0154 14.1458 13.4625 13.8286 13.539ZM13.8321 11.2344C13.7002 10.7867 14.4293 10.5572 14.569 10.9916C14.7128 11.4372 13.9578 11.6744 13.8321 11.2344ZM15.0532 12.0547C15.2244 12.5656 14.3613 12.8379 14.2027 12.3347C14.0427 11.8197 14.9121 11.5474 15.0532 12.0547ZM15.0995 10.6863C15.2518 10.6456 15.4125 10.6604 15.5283 10.7846C15.7051 10.9747 15.6448 11.2997 15.383 11.3481C15.2602 11.3705 15.07 11.3614 14.9739 11.2772C14.8013 11.1242 14.8097 10.7642 15.0995 10.6863ZM15.8364 11.7586C16.1143 11.7586 16.2546 12.167 16.0925 12.3698C15.995 12.4926 15.7844 12.5004 15.6413 12.4779C15.376 12.4372 15.2062 12.0954 15.3851 11.8646C15.4939 11.7249 15.6799 11.7586 15.8364 11.7586ZM14.5009 13.44C14.3297 12.8526 15.3276 12.5902 15.4806 13.1733C15.6357 13.7663 14.6321 14.0274 14.5009 13.44ZM15.1129 14.1916C15.3851 14.1635 15.6686 14.1004 15.8364 14.386C16.0111 14.6877 15.8806 15.1074 15.5269 15.1783C15.2946 15.2267 15.0132 15.2491 14.8476 15.0435C14.63 14.7719 14.7164 14.2288 15.1129 14.1916ZM16.4981 12.8835C16.835 13.0225 16.9486 13.4197 16.7114 13.6414C16.5837 13.7572 16.3521 13.7347 16.1957 13.7032C15.882 13.6414 15.6778 13.1712 15.9521 12.9481C16.0932 12.8337 16.3451 12.8197 16.4981 12.8835ZM17.0279 14.2997C17.2392 14.5593 17.1606 15.0175 16.79 15.04C16.5971 15.0512 16.3444 15.0288 16.2139 14.8702C16.0041 14.6168 16.0834 14.1411 16.4532 14.1284C16.6469 14.1207 16.8974 14.1411 17.0279 14.2997ZM18.4588 9.62316C18.449 9.608 18.4345 9.59642 18.4176 9.59011C18.4006 9.58379 18.3821 9.58309 18.3648 9.58807C18.3206 9.60281 18.2911 9.65123 18.3079 9.69404C19.1536 11.9656 18.0736 13.0842 17.6223 14.6744C17.0813 13.3825 18.875 12.167 17.9507 9.81193C17.9374 9.78176 17.9136 9.7572 17.8806 9.75228C17.8343 9.74597 17.79 9.76492 17.783 9.82667C17.7592 9.99228 17.6504 11.2975 16.5914 12.0625C16.4784 11.792 16.3104 11.5481 16.0981 11.346C15.9999 10.906 15.7129 10.3018 15.1086 10.1235C15.0181 9.89544 14.8364 9.56913 14.4862 9.39369C14.1564 9.22948 13.7753 9.24421 13.3514 9.43649C12.8399 9.49614 12.4876 9.69614 12.3023 10.0295C12.1269 10.3446 12.1585 10.6877 12.2174 10.9214C11.7865 11.3818 11.7662 12.0639 11.7774 12.3312C11.5213 12.946 11.6651 13.6639 11.7458 13.9621C11.4399 14.7979 11.7388 15.6084 11.8581 15.8772C11.8581 15.9502 11.8616 16.019 11.8658 16.0877C10.8637 14.9916 8.58372 13.6337 7.71285 13.1158C7.69306 13.1037 7.66976 13.0986 7.64674 13.1013C7.62379 13.1039 7.60232 13.1143 7.58583 13.1305C7.57537 13.1402 7.56695 13.1518 7.56099 13.1648C7.55509 13.1777 7.55179 13.1917 7.55123 13.2058C7.55074 13.2201 7.55299 13.2343 7.55797 13.2476C7.56295 13.2609 7.57046 13.2731 7.58021 13.2835C9.52267 15.1783 11.256 17.5165 12.9206 22.3684C13.7514 21.5046 15.2525 20.3691 17.3886 20.3691H19.8876C18.3002 14.4547 20.6118 12.3383 18.4588 9.62316ZM30.2736 12.6814C29.8167 12.5621 26.8995 12.0456 23.63 18.059C24.1072 15.8197 25.5571 13.1102 25.9543 12.3235V12.3179C25.9659 12.2956 25.9693 12.2698 25.964 12.2452C25.9586 12.2206 25.9447 12.1986 25.9248 12.1832C25.9039 12.1688 25.8783 12.1634 25.8533 12.168C25.8285 12.1726 25.8065 12.1869 25.7922 12.2077C23.6322 15.8098 22.8736 17.8856 22.4258 20.3691H23.7795C24.0097 17.9747 27.0336 12.3347 30.2567 12.7537H30.2602C30.2792 12.7579 30.2953 12.7425 30.2974 12.7263C30.3044 12.7053 30.2918 12.6849 30.2736 12.6814ZM23.7739 32.4933L23.0427 29.4372H21.7978C21.995 30.2126 22.2764 31.0014 22.6413 31.6933C22.6519 31.7132 22.6684 31.7294 22.6884 31.7398C22.7084 31.7502 22.7311 31.7543 22.7536 31.7516C22.7837 31.7463 22.8104 31.7293 22.828 31.7043C22.8456 31.6793 22.8526 31.6484 22.8476 31.6183C22.7627 30.9712 22.6616 30.3474 22.5655 29.7242C22.8293 30.7032 23.1844 31.6597 23.6637 32.5404C23.6764 32.5677 23.7037 32.5804 23.7297 32.5719C23.7648 32.5642 23.783 32.527 23.7739 32.4933ZM25.0322 31.106C24.9044 30.5951 24.7718 29.9684 24.6581 29.4372H24.1844C24.369 30.0042 24.6174 30.6365 24.8385 31.1769C24.8602 31.2295 24.91 31.2554 24.9578 31.2421C24.9853 31.2333 25.0084 31.2143 25.0223 31.1889C25.0361 31.1636 25.0396 31.1339 25.0322 31.106ZM25.1901 32.9032L25.1865 32.8962C25.0336 32.4688 24.8216 32.0863 24.6539 31.6765C24.4722 31.2719 24.3069 30.8601 24.1585 30.4421C24.0392 30.127 23.9122 29.7656 23.8146 29.4372H23.3578C23.4869 29.8197 23.6546 30.2316 23.8111 30.6007C24.155 31.4344 24.5529 32.2512 25.0595 32.9818C25.069 32.995 25.0827 33.0046 25.0984 33.0091C25.114 33.0136 25.1308 33.0126 25.1458 33.0063C25.1865 32.9909 25.2048 32.9446 25.1901 32.9032ZM25.8736 18.2365C25.8385 18.1839 25.7536 18.1726 25.7136 18.2154C25.1123 18.8587 24.6051 19.5838 24.2069 20.3691H24.7002C24.9472 19.7895 25.503 18.7656 25.8609 18.3965L25.8644 18.393C25.883 18.3716 25.894 18.3446 25.8956 18.3163C25.8973 18.288 25.8895 18.2599 25.8736 18.2365ZM22.1164 13.9944C22.5732 13.2442 23.2511 12.6702 23.8258 11.9768C23.8359 11.9637 23.8408 11.9473 23.8397 11.9307C23.8385 11.9142 23.8313 11.8987 23.8195 11.887C23.8144 11.8813 23.8082 11.8766 23.8011 11.8733C23.7942 11.8701 23.7866 11.8683 23.7789 11.8681C23.7712 11.8679 23.7635 11.8693 23.7564 11.8722C23.7493 11.8751 23.7428 11.8794 23.7374 11.8849C23.6062 12.0246 23.47 12.1558 23.3304 12.2856C23.2693 12.2561 23.115 12.3158 22.9578 12.4386C22.835 12.5361 22.7465 12.6442 22.715 12.7221C22.6357 12.7039 22.4869 12.7965 22.3522 12.9684C22.2413 13.1123 22.1774 13.2632 22.1788 13.3565C22.0939 13.3635 21.9711 13.4716 21.8658 13.6435C21.7978 13.7572 21.7536 13.8674 21.7388 13.9586C21.6512 14.0265 21.5776 14.1106 21.522 14.2063C21.4279 14.3635 21.3795 14.5214 21.3943 14.6126C21.3725 14.6526 21.35 14.6898 21.3318 14.7284L21.343 14.6358C21.4778 13.574 21.6722 12.5228 21.969 11.5088C22.2672 10.4975 22.6244 9.4779 23.2378 8.65895L23.242 8.65544C23.2571 8.63327 23.2644 8.6066 23.2623 8.57979C23.2602 8.55299 23.2491 8.52765 23.2307 8.50807C23.2218 8.4979 23.2108 8.48962 23.1985 8.48393C23.1862 8.47825 23.1729 8.47523 23.1592 8.47502C23.1457 8.47481 23.1322 8.47748 23.1198 8.48281C23.1073 8.48814 23.0961 8.496 23.0869 8.50597C22.8794 8.73277 22.6948 8.97958 22.536 9.24281C22.4665 9.20562 22.3192 9.34386 22.2069 9.56C22.1037 9.75509 22.0665 9.93614 22.1058 10.0056C22.1058 10.0056 22.1037 10.0112 22.0995 10.0091C22.0258 9.97755 21.8897 10.1418 21.8069 10.3614C21.7262 10.5684 21.7114 10.7586 21.7669 10.8225C21.7627 10.826 21.7627 10.8281 21.7606 10.8316C21.6785 10.8014 21.5437 10.9902 21.4609 11.2568C21.3922 11.4821 21.3851 11.6779 21.435 11.7565C21.4385 11.76 21.435 11.7698 21.4314 11.7677C21.3465 11.7375 21.2174 11.9319 21.1423 12.1965C21.0665 12.4519 21.0722 12.6779 21.1437 12.7221C21.0609 12.713 20.9451 12.9067 20.8841 13.1698C20.8293 13.3972 20.835 13.593 20.8883 13.6716C20.8069 13.6954 20.7171 13.8856 20.6707 14.1319C20.6265 14.3726 20.6483 14.5719 20.7072 14.6358C20.6322 14.6744 20.555 14.8702 20.5269 15.113C20.4995 15.3537 20.5346 15.5509 20.5971 15.6147C20.5346 15.6849 20.4736 15.8526 20.4476 16.0547C20.4223 16.2463 20.4385 16.4126 20.4757 16.506C20.4076 16.5635 20.3557 16.7579 20.3536 16.9909C20.3486 17.1768 20.376 17.3354 20.4237 17.4267C20.3804 17.5487 20.3593 17.6775 20.3613 17.807C20.3578 18.0028 20.3886 18.1705 20.4385 18.2583C20.4237 18.9467 20.4329 19.6793 20.47 20.3691H21.9564C21.9669 19.8323 22.0027 19.2463 22.0553 18.7151C22.1606 17.7677 22.3171 16.8056 22.7907 15.9965L22.7943 15.9909C22.8018 15.9768 22.8049 15.9608 22.8033 15.9449C22.8017 15.9291 22.7954 15.914 22.7851 15.9018C22.7571 15.8772 22.7185 15.8772 22.6925 15.9074C22.0497 16.6533 21.7683 17.666 21.6027 18.6372C21.5732 18.8274 21.5493 19.019 21.5269 19.2098C21.5676 18.4302 21.6392 17.654 21.8181 16.9158C22.0223 16.0168 22.4314 15.1614 23.2104 14.6821C23.223 14.6739 23.2325 14.6617 23.2375 14.6475C23.2424 14.6333 23.2425 14.6178 23.2378 14.6035C23.2336 14.5872 23.2232 14.5731 23.2087 14.5644C23.1943 14.5558 23.1769 14.5531 23.1606 14.5572C23.1107 14.5719 23.0651 14.5979 23.0167 14.619C22.9655 14.5551 22.776 14.6021 22.5802 14.7263C22.3943 14.8477 22.2707 14.9972 22.2841 15.0793C22.2841 15.0828 22.275 15.0884 22.275 15.0807C22.2738 15.0721 22.2707 15.064 22.2658 15.0568C22.1957 14.9993 22.0076 15.1298 21.849 15.3516C21.689 15.5733 21.6265 15.8049 21.6946 15.8646C21.6981 15.866 21.6967 15.8716 21.6932 15.8716C21.6097 15.8379 21.4722 16.0267 21.3851 16.2898C21.3227 16.4737 21.3079 16.6435 21.3304 16.7411C21.3304 16.7439 21.3262 16.7481 21.3262 16.7481C21.2616 16.9607 21.2083 17.1754 21.1585 17.393C21.1774 17.0856 21.2048 16.7761 21.249 16.4702C21.3795 15.5902 21.6448 14.7284 22.1164 13.9944ZM26.7922 11.5397C26.6847 11.4934 26.565 11.4843 26.4518 11.5137C26.3674 11.5354 26.2891 11.5762 26.223 11.633C26.2341 11.5522 26.2298 11.47 26.2104 11.3909C26.186 11.2699 26.1241 11.1597 26.0336 11.0758C25.6322 10.6751 25.9079 9.46807 25.8146 9.45334C25.7227 9.44071 25.7557 10.6435 25.5662 11.2063C25.5254 11.3261 25.5208 11.4552 25.5529 11.5775C25.5807 11.6989 25.6442 11.8091 25.7353 11.894C25.8146 11.9635 25.91 11.9951 26.0006 11.967C26.0254 11.9627 26.0488 11.9524 26.0686 11.9368C26.0686 11.9523 26.0686 11.967 26.07 11.9818C26.0911 12.0807 26.1606 12.1572 26.2567 12.2021C26.3644 12.2504 26.4854 12.2596 26.5992 12.2281C26.7164 12.2013 26.8218 12.1373 26.8995 12.0456C27.2771 11.607 28.1648 10.9825 28.1115 10.899C28.0574 10.8168 27.3079 11.7375 26.7922 11.5397ZM28.5093 10.0204C28.4518 9.93825 27.7409 10.7677 27.2567 10.5607C27.1581 10.5124 27.0453 10.5018 26.9395 10.5312C26.8787 10.5511 26.8224 10.5828 26.7739 10.6246C26.7718 10.5909 26.7739 10.5607 26.7669 10.5312C26.741 10.4204 26.6778 10.3218 26.5879 10.2519C26.183 9.89755 26.5016 8.81965 26.4055 8.80842C26.3079 8.7972 26.31 9.86948 26.0995 10.3726C26.0526 10.4757 26.0437 10.592 26.0743 10.7011C26.1037 10.8204 26.1704 10.9193 26.2532 10.9825C26.2917 11.0126 26.3363 11.0341 26.3839 11.0453C26.4315 11.0566 26.481 11.0574 26.529 11.0477C26.5696 11.0356 26.6077 11.0161 26.6413 10.9902C26.6413 10.9958 26.6392 11.0028 26.6413 11.0084C26.6553 11.0577 26.6795 11.1034 26.712 11.143C26.7446 11.1824 26.7851 11.2147 26.8307 11.2379C26.9288 11.2839 27.0402 11.2931 27.1444 11.2639C27.2493 11.2367 27.3406 11.1717 27.4006 11.0814C27.7002 10.6323 28.5662 10.106 28.5093 10.0204ZM28.6841 8.98176C28.6209 8.91649 28.1115 9.77053 27.649 9.66807C27.5555 9.64183 27.4555 9.65186 27.369 9.69614C27.3246 9.71537 27.2845 9.7433 27.2511 9.77825C27.2511 9.7572 27.2567 9.73685 27.2567 9.71439C27.2477 9.61186 27.2056 9.51509 27.1367 9.4386C26.8258 9.05825 27.2581 8.1579 27.1753 8.12983C27.0911 8.10527 26.9437 9.05264 26.6855 9.46457C26.631 9.55053 26.6077 9.65257 26.6195 9.75369C26.6265 9.86386 26.6729 9.96281 26.7374 10.0316C26.8034 10.1004 26.8848 10.1382 26.9732 10.1326C27.0387 10.1268 27.0998 10.0968 27.1444 10.0484C27.1444 10.0856 27.1515 10.1263 27.1697 10.1656C27.1887 10.2068 27.2166 10.2434 27.2512 10.2727C27.2859 10.302 27.3265 10.3234 27.3704 10.3354C27.4574 10.3635 27.5606 10.3558 27.6525 10.3109C27.7409 10.2681 27.8115 10.1956 27.8518 10.106C28.0539 9.65685 28.7444 9.04702 28.6841 8.98176ZM28.3781 7.79579C28.2736 7.72141 27.9402 8.55088 27.5437 8.76702C27.46 8.81502 27.3927 8.88716 27.3508 8.97404C27.3035 9.06337 27.2842 9.16485 27.2953 9.26527C27.3044 9.35299 27.3451 9.42737 27.4097 9.46457C27.4435 9.48351 27.4816 9.49327 27.5204 9.49306C27.5591 9.49277 27.5971 9.48253 27.6308 9.46316C27.7164 9.41572 27.7852 9.3426 27.8272 9.25404C27.8733 9.16506 27.8926 9.06463 27.8827 8.96492C27.8532 8.49544 28.4518 7.84211 28.3781 7.79579ZM21.1093 29.4372H16.9374C16.6539 29.4372 16.3978 29.4147 16.162 29.3719C16.1641 29.3719 16.1641 29.3733 16.1641 29.3733C16.849 30.3916 17.9227 31.1642 19.0111 31.6821C19.1788 32.6105 19.3886 33.4702 19.4644 33.5376C19.5416 33.6042 20.6097 33.2969 20.6434 33.1979C20.6743 33.0997 20.2062 31.5088 20.2062 31.5088C20.7683 30.5446 20.9416 29.9755 21.1093 29.4372ZM31.6027 36.5733C30.5493 36.9895 29.1753 37.0239 28.0539 36.7263C25.4848 35.9263 22.6322 34.4105 19.8932 35.6688C17.155 34.4105 14.3023 35.9263 11.7332 36.7263C10.6118 37.0239 9.23776 36.9895 8.18443 36.5733C8.17832 36.5707 8.17144 36.5703 8.1652 36.5724C8.15888 36.5745 8.15362 36.5789 8.15032 36.5847C8.14709 36.5905 8.14611 36.5973 8.14765 36.6037C8.14913 36.6102 8.15299 36.6159 8.15846 36.6197C9.67425 37.7923 11.7978 38.3319 13.7093 37.6414C15.5451 37.0695 17.0981 35.1242 19.2729 35.9544C17.5507 36.6274 15.9409 37.8695 14.6981 39.0414L15.602 39.7839C16.7311 38.4695 18.002 37.1551 19.4406 36.3551C19.6371 36.2393 19.755 36.193 19.8932 36.1853C20.0322 36.193 20.1493 36.2393 20.3444 36.3551C21.7851 37.1551 23.056 38.4695 24.1844 39.7839L25.089 39.0414C23.8462 37.8695 22.2364 36.6274 20.5143 35.9544C22.689 35.1242 24.242 37.0695 26.0778 37.6414C27.9893 38.3319 30.1129 37.7923 31.6286 36.6197C31.6525 36.5993 31.6322 36.5621 31.6027 36.5733ZM14.67 34.8014C11.9851 34.1509 11.2504 31.6337 9.00548 30.5411C8.98162 30.5284 8.95565 30.5565 8.97039 30.5783C9.67776 31.7418 10.0609 33.5242 12.0995 34.6232C12.1164 34.6316 12.1072 34.6583 12.0883 34.6526C9.16407 34.0898 7.9353 34.8723 4.87071 33.487C4.84475 33.4758 4.81738 33.5039 4.83422 33.5284C5.84124 34.9902 8.23144 35.9895 11.5065 35.7137C12.6855 35.6133 13.5395 35.1172 14.67 34.8526C14.6981 34.8449 14.6981 34.807 14.67 34.8014ZM9.04618 33.2576C8.02583 31.9207 8.31636 29.0667 6.01247 26.454C5.99422 26.4337 5.96124 26.4498 5.96685 26.4758C6.40685 28.4 6.27562 30.586 7.48057 32.1874C7.49179 32.2042 7.47495 32.2211 7.45811 32.2098C5.08264 30.3397 2.64053 29.7761 1.55352 28.2625C1.53738 28.2421 1.50439 28.2526 1.5079 28.2793C1.77667 30.2386 5.54089 33.2933 9.02583 33.299C9.04618 33.299 9.05881 33.2751 9.04618 33.2576ZM5.47843 29.7039C4.3844 27.6751 5.69176 24.5797 4.45106 21.5719C4.43773 21.5404 4.39001 21.5481 4.39001 21.5818C4.35352 23.2239 3.33317 25.6765 3.95001 27.5277C3.95703 27.5446 3.93527 27.5537 3.92615 27.539C2.35492 25.2435 1.1086 24.7642 0.0693073 22.6632C0.0545705 22.6316 0.00685112 22.64 0.00474586 22.6737C-0.0612191 24.1018 0.57036 25.266 1.28334 26.3474C2.40104 27.7733 3.82206 28.9325 5.44334 29.7411C5.4679 29.7523 5.48966 29.7277 5.47843 29.7039ZM4.73668 17.3488C4.73457 17.3151 4.69036 17.3039 4.67352 17.3333C3.83913 18.894 2.35352 20.1361 2.3051 22.1972C2.30369 22.2176 2.28124 22.219 2.27773 22.2C2.00685 20.6098 0.657378 18.8274 0.59843 16.5242C0.59843 16.4891 0.548606 16.48 0.535273 16.513C-0.574903 19.5081 1.02159 22.3474 2.72124 24.6933C2.74018 24.7172 2.77667 24.7032 2.77667 24.6709C2.7072 22.1853 4.86159 20.3298 4.73668 17.3488ZM5.79703 13.4737C5.00896 14.5684 3.23562 15.3425 2.5872 16.9214C2.57808 16.9439 2.55001 16.9383 2.55422 16.9123C2.81176 15.1425 2.12825 13.0877 2.76966 10.7368C2.77878 10.7032 2.73668 10.6807 2.71632 10.7067C1.7472 11.8982 1.41948 13.2947 1.36615 14.8035C1.30018 16.6568 1.95141 18.0084 2.27422 19.2653C2.28124 19.2954 2.31983 19.2933 2.32755 19.2632C2.79141 17.6154 5.12124 16.6232 5.85036 13.4997C5.86019 13.4667 5.81738 13.4456 5.79703 13.4737ZM7.9353 9.79299C6.63913 10.8091 4.65878 11.7881 4.23352 12.4947C4.2265 12.5095 4.20404 12.4983 4.20755 12.4835L4.68825 10.1768C4.90369 9.1979 5.08966 8.26035 5.63141 7.38386C5.64826 7.3579 5.61668 7.32772 5.59282 7.34667C3.12475 9.30106 3.48545 12.127 3.37668 14.4414C3.37527 14.466 3.40475 14.4772 3.42159 14.4604C4.87422 12.8842 7.24267 11.967 7.976 9.82456C7.98513 9.7986 7.95706 9.77614 7.9353 9.79299ZM9.77179 6.24983C7.59074 6.3193 5.98861 8.15579 5.30159 10.494C5.29808 10.5074 5.31633 10.5186 5.32755 10.5109C8.33179 8.30877 8.16337 7.36491 9.79004 6.31719C9.81951 6.29825 9.80688 6.24983 9.77179 6.24983ZM34.9143 33.487C31.8518 34.8723 30.6216 34.0898 27.6967 34.6526C27.6785 34.6583 27.6693 34.6316 27.6855 34.6232C29.7241 33.5242 30.1072 31.7418 30.8146 30.5783C30.8293 30.5565 30.8041 30.5284 30.7795 30.5411C28.5367 31.6337 27.802 34.1509 25.115 34.8014C25.0869 34.807 25.0869 34.8449 25.115 34.8526C26.2455 35.1172 27.1002 35.6133 28.2785 35.7137C31.5529 35.9895 33.9458 34.9902 34.9515 33.5284C34.9676 33.5039 34.9402 33.4758 34.9143 33.487ZM38.2308 28.2625C37.1444 29.7761 34.7023 30.3397 32.3269 32.2098C32.3122 32.2211 32.2939 32.2042 32.3065 32.1874C33.5093 30.586 33.3781 28.4 33.8181 26.4758C33.8237 26.4498 33.7908 26.4337 33.7725 26.454C31.4701 29.0667 31.7592 31.9207 30.7409 33.2576C30.7283 33.2751 30.7388 33.299 30.7613 33.299C34.2455 33.2933 38.0083 30.2386 38.2771 28.2793C38.2806 28.2526 38.2476 28.2421 38.2308 28.2625ZM39.7802 22.6737C39.7781 22.64 39.7304 22.6316 39.7157 22.6632C38.6771 24.7642 37.4301 25.2435 35.8609 27.539C35.8497 27.5537 35.8294 27.5446 35.8357 27.5277C36.4518 25.6765 35.4336 23.2239 35.395 21.5818C35.395 21.5481 35.3472 21.5404 35.3346 21.5719C34.0932 24.5797 35.4006 27.6751 34.3087 29.7039C34.2953 29.7277 34.3178 29.7523 34.3416 29.7411C35.963 28.9326 37.3841 27.7734 38.5016 26.3474C39.2146 25.266 39.8462 24.1018 39.7802 22.6737ZM39.2497 16.513C39.2371 16.48 39.1872 16.4891 39.1872 16.5242C39.1283 18.8274 37.7781 20.6098 37.5072 22.2C37.5037 22.219 37.482 22.2176 37.482 22.1972C37.4336 20.1361 35.9458 18.894 35.1115 17.3333C35.0946 17.3039 35.0504 17.3151 35.0504 17.3488C34.9255 20.3298 37.0785 22.1853 37.0083 24.6709C37.0083 24.7032 37.0469 24.7172 37.0651 24.6933C38.7634 22.3474 40.3599 19.5081 39.2497 16.513ZM38.4188 14.8035C38.3655 13.2947 38.0378 11.8982 37.0694 10.7067C37.049 10.6807 37.0083 10.7032 37.016 10.7368C37.6567 13.0877 36.9732 15.1425 37.2329 16.9123C37.2364 16.9383 37.2076 16.9439 37.1978 16.9214C36.5501 15.3425 34.776 14.5684 33.9879 13.4737C33.9697 13.4456 33.9269 13.4667 33.9346 13.4997C34.6637 16.6232 36.9936 17.6154 37.4581 19.2632C37.4651 19.2933 37.5037 19.2954 37.5115 19.2653C37.8336 18.0084 38.4855 16.6568 38.4188 14.8035ZM34.1922 7.34667C34.1683 7.32772 34.1374 7.3579 34.1536 7.38386C34.6953 8.26035 34.8813 9.1979 35.0967 10.1768L35.5774 12.4835C35.5809 12.4983 35.5585 12.5095 35.5515 12.4947C35.1262 11.7881 33.1479 10.8091 31.8497 9.79299C31.8293 9.77614 31.7999 9.7986 31.809 9.82456C32.5423 11.967 34.9108 12.8842 36.3634 14.4604C36.3802 14.4772 36.4097 14.466 36.4076 14.4414C36.2995 12.127 36.6602 9.30106 34.1922 7.34667ZM30.0139 6.24983C29.9788 6.24983 29.9676 6.29825 29.995 6.31719C31.6216 7.36491 31.4539 8.30877 34.4574 10.5109C34.4708 10.5186 34.4869 10.5074 34.4834 10.494C33.7964 8.15579 32.1943 6.3193 30.0139 6.24983ZM49.8209 19.9846H48.2546L47.3753 16.5761C47.343 16.4547 47.2876 16.2042 47.209 15.8239C47.1523 15.5708 47.1071 15.3154 47.0736 15.0583C47.056 15.2175 47.0118 15.4744 46.9409 15.8281C46.8694 16.1818 46.8146 16.4344 46.776 16.5853L45.9023 19.9846H44.3395L42.6841 13.4961H44.0378L44.868 17.0379C45.0132 17.6919 45.1178 18.2583 45.183 18.7376C45.2006 18.5691 45.2413 18.3081 45.3051 17.9544C45.3683 17.6007 45.4287 17.3263 45.4848 17.1312L46.4301 13.4961H47.7304L48.6757 17.1312C48.7171 17.2933 48.769 17.5425 48.8315 17.8765C48.8932 18.2112 48.9409 18.4976 48.9732 18.7376C49.0027 18.5067 49.0497 18.2197 49.1157 17.8737C49.1802 17.5298 49.2399 17.2512 49.2932 17.0379L50.1185 13.4961H51.4722L49.8209 19.9846ZM53.0336 17.4947C53.0336 17.9867 53.1136 18.3572 53.2757 18.6084C53.4364 18.8604 53.6988 18.986 54.063 18.986C54.4237 18.986 54.6834 18.8611 54.842 18.6112C55.0006 18.3614 55.0792 17.9888 55.0792 17.4947C55.0792 17.0035 54.9999 16.6358 54.8399 16.3895C54.6799 16.1446 54.4181 16.0218 54.0539 16.0218C53.6932 16.0218 53.4329 16.1439 53.2729 16.3874C53.1136 16.6316 53.0336 17.0007 53.0336 17.4947ZM56.4637 17.4947C56.4637 18.3025 56.2511 18.934 55.8251 19.3902C55.3992 19.8456 54.8055 20.0737 54.0455 20.0737C53.569 20.0737 53.1487 19.9691 52.7852 19.7607C52.4213 19.5526 52.1289 19.2392 51.9466 18.8618C51.7508 18.4716 51.6532 18.0154 51.6532 17.4947C51.6532 16.6842 51.8645 16.054 52.2876 15.6042C52.7108 15.1544 53.3059 14.9291 54.0722 14.9291C54.548 14.9291 54.9683 15.0337 55.3325 15.24C55.6967 15.447 55.976 15.7446 56.1711 16.1326C56.3662 16.52 56.4637 16.974 56.4637 17.4947ZM60.2364 14.9291C60.4202 14.9291 60.5725 14.9432 60.6939 14.9698L60.5915 16.2386C60.4608 16.2066 60.3266 16.1917 60.1922 16.1944C59.7606 16.1944 59.4238 16.3053 59.183 16.527C58.9416 16.7495 58.8209 17.0597 58.8209 17.4597V19.9846H57.4673V15.0225H58.4925L58.6918 15.8568H58.7585C58.9129 15.579 59.1206 15.3551 59.3823 15.1846C59.6356 15.0171 59.9327 14.9282 60.2364 14.9291ZM61.4638 19.9846H62.8174V13.0786H61.4638V19.9846ZM66.2076 18.9951C66.5536 18.9951 66.8076 18.894 66.969 18.6926C67.1304 18.4919 67.2181 18.1502 67.2329 17.6674V17.5214C67.2329 16.9888 67.1508 16.607 66.9866 16.3768C66.8223 16.1453 66.555 16.0302 66.1852 16.0302C65.8834 16.0302 65.649 16.1579 65.482 16.414C65.315 16.6702 65.2315 17.0421 65.2315 17.5305C65.2315 18.0183 65.3157 18.3846 65.4841 18.6288C65.6532 18.873 65.8939 18.9951 66.2076 18.9951ZM65.7325 20.0737C65.1494 20.0737 64.6918 19.847 64.3592 19.3944C64.0259 18.9418 63.8602 18.3144 63.8602 17.513C63.8602 16.699 64.0294 16.0646 64.3683 15.6112C64.7066 15.1565 65.1739 14.9291 65.7683 14.9291C66.3922 14.9291 66.8694 15.1719 67.1971 15.6575H67.242C67.1782 15.3312 67.1439 14.9999 67.1395 14.6674V13.0786H68.4974V19.9846H67.4588L67.1971 19.3411H67.1395C66.8322 19.8288 66.3627 20.0737 65.7325 20.0737ZM73.5713 19.9846H72.2176V13.4961H75.9369V14.6239H73.5713V16.2961H75.7727V17.4197H73.5713V19.9846ZM78.0478 17.4947C78.0478 17.9867 78.1285 18.3572 78.2899 18.6084C78.4506 18.8604 78.7137 18.986 79.0772 18.986C79.4379 18.986 79.6976 18.8611 79.8562 18.6112C80.0148 18.3614 80.0934 17.9888 80.0934 17.4947C80.0934 17.0035 80.0141 16.6358 79.8541 16.3895C79.6941 16.1446 79.4323 16.0218 79.0681 16.0218C78.7074 16.0218 78.4471 16.1439 78.2871 16.3874C78.1278 16.6316 78.0478 17.0007 78.0478 17.4947ZM81.4779 17.4947C81.4779 18.3025 81.2653 18.934 80.8393 19.3902C80.4134 19.8456 79.8197 20.0737 79.0597 20.0737C78.5832 20.0737 78.1628 19.9691 77.7993 19.7607C77.4351 19.5526 77.1432 19.2392 76.9607 18.8618C76.765 18.4716 76.6674 18.0154 76.6674 17.4947C76.6674 16.6842 76.8786 16.054 77.3018 15.6042C77.725 15.1544 78.32 14.9291 79.0864 14.9291C79.5628 14.9291 79.9825 15.0337 80.3467 15.24C80.7109 15.447 80.9902 15.7446 81.1853 16.1326C81.3804 16.52 81.4779 16.974 81.4779 17.4947ZM83.5902 17.4947C83.5902 17.9867 83.6709 18.3572 83.8316 18.6084C83.993 18.8604 84.2555 18.986 84.6197 18.986C84.9804 18.986 85.24 18.8611 85.3986 18.6112C85.5565 18.3614 85.6358 17.9888 85.6358 17.4947C85.6358 17.0035 85.5565 16.6358 85.3965 16.3895C85.2365 16.1446 84.9748 16.0218 84.6106 16.0218C84.2499 16.0218 83.9895 16.1439 83.8295 16.3874C83.6702 16.6316 83.5902 17.0007 83.5902 17.4947ZM87.0204 17.4947C87.0204 18.3025 86.8078 18.934 86.3818 19.3902C85.9558 19.8456 85.3622 20.0737 84.6021 20.0737C84.1257 20.0737 83.7053 19.9691 83.3418 19.7607C82.9776 19.5524 82.685 19.2391 82.5025 18.8618C82.3074 18.4716 82.2099 18.0154 82.2099 17.4947C82.2099 16.6842 82.4211 16.054 82.8443 15.6042C83.2674 15.1544 83.8618 14.9291 84.6288 14.9291C85.1046 14.9291 85.525 15.0337 85.8892 15.24C86.2534 15.447 86.5327 15.7446 86.7278 16.1326C86.9229 16.52 87.0204 16.974 87.0204 17.4947ZM90.1207 18.9951C90.4667 18.9951 90.72 18.894 90.8814 18.6926C91.0429 18.4919 91.1306 18.1502 91.146 17.6674V17.5214C91.146 16.9888 91.0639 16.607 90.8997 16.3768C90.7355 16.1453 90.4681 16.0302 90.0983 16.0302C89.7965 16.0302 89.5621 16.1579 89.3951 16.414C89.2274 16.6702 89.1439 17.0421 89.1439 17.5305C89.1439 18.0183 89.2281 18.3846 89.3972 18.6288C89.5657 18.873 89.8071 18.9951 90.1207 18.9951ZM89.6457 20.0737C89.0625 20.0737 88.605 19.847 88.2723 19.3944C87.939 18.9418 87.7727 18.3144 87.7727 17.513C87.7727 16.699 87.9418 16.0646 88.2807 15.6112C88.6197 15.1565 89.0864 14.9291 89.6807 14.9291C90.3053 14.9291 90.7818 15.1719 91.1102 15.6575H91.1551C91.0906 15.3313 91.0569 14.9999 91.0527 14.6674V13.0786H92.4106V19.9846H91.372L91.1102 19.3411H91.0527C90.7453 19.8288 90.2758 20.0737 89.6457 20.0737ZM44.9023 25.8323H45.355C45.7781 25.8323 46.0946 25.7488 46.3051 25.5818C46.515 25.4147 46.6202 25.1712 46.6202 24.8519C46.6202 24.5291 46.5318 24.2912 46.3557 24.1369C46.1795 23.9832 45.9044 23.9067 45.5283 23.9067H44.9023V25.8323ZM48.0097 24.8028C48.0097 25.5011 47.7908 26.0351 47.355 26.4056C46.9185 26.7754 46.2974 26.96 45.4932 26.96H44.9023V29.2681H43.5269V22.7797H45.5992C46.3865 22.7797 46.9851 22.9488 47.395 23.287C47.8048 23.6267 48.0097 24.1312 48.0097 24.8028ZM51.4385 24.2126C51.6223 24.2126 51.7746 24.226 51.8967 24.2526L51.7943 25.5221C51.6637 25.4899 51.5294 25.4748 51.395 25.4772C50.9627 25.4772 50.6259 25.5888 50.3844 25.8105C50.1437 26.0323 50.0237 26.3432 50.0237 26.7425V29.2681H48.6694V24.3053H49.6946L49.8946 25.1404H49.9613C50.115 24.8618 50.3234 24.6379 50.5852 24.4681C50.8381 24.3006 51.135 24.2117 51.4385 24.2126ZM53.4771 26.7783C53.4771 27.2695 53.5578 27.64 53.7185 27.8919C53.8799 28.1432 54.1423 28.2695 54.5059 28.2695C54.8673 28.2695 55.1269 28.1439 55.2855 27.8947C55.4434 27.6442 55.5234 27.2723 55.5234 26.7783C55.5234 26.287 55.4427 25.9186 55.2834 25.673C55.1234 25.4274 54.8616 25.3046 54.4981 25.3046C54.1367 25.3046 53.8764 25.4267 53.7164 25.6709C53.5571 25.9144 53.4771 26.2842 53.4771 26.7783ZM56.9073 26.7783C56.9073 27.5853 56.6946 28.2176 56.2687 28.673C55.8427 29.1284 55.249 29.3572 54.489 29.3572C54.0118 29.3572 53.5922 29.2519 53.228 29.0435C52.8642 28.8352 52.572 28.5218 52.3894 28.1446C52.1943 27.7551 52.0967 27.299 52.0967 26.7783C52.0967 25.9677 52.308 25.3369 52.7311 24.8877C53.1543 24.4379 53.7487 24.2126 54.515 24.2126C54.9922 24.2126 55.4118 24.3165 55.776 24.5235C56.139 24.7295 56.4314 25.0404 56.6146 25.4154C56.8104 25.8028 56.9073 26.2576 56.9073 26.7783ZM58.6329 25.9305C58.6329 26.2 58.6946 26.4126 58.8174 26.5691C58.9402 26.7263 59.1269 26.8049 59.3795 26.8049C59.6336 26.8049 59.8202 26.7263 59.9388 26.5691C60.0567 26.4126 60.1164 26.2 60.1164 25.9305C60.1164 25.3326 59.8701 25.0337 59.3795 25.0337C58.882 25.0337 58.6329 25.3326 58.6329 25.9305ZM58.1409 29.9691C58.1409 30.1551 58.2301 30.3018 58.409 30.4084C58.5887 30.5151 58.8392 30.5684 59.1613 30.5684C59.6469 30.5684 60.0273 30.5011 60.3023 30.3684C60.5774 30.2358 60.715 30.0533 60.715 29.8232C60.715 29.6365 60.6336 29.5074 60.4708 29.4365C60.308 29.3649 60.0567 29.3305 59.7164 29.3305H59.0146C58.7669 29.3305 58.5585 29.3888 58.3922 29.5053C58.2245 29.6225 58.1409 29.7769 58.1409 29.9691ZM61.9711 24.3053V24.9937L61.1943 25.1937C61.3367 25.4154 61.4069 25.6639 61.4069 25.9397C61.4069 26.4716 61.2216 26.8863 60.8497 27.1839C60.4792 27.4814 59.9634 27.6302 59.303 27.6302L59.0595 27.6169L58.8602 27.5944C58.7206 27.7011 58.6511 27.8197 58.6511 27.9502C58.6511 28.1446 58.8995 28.2428 59.3964 28.2428H60.2399C60.7845 28.2428 61.1999 28.36 61.4855 28.5937C61.7704 28.8274 61.9136 29.1705 61.9136 29.6232C61.9136 30.2028 61.6715 30.6526 61.188 30.9719C60.7038 31.2912 60.009 31.4512 59.1038 31.4512C58.4118 31.4512 57.8827 31.3305 57.5171 31.0898C57.1515 30.8491 56.969 30.5102 56.969 30.0758C56.969 29.7769 57.0623 29.527 57.249 29.3256C57.435 29.1249 57.7087 28.9804 58.0701 28.8947C57.9252 28.8317 57.7995 28.7314 57.7059 28.6042C57.6072 28.4832 57.5522 28.3323 57.5501 28.1762C57.5501 27.9867 57.6048 27.8295 57.715 27.7032C57.8244 27.5776 57.983 27.454 58.1901 27.3326C57.9313 27.2223 57.7143 27.0326 57.5704 26.7909C57.4181 26.5432 57.3416 26.2498 57.3416 25.9123C57.3416 25.3712 57.5178 24.9523 57.8701 24.6561C58.2216 24.3607 58.7248 24.2126 59.3795 24.2126C59.5178 24.2126 59.6827 24.2253 59.8743 24.2498C60.0645 24.2751 60.1866 24.294 60.2399 24.3053H61.9711ZM65.1831 24.2126C65.3669 24.2126 65.5192 24.226 65.6413 24.2526L65.5388 25.5221C65.4082 25.4899 65.274 25.4748 65.1395 25.4772C64.7073 25.4772 64.3704 25.5888 64.129 25.8105C63.8883 26.0323 63.7683 26.3432 63.7683 26.7425V29.2681H62.4139V24.3053H63.4392L63.6392 25.1404H63.7059C63.8595 24.8618 64.0673 24.6379 64.329 24.4681C64.5823 24.3007 64.8794 24.2119 65.1831 24.2126ZM68.8034 26.9684L68.2792 26.9867C67.8862 26.9979 67.5936 27.0695 67.4006 27.1993C67.2083 27.3298 67.1122 27.5277 67.1122 27.7944C67.1122 28.1761 67.3318 28.3663 67.7697 28.3663C68.0827 28.3663 68.3339 28.2772 68.5213 28.0961C68.7094 27.9158 68.8034 27.6758 68.8034 27.3769V26.9684ZM69.2027 29.2681L68.9409 28.5937H68.9059C68.6778 28.88 68.4434 29.0793 68.202 29.1902C67.9606 29.3018 67.6462 29.3572 67.2588 29.3572C66.7831 29.3572 66.4069 29.2204 66.1339 28.9488C65.8602 28.6765 65.7234 28.2884 65.7234 27.7853C65.7234 27.2583 65.908 26.8709 66.2757 26.6204C66.6441 26.3705 67.1992 26.2316 67.9424 26.2049L68.8034 26.1783V25.9614C68.8034 25.4583 68.5459 25.207 68.0315 25.207C67.6343 25.207 67.1683 25.3263 66.6336 25.5663L66.1852 24.6526C66.7557 24.3537 67.3894 24.2035 68.0841 24.2035C68.7501 24.2035 69.2609 24.3488 69.616 24.6386C69.9711 24.9284 70.148 25.3698 70.148 25.9614V29.2681H69.2027ZM75.5558 29.2681H74.2021V26.3698C74.2021 26.0119 74.1418 25.7432 74.0218 25.5635C73.9025 25.3846 73.7137 25.2962 73.4562 25.2962C73.1102 25.2962 72.859 25.4225 72.7018 25.6779C72.5453 25.9319 72.4667 26.3502 72.4667 26.9333V29.2681H71.1123V24.3053H72.1467L72.3292 24.9411H72.4043C72.5376 24.7123 72.7299 24.5347 72.9818 24.4056C73.2506 24.2727 73.5474 24.2065 73.8471 24.2126C74.5895 24.2126 75.092 24.4547 75.3558 24.9411H75.4751C75.6092 24.7102 75.8049 24.5312 76.0639 24.4035C76.3369 24.2727 76.6372 24.2074 76.9404 24.2126C77.5025 24.2126 77.9278 24.3572 78.2169 24.6456C78.5053 24.934 78.6492 25.3958 78.6492 26.0323V29.2681H77.2906V26.3698C77.2906 26.0119 77.2309 25.7432 77.1109 25.5635C76.9909 25.3846 76.8028 25.2962 76.5453 25.2962C76.2141 25.2962 75.9664 25.414 75.8021 25.6505C75.6379 25.887 75.5558 26.2625 75.5558 26.7783V29.2681ZM84.0569 29.2681H82.7032V26.3698C82.7032 26.0119 82.6429 25.7432 82.5229 25.5635C82.4035 25.3846 82.2148 25.2962 81.9579 25.2962C81.6113 25.2962 81.36 25.4225 81.2029 25.6779C81.0464 25.9319 80.9678 26.3502 80.9678 26.9333V29.2681H79.6141V24.3053H80.6478L80.8302 24.9411H80.906C81.0386 24.7123 81.2309 24.5347 81.4828 24.4056C81.7516 24.2727 82.0485 24.2065 82.3481 24.2126C83.0906 24.2126 83.5937 24.4547 83.8576 24.9411H83.9769C84.1102 24.7102 84.306 24.5312 84.565 24.4035C84.8379 24.2729 85.1383 24.2075 85.4414 24.2126C86.0036 24.2126 86.4295 24.3572 86.7179 24.6456C87.0064 24.934 87.1502 25.3958 87.1502 26.0323V29.2681H85.7916V26.3698C85.7916 26.0119 85.732 25.7432 85.6127 25.5635C85.4927 25.3846 85.3039 25.2962 85.0464 25.2962C84.7151 25.2962 84.4674 25.414 84.3032 25.6505C84.139 25.887 84.0569 26.2625 84.0569 26.7783V29.2681ZM90.2007 25.1761C89.9137 25.1761 89.6885 25.2674 89.5257 25.4484C89.3629 25.6309 89.2702 25.8884 89.2457 26.2232H91.1453C91.1404 25.8884 91.0527 25.6309 90.8836 25.4484C90.7151 25.2674 90.4878 25.1761 90.2007 25.1761ZM90.3909 29.3572C89.5923 29.3572 88.9678 29.1362 88.5179 28.6954C88.0688 28.254 87.8436 27.6302 87.8436 26.8225C87.8436 25.9909 88.0513 25.3481 88.4674 24.894C88.8829 24.44 89.4576 24.2126 90.1916 24.2126C90.8927 24.2126 91.4386 24.4126 91.8295 24.8119C92.2204 25.2112 92.4148 25.7635 92.4148 26.4674V27.1242H89.2148C89.2302 27.5088 89.3439 27.8098 89.5572 28.0253C89.7699 28.2414 90.0688 28.3488 90.4534 28.3488C90.7383 28.3504 91.0232 28.3191 91.3011 28.2554C91.5678 28.1937 91.845 28.0947 92.1355 27.9579V29.0063C91.8948 29.1263 91.6393 29.215 91.3762 29.2702C91.0513 29.3331 90.7215 29.3623 90.3909 29.3572Z",
          fill: "#C1C7CD"
        }
      ) }),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_376_19530", children: /* @__PURE__ */ w("rect", { width: "92.6316", height: "40", fill: "white" }) }) })
    ]
  }
), cg = ({ show: t, onClick: e }) => /* @__PURE__ */ ae("div", { className: "w-20 md:hidden px-6 py-2.5 bg-primary-dark relative", children: [
  /* @__PURE__ */ w(
    Za,
    {
      show: !t,
      className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
      enter: "transition-opacity ease-out duration-300",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0",
      leave: "transition-opacity ease-out duration-300",
      onClick: () => e(!0),
      children: /* @__PURE__ */ w(ag, {})
    }
  ),
  /* @__PURE__ */ w(
    Za,
    {
      show: t,
      className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
      enter: "transition-opacity ease-out duration-300",
      enterFrom: "opacity-0",
      enterTo: "opacity-100",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0",
      leave: "transition-opacity ease-out duration-300",
      onClick: () => e(!1),
      children: /* @__PURE__ */ w(sg, {})
    }
  )
] }), ug = ({ navItems: t }) => {
  const { pathname: e } = I1(), n = le(
    (i) => {
      const [r] = e.split("/").slice(-1), s = i.path.includes("/") ? i.path.split("/").slice(-1)[0] : i.path, a = r === "" ? i.path === "/" : s.includes(r);
      return de("p-3 flex items-center gap-2", {
        "bg-[#085387]": a
      });
    },
    [e]
  );
  return /* @__PURE__ */ w("nav", { className: "hidden md:block bg-zinc-900 bg-opacity-9", children: /* @__PURE__ */ w("ul", { className: "px-6 list-none flex items-center gap-6", children: t.map((i) => /* @__PURE__ */ ae(
    "li",
    {
      className: n(i),
      children: [
        i.icon,
        /* @__PURE__ */ w(
          To,
          {
            onClick: i.onClick,
            to: i.path,
            className: "text-base leading-normal",
            children: i.name
          }
        )
      ]
    },
    `navigation-${i.name}`
  )) }) });
}, ss = ({ to: t, mobile: e, onClick: n, icon: i, label: r, color: s }) => {
  const a = ne(
    () => de("w-40 h-14 items-center rounded-[2rem] px-6 py-2 my-auto", {
      "hidden md:flex justify-center": !e,
      "bg-primary-darker": s !== "green",
      "bg-[#1FA821]": s === "green",
      flex: e
    }),
    [e, s]
  ), o = ne(
    () => de("ml-2 uppercase leading-tight font-bold first-line:font-thin", {
      "inline-block": !e,
      "text-slate-100": e
    }),
    [e]
  );
  return /* @__PURE__ */ ae(To, { className: a, onClick: () => n == null ? void 0 : n(!1), to: t, children: [
    /* @__PURE__ */ w("div", { className: "text-slate-100 text-3xl flex items-center justify-center", children: i }),
    /* @__PURE__ */ w("div", { className: o, children: r })
  ] });
}, dg = ({
  show: t,
  showDOButton: e,
  onClick: n,
  username: i,
  navItems: r,
  lockLink: s,
  clientLink: a,
  logout: o
}) => /* @__PURE__ */ ae(
  Za,
  {
    show: t,
    onClick: () => n(!1),
    as: "aside",
    className: "bg-zinc-900 fixed top-16 h-full w-full z-30",
    enter: "transition-all ease-out duration-300",
    enterFrom: "-right-full",
    enterTo: "right-0",
    leave: "transition-all ease-out duration-300",
    leaveFrom: "right-0",
    leaveTo: "-right-full",
    children: [
      /* @__PURE__ */ w("div", { className: "px-6 py-4 bg-primary-darker", children: /* @__PURE__ */ ae("h3", { className: "text-slate-100 text-lg font-normal", children: [
        "Hello, ",
        /* @__PURE__ */ w("strong", { children: i })
      ] }) }),
      /* @__PURE__ */ w("ul", { className: "flex flex-col list-none border-b border-zinc-700", children: r.map((l) => /* @__PURE__ */ ae("li", { className: "p-6 flex gap-2", children: [
        l.icon,
        /* @__PURE__ */ w(
          To,
          {
            to: l.path,
            className: "text-slate-100 text-base font-semibold leading-normal",
            onClick: () => n(!1),
            children: l.name
          }
        )
      ] }, l.name)) }),
      e && /* @__PURE__ */ w("div", { className: "p-6 border-b border-zinc-700", children: /* @__PURE__ */ ae("div", { className: "flex flex-col gap-4", children: [
        a && /* @__PURE__ */ w(
          ss,
          {
            mobile: !0,
            to: a,
            onClick: n,
            icon: /* @__PURE__ */ w(Gd, {}),
            label: "MY EVENTS",
            color: "green"
          }
        ),
        s && /* @__PURE__ */ w(ss, { mobile: !0, to: s, onClick: n, icon: /* @__PURE__ */ w(qd, {}), label: "DIGITAL OFFICE" })
      ] }) }),
      /* @__PURE__ */ w("div", { className: "p-6", children: /* @__PURE__ */ w("h4", { className: "text-neutral-300 text-base leading-normal", onClick: o, children: "Log out" }) })
    ]
  }
), hg = or(
  ({ username: t, lockLink: e, clientLink: n, navItems: i, logoImg: r, logout: s }, a) => {
    const [o, l] = Be(!1), c = ne(
      () => de("text-white z-30 w-full", {
        relative: !o,
        fixed: o
      }),
      [o]
    );
    return /* @__PURE__ */ ae(on, { children: [
      /* @__PURE__ */ ae("header", { ref: a, className: c, children: [
        /* @__PURE__ */ ae("div", { className: "bg-[#0a6eb4] flex pl-4 sm:pl-8 h-[85px]", children: [
          /* @__PURE__ */ w(L1, { logoImg: r }),
          /* @__PURE__ */ ae("div", { className: "flex gap-8", children: [
            n && /* @__PURE__ */ w(ss, { to: n, icon: /* @__PURE__ */ w(Gd, {}), label: "MY EVENTS", color: "green" }),
            e && /* @__PURE__ */ w(ss, { to: e, icon: /* @__PURE__ */ w(qd, {}), label: "DIGITAL OFFICE" })
          ] }),
          /* @__PURE__ */ w(N1, { username: t, logout: s }),
          /* @__PURE__ */ w(cg, { show: o, onClick: l })
        ] }),
        /* @__PURE__ */ w(ug, { navItems: i })
      ] }),
      /* @__PURE__ */ w(
        dg,
        {
          username: t,
          navItems: i,
          lockLink: e,
          clientLink: n,
          logout: s,
          show: o,
          onClick: l
        }
      )
    ] });
  }
);
hg.displayName = "Header";
const Wl = ({ href: t, children: e }) => /* @__PURE__ */ w("a", { href: t, target: "_blank", className: "no-underline", rel: "noreferrer", children: e }), fg = or(
  ({ appVersion: t, termsOfUseLink: e, privacyPolicyLink: n }, i) => /* @__PURE__ */ ae(
    "footer",
    {
      ref: i,
      className: "px-8 py-3 bg-gray-darker border-t border-zinc-700 flex flex-col md:flex-row md:items-center gap-2.5",
      children: [
        /* @__PURE__ */ ae("div", { className: "flex items-center flex-1 gap-6", children: [
          /* @__PURE__ */ w("div", { className: "text-[40px] contents", children: /* @__PURE__ */ w(lg, {}) }),
          /* @__PURE__ */ ae("div", { className: "justify-start items-start gap-2 flex text-neutral-300 text-sm font-normal", children: [
            /* @__PURE__ */ w("span", { children: "2023 © WFP" }),
            /* @__PURE__ */ ae("span", { children: [
              "Ver. ",
              t
            ] })
          ] })
        ] }),
        /* @__PURE__ */ ae("div", { className: "flex items-center text-gray-lighter text-sm gap-2", children: [
          /* @__PURE__ */ w(Wl, { href: e, children: "Terms of Use" }),
          /* @__PURE__ */ w("div", { className: "w-px self-stretch bg-zinc-500" }),
          /* @__PURE__ */ w(Wl, { href: n, children: "Privacy policy" })
        ] })
      ]
    }
  )
);
fg.displayName = "Footer";
var ut = function() {
  return ut = Object.assign || function(e) {
    for (var n, i = 1, r = arguments.length; i < r; i++) {
      n = arguments[i];
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, ut.apply(this, arguments);
};
function Tn(t, e, n) {
  if (n || arguments.length === 2)
    for (var i = 0, r = e.length, s; i < r; i++)
      (s || !(i in e)) && (s || (s = Array.prototype.slice.call(e, 0, i)), s[i] = e[i]);
  return t.concat(s || Array.prototype.slice.call(e));
}
function gg(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return e[n] === void 0 && (e[n] = t(n)), e[n];
  };
}
var mg = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, pg = /* @__PURE__ */ gg(
  function(t) {
    return mg.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Te = "-ms-", zi = "-moz-", _e = "-webkit-", Zd = "comm", Bs = "rule", $o = "decl", bg = "@import", Jd = "@keyframes", vg = "@layer", Xd = Math.abs, Wo = String.fromCharCode, Ja = Object.assign;
function yg(t, e) {
  return Ge(t, 0) ^ 45 ? (((e << 2 ^ Ge(t, 0)) << 2 ^ Ge(t, 1)) << 2 ^ Ge(t, 2)) << 2 ^ Ge(t, 3) : 0;
}
function eh(t) {
  return t.trim();
}
function Vt(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function be(t, e, n) {
  return t.replace(e, n);
}
function jr(t, e, n) {
  return t.indexOf(e, n);
}
function Ge(t, e) {
  return t.charCodeAt(e) | 0;
}
function hi(t, e, n) {
  return t.slice(e, n);
}
function Ot(t) {
  return t.length;
}
function th(t) {
  return t.length;
}
function Li(t, e) {
  return e.push(t), t;
}
function xg(t, e) {
  return t.map(e).join("");
}
function Yl(t, e) {
  return t.filter(function(n) {
    return !Vt(n, e);
  });
}
var Ls = 1, fi = 1, nh = 0, xt = 0, We = 0, Ai = "";
function Ns(t, e, n, i, r, s, a, o) {
  return { value: t, root: e, parent: n, type: i, props: r, children: s, line: Ls, column: fi, length: a, return: "", siblings: o };
}
function Zt(t, e) {
  return Ja(Ns("", null, null, "", null, null, 0, t.siblings), t, { length: -t.length }, e);
}
function Un(t) {
  for (; t.root; )
    t = Zt(t.root, { children: [t] });
  Li(t, t.siblings);
}
function Ag() {
  return We;
}
function Cg() {
  return We = xt > 0 ? Ge(Ai, --xt) : 0, fi--, We === 10 && (fi = 1, Ls--), We;
}
function St() {
  return We = xt < nh ? Ge(Ai, xt++) : 0, fi++, We === 10 && (fi = 1, Ls++), We;
}
function Mn() {
  return Ge(Ai, xt);
}
function $r() {
  return xt;
}
function Vs(t, e) {
  return hi(Ai, t, e);
}
function Xa(t) {
  switch (t) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function wg(t) {
  return Ls = fi = 1, nh = Ot(Ai = t), xt = 0, [];
}
function Sg(t) {
  return Ai = "", t;
}
function la(t) {
  return eh(Vs(xt - 1, eo(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function Eg(t) {
  for (; (We = Mn()) && We < 33; )
    St();
  return Xa(t) > 2 || Xa(We) > 3 ? "" : " ";
}
function kg(t, e) {
  for (; --e && St() && !(We < 48 || We > 102 || We > 57 && We < 65 || We > 70 && We < 97); )
    ;
  return Vs(t, $r() + (e < 6 && Mn() == 32 && St() == 32));
}
function eo(t) {
  for (; St(); )
    switch (We) {
      case t:
        return xt;
      case 34:
      case 39:
        t !== 34 && t !== 39 && eo(We);
        break;
      case 40:
        t === 41 && eo(t);
        break;
      case 92:
        St();
        break;
    }
  return xt;
}
function _g(t, e) {
  for (; St() && t + We !== 57; )
    if (t + We === 84 && Mn() === 47)
      break;
  return "/*" + Vs(e, xt - 1) + "*" + Wo(t === 47 ? t : St());
}
function Mg(t) {
  for (; !Xa(Mn()); )
    St();
  return Vs(t, xt);
}
function Og(t) {
  return Sg(Wr("", null, null, null, [""], t = wg(t), 0, [0], t));
}
function Wr(t, e, n, i, r, s, a, o, l) {
  for (var c = 0, u = 0, d = a, h = 0, g = 0, b = 0, m = 1, p = 1, x = 1, C = 0, M = "", _ = r, A = s, E = i, P = M; p; )
    switch (b = C, C = St()) {
      case 40:
        if (b != 108 && Ge(P, d - 1) == 58) {
          jr(P += be(la(C), "&", "&\f"), "&\f", Xd(c ? o[c - 1] : 0)) != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += la(C);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += Eg(b);
        break;
      case 92:
        P += kg($r() - 1, 7);
        continue;
      case 47:
        switch (Mn()) {
          case 42:
          case 47:
            Li(Dg(_g(St(), $r()), e, n, l), l);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * m:
        o[c++] = Ot(P) * x;
      case 125 * m:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            p = 0;
          case 59 + u:
            x == -1 && (P = be(P, /\f/g, "")), g > 0 && Ot(P) - d && Li(g > 32 ? Ul(P + ";", i, n, d - 1, l) : Ul(be(P, " ", "") + ";", i, n, d - 2, l), l);
            break;
          case 59:
            P += ";";
          default:
            if (Li(E = zl(P, e, n, c, u, r, o, M, _ = [], A = [], d, s), s), C === 123)
              if (u === 0)
                Wr(P, e, E, E, _, s, d, o, A);
              else
                switch (h === 99 && Ge(P, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Wr(t, E, E, i && Li(zl(t, E, E, 0, 0, r, o, M, r, _ = [], d, A), A), r, A, d, o, i ? _ : A);
                    break;
                  default:
                    Wr(P, E, E, E, [""], A, 0, o, A);
                }
        }
        c = u = g = 0, m = x = 1, M = P = "", d = a;
        break;
      case 58:
        d = 1 + Ot(P), g = b;
      default:
        if (m < 1) {
          if (C == 123)
            --m;
          else if (C == 125 && m++ == 0 && Cg() == 125)
            continue;
        }
        switch (P += Wo(C), C * m) {
          case 38:
            x = u > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            o[c++] = (Ot(P) - 1) * x, x = 1;
            break;
          case 64:
            Mn() === 45 && (P += la(St())), h = Mn(), u = d = Ot(M = P += Mg($r())), C++;
            break;
          case 45:
            b === 45 && Ot(P) == 2 && (m = 0);
        }
    }
  return s;
}
function zl(t, e, n, i, r, s, a, o, l, c, u, d) {
  for (var h = r - 1, g = r === 0 ? s : [""], b = th(g), m = 0, p = 0, x = 0; m < i; ++m)
    for (var C = 0, M = hi(t, h + 1, h = Xd(p = a[m])), _ = t; C < b; ++C)
      (_ = eh(p > 0 ? g[C] + " " + M : be(M, /&\f/g, g[C]))) && (l[x++] = _);
  return Ns(t, e, n, r === 0 ? Bs : o, l, c, u, d);
}
function Dg(t, e, n, i) {
  return Ns(t, e, n, Zd, Wo(Ag()), hi(t, 2, -2), 0, i);
}
function Ul(t, e, n, i, r) {
  return Ns(t, e, n, $o, hi(t, 0, i), hi(t, i + 1, -1), i, r);
}
function ih(t, e, n) {
  switch (yg(t, e)) {
    case 5103:
      return _e + "print-" + t + t;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return _e + t + t;
    case 4789:
      return zi + t + t;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return _e + t + zi + t + Te + t + t;
    case 5936:
      switch (Ge(t, e + 11)) {
        case 114:
          return _e + t + Te + be(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        case 108:
          return _e + t + Te + be(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        case 45:
          return _e + t + Te + be(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
    case 6828:
    case 4268:
    case 2903:
      return _e + t + Te + t + t;
    case 6165:
      return _e + t + Te + "flex-" + t + t;
    case 5187:
      return _e + t + be(t, /(\w+).+(:[^]+)/, _e + "box-$1$2" + Te + "flex-$1$2") + t;
    case 5443:
      return _e + t + Te + "flex-item-" + be(t, /flex-|-self/g, "") + (Vt(t, /flex-|baseline/) ? "" : Te + "grid-row-" + be(t, /flex-|-self/g, "")) + t;
    case 4675:
      return _e + t + Te + "flex-line-pack" + be(t, /align-content|flex-|-self/g, "") + t;
    case 5548:
      return _e + t + Te + be(t, "shrink", "negative") + t;
    case 5292:
      return _e + t + Te + be(t, "basis", "preferred-size") + t;
    case 6060:
      return _e + "box-" + be(t, "-grow", "") + _e + t + Te + be(t, "grow", "positive") + t;
    case 4554:
      return _e + be(t, /([^-])(transform)/g, "$1" + _e + "$2") + t;
    case 6187:
      return be(be(be(t, /(zoom-|grab)/, _e + "$1"), /(image-set)/, _e + "$1"), t, "") + t;
    case 5495:
    case 3959:
      return be(t, /(image-set\([^]*)/, _e + "$1$`$1");
    case 4968:
      return be(be(t, /(.+:)(flex-)?(.*)/, _e + "box-pack:$3" + Te + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + _e + t + t;
    case 4200:
      if (!Vt(t, /flex-|baseline/))
        return Te + "grid-column-align" + hi(t, e) + t;
      break;
    case 2592:
    case 3360:
      return Te + be(t, "template-", "") + t;
    case 4384:
    case 3616:
      return n && n.some(function(i, r) {
        return e = r, Vt(i.props, /grid-\w+-end/);
      }) ? ~jr(t + (n = n[e].value), "span", 0) ? t : Te + be(t, "-start", "") + t + Te + "grid-row-span:" + (~jr(n, "span", 0) ? Vt(n, /\d+/) : +Vt(n, /\d+/) - +Vt(t, /\d+/)) + ";" : Te + be(t, "-start", "") + t;
    case 4896:
    case 4128:
      return n && n.some(function(i) {
        return Vt(i.props, /grid-\w+-start/);
      }) ? t : Te + be(be(t, "-end", "-span"), "span ", "") + t;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return be(t, /(.+)-inline(.+)/, _e + "$1$2") + t;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ot(t) - 1 - e > 6)
        switch (Ge(t, e + 1)) {
          case 109:
            if (Ge(t, e + 4) !== 45)
              break;
          case 102:
            return be(t, /(.+:)(.+)-([^]+)/, "$1" + _e + "$2-$3$1" + zi + (Ge(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
          case 115:
            return ~jr(t, "stretch", 0) ? ih(be(t, "stretch", "fill-available"), e, n) + t : t;
        }
      break;
    case 5152:
    case 5920:
      return be(t, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(i, r, s, a, o, l, c) {
        return Te + r + ":" + s + c + (a ? Te + r + "-span:" + (o ? l : +l - +s) + c : "") + t;
      });
    case 4949:
      if (Ge(t, e + 6) === 121)
        return be(t, ":", ":" + _e) + t;
      break;
    case 6444:
      switch (Ge(t, Ge(t, 14) === 45 ? 18 : 11)) {
        case 120:
          return be(t, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + _e + (Ge(t, 14) === 45 ? "inline-" : "") + "box$3$1" + _e + "$2$3$1" + Te + "$2box$3") + t;
        case 100:
          return be(t, ":", ":" + Te) + t;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return be(t, "scroll-", "scroll-snap-") + t;
  }
  return t;
}
function as(t, e) {
  for (var n = "", i = 0; i < t.length; i++)
    n += e(t[i], i, t, e) || "";
  return n;
}
function Pg(t, e, n, i) {
  switch (t.type) {
    case vg:
      if (t.children.length)
        break;
    case bg:
    case $o:
      return t.return = t.return || t.value;
    case Zd:
      return "";
    case Jd:
      return t.return = t.value + "{" + as(t.children, i) + "}";
    case Bs:
      if (!Ot(t.value = t.props.join(",")))
        return "";
  }
  return Ot(n = as(t.children, i)) ? t.return = t.value + "{" + n + "}" : "";
}
function Fg(t) {
  var e = th(t);
  return function(n, i, r, s) {
    for (var a = "", o = 0; o < e; o++)
      a += t[o](n, i, r, s) || "";
    return a;
  };
}
function Tg(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
function Ig(t, e, n, i) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case $o:
        t.return = ih(t.value, t.length, n);
        return;
      case Jd:
        return as([Zt(t, { value: be(t.value, "@", "@" + _e) })], i);
      case Bs:
        if (t.length)
          return xg(n = t.props, function(r) {
            switch (Vt(r, i = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Un(Zt(t, { props: [be(r, /:(read-\w+)/, ":" + zi + "$1")] })), Un(Zt(t, { props: [r] })), Ja(t, { props: Yl(n, i) });
                break;
              case "::placeholder":
                Un(Zt(t, { props: [be(r, /:(plac\w+)/, ":" + _e + "input-$1")] })), Un(Zt(t, { props: [be(r, /:(plac\w+)/, ":" + zi + "$1")] })), Un(Zt(t, { props: [be(r, /:(plac\w+)/, Te + "input-$1")] })), Un(Zt(t, { props: [r] })), Ja(t, { props: Yl(n, i) });
                break;
            }
            return "";
          });
    }
}
var Rg = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, In = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", rh = "active", sh = "data-styled-version", Hs = "6.1.11", Yo = `/*!sc*/
`, zo = typeof window < "u" && "HTMLElement" in window, Bg = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), Ql = /invalid hook call/i, br = /* @__PURE__ */ new Set(), Lg = function(t, e) {
  if (process.env.NODE_ENV !== "production") {
    var n = e ? ' with the id of "'.concat(e, '"') : "", i = "The component ".concat(t).concat(n, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, r = console.error;
    try {
      var s = !0;
      console.error = function(a) {
        for (var o = [], l = 1; l < arguments.length; l++)
          o[l - 1] = arguments[l];
        Ql.test(a) ? (s = !1, br.delete(i)) : r.apply(void 0, Tn([a], o, !1));
      }, Se(), s && !br.has(i) && (console.warn(i), br.add(i));
    } catch (a) {
      Ql.test(a.message) && br.delete(i);
    } finally {
      console.error = r;
    }
  }
}, js = Object.freeze([]), gi = Object.freeze({});
function Ng(t, e, n) {
  return n === void 0 && (n = gi), t.theme !== n.theme && t.theme || e || n.theme;
}
var to = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), Vg = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, Hg = /(^-|-$)/g;
function Kl(t) {
  return t.replace(Vg, "-").replace(Hg, "");
}
var jg = /(a)(d)/gi, vr = 52, Gl = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function no(t) {
  var e, n = "";
  for (e = Math.abs(t); e > vr; e = e / vr | 0)
    n = Gl(e % vr) + n;
  return (Gl(e % vr) + n).replace(jg, "$1-$2");
}
var ca, ah = 5381, Cn = function(t, e) {
  for (var n = e.length; n; )
    t = 33 * t ^ e.charCodeAt(--n);
  return t;
}, oh = function(t) {
  return Cn(ah, t);
};
function lh(t) {
  return no(oh(t) >>> 0);
}
function ch(t) {
  return process.env.NODE_ENV !== "production" && typeof t == "string" && t || t.displayName || t.name || "Component";
}
function ua(t) {
  return typeof t == "string" && (process.env.NODE_ENV === "production" || t.charAt(0) === t.charAt(0).toLowerCase());
}
var uh = typeof Symbol == "function" && Symbol.for, dh = uh ? Symbol.for("react.memo") : 60115, $g = uh ? Symbol.for("react.forward_ref") : 60112, Wg = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, Yg = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, hh = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, zg = ((ca = {})[$g] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ca[dh] = hh, ca);
function ql(t) {
  return ("type" in (e = t) && e.type.$$typeof) === dh ? hh : "$$typeof" in t ? zg[t.$$typeof] : Wg;
  var e;
}
var Ug = Object.defineProperty, Qg = Object.getOwnPropertyNames, Zl = Object.getOwnPropertySymbols, Kg = Object.getOwnPropertyDescriptor, Gg = Object.getPrototypeOf, Jl = Object.prototype;
function fh(t, e, n) {
  if (typeof e != "string") {
    if (Jl) {
      var i = Gg(e);
      i && i !== Jl && fh(t, i, n);
    }
    var r = Qg(e);
    Zl && (r = r.concat(Zl(e)));
    for (var s = ql(t), a = ql(e), o = 0; o < r.length; ++o) {
      var l = r[o];
      if (!(l in Yg || n && n[l] || a && l in a || s && l in s)) {
        var c = Kg(e, l);
        try {
          Ug(t, l, c);
        } catch {
        }
      }
    }
  }
  return t;
}
function mi(t) {
  return typeof t == "function";
}
function Uo(t) {
  return typeof t == "object" && "styledComponentId" in t;
}
function Sn(t, e) {
  return t && e ? "".concat(t, " ").concat(e) : t || e || "";
}
function io(t, e) {
  if (t.length === 0)
    return "";
  for (var n = t[0], i = 1; i < t.length; i++)
    n += t[i];
  return n;
}
function pi(t) {
  return t !== null && typeof t == "object" && t.constructor.name === Object.name && !("props" in t && t.$$typeof);
}
function ro(t, e, n) {
  if (n === void 0 && (n = !1), !n && !pi(t) && !Array.isArray(t))
    return e;
  if (Array.isArray(e))
    for (var i = 0; i < e.length; i++)
      t[i] = ro(t[i], e[i]);
  else if (pi(e))
    for (var i in e)
      t[i] = ro(t[i], e[i]);
  return t;
}
function Qo(t, e) {
  Object.defineProperty(t, "toString", { value: e });
}
var qg = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function Zg() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  for (var n = t[0], i = [], r = 1, s = t.length; r < s; r += 1)
    i.push(t[r]);
  return i.forEach(function(a) {
    n = n.replace(/%[a-z]/, a);
  }), n;
}
function Ci(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(e.length > 0 ? " Args: ".concat(e.join(", ")) : "")) : new Error(Zg.apply(void 0, Tn([qg[t]], e, !1)).trim());
}
var Jg = function() {
  function t(e) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
  }
  return t.prototype.indexOfGroup = function(e) {
    for (var n = 0, i = 0; i < e; i++)
      n += this.groupSizes[i];
    return n;
  }, t.prototype.insertRules = function(e, n) {
    if (e >= this.groupSizes.length) {
      for (var i = this.groupSizes, r = i.length, s = r; e >= s; )
        if ((s <<= 1) < 0)
          throw Ci(16, "".concat(e));
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(i), this.length = s;
      for (var a = r; a < s; a++)
        this.groupSizes[a] = 0;
    }
    for (var o = this.indexOfGroup(e + 1), l = (a = 0, n.length); a < l; a++)
      this.tag.insertRule(o, n[a]) && (this.groupSizes[e]++, o++);
  }, t.prototype.clearGroup = function(e) {
    if (e < this.length) {
      var n = this.groupSizes[e], i = this.indexOfGroup(e), r = i + n;
      this.groupSizes[e] = 0;
      for (var s = i; s < r; s++)
        this.tag.deleteRule(i);
    }
  }, t.prototype.getGroup = function(e) {
    var n = "";
    if (e >= this.length || this.groupSizes[e] === 0)
      return n;
    for (var i = this.groupSizes[e], r = this.indexOfGroup(e), s = r + i, a = r; a < s; a++)
      n += "".concat(this.tag.getRule(a)).concat(Yo);
    return n;
  }, t;
}(), Xg = 1 << 30, Yr = /* @__PURE__ */ new Map(), os = /* @__PURE__ */ new Map(), zr = 1, yr = function(t) {
  if (Yr.has(t))
    return Yr.get(t);
  for (; os.has(zr); )
    zr++;
  var e = zr++;
  if (process.env.NODE_ENV !== "production" && ((0 | e) < 0 || e > Xg))
    throw Ci(16, "".concat(e));
  return Yr.set(t, e), os.set(e, t), e;
}, e0 = function(t, e) {
  zr = e + 1, Yr.set(t, e), os.set(e, t);
}, t0 = "style[".concat(In, "][").concat(sh, '="').concat(Hs, '"]'), n0 = new RegExp("^".concat(In, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), i0 = function(t, e, n) {
  for (var i, r = n.split(","), s = 0, a = r.length; s < a; s++)
    (i = r[s]) && t.registerName(e, i);
}, r0 = function(t, e) {
  for (var n, i = ((n = e.textContent) !== null && n !== void 0 ? n : "").split(Yo), r = [], s = 0, a = i.length; s < a; s++) {
    var o = i[s].trim();
    if (o) {
      var l = o.match(n0);
      if (l) {
        var c = 0 | parseInt(l[1], 10), u = l[2];
        c !== 0 && (e0(u, c), i0(t, u, l[3]), t.getTag().insertRules(c, r)), r.length = 0;
      } else
        r.push(o);
    }
  }
};
function s0() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var gh = function(t) {
  var e = document.head, n = t || e, i = document.createElement("style"), r = function(o) {
    var l = Array.from(o.querySelectorAll("style[".concat(In, "]")));
    return l[l.length - 1];
  }(n), s = r !== void 0 ? r.nextSibling : null;
  i.setAttribute(In, rh), i.setAttribute(sh, Hs);
  var a = s0();
  return a && i.setAttribute("nonce", a), n.insertBefore(i, s), i;
}, a0 = function() {
  function t(e) {
    this.element = gh(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(n) {
      if (n.sheet)
        return n.sheet;
      for (var i = document.styleSheets, r = 0, s = i.length; r < s; r++) {
        var a = i[r];
        if (a.ownerNode === n)
          return a;
      }
      throw Ci(17);
    }(this.element), this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    try {
      return this.sheet.insertRule(n, e), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.prototype.deleteRule = function(e) {
    this.sheet.deleteRule(e), this.length--;
  }, t.prototype.getRule = function(e) {
    var n = this.sheet.cssRules[e];
    return n && n.cssText ? n.cssText : "";
  }, t;
}(), o0 = function() {
  function t(e) {
    this.element = gh(e), this.nodes = this.element.childNodes, this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    if (e <= this.length && e >= 0) {
      var i = document.createTextNode(n);
      return this.element.insertBefore(i, this.nodes[e] || null), this.length++, !0;
    }
    return !1;
  }, t.prototype.deleteRule = function(e) {
    this.element.removeChild(this.nodes[e]), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.nodes[e].textContent : "";
  }, t;
}(), l0 = function() {
  function t(e) {
    this.rules = [], this.length = 0;
  }
  return t.prototype.insertRule = function(e, n) {
    return e <= this.length && (this.rules.splice(e, 0, n), this.length++, !0);
  }, t.prototype.deleteRule = function(e) {
    this.rules.splice(e, 1), this.length--;
  }, t.prototype.getRule = function(e) {
    return e < this.length ? this.rules[e] : "";
  }, t;
}(), Xl = zo, c0 = { isServer: !zo, useCSSOMInjection: !Bg }, mh = function() {
  function t(e, n, i) {
    e === void 0 && (e = gi), n === void 0 && (n = {});
    var r = this;
    this.options = ut(ut({}, c0), e), this.gs = n, this.names = new Map(i), this.server = !!e.isServer, !this.server && zo && Xl && (Xl = !1, function(s) {
      for (var a = document.querySelectorAll(t0), o = 0, l = a.length; o < l; o++) {
        var c = a[o];
        c && c.getAttribute(In) !== rh && (r0(s, c), c.parentNode && c.parentNode.removeChild(c));
      }
    }(this)), Qo(this, function() {
      return function(s) {
        for (var a = s.getTag(), o = a.length, l = "", c = function(d) {
          var h = function(x) {
            return os.get(x);
          }(d);
          if (h === void 0)
            return "continue";
          var g = s.names.get(h), b = a.getGroup(d);
          if (g === void 0 || b.length === 0)
            return "continue";
          var m = "".concat(In, ".g").concat(d, '[id="').concat(h, '"]'), p = "";
          g !== void 0 && g.forEach(function(x) {
            x.length > 0 && (p += "".concat(x, ","));
          }), l += "".concat(b).concat(m, '{content:"').concat(p, '"}').concat(Yo);
        }, u = 0; u < o; u++)
          c(u);
        return l;
      }(r);
    });
  }
  return t.registerId = function(e) {
    return yr(e);
  }, t.prototype.reconstructWithOptions = function(e, n) {
    return n === void 0 && (n = !0), new t(ut(ut({}, this.options), e), this.gs, n && this.names || void 0);
  }, t.prototype.allocateGSInstance = function(e) {
    return this.gs[e] = (this.gs[e] || 0) + 1;
  }, t.prototype.getTag = function() {
    return this.tag || (this.tag = (e = function(n) {
      var i = n.useCSSOMInjection, r = n.target;
      return n.isServer ? new l0(r) : i ? new a0(r) : new o0(r);
    }(this.options), new Jg(e)));
    var e;
  }, t.prototype.hasNameForId = function(e, n) {
    return this.names.has(e) && this.names.get(e).has(n);
  }, t.prototype.registerName = function(e, n) {
    if (yr(e), this.names.has(e))
      this.names.get(e).add(n);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(n), this.names.set(e, i);
    }
  }, t.prototype.insertRules = function(e, n, i) {
    this.registerName(e, n), this.getTag().insertRules(yr(e), i);
  }, t.prototype.clearNames = function(e) {
    this.names.has(e) && this.names.get(e).clear();
  }, t.prototype.clearRules = function(e) {
    this.getTag().clearGroup(yr(e)), this.clearNames(e);
  }, t.prototype.clearTag = function() {
    this.tag = void 0;
  }, t;
}(), u0 = /&/g, d0 = /^\s*\/\/.*$/gm;
function ph(t, e) {
  return t.map(function(n) {
    return n.type === "rule" && (n.value = "".concat(e, " ").concat(n.value), n.value = n.value.replaceAll(",", ",".concat(e, " ")), n.props = n.props.map(function(i) {
      return "".concat(e, " ").concat(i);
    })), Array.isArray(n.children) && n.type !== "@keyframes" && (n.children = ph(n.children, e)), n;
  });
}
function h0(t) {
  var e, n, i, r = gi, s = r.options, a = s === void 0 ? gi : s, o = r.plugins, l = o === void 0 ? js : o, c = function(h, g, b) {
    return b.startsWith(n) && b.endsWith(n) && b.replaceAll(n, "").length > 0 ? ".".concat(e) : h;
  }, u = l.slice();
  u.push(function(h) {
    h.type === Bs && h.value.includes("&") && (h.props[0] = h.props[0].replace(u0, n).replace(i, c));
  }), a.prefix && u.push(Ig), u.push(Pg);
  var d = function(h, g, b, m) {
    g === void 0 && (g = ""), b === void 0 && (b = ""), m === void 0 && (m = "&"), e = m, n = g, i = new RegExp("\\".concat(n, "\\b"), "g");
    var p = h.replace(d0, ""), x = Og(b || g ? "".concat(b, " ").concat(g, " { ").concat(p, " }") : p);
    a.namespace && (x = ph(x, a.namespace));
    var C = [];
    return as(x, Fg(u.concat(Tg(function(M) {
      return C.push(M);
    })))), C;
  };
  return d.hash = l.length ? l.reduce(function(h, g) {
    return g.name || Ci(15), Cn(h, g.name);
  }, ah).toString() : "", d;
}
var f0 = new mh(), so = h0(), bh = re.createContext({ shouldForwardProp: void 0, styleSheet: f0, stylis: so });
bh.Consumer;
re.createContext(void 0);
function ec() {
  return Et(bh);
}
var ao = function() {
  function t(e, n) {
    var i = this;
    this.inject = function(r, s) {
      s === void 0 && (s = so);
      var a = i.name + s.hash;
      r.hasNameForId(i.id, a) || r.insertRules(i.id, a, s(i.rules, a, "@keyframes"));
    }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = n, Qo(this, function() {
      throw Ci(12, String(i.name));
    });
  }
  return t.prototype.getName = function(e) {
    return e === void 0 && (e = so), this.name + e.hash;
  }, t;
}(), g0 = function(t) {
  return t >= "A" && t <= "Z";
};
function tc(t) {
  for (var e = "", n = 0; n < t.length; n++) {
    var i = t[n];
    if (n === 1 && i === "-" && t[0] === "-")
      return t;
    g0(i) ? e += "-" + i.toLowerCase() : e += i;
  }
  return e.startsWith("ms-") ? "-" + e : e;
}
var vh = function(t) {
  return t == null || t === !1 || t === "";
}, yh = function(t) {
  var e, n, i = [];
  for (var r in t) {
    var s = t[r];
    t.hasOwnProperty(r) && !vh(s) && (Array.isArray(s) && s.isCss || mi(s) ? i.push("".concat(tc(r), ":"), s, ";") : pi(s) ? i.push.apply(i, Tn(Tn(["".concat(r, " {")], yh(s), !1), ["}"], !1)) : i.push("".concat(tc(r), ": ").concat((e = r, (n = s) == null || typeof n == "boolean" || n === "" ? "" : typeof n != "number" || n === 0 || e in Rg || e.startsWith("--") ? String(n).trim() : "".concat(n, "px")), ";")));
  }
  return i;
};
function On(t, e, n, i) {
  if (vh(t))
    return [];
  if (Uo(t))
    return [".".concat(t.styledComponentId)];
  if (mi(t)) {
    if (!mi(s = t) || s.prototype && s.prototype.isReactComponent || !e)
      return [t];
    var r = t(e);
    return process.env.NODE_ENV === "production" || typeof r != "object" || Array.isArray(r) || r instanceof ao || pi(r) || r === null || console.error("".concat(ch(t), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), On(r, e, n, i);
  }
  var s;
  return t instanceof ao ? n ? (t.inject(n, i), [t.getName(i)]) : [t] : pi(t) ? yh(t) : Array.isArray(t) ? Array.prototype.concat.apply(js, t.map(function(a) {
    return On(a, e, n, i);
  })) : [t.toString()];
}
function m0(t) {
  for (var e = 0; e < t.length; e += 1) {
    var n = t[e];
    if (mi(n) && !Uo(n))
      return !1;
  }
  return !0;
}
var p0 = oh(Hs), b0 = function() {
  function t(e, n, i) {
    this.rules = e, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (i === void 0 || i.isStatic) && m0(e), this.componentId = n, this.baseHash = Cn(p0, n), this.baseStyle = i, mh.registerId(n);
  }
  return t.prototype.generateAndInjectStyles = function(e, n, i) {
    var r = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, n, i) : "";
    if (this.isStatic && !i.hash)
      if (this.staticRulesId && n.hasNameForId(this.componentId, this.staticRulesId))
        r = Sn(r, this.staticRulesId);
      else {
        var s = io(On(this.rules, e, n, i)), a = no(Cn(this.baseHash, s) >>> 0);
        if (!n.hasNameForId(this.componentId, a)) {
          var o = i(s, ".".concat(a), void 0, this.componentId);
          n.insertRules(this.componentId, a, o);
        }
        r = Sn(r, a), this.staticRulesId = a;
      }
    else {
      for (var l = Cn(this.baseHash, i.hash), c = "", u = 0; u < this.rules.length; u++) {
        var d = this.rules[u];
        if (typeof d == "string")
          c += d, process.env.NODE_ENV !== "production" && (l = Cn(l, d));
        else if (d) {
          var h = io(On(d, e, n, i));
          l = Cn(l, h + u), c += h;
        }
      }
      if (c) {
        var g = no(l >>> 0);
        n.hasNameForId(this.componentId, g) || n.insertRules(this.componentId, g, i(c, ".".concat(g), void 0, this.componentId)), r = Sn(r, g);
      }
    }
    return r;
  }, t;
}(), xh = re.createContext(void 0);
xh.Consumer;
var da = {}, nc = /* @__PURE__ */ new Set();
function v0(t, e, n) {
  var i = Uo(t), r = t, s = !ua(t), a = e.attrs, o = a === void 0 ? js : a, l = e.componentId, c = l === void 0 ? function(_, A) {
    var E = typeof _ != "string" ? "sc" : Kl(_);
    da[E] = (da[E] || 0) + 1;
    var P = "".concat(E, "-").concat(lh(Hs + E + da[E]));
    return A ? "".concat(A, "-").concat(P) : P;
  }(e.displayName, e.parentComponentId) : l, u = e.displayName, d = u === void 0 ? function(_) {
    return ua(_) ? "styled.".concat(_) : "Styled(".concat(ch(_), ")");
  }(t) : u, h = e.displayName && e.componentId ? "".concat(Kl(e.displayName), "-").concat(e.componentId) : e.componentId || c, g = i && r.attrs ? r.attrs.concat(o).filter(Boolean) : o, b = e.shouldForwardProp;
  if (i && r.shouldForwardProp) {
    var m = r.shouldForwardProp;
    if (e.shouldForwardProp) {
      var p = e.shouldForwardProp;
      b = function(_, A) {
        return m(_, A) && p(_, A);
      };
    } else
      b = m;
  }
  var x = new b0(n, h, i ? r.componentStyle : void 0);
  function C(_, A) {
    return function(E, P, I) {
      var U = E.attrs, Q = E.componentStyle, T = E.defaultProps, Y = E.foldedComponentIds, q = E.styledComponentId, $ = E.target, N = re.useContext(xh), R = ec(), B = E.shouldForwardProp || R.shouldForwardProp;
      process.env.NODE_ENV !== "production" && Rl(q);
      var j = Ng(P, N, T) || gi, y = function(V, z, H) {
        for (var K, Z = ut(ut({}, z), { className: void 0, theme: H }), G = 0; G < V.length; G += 1) {
          var X = mi(K = V[G]) ? K(Z) : K;
          for (var W in X)
            Z[W] = W === "className" ? Sn(Z[W], X[W]) : W === "style" ? ut(ut({}, Z[W]), X[W]) : X[W];
        }
        return z.className && (Z.className = Sn(Z.className, z.className)), Z;
      }(U, P, j), v = y.as || $, k = {};
      for (var S in y)
        y[S] === void 0 || S[0] === "$" || S === "as" || S === "theme" && y.theme === j || (S === "forwardedAs" ? k.as = y.forwardedAs : B && !B(S, v) || (k[S] = y[S], B || process.env.NODE_ENV !== "development" || pg(S) || nc.has(S) || !to.has(v) || (nc.add(S), console.warn('styled-components: it looks like an unknown prop "'.concat(S, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var f = function(V, z) {
        var H = ec(), K = V.generateAndInjectStyles(z, H.styleSheet, H.stylis);
        return process.env.NODE_ENV !== "production" && Rl(K), K;
      }(Q, y);
      process.env.NODE_ENV !== "production" && E.warnTooManyClasses && E.warnTooManyClasses(f);
      var D = Sn(Y, q);
      return f && (D += " " + f), y.className && (D += " " + y.className), k[ua(v) && !to.has(v) ? "class" : "className"] = D, k.ref = I, Id(v, k);
    }(M, _, A);
  }
  C.displayName = d;
  var M = re.forwardRef(C);
  return M.attrs = g, M.componentStyle = x, M.displayName = d, M.shouldForwardProp = b, M.foldedComponentIds = i ? Sn(r.foldedComponentIds, r.styledComponentId) : "", M.styledComponentId = h, M.target = i ? r.target : t, Object.defineProperty(M, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(_) {
    this._foldedDefaultProps = i ? function(A) {
      for (var E = [], P = 1; P < arguments.length; P++)
        E[P - 1] = arguments[P];
      for (var I = 0, U = E; I < U.length; I++)
        ro(A, U[I], !0);
      return A;
    }({}, r.defaultProps, _) : _;
  } }), process.env.NODE_ENV !== "production" && (Lg(d, h), M.warnTooManyClasses = /* @__PURE__ */ function(_, A) {
    var E = {}, P = !1;
    return function(I) {
      if (!P && (E[I] = !0, Object.keys(E).length >= 200)) {
        var U = A ? ' with the id of "'.concat(A, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(_).concat(U, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), P = !0, E = {};
      }
    };
  }(d, h)), Qo(M, function() {
    return ".".concat(M.styledComponentId);
  }), s && fh(M, t, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), M;
}
function ic(t, e) {
  for (var n = [t[0]], i = 0, r = e.length; i < r; i += 1)
    n.push(e[i], t[i + 1]);
  return n;
}
var rc = function(t) {
  return Object.assign(t, { isCss: !0 });
};
function Ah(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  if (mi(t) || pi(t))
    return rc(On(ic(js, Tn([t], e, !0))));
  var i = t;
  return e.length === 0 && i.length === 1 && typeof i[0] == "string" ? On(i) : rc(On(ic(i, e)));
}
function oo(t, e, n) {
  if (n === void 0 && (n = gi), !e)
    throw Ci(1, e);
  var i = function(r) {
    for (var s = [], a = 1; a < arguments.length; a++)
      s[a - 1] = arguments[a];
    return t(e, n, Ah.apply(void 0, Tn([r], s, !1)));
  };
  return i.attrs = function(r) {
    return oo(t, e, ut(ut({}, n), { attrs: Array.prototype.concat(n.attrs, r).filter(Boolean) }));
  }, i.withConfig = function(r) {
    return oo(t, e, ut(ut({}, n), r));
  }, i;
}
var Ch = function(t) {
  return oo(v0, t);
}, Hn = Ch;
to.forEach(function(t) {
  Hn[t] = Ch(t);
});
function Ko(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var i = io(Ah.apply(void 0, Tn([t], e, !1))), r = lh(i);
  return new ao(r, i);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var xr = "__sc-".concat(In, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[xr] || (window[xr] = 0), window[xr] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[xr] += 1);
const y0 = "#4fa94d", x0 = {
  "aria-busy": !0,
  role: "progressbar"
}, A0 = Hn.div`
  display: ${(t) => t.$visible ? "flex" : "none"};
`, C0 = "http://www.w3.org/2000/svg", wt = 242.776657104492, w0 = 1.6, S0 = Ko`
12.5% {
  stroke-dasharray: ${wt * 0.14}px, ${wt}px;
  stroke-dashoffset: -${wt * 0.11}px;
}
43.75% {
  stroke-dasharray: ${wt * 0.35}px, ${wt}px;
  stroke-dashoffset: -${wt * 0.35}px;
}
100% {
  stroke-dasharray: ${wt * 0.01}px, ${wt}px;
  stroke-dashoffset: -${wt * 0.99}px;
}
`;
Hn.path`
  stroke-dasharray: ${wt * 0.01}px, ${wt};
  stroke-dashoffset: 0;
  animation: ${S0} ${w0}s linear infinite;
`;
const E0 = Ko`
to {
   transform: rotate(360deg);
 }
`;
Hn.svg`
  animation: ${E0} 0.75s steps(12, end) infinite;
  animation-duration: 0.75s;
`;
Hn.polyline`
  stroke-width: ${(t) => t.width}px;
  stroke-linecap: round;

  &:nth-child(12n + 0) {
    stroke-opacity: 0.08;
  }

  &:nth-child(12n + 1) {
    stroke-opacity: 0.17;
  }

  &:nth-child(12n + 2) {
    stroke-opacity: 0.25;
  }

  &:nth-child(12n + 3) {
    stroke-opacity: 0.33;
  }

  &:nth-child(12n + 4) {
    stroke-opacity: 0.42;
  }

  &:nth-child(12n + 5) {
    stroke-opacity: 0.5;
  }

  &:nth-child(12n + 6) {
    stroke-opacity: 0.58;
  }

  &:nth-child(12n + 7) {
    stroke-opacity: 0.66;
  }

  &:nth-child(12n + 8) {
    stroke-opacity: 0.75;
  }

  &:nth-child(12n + 9) {
    stroke-opacity: 0.83;
  }

  &:nth-child(12n + 11) {
    stroke-opacity: 0.92;
  }
`;
const k0 = ({ height: t = 80, width: e = 80, strokeWidth: n = 2, radius: i = 1, color: r = y0, ariaLabel: s = "tail-spin-loading", wrapperStyle: a, wrapperClass: o, visible: l = !0 }) => {
  const c = parseInt(String(n)), u = c + 36, d = c / 2, h = d + parseInt(String(i)) - 1;
  return /* @__PURE__ */ w(A0, {
    style: a,
    $visible: l,
    className: o,
    "data-testid": "tail-spin-loading",
    "aria-label": s,
    ...x0,
    children: /* @__PURE__ */ ae("svg", {
      width: e,
      height: t,
      viewBox: `0 0 ${u} ${u}`,
      xmlns: C0,
      "data-testid": "tail-spin-svg",
      children: [
        /* @__PURE__ */ w("defs", {
          children: /* @__PURE__ */ ae("linearGradient", {
            x1: "8.042%",
            y1: "0%",
            x2: "65.682%",
            y2: "23.865%",
            id: "a",
            children: [
              /* @__PURE__ */ w("stop", {
                stopColor: r,
                stopOpacity: "0",
                offset: "0%"
              }),
              /* @__PURE__ */ w("stop", {
                stopColor: r,
                stopOpacity: ".631",
                offset: "63.146%"
              }),
              /* @__PURE__ */ w("stop", {
                stopColor: r,
                offset: "100%"
              })
            ]
          })
        }),
        /* @__PURE__ */ w("g", {
          fill: "none",
          fillRule: "evenodd",
          children: /* @__PURE__ */ ae("g", {
            transform: `translate(${d} ${d})`,
            children: [
              /* @__PURE__ */ w("path", {
                d: "M36 18c0-9.94-8.06-18-18-18",
                id: "Oval-2",
                stroke: r,
                strokeWidth: n,
                children: /* @__PURE__ */ w("animateTransform", {
                  attributeName: "transform",
                  type: "rotate",
                  from: "0 18 18",
                  to: "360 18 18",
                  dur: "0.9s",
                  repeatCount: "indefinite"
                })
              }),
              /* @__PURE__ */ w("circle", {
                fill: "#fff",
                cx: "36",
                cy: "18",
                r: h,
                children: /* @__PURE__ */ w("animateTransform", {
                  attributeName: "transform",
                  type: "rotate",
                  from: "0 18 18",
                  to: "360 18 18",
                  dur: "0.9s",
                  repeatCount: "indefinite"
                })
              })
            ]
          })
        })
      ]
    })
  });
}, _0 = Ko`
to {
   stroke-dashoffset: 136;
 }
`;
Hn.polygon`
  stroke-dasharray: 17;
  animation: ${_0} 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;
`;
Hn.svg`
  transform-origin: 50% 65%;
`;
function Dy({
  containerClassName: t,
  fullWidth: e,
  ...n
}) {
  return /* @__PURE__ */ w(
    "div",
    {
      className: de(t, {
        "content flex items-center justify-center bg-zinc-800": e
      }),
      children: /* @__PURE__ */ w(
        k0,
        {
          height: 100,
          width: 100,
          color: "#007DBC",
          ariaLabel: "tail-spin-loading",
          radius: 2,
          visible: !0,
          ...n
        }
      )
    }
  );
}
function M0(t) {
  if (Array.isArray(t)) {
    for (var e = 0, n = new Array(t.length); e < t.length; e++)
      n[e] = t[e];
    return n;
  }
}
function O0(t) {
  if (Symbol.iterator in Object(t) || Object.prototype.toString.call(t) === "[object Arguments]")
    return Array.from(t);
}
function D0() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function ls(t) {
  return M0(t) || O0(t) || D0();
}
function yt() {
  return yt = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, yt.apply(this, arguments);
}
function P0(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function F0(t, e) {
  for (var n = 0; n < e.length; n++) {
    var i = e[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function T0(t, e, n) {
  return e && F0(t.prototype, e), t;
}
function xe(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function lo(t, e) {
  return lo = Object.setPrototypeOf || function(i, r) {
    return i.__proto__ = r, i;
  }, lo(t, e);
}
function I0(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), e && lo(t, e);
}
function si(t) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? si = function(n) {
    return typeof n;
  } : si = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, si(t);
}
function Ur(t) {
  return typeof Symbol == "function" && si(Symbol.iterator) === "symbol" ? Ur = function(n) {
    return si(n);
  } : Ur = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : si(n);
  }, Ur(t);
}
function R0(t, e) {
  return e && (Ur(e) === "object" || typeof e == "function") ? e : xe(t);
}
function cs(t) {
  return cs = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, cs(t);
}
function ye(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var B0 = function(t, e, n, i, r, s, a, o) {
  if (process.env.NODE_ENV !== "production" && e === void 0)
    throw new Error("invariant requires an error message argument");
  if (!t) {
    var l;
    if (e === void 0)
      l = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    else {
      var c = [n, i, r, s, a, o], u = 0;
      l = new Error(
        e.replace(/%s/g, function() {
          return c[u++];
        })
      ), l.name = "Invariant Violation";
    }
    throw l.framesToPop = 1, l;
  }
}, wh = B0;
const bi = /* @__PURE__ */ Ut(wh);
function L0(t) {
  if (Array.isArray(t))
    return t;
}
function N0(t, e) {
  var n = [], i = !0, r = !1, s = void 0;
  try {
    for (var a = t[Symbol.iterator](), o; !(i = (o = a.next()).done) && (n.push(o.value), !(e && n.length === e)); i = !0)
      ;
  } catch (l) {
    r = !0, s = l;
  } finally {
    try {
      !i && a.return != null && a.return();
    } finally {
      if (r)
        throw s;
    }
  }
  return n;
}
function V0() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function us(t, e) {
  return L0(t) || N0(t, e) || V0();
}
function H0(t, e) {
  if (t == null)
    return {};
  var n = {}, i = Object.keys(t), r, s;
  for (s = 0; s < i.length; s++)
    r = i[s], !(e.indexOf(r) >= 0) && (n[r] = t[r]);
  return n;
}
function j0(t, e) {
  if (t == null)
    return {};
  var n = H0(t, e), i, r;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(t);
    for (r = 0; r < s.length; r++)
      i = s[r], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (n[i] = t[i]);
  }
  return n;
}
function Xi(t) {
  "@babel/helpers - typeof";
  return Xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xi(t);
}
function $0(t, e) {
  if (Xi(t) != "object" || !t)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e || "default");
    if (Xi(i) != "object")
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function W0(t) {
  var e = $0(t, "string");
  return Xi(e) == "symbol" ? e : e + "";
}
function er(t, e, n) {
  return e = W0(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function co(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, i = new Array(e); n < e; n++)
    i[n] = t[n];
  return i;
}
function Y0(t) {
  if (Array.isArray(t))
    return co(t);
}
function z0(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function U0(t, e) {
  if (t) {
    if (typeof t == "string")
      return co(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return co(t, e);
  }
}
function Q0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wt(t) {
  return Y0(t) || z0(t) || U0(t) || Q0();
}
var wi = function(e) {
  return e === Object(e) ? Object.keys(e) : [];
}, Sh = function(e) {
  return e === Object(e) ? Object.values(e) : [];
};
function Eh(t, e) {
  var n = Object.assign({}, t);
  return Qr(t) && Qr(e) && wi(e).forEach(function(i) {
    Qr(e[i]) ? i in t ? n[i] = Eh(t[i], e[i]) : Object.assign(n, er({}, i, e[i])) : Object.assign(n, er({}, i, e[i]));
  }), n;
}
var uo = function(e) {
  for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)
    i[r - 1] = arguments[r];
  return i.reduce(function(s, a) {
    return Eh(s, a);
  }, e);
}, K0 = function(e, n) {
  var i = Object.assign({}, e);
  if (n)
    for (var r = 0; r < n.length; r++)
      delete i[n[r]];
  return i;
}, Qr = function(e) {
  return e === Object(e) && !(e instanceof Date) && !Array.isArray(e);
}, G0 = function(e) {
  return (e || []).filter(Boolean);
}, Go = function(e) {
  return e[0] === "&";
}, q0 = function(e) {
  return !Go(e);
}, sc = function(e) {
  return e.replace(/-(\w)/g, function(n, i) {
    return i.toUpperCase();
  });
}, Z0 = function(e) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = wi(e), r = {}, s = 0, a = i.length; s < a; s += 1) {
    var o = i[s], l = Object.prototype.toString.call(e[o]) !== "[object Object]" || // style defs
    o[0] === ":" || // pseudo selectors
    o[0] === "@" || // @media / @keyframes / @supports / @font-face
    n.indexOf(o) >= 0;
    l && (r[o] = e[o]);
  }
  return r;
}, kh = function(e, n) {
  for (var i = n.map(sc), r = wi(e), s = {}, a = 0, o = r.length; a < o; a += 1) {
    var l = r[a];
    (n.indexOf(l) >= 0 || i.indexOf(sc(l)) >= 0) && (s[l] = e[l]);
  }
  return s;
}, J0 = function t(e, n) {
  for (var i = uo.apply(void 0, [{}, K0(e, n)].concat(Wt(Sh(kh(e, n))))), r = wi(i).filter(Go), s = 0, a = r.length; s < a; s += 1) {
    var o = r[s], l = t(i[o], n);
    n.indexOf(o) >= 0 ? (delete i[o], i = uo({}, i, l)) : i[o] = l;
  }
  return i;
};
function ac(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function oc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ac(Object(n), !0).forEach(function(i) {
      er(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ac(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var X0 = ["animationName"], _h = function(e) {
  var n = e.style, i = e.className;
  return oc(oc({}, n ? {
    style: Z0(n, X0)
  } : {}), i ? {
    className: i
  } : {});
}, Mh = /* @__PURE__ */ zt(_h);
Mh.Provider;
var Oh = function(e) {
  if (e) {
    if (typeof e == "string")
      return [e];
    if (!Array.isArray(e)) {
      var n = e;
      return wi(e).reduce(function(i, r) {
        return i.concat(n[r] ? [r] : []);
      }, []);
    }
  } else
    return [];
  return e;
}, em = {}, tm = function(e) {
  return function(n, i) {
    var r = i || em;
    e.memoize = e.memoize || /* @__PURE__ */ new WeakMap();
    var s;
    e.memoize.has(r) ? s = e.memoize.get(r) : (s = {}, e.memoize.set(r, s));
    var a = Oh(n).join(" ");
    return a in s ? s[a] : s[a] = e(n || [], i);
  };
};
function lc(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Qn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? lc(Object(n), !0).forEach(function(i) {
      er(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : lc(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var nm = function(e) {
  var n = e && wi(e)[0];
  return n && n.split("__")[0].split("--")[0];
}, im = function(e, n, i) {
  if (e) {
    var r = e.split(" ")[0], s = [].concat(Wt(n.length === 0 ? i.map(function(a) {
      return "".concat(r, "--").concat(a.substring(1));
    }) : []), Wt(n.map(function(a) {
      return "".concat(r, "__").concat(a);
    })));
    return n.length === 0 ? [e].concat(Wt(s)) : s;
  }
};
function Dh(t) {
  var e = t.style, n = t.className, i = t.classNames, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _h, s = n || nm(i) || (e == null ? void 0 : e.className), a = typeof e == "function" ? e : tm(function(d, h) {
    var g = Oh(d);
    bi(Array.isArray(g), "First parameter must be a string, an array of strings, a plain object with boolean values, or a falsy value."), bi(!h || Qr(h), "Optional second parameter must be a plain object.");
    var b = g.filter(Go), m = g.filter(q0), p = m.length > 0 ? function(M) {
      return Sh(kh(M, m));
    } : function(M) {
      return [M];
    }, x = function() {
      var _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return p(J0(_, b));
    }, C = im(s, m, b);
    return Dh(Qn(Qn(Qn({}, (e || h) && {
      style: uo.apply(void 0, [{}].concat(Wt(x(h)), Wt(x(e))))
    }), C && {
      className: C.join(" ")
    }), i && {
      classNames: i
    }), r);
  }), o = Qn({}, typeof e == "function" ? e : {
    style: e
  }), l = Wt(new Set([].concat(Wt(o.className ? o.className.split(" ") : []), Wt(s ? s.split(" ") : [])))), c = i ? G0(l.map(function(d) {
    return i[d];
  })) : l, u = r(Qn(Qn({}, o), c.length > 0 ? {
    className: c.join(" ")
  } : {}));
  return Object.assign(a, u), a;
}
function cc(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Oi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cc(Object(n), !0).forEach(function(i) {
      er(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : cc(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var rm = function() {
  for (var e = arguments.length, n = new Array(e), i = 0; i < e; i++)
    n[i] = arguments[i];
  return n.reduce(function(r, s) {
    return Oi(Oi(Oi({}, r), typeof s == "function" ? s : {}), {}, {
      style: Oi(Oi({}, r.style), typeof s == "function" ? s.style : s)
    });
  }, {});
}, qo = function(e, n, i) {
  var r = n.style, s = n.className, a = n.classNames, o = Et(Mh), l = ne(function() {
    return Dh({
      style: r,
      className: s,
      classNames: a
    }, o);
  }, [r, s, a, o]);
  return l(i, e);
}, ho = { exports: {} }, Ar = { exports: {} }, Ee = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uc;
function sm() {
  if (uc)
    return Ee;
  uc = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, r = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, o = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, p = t ? Symbol.for("react.fundamental") : 60117, x = t ? Symbol.for("react.responder") : 60118, C = t ? Symbol.for("react.scope") : 60119;
  function M(A) {
    if (typeof A == "object" && A !== null) {
      var E = A.$$typeof;
      switch (E) {
        case e:
          switch (A = A.type, A) {
            case l:
            case c:
            case i:
            case s:
            case r:
            case d:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case o:
                case u:
                case b:
                case g:
                case a:
                  return A;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function _(A) {
    return M(A) === c;
  }
  return Ee.AsyncMode = l, Ee.ConcurrentMode = c, Ee.ContextConsumer = o, Ee.ContextProvider = a, Ee.Element = e, Ee.ForwardRef = u, Ee.Fragment = i, Ee.Lazy = b, Ee.Memo = g, Ee.Portal = n, Ee.Profiler = s, Ee.StrictMode = r, Ee.Suspense = d, Ee.isAsyncMode = function(A) {
    return _(A) || M(A) === l;
  }, Ee.isConcurrentMode = _, Ee.isContextConsumer = function(A) {
    return M(A) === o;
  }, Ee.isContextProvider = function(A) {
    return M(A) === a;
  }, Ee.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === e;
  }, Ee.isForwardRef = function(A) {
    return M(A) === u;
  }, Ee.isFragment = function(A) {
    return M(A) === i;
  }, Ee.isLazy = function(A) {
    return M(A) === b;
  }, Ee.isMemo = function(A) {
    return M(A) === g;
  }, Ee.isPortal = function(A) {
    return M(A) === n;
  }, Ee.isProfiler = function(A) {
    return M(A) === s;
  }, Ee.isStrictMode = function(A) {
    return M(A) === r;
  }, Ee.isSuspense = function(A) {
    return M(A) === d;
  }, Ee.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === i || A === c || A === s || A === r || A === d || A === h || typeof A == "object" && A !== null && (A.$$typeof === b || A.$$typeof === g || A.$$typeof === a || A.$$typeof === o || A.$$typeof === u || A.$$typeof === p || A.$$typeof === x || A.$$typeof === C || A.$$typeof === m);
  }, Ee.typeOf = M, Ee;
}
var ke = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dc;
function am() {
  return dc || (dc = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, r = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, o = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, b = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, p = t ? Symbol.for("react.fundamental") : 60117, x = t ? Symbol.for("react.responder") : 60118, C = t ? Symbol.for("react.scope") : 60119;
    function M(W) {
      return typeof W == "string" || typeof W == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      W === i || W === c || W === s || W === r || W === d || W === h || typeof W == "object" && W !== null && (W.$$typeof === b || W.$$typeof === g || W.$$typeof === a || W.$$typeof === o || W.$$typeof === u || W.$$typeof === p || W.$$typeof === x || W.$$typeof === C || W.$$typeof === m);
    }
    function _(W) {
      if (typeof W == "object" && W !== null) {
        var ie = W.$$typeof;
        switch (ie) {
          case e:
            var J = W.type;
            switch (J) {
              case l:
              case c:
              case i:
              case s:
              case r:
              case d:
                return J;
              default:
                var ce = J && J.$$typeof;
                switch (ce) {
                  case o:
                  case u:
                  case b:
                  case g:
                  case a:
                    return ce;
                  default:
                    return ie;
                }
            }
          case n:
            return ie;
        }
      }
    }
    var A = l, E = c, P = o, I = a, U = e, Q = u, T = i, Y = b, q = g, $ = n, N = s, R = r, B = d, j = !1;
    function y(W) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), v(W) || _(W) === l;
    }
    function v(W) {
      return _(W) === c;
    }
    function k(W) {
      return _(W) === o;
    }
    function S(W) {
      return _(W) === a;
    }
    function f(W) {
      return typeof W == "object" && W !== null && W.$$typeof === e;
    }
    function D(W) {
      return _(W) === u;
    }
    function V(W) {
      return _(W) === i;
    }
    function z(W) {
      return _(W) === b;
    }
    function H(W) {
      return _(W) === g;
    }
    function K(W) {
      return _(W) === n;
    }
    function Z(W) {
      return _(W) === s;
    }
    function G(W) {
      return _(W) === r;
    }
    function X(W) {
      return _(W) === d;
    }
    ke.AsyncMode = A, ke.ConcurrentMode = E, ke.ContextConsumer = P, ke.ContextProvider = I, ke.Element = U, ke.ForwardRef = Q, ke.Fragment = T, ke.Lazy = Y, ke.Memo = q, ke.Portal = $, ke.Profiler = N, ke.StrictMode = R, ke.Suspense = B, ke.isAsyncMode = y, ke.isConcurrentMode = v, ke.isContextConsumer = k, ke.isContextProvider = S, ke.isElement = f, ke.isForwardRef = D, ke.isFragment = V, ke.isLazy = z, ke.isMemo = H, ke.isPortal = K, ke.isProfiler = Z, ke.isStrictMode = G, ke.isSuspense = X, ke.isValidElementType = M, ke.typeOf = _;
  }()), ke;
}
var hc;
function Ph() {
  return hc || (hc = 1, process.env.NODE_ENV === "production" ? Ar.exports = sm() : Ar.exports = am()), Ar.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ha, fc;
function om() {
  if (fc)
    return ha;
  fc = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function r() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var a = {}, o = 0; o < 10; o++)
        a["_" + String.fromCharCode(o)] = o;
      var l = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ha = r() ? Object.assign : function(s, a) {
    for (var o, l = i(s), c, u = 1; u < arguments.length; u++) {
      o = Object(arguments[u]);
      for (var d in o)
        e.call(o, d) && (l[d] = o[d]);
      if (t) {
        c = t(o);
        for (var h = 0; h < c.length; h++)
          n.call(o, c[h]) && (l[c[h]] = o[c[h]]);
      }
    }
    return l;
  }, ha;
}
var fa, gc;
function Zo() {
  if (gc)
    return fa;
  gc = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return fa = t, fa;
}
var ga, mc;
function Fh() {
  return mc || (mc = 1, ga = Function.call.bind(Object.prototype.hasOwnProperty)), ga;
}
var ma, pc;
function lm() {
  if (pc)
    return ma;
  pc = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Zo(), n = {}, i = Fh();
    t = function(s) {
      var a = "Warning: " + s;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function r(s, a, o, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (i(s, u)) {
          var d;
          try {
            if (typeof s[u] != "function") {
              var h = Error(
                (l || "React class") + ": " + o + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = s[u](a, u, l, o, null, e);
          } catch (b) {
            d = b;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + o + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var g = c ? c() : "";
            t(
              "Failed " + o + " type: " + d.message + (g ?? "")
            );
          }
        }
    }
  }
  return r.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, ma = r, ma;
}
var pa, bc;
function cm() {
  if (bc)
    return pa;
  bc = 1;
  var t = Ph(), e = om(), n = Zo(), i = Fh(), r = lm(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(o) {
    var l = "Warning: " + o;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return pa = function(o, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(v) {
      var k = v && (c && v[c] || v[u]);
      if (typeof k == "function")
        return k;
    }
    var h = "<<anonymous>>", g = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: C(),
      arrayOf: M,
      element: _(),
      elementType: A(),
      instanceOf: E,
      node: Q(),
      objectOf: I,
      oneOf: P,
      oneOfType: U,
      shape: Y,
      exact: q
    };
    function b(v, k) {
      return v === k ? v !== 0 || 1 / v === 1 / k : v !== v && k !== k;
    }
    function m(v, k) {
      this.message = v, this.data = k && typeof k == "object" ? k : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function p(v) {
      if (process.env.NODE_ENV !== "production")
        var k = {}, S = 0;
      function f(V, z, H, K, Z, G, X) {
        if (K = K || h, G = G || H, X !== n) {
          if (l) {
            var W = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw W.name = "Invariant Violation", W;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ie = K + ":" + H;
            !k[ie] && // Avoid spamming the console because they are often not actionable except for lib authors
            S < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + G + "` prop on `" + K + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), k[ie] = !0, S++);
          }
        }
        return z[H] == null ? V ? z[H] === null ? new m("The " + Z + " `" + G + "` is marked as required " + ("in `" + K + "`, but its value is `null`.")) : new m("The " + Z + " `" + G + "` is marked as required in " + ("`" + K + "`, but its value is `undefined`.")) : null : v(z, H, K, Z, G);
      }
      var D = f.bind(null, !1);
      return D.isRequired = f.bind(null, !0), D;
    }
    function x(v) {
      function k(S, f, D, V, z, H) {
        var K = S[f], Z = R(K);
        if (Z !== v) {
          var G = B(K);
          return new m(
            "Invalid " + V + " `" + z + "` of type " + ("`" + G + "` supplied to `" + D + "`, expected ") + ("`" + v + "`."),
            { expectedType: v }
          );
        }
        return null;
      }
      return p(k);
    }
    function C() {
      return p(a);
    }
    function M(v) {
      function k(S, f, D, V, z) {
        if (typeof v != "function")
          return new m("Property `" + z + "` of component `" + D + "` has invalid PropType notation inside arrayOf.");
        var H = S[f];
        if (!Array.isArray(H)) {
          var K = R(H);
          return new m("Invalid " + V + " `" + z + "` of type " + ("`" + K + "` supplied to `" + D + "`, expected an array."));
        }
        for (var Z = 0; Z < H.length; Z++) {
          var G = v(H, Z, D, V, z + "[" + Z + "]", n);
          if (G instanceof Error)
            return G;
        }
        return null;
      }
      return p(k);
    }
    function _() {
      function v(k, S, f, D, V) {
        var z = k[S];
        if (!o(z)) {
          var H = R(z);
          return new m("Invalid " + D + " `" + V + "` of type " + ("`" + H + "` supplied to `" + f + "`, expected a single ReactElement."));
        }
        return null;
      }
      return p(v);
    }
    function A() {
      function v(k, S, f, D, V) {
        var z = k[S];
        if (!t.isValidElementType(z)) {
          var H = R(z);
          return new m("Invalid " + D + " `" + V + "` of type " + ("`" + H + "` supplied to `" + f + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return p(v);
    }
    function E(v) {
      function k(S, f, D, V, z) {
        if (!(S[f] instanceof v)) {
          var H = v.name || h, K = y(S[f]);
          return new m("Invalid " + V + " `" + z + "` of type " + ("`" + K + "` supplied to `" + D + "`, expected ") + ("instance of `" + H + "`."));
        }
        return null;
      }
      return p(k);
    }
    function P(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), a;
      function k(S, f, D, V, z) {
        for (var H = S[f], K = 0; K < v.length; K++)
          if (b(H, v[K]))
            return null;
        var Z = JSON.stringify(v, function(X, W) {
          var ie = B(W);
          return ie === "symbol" ? String(W) : W;
        });
        return new m("Invalid " + V + " `" + z + "` of value `" + String(H) + "` " + ("supplied to `" + D + "`, expected one of " + Z + "."));
      }
      return p(k);
    }
    function I(v) {
      function k(S, f, D, V, z) {
        if (typeof v != "function")
          return new m("Property `" + z + "` of component `" + D + "` has invalid PropType notation inside objectOf.");
        var H = S[f], K = R(H);
        if (K !== "object")
          return new m("Invalid " + V + " `" + z + "` of type " + ("`" + K + "` supplied to `" + D + "`, expected an object."));
        for (var Z in H)
          if (i(H, Z)) {
            var G = v(H, Z, D, V, z + "." + Z, n);
            if (G instanceof Error)
              return G;
          }
        return null;
      }
      return p(k);
    }
    function U(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var k = 0; k < v.length; k++) {
        var S = v[k];
        if (typeof S != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + j(S) + " at index " + k + "."
          ), a;
      }
      function f(D, V, z, H, K) {
        for (var Z = [], G = 0; G < v.length; G++) {
          var X = v[G], W = X(D, V, z, H, K, n);
          if (W == null)
            return null;
          W.data && i(W.data, "expectedType") && Z.push(W.data.expectedType);
        }
        var ie = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new m("Invalid " + H + " `" + K + "` supplied to " + ("`" + z + "`" + ie + "."));
      }
      return p(f);
    }
    function Q() {
      function v(k, S, f, D, V) {
        return $(k[S]) ? null : new m("Invalid " + D + " `" + V + "` supplied to " + ("`" + f + "`, expected a ReactNode."));
      }
      return p(v);
    }
    function T(v, k, S, f, D) {
      return new m(
        (v || "React class") + ": " + k + " type `" + S + "." + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + D + "`."
      );
    }
    function Y(v) {
      function k(S, f, D, V, z) {
        var H = S[f], K = R(H);
        if (K !== "object")
          return new m("Invalid " + V + " `" + z + "` of type `" + K + "` " + ("supplied to `" + D + "`, expected `object`."));
        for (var Z in v) {
          var G = v[Z];
          if (typeof G != "function")
            return T(D, V, z, Z, B(G));
          var X = G(H, Z, D, V, z + "." + Z, n);
          if (X)
            return X;
        }
        return null;
      }
      return p(k);
    }
    function q(v) {
      function k(S, f, D, V, z) {
        var H = S[f], K = R(H);
        if (K !== "object")
          return new m("Invalid " + V + " `" + z + "` of type `" + K + "` " + ("supplied to `" + D + "`, expected `object`."));
        var Z = e({}, S[f], v);
        for (var G in Z) {
          var X = v[G];
          if (i(v, G) && typeof X != "function")
            return T(D, V, z, G, B(X));
          if (!X)
            return new m(
              "Invalid " + V + " `" + z + "` key `" + G + "` supplied to `" + D + "`.\nBad object: " + JSON.stringify(S[f], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(v), null, "  ")
            );
          var W = X(H, G, D, V, z + "." + G, n);
          if (W)
            return W;
        }
        return null;
      }
      return p(k);
    }
    function $(v) {
      switch (typeof v) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !v;
        case "object":
          if (Array.isArray(v))
            return v.every($);
          if (v === null || o(v))
            return !0;
          var k = d(v);
          if (k) {
            var S = k.call(v), f;
            if (k !== v.entries) {
              for (; !(f = S.next()).done; )
                if (!$(f.value))
                  return !1;
            } else
              for (; !(f = S.next()).done; ) {
                var D = f.value;
                if (D && !$(D[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function N(v, k) {
      return v === "symbol" ? !0 : k ? k["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && k instanceof Symbol : !1;
    }
    function R(v) {
      var k = typeof v;
      return Array.isArray(v) ? "array" : v instanceof RegExp ? "object" : N(k, v) ? "symbol" : k;
    }
    function B(v) {
      if (typeof v > "u" || v === null)
        return "" + v;
      var k = R(v);
      if (k === "object") {
        if (v instanceof Date)
          return "date";
        if (v instanceof RegExp)
          return "regexp";
      }
      return k;
    }
    function j(v) {
      var k = B(v);
      switch (k) {
        case "array":
        case "object":
          return "an " + k;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + k;
        default:
          return k;
      }
    }
    function y(v) {
      return !v.constructor || !v.constructor.name ? h : v.constructor.name;
    }
    return g.checkPropTypes = r, g.resetWarningCache = r.resetWarningCache, g.PropTypes = g, g;
  }, pa;
}
var ba, vc;
function um() {
  if (vc)
    return ba;
  vc = 1;
  var t = Zo();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, ba = function() {
    function i(a, o, l, c, u, d) {
      if (d !== t) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    i.isRequired = i;
    function r() {
      return i;
    }
    var s = {
      array: i,
      bigint: i,
      bool: i,
      func: i,
      number: i,
      object: i,
      string: i,
      symbol: i,
      any: i,
      arrayOf: r,
      element: i,
      elementType: i,
      instanceOf: r,
      node: i,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, ba;
}
if (process.env.NODE_ENV !== "production") {
  var dm = Ph(), hm = !0;
  ho.exports = cm()(dm.isElement, hm);
} else
  ho.exports = um()();
var fm = ho.exports;
const oe = /* @__PURE__ */ Ut(fm);
var Kr = function(e) {
  return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}, Dt = {
  id: "__id__",
  display: "__display__"
}, yc = function(e, n) {
  bi(n === "id" || n === "display", 'Second arg must be either "id" or "display", got: "'.concat(n, '"'));
  var i = e.indexOf(Dt.display), r = e.indexOf(Dt.id);
  return i < 0 && (i = null), r < 0 && (r = null), bi(i !== null || r !== null, "The markup '".concat(e, "' does not contain either of the placeholders '__id__' or '__display__'")), i !== null && r !== null ? n === "id" && r <= i || n === "display" && i <= r ? 0 : 1 : 0;
}, gm = function(e) {
  var n = /^\/(.+)\/(\w+)?$/;
  return new RegExp(e.map(function(i) {
    var r = n.exec(i.toString()), s = us(r, 3), a = s[1], o = s[2];
    return bi(!o, "RegExp flags are not supported. Change /".concat(a, "/").concat(o, " into /").concat(a, "/")), "(".concat(a, ")");
  }).join("|"), "g");
}, Th = function(e) {
  var n = 0;
  return e.indexOf("__id__") >= 0 && n++, e.indexOf("__display__") >= 0 && n++, n;
}, mm = function() {
}, ur = function(e, n, i) {
  for (var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : mm, s = gm(n.map(function(A) {
    return A.regex;
  })), a = 2, o = n.map(function(A) {
    var E = A.markup, P = a;
    return a += Th(E) + 1, P;
  }), l, c = 0, u = 0; (l = s.exec(e)) !== null; ) {
    var d = o.find(function(A) {
      return !!l[A];
    }), h = o.indexOf(d), g = n[h], b = g.markup, m = g.displayTransform, p = d + yc(b, "id"), x = d + yc(b, "display"), C = l[p], M = m(C, l[x]), _ = e.substring(c, l.index);
    r(_, c, u), u += _.length, i(l[0], l.index, u, C, M, h, c), u += M.length, c = s.lastIndex;
  }
  c < e.length && r(e.substring(c), c, u);
}, wn = function(e, n) {
  var i = "";
  return ur(e, n, function(r, s, a, o, l) {
    i += l;
  }, function(r) {
    i += r;
  }), i;
}, nt = function(e, n, i) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "START";
  if (typeof i != "number")
    return i;
  var s, a = function(c, u, d) {
    s === void 0 && d + c.length >= i && (s = u + i - d);
  }, o = function(c, u, d, h, g, b, m) {
    s === void 0 && d + g.length > i && (r === "NULL" ? s = null : s = u + (r === "END" ? c.length : 0));
  };
  return ur(e, n, o, a), s === void 0 ? e.length : s;
}, Ui = function(e, n, i, r) {
  return e.substring(0, n) + r + e.substring(i);
}, pm = function(e, n, i, r) {
  var s = i.selectionStartBefore, a = i.selectionEndBefore, o = i.selectionEndAfter, l = wn(e, r), c = l.length - n.length;
  s === "undefined" && (s = o + c), a === "undefined" && (a = s), s === a && a === o && l.length === n.length && (s = s - 1);
  var u = n.slice(s, o), d = Math.min(s, o), h = a;
  s === o && (h = Math.max(a, s + c));
  var g = nt(e, r, d, "START"), b = nt(e, r, h, "END"), m = nt(e, r, d, "NULL"), p = nt(e, r, h, "NULL"), x = m === null || p === null, C = Ui(e, g, b, u);
  if (!x) {
    var M = wn(C, r);
    if (M !== n) {
      for (d = 0; n[d] === M[d]; )
        d++;
      u = n.slice(d, o), h = l.lastIndexOf(n.substring(o)), g = nt(e, r, d, "START"), b = nt(e, r, h, "END"), C = Ui(e, g, b, u);
    }
  }
  return C;
}, xc = function(e, n, i) {
  var r = i, s = !1, a = function(l, c, u, d, h, g, b) {
    u <= i && u + h.length > i && (r = u, s = !0);
  };
  if (ur(e, n, a), s)
    return r;
}, Ni = function(e, n) {
  var i = [];
  return ur(e, n, function(r, s, a, o, l, c, u) {
    i.push({
      id: o,
      display: l,
      childIndex: c,
      index: s,
      plainTextIndex: a
    });
  }), i;
}, Ih = function(e, n) {
  return "".concat(e, "-").concat(n);
}, Cr = function(e) {
  return Object.values(e).reduce(function(n, i) {
    var r = i.results;
    return n + r.length;
  }, 0);
}, bm = function(e, n) {
  var i = Ni(e, n), r = i[i.length - 1];
  return r ? r.plainTextIndex + r.display.length : 0;
}, vm = function(e) {
  var n = Kr(e), i = e[e.indexOf(Dt.display) + Dt.display.length], r = e[e.indexOf(Dt.id) + Dt.id.length];
  return new RegExp(n.replace(Dt.display, "([^".concat(Kr(i || ""), "]+?)")).replace(Dt.id, "([^".concat(Kr(r || ""), "]+?)")));
}, Jt = function(e) {
  return Ji.toArray(e).map(function(n) {
    var i = n.props, r = i.markup, s = i.regex, a = i.displayTransform;
    return {
      markup: r,
      regex: s ? ym(s, r) : vm(r),
      displayTransform: a || function(o, l) {
        return l || o;
      }
    };
  });
}, ym = function(e, n) {
  var i = new RegExp(e.toString() + "|").exec("").length - 1, r = Th(n);
  return bi(i === r, "Number of capturing groups in RegExp ".concat(e.toString(), " (").concat(i, ") does not match the number of placeholders in the markup '").concat(n, "' (").concat(r, ")")), e;
}, xm = function(e, n, i) {
  return e.replace(Dt.id, n).replace(Dt.display, i);
}, Am = [{
  base: "A",
  letters: /(&#65;|&#9398;|&#65313;|&#192;|&#193;|&#194;|&#7846;|&#7844;|&#7850;|&#7848;|&#195;|&#256;|&#258;|&#7856;|&#7854;|&#7860;|&#7858;|&#550;|&#480;|&#196;|&#478;|&#7842;|&#197;|&#506;|&#461;|&#512;|&#514;|&#7840;|&#7852;|&#7862;|&#7680;|&#260;|&#570;|&#11375;|[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F])/g
}, {
  base: "AA",
  letters: /(&#42802;|[\uA732])/g
}, {
  base: "AE",
  letters: /(&#198;|&#508;|&#482;|[\u00C6\u01FC\u01E2])/g
}, {
  base: "AO",
  letters: /(&#42804;|[\uA734])/g
}, {
  base: "AU",
  letters: /(&#42806;|[\uA736])/g
}, {
  base: "AV",
  letters: /(&#42808;|&#42810;|[\uA738\uA73A])/g
}, {
  base: "AY",
  letters: /(&#42812;|[\uA73C])/g
}, {
  base: "B",
  letters: /(&#66;|&#9399;|&#65314;|&#7682;|&#7684;|&#7686;|&#579;|&#386;|&#385;|[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181])/g
}, {
  base: "C",
  letters: /(&#67;|&#9400;|&#65315;|&#262;|&#264;|&#266;|&#268;|&#199;|&#7688;|&#391;|&#571;|&#42814;|[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E])/g
}, {
  base: "D",
  letters: /(&#68;|&#9401;|&#65316;|&#7690;|&#270;|&#7692;|&#7696;|&#7698;|&#7694;|&#272;|&#395;|&#394;|&#393;|&#42873;|&#208;|[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0])/g
}, {
  base: "DZ",
  letters: /(&#497;|&#452;|[\u01F1\u01C4])/g
}, {
  base: "Dz",
  letters: /(&#498;|&#453;|[\u01F2\u01C5])/g
}, {
  base: "E",
  letters: /(&#69;|&#9402;|&#65317;|&#200;|&#201;|&#202;|&#7872;|&#7870;|&#7876;|&#7874;|&#7868;|&#274;|&#7700;|&#7702;|&#276;|&#278;|&#203;|&#7866;|&#282;|&#516;|&#518;|&#7864;|&#7878;|&#552;|&#7708;|&#280;|&#7704;|&#7706;|&#400;|&#398;|[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E])/g
}, {
  base: "F",
  letters: /(&#70;|&#9403;|&#65318;|&#7710;|&#401;|&#42875;|[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B])/g
}, {
  base: "G",
  letters: /(&#71;|&#9404;|&#65319;|&#500;|&#284;|&#7712;|&#286;|&#288;|&#486;|&#290;|&#484;|&#403;|&#42912;|&#42877;|&#42878;|[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E])/g
}, {
  base: "H",
  letters: /(&#72;|&#9405;|&#65320;|&#292;|&#7714;|&#7718;|&#542;|&#7716;|&#7720;|&#7722;|&#294;|&#11367;|&#11381;|&#42893;|[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D])/g
}, {
  base: "I",
  letters: /(&#73;|&#9406;|&#65321;|&#204;|&#205;|&#206;|&#296;|&#298;|&#300;|&#304;|&#207;|&#7726;|&#7880;|&#463;|&#520;|&#522;|&#7882;|&#302;|&#7724;|&#407;|[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197])/g
}, {
  base: "J",
  letters: /(&#74;|&#9407;|&#65322;|&#308;|&#584;|[\u004A\u24BF\uFF2A\u0134\u0248])/g
}, {
  base: "K",
  letters: /(&#75;|&#9408;|&#65323;|&#7728;|&#488;|&#7730;|&#310;|&#7732;|&#408;|&#11369;|&#42816;|&#42818;|&#42820;|&#42914;|[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2])/g
}, {
  base: "L",
  letters: /(&#76;|&#9409;|&#65324;|&#319;|&#313;|&#317;|&#7734;|&#7736;|&#315;|&#7740;|&#7738;|&#321;|&#573;|&#11362;|&#11360;|&#42824;|&#42822;|&#42880;|[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780])/g
}, {
  base: "LJ",
  letters: /(&#455;|[\u01C7])/g
}, {
  base: "Lj",
  letters: /(&#456;|[\u01C8])/g
}, {
  base: "M",
  letters: /(&#77;|&#9410;|&#65325;|&#7742;|&#7744;|&#7746;|&#11374;|&#412;|[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C])/g
}, {
  base: "N",
  letters: /(&#78;|&#9411;|&#65326;|&#504;|&#323;|&#209;|&#7748;|&#327;|&#7750;|&#325;|&#7754;|&#7752;|&#544;|&#413;|&#42896;|&#42916;|&#330;|[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4\u014A])/g
}, {
  base: "NJ",
  letters: /(&#458;|[\u01CA])/g
}, {
  base: "Nj",
  letters: /(&#459;|[\u01CB])/g
}, {
  base: "O",
  letters: /(&#79;|&#9412;|&#65327;|&#210;|&#211;|&#212;|&#7890;|&#7888;|&#7894;|&#7892;|&#213;|&#7756;|&#556;|&#7758;|&#332;|&#7760;|&#7762;|&#334;|&#558;|&#560;|&#214;|&#554;|&#7886;|&#336;|&#465;|&#524;|&#526;|&#416;|&#7900;|&#7898;|&#7904;|&#7902;|&#7906;|&#7884;|&#7896;|&#490;|&#492;|&#216;|&#510;|&#390;|&#415;|&#42826;|&#42828;|[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C])/g
}, {
  base: "OE",
  letters: /(&#338;|[\u0152])/g
}, {
  base: "OI",
  letters: /(&#418;|[\u01A2])/g
}, {
  base: "OO",
  letters: /(&#42830;|[\uA74E])/g
}, {
  base: "OU",
  letters: /(&#546;|[\u0222])/g
}, {
  base: "P",
  letters: /(&#80;|&#9413;|&#65328;|&#7764;|&#7766;|&#420;|&#11363;|&#42832;|&#42834;|&#42836;|[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754])/g
}, {
  base: "Q",
  letters: /(&#81;|&#9414;|&#65329;|&#42838;|&#42840;|&#586;|[\u0051\u24C6\uFF31\uA756\uA758\u024A])/g
}, {
  base: "R",
  letters: /(&#82;|&#9415;|&#65330;|&#340;|&#7768;|&#344;|&#528;|&#530;|&#7770;|&#7772;|&#342;|&#7774;|&#588;|&#11364;|&#42842;|&#42918;|&#42882;|[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782])/g
}, {
  base: "S",
  letters: /(&#83;|&#9416;|&#65331;|&#7838;|&#346;|&#7780;|&#348;|&#7776;|&#352;|&#7782;|&#7778;|&#7784;|&#536;|&#350;|&#11390;|&#42920;|&#42884;|[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784])/g
}, {
  base: "T",
  letters: /(&#84;|&#9417;|&#65332;|&#7786;|&#356;|&#7788;|&#538;|&#354;|&#7792;|&#7790;|&#358;|&#428;|&#430;|&#574;|&#42886;|[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786])/g
}, {
  base: "TH",
  letters: /(&#222;|[\u00DE])/g
}, {
  base: "TZ",
  letters: /(&#42792;|[\uA728])/g
}, {
  base: "U",
  letters: /(&#85;|&#9418;|&#65333;|&#217;|&#218;|&#219;|&#360;|&#7800;|&#362;|&#7802;|&#364;|&#220;|&#475;|&#471;|&#469;|&#473;|&#7910;|&#366;|&#368;|&#467;|&#532;|&#534;|&#431;|&#7914;|&#7912;|&#7918;|&#7916;|&#7920;|&#7908;|&#7794;|&#370;|&#7798;|&#7796;|&#580;|[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244])/g
}, {
  base: "V",
  letters: /(&#86;|&#9419;|&#65334;|&#7804;|&#7806;|&#434;|&#42846;|&#581;|[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245])/g
}, {
  base: "VY",
  letters: /(&#42848;|[\uA760])/g
}, {
  base: "W",
  letters: /(&#87;|&#9420;|&#65335;|&#7808;|&#7810;|&#372;|&#7814;|&#7812;|&#7816;|&#11378;|[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72])/g
}, {
  base: "X",
  letters: /(&#88;|&#9421;|&#65336;|&#7818;|&#7820;|[\u0058\u24CD\uFF38\u1E8A\u1E8C])/g
}, {
  base: "Y",
  letters: /(&#89;|&#9422;|&#65337;|&#7922;|&#221;|&#374;|&#7928;|&#562;|&#7822;|&#376;|&#7926;|&#7924;|&#435;|&#590;|&#7934;|[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE])/g
}, {
  base: "Z",
  letters: /(&#90;|&#9423;|&#65338;|&#377;|&#7824;|&#379;|&#381;|&#7826;|&#7828;|&#437;|&#548;|&#11391;|&#11371;|&#42850;|[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762])/g
}, {
  base: "a",
  letters: /(&#97;|&#9424;|&#65345;|&#7834;|&#224;|&#225;|&#226;|&#7847;|&#7845;|&#7851;|&#7849;|&#227;|&#257;|&#259;|&#7857;|&#7855;|&#7861;|&#7859;|&#551;|&#481;|&#228;|&#479;|&#7843;|&#229;|&#507;|&#462;|&#513;|&#515;|&#7841;|&#7853;|&#7863;|&#7681;|&#261;|&#11365;|&#592;|[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250])/g
}, {
  base: "aa",
  letters: /(&#42803;|[\uA733])/g
}, {
  base: "ae",
  letters: /(&#230;|&#509;|&#483;|[\u00E6\u01FD\u01E3])/g
}, {
  base: "ao",
  letters: /(&#42805;|[\uA735])/g
}, {
  base: "au",
  letters: /(&#42807;|[\uA737])/g
}, {
  base: "av",
  letters: /(&#42809;|&#42811;|[\uA739\uA73B])/g
}, {
  base: "ay",
  letters: /(&#42813;|[\uA73D])/g
}, {
  base: "b",
  letters: /(&#98;|&#9425;|&#65346;|&#7683;|&#7685;|&#7687;|&#384;|&#387;|&#595;|[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253])/g
}, {
  base: "c",
  letters: /(&#99;|&#9426;|&#65347;|&#263;|&#265;|&#267;|&#269;|&#231;|&#7689;|&#392;|&#572;|&#42815;|&#8580;|[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184])/g
}, {
  base: "d",
  letters: /(&#100;|&#9427;|&#65348;|&#7691;|&#271;|&#7693;|&#7697;|&#7699;|&#7695;|&#273;|&#396;|&#598;|&#599;|&#42874;|&#240;|[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A\u00F0])/g
}, {
  base: "dz",
  letters: /(&#499;|&#454;|[\u01F3\u01C6])/g
}, {
  base: "e",
  letters: /(&#101;|&#9428;|&#65349;|&#232;|&#233;|&#234;|&#7873;|&#7871;|&#7877;|&#7875;|&#7869;|&#275;|&#7701;|&#7703;|&#277;|&#279;|&#235;|&#7867;|&#283;|&#517;|&#519;|&#7865;|&#7879;|&#553;|&#7709;|&#281;|&#7705;|&#7707;|&#583;|&#603;|&#477;|[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD])/g
}, {
  base: "f",
  letters: /(&#102;|&#9429;|&#65350;|&#7711;|&#402;|&#42876;|[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C])/g
}, {
  base: "g",
  letters: /(&#103;|&#9430;|&#65351;|&#501;|&#285;|&#7713;|&#287;|&#289;|&#487;|&#291;|&#485;|&#608;|&#42913;|&#7545;|&#42879;|[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F])/g
}, {
  base: "h",
  letters: /(&#104;|&#9431;|&#65352;|&#293;|&#7715;|&#7719;|&#543;|&#7717;|&#7721;|&#7723;|&#7830;|&#295;|&#11368;|&#11382;|&#613;|[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265])/g
}, {
  base: "hv",
  letters: /(&#405;|[\u0195])/g
}, {
  base: "i",
  letters: /(&#105;|&#9432;|&#65353;|&#236;|&#237;|&#238;|&#297;|&#299;|&#301;|&#239;|&#7727;|&#7881;|&#464;|&#521;|&#523;|&#7883;|&#303;|&#7725;|&#616;|&#305;|[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131])/g
}, {
  base: "ij",
  letters: /(&#307;|[\u0133])/g
}, {
  base: "j",
  letters: /(&#106;|&#9433;|&#65354;|&#309;|&#496;|&#585;|[\u006A\u24D9\uFF4A\u0135\u01F0\u0249])/g
}, {
  base: "k",
  letters: /(&#107;|&#9434;|&#65355;|&#7729;|&#489;|&#7731;|&#311;|&#7733;|&#409;|&#11370;|&#42817;|&#42819;|&#42821;|&#42915;|[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3])/g
}, {
  base: "l",
  letters: /(&#108;|&#9435;|&#65356;|&#320;|&#314;|&#318;|&#7735;|&#7737;|&#316;|&#7741;|&#7739;|&#322;|&#410;|&#619;|&#11361;|&#42825;|&#42881;|&#42823;|[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u0142\u019A\u026B\u2C61\uA749\uA781\uA747])/g
}, {
  base: "lj",
  letters: /(&#457;|[\u01C9])/g
}, {
  base: "m",
  letters: /(&#109;|&#9436;|&#65357;|&#7743;|&#7745;|&#7747;|&#625;|&#623;|[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F])/g
}, {
  base: "n",
  letters: /(&#110;|&#9437;|&#65358;|&#505;|&#324;|&#241;|&#7749;|&#328;|&#7751;|&#326;|&#7755;|&#7753;|&#414;|&#626;|&#329;|&#42897;|&#42917;|&#331;|[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u014B])/g
}, {
  base: "nj",
  letters: /(&#460;|[\u01CC])/g
}, {
  base: "o",
  letters: /(&#111;|&#9438;|&#65359;|&#242;|&#243;|&#244;|&#7891;|&#7889;|&#7895;|&#7893;|&#245;|&#7757;|&#557;|&#7759;|&#333;|&#7761;|&#7763;|&#335;|&#559;|&#561;|&#246;|&#555;|&#7887;|&#337;|&#466;|&#525;|&#527;|&#417;|&#7901;|&#7899;|&#7905;|&#7903;|&#7907;|&#7885;|&#7897;|&#491;|&#493;|&#248;|&#511;|&#596;|&#42827;|&#42829;|&#629;|[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275])/g
}, {
  base: "oe",
  letters: /(&#339;|[\u0153])/g
}, {
  base: "oi",
  letters: /(&#419;|[\u01A3])/g
}, {
  base: "ou",
  letters: /(&#547;|[\u0223])/g
}, {
  base: "oo",
  letters: /(&#42831;|[\uA74F])/g
}, {
  base: "p",
  letters: /(&#112;|&#9439;|&#65360;|&#7765;|&#7767;|&#421;|&#7549;|&#42833;|&#42835;|&#42837;|[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755])/g
}, {
  base: "q",
  letters: /(&#113;|&#9440;|&#65361;|&#587;|&#42839;|&#42841;|[\u0071\u24E0\uFF51\u024B\uA757\uA759])/g
}, {
  base: "r",
  letters: /(&#114;|&#9441;|&#65362;|&#341;|&#7769;|&#345;|&#529;|&#531;|&#7771;|&#7773;|&#343;|&#7775;|&#589;|&#637;|&#42843;|&#42919;|&#42883;|[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783])/g
}, {
  base: "s",
  letters: /(&#115;|&#9442;|&#65363;|&#347;|&#7781;|&#349;|&#7777;|&#353;|&#7783;|&#7779;|&#7785;|&#537;|&#351;|&#575;|&#42921;|&#42885;|&#7835;|&#383;|[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u017F])/g
}, {
  base: "ss",
  letters: /(&#223;|[\u00DF])/g
}, {
  base: "t",
  letters: /(&#116;|&#9443;|&#65364;|&#7787;|&#7831;|&#357;|&#7789;|&#539;|&#355;|&#7793;|&#7791;|&#359;|&#429;|&#648;|&#11366;|&#42887;|[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787])/g
}, {
  base: "th",
  letters: /(&#254;|[\u00FE])/g
}, {
  base: "tz",
  letters: /(&#42793;|[\uA729])/g
}, {
  base: "u",
  letters: /(&#117;|&#9444;|&#65365;|&#249;|&#250;|&#251;|&#361;|&#7801;|&#363;|&#7803;|&#365;|&#252;|&#476;|&#472;|&#470;|&#474;|&#7911;|&#367;|&#369;|&#468;|&#533;|&#535;|&#432;|&#7915;|&#7913;|&#7919;|&#7917;|&#7921;|&#7909;|&#7795;|&#371;|&#7799;|&#7797;|&#649;|[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289])/g
}, {
  base: "v",
  letters: /(&#118;|&#9445;|&#65366;|&#7805;|&#7807;|&#651;|&#42847;|&#652;|[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C])/g
}, {
  base: "vy",
  letters: /(&#42849;|[\uA761])/g
}, {
  base: "w",
  letters: /(&#119;|&#9446;|&#65367;|&#7809;|&#7811;|&#373;|&#7815;|&#7813;|&#7832;|&#7817;|&#11379;|[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73])/g
}, {
  base: "x",
  letters: /(&#120;|&#9447;|&#65368;|&#7819;|&#7821;|[\u0078\u24E7\uFF58\u1E8B\u1E8D])/g
}, {
  base: "y",
  letters: /(&#121;|&#9448;|&#65369;|&#7923;|&#253;|&#375;|&#7929;|&#563;|&#7823;|&#255;|&#7927;|&#7833;|&#7925;|&#436;|&#591;|&#7935;|[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF])/g
}, {
  base: "z",
  letters: /(&#122;|&#9449;|&#65370;|&#378;|&#7825;|&#380;|&#382;|&#7827;|&#7829;|&#438;|&#549;|&#576;|&#11372;|&#42851;|[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763])/g
}], Cm = function(e) {
  var n = e;
  return Am.forEach(function(i) {
    n = n.replace(i.letters, i.base);
  }), n;
}, Ac = function(e) {
  return Cm(e).toLowerCase();
}, Rh = function(e, n, i) {
  return i ? Ac(e).indexOf(Ac(n)) : e.toLowerCase().indexOf(n.toLowerCase());
}, wm = function() {
  return !!document.documentMode;
}, fo = function(e) {
  return typeof e == "number";
}, Sm = function(e) {
  return e === Object(e) ? Object.keys(e) : [];
}, Em = function(e) {
  for (var n, i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
    r[s - 1] = arguments[s];
  var a = (n = []).concat.apply(n, r);
  return Object.keys(e).reduce(function(o, l) {
    return e.hasOwnProperty(l) && !a.includes(l) && e[l] !== void 0 && (o[l] = e[l]), o;
  }, {});
}, km = ["style", "className", "classNames"];
function Cc(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function wc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Cc(Object(n), !0).forEach(function(i) {
      ye(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Cc(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function $s(t, e) {
  var n = function(r) {
    var s = function(l) {
      var c = l.style, u = l.className, d = l.classNames, h = j0(l, km), g = e ? e(h) : void 0, b = qo(t, {
        style: c,
        className: u,
        classNames: d
      }, g);
      return /* @__PURE__ */ re.createElement(r, yt({}, h, {
        style: b
      }));
    }, a = r.displayName || r.name || "Component";
    return s.displayName = "defaultStyle(".concat(a, ")"), /* @__PURE__ */ re.forwardRef(function(o, l) {
      return s(wc(wc({}, o), {}, {
        ref: l
      }));
    });
  };
  return n;
}
var _m = function(e, n) {
  return e.hasOwnProperty(n) ? e[n]++ : e[n] = 0, n + "_" + e[n];
};
function Bh(t) {
  var e = t.selectionStart, n = t.selectionEnd, i = t.value, r = i === void 0 ? "" : i, s = t.onCaretPositionChange, a = t.containerRef, o = t.children;
  t.singleLine;
  var l = t.style, c = Be({
    left: void 0,
    top: void 0
  }), u = us(c, 2), d = u[0], h = u[1], g = Be(), b = us(g, 2), m = b[0], p = b[1];
  Fe(function() {
    x();
  });
  var x = function() {
    if (m) {
      var $ = m.offsetLeft, N = m.offsetTop;
      if (!(d.left === $ && d.top === N)) {
        var R = {
          left: $,
          top: N
        };
        h(R), s(R);
      }
    }
  }, C = Jt(o), M;
  n === e && (M = nt(r, C, e, "START"));
  var _ = [], A = {}, E = _, P = 0, I = function($, N, R) {
    if (fo(M) && M >= N && M <= N + $.length) {
      var B = M - N;
      E.push(Q($.substring(0, B), P)), E = [Q($.substring(B), P)];
    } else
      E.push(Q($, P));
    P++;
  }, U = function($, N, R, B, j, y, v) {
    var k = _m(A, B);
    E.push(T(B, j, y, k));
  }, Q = function($, N) {
    return /* @__PURE__ */ re.createElement("span", yt({}, l("substring"), {
      key: N
    }), $);
  }, T = function($, N, R, B) {
    var j = {
      id: $,
      display: N,
      key: B
    }, y = Ji.toArray(o)[R];
    return /* @__PURE__ */ re.cloneElement(y, j);
  }, Y = function($) {
    return /* @__PURE__ */ re.createElement("span", yt({}, l("caret"), {
      ref: p,
      key: "caret"
    }), $);
  };
  return ur(r, C, U, I), E.push(" "), E !== _ && _.push(Y(E)), /* @__PURE__ */ re.createElement("div", yt({}, l, {
    ref: a
  }), _);
}
Bh.propTypes = {
  selectionStart: oe.number,
  selectionEnd: oe.number,
  value: oe.string.isRequired,
  onCaretPositionChange: oe.func.isRequired,
  containerRef: oe.oneOfType([oe.func, oe.shape({
    current: typeof Element > "u" ? oe.any : oe.instanceOf(Element)
  })]),
  children: oe.oneOfType([oe.element, oe.arrayOf(oe.element)]).isRequired
};
var Mm = $s({
  position: "relative",
  boxSizing: "border-box",
  width: "100%",
  color: "transparent",
  overflow: "hidden",
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
  border: "1px solid transparent",
  textAlign: "start",
  "&singleLine": {
    whiteSpace: "pre",
    wordWrap: null
  },
  substring: {
    visibility: "hidden"
  }
}, function(t) {
  return {
    "&singleLine": t.singleLine
  };
}), Om = Mm(Bh);
function Lh(t) {
  var e = t.id, n = t.focused, i = t.ignoreAccents, r = t.index, s = t.onClick, a = t.onMouseEnter, o = t.query, l = t.renderSuggestion, c = t.suggestion, u = t.style;
  t.className, t.classNames;
  var d = {
    onClick: s,
    onMouseEnter: a
  }, h = function() {
    var p = g(), x = b(p);
    return l ? l(c, o, x, r, n) : x;
  }, g = function() {
    if (typeof c == "string")
      return c;
    var p = c.id, x = c.display;
    return p === void 0 || !x ? p : x;
  }, b = function(p) {
    var x = Rh(p, o, i);
    return x === -1 ? /* @__PURE__ */ re.createElement("span", u("display"), p) : /* @__PURE__ */ re.createElement("span", u("display"), p.substring(0, x), /* @__PURE__ */ re.createElement("b", u("highlight"), p.substring(x, x + o.length)), p.substring(x + o.length));
  };
  return /* @__PURE__ */ re.createElement("li", yt({
    id: e,
    role: "option",
    "aria-selected": n
  }, d, u), h());
}
Lh.propTypes = {
  id: oe.string.isRequired,
  query: oe.string.isRequired,
  index: oe.number.isRequired,
  ignoreAccents: oe.bool,
  suggestion: oe.oneOfType([oe.string, oe.shape({
    id: oe.oneOfType([oe.string, oe.number]).isRequired,
    display: oe.string
  })]).isRequired,
  renderSuggestion: oe.func,
  focused: oe.bool
};
var Dm = $s({
  cursor: "pointer"
}, function(t) {
  return {
    "&focused": t.focused
  };
}), Pm = Dm(Lh);
function Fm(t) {
  var e = t.style, n = t.className, i = t.classNames, r = qo(Tm, {
    style: e,
    className: n,
    classNames: i
  }), s = r("spinner");
  return /* @__PURE__ */ re.createElement("div", r, /* @__PURE__ */ re.createElement("div", s, /* @__PURE__ */ re.createElement("div", s(["element", "element1"])), /* @__PURE__ */ re.createElement("div", s(["element", "element2"])), /* @__PURE__ */ re.createElement("div", s(["element", "element3"])), /* @__PURE__ */ re.createElement("div", s(["element", "element4"])), /* @__PURE__ */ re.createElement("div", s(["element", "element5"]))));
}
var Tm = {};
function Nh(t) {
  var e = t.id, n = t.suggestions, i = n === void 0 ? {} : n, r = t.a11ySuggestionsListLabel, s = t.focusIndex, a = t.position, o = t.left, l = t.right, c = t.top, u = t.scrollFocusedIntoView, d = t.isLoading, h = t.isOpened, g = t.onSelect, b = g === void 0 ? function() {
    return null;
  } : g, m = t.ignoreAccents, p = t.containerRef, x = t.children, C = t.style, M = t.customSuggestionsContainer, _ = t.onMouseDown, A = t.onMouseEnter, E = Be(void 0), P = us(E, 2), I = P[0], U = P[1];
  Fe(function() {
    if (!(!I || I.offsetHeight >= I.scrollHeight || !u)) {
      var R = I.scrollTop, B = I.children[s].getBoundingClientRect(), j = B.top, y = B.bottom, v = I.getBoundingClientRect(), k = v.top;
      j = j - k + R, y = y - k + R, j < R ? I.scrollTop = j : y > I.offsetHeight && (I.scrollTop = y - I.offsetHeight);
    }
  }, [s, u, I]);
  var Q = function() {
    var B = /* @__PURE__ */ re.createElement("ul", yt({
      ref: U,
      id: e,
      role: "listbox",
      "aria-label": r
    }, C("list")), Object.values(i).reduce(function(j, y) {
      var v = y.results, k = y.queryInfo;
      return [].concat(ls(j), ls(v.map(function(S, f) {
        return T(S, k, j.length + f);
      })));
    }, []));
    return M ? M(B) : B;
  }, T = function(B, j, y) {
    var v = y === s, k = j.childIndex, S = j.query, f = Ji.toArray(x)[k].props.renderSuggestion;
    return /* @__PURE__ */ re.createElement(Pm, {
      style: C("item"),
      key: "".concat(k, "-").concat(N(B)),
      id: Ih(e, y),
      query: S,
      index: y,
      ignoreAccents: m,
      renderSuggestion: f,
      suggestion: B,
      focused: v,
      onClick: function() {
        return $(B, j);
      },
      onMouseEnter: function() {
        return q(y);
      }
    });
  }, Y = function() {
    if (d)
      return /* @__PURE__ */ re.createElement(Fm, {
        style: C("loadingIndicator")
      });
  }, q = function(B, j) {
    A && A(B);
  }, $ = function(B, j) {
    b(B, j);
  }, N = function(B) {
    return typeof B == "string" ? B : B.id;
  };
  return h ? /* @__PURE__ */ re.createElement("div", yt({}, rm({
    position: a || "absolute",
    left: o,
    right: l,
    top: c
  }, C), {
    onMouseDown: _,
    ref: p
  }), Q(), Y()) : null;
}
Nh.propTypes = {
  id: oe.string.isRequired,
  suggestions: oe.object.isRequired,
  a11ySuggestionsListLabel: oe.string,
  focusIndex: oe.number,
  position: oe.string,
  left: oe.number,
  right: oe.number,
  top: oe.number,
  scrollFocusedIntoView: oe.bool,
  isLoading: oe.bool,
  isOpened: oe.bool.isRequired,
  onSelect: oe.func,
  ignoreAccents: oe.bool,
  customSuggestionsContainer: oe.func,
  containerRef: oe.oneOfType([oe.func, oe.shape({
    current: typeof Element > "u" ? oe.any : oe.instanceOf(Element)
  })])
};
var Im = $s({
  zIndex: 1,
  backgroundColor: "white",
  marginTop: 14,
  minWidth: 100,
  list: {
    margin: 0,
    padding: 0,
    listStyleType: "none"
  }
}), Rm = Im(Nh);
function Sc(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Ct(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Sc(Object(n), !0).forEach(function(i) {
      ye(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Sc(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function Bm(t) {
  var e = Lm();
  return function() {
    var i = cs(t), r;
    if (e) {
      var s = cs(this).constructor;
      r = Reflect.construct(i, arguments, s);
    } else
      r = i.apply(this, arguments);
    return R0(this, r);
  };
}
function Lm() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var Nm = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (e instanceof RegExp)
    return e;
  var i = n.allowSpaceInQuery, r = Kr(e);
  return new RegExp("(?:^|\\s)(".concat(r, "([^").concat(i ? "" : "\\s").concat(r, "]*))$"));
}, Vm = function(e, n) {
  return e instanceof Array ? function(i, r) {
    for (var s = [], a = 0, o = e.length; a < o; ++a) {
      var l = e[a].display || e[a].id;
      Rh(l, i, n) >= 0 && s.push(e[a]);
    }
    return s;
  } : e;
}, Kn = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  UP: 38,
  DOWN: 40
}, wr = !1, Vh = {
  /**
   * If set to `true` a regular text input element will be rendered
   * instead of a textarea
   */
  singleLine: oe.bool,
  allowSpaceInQuery: oe.bool,
  allowSuggestionsAboveCursor: oe.bool,
  forceSuggestionsAboveCursor: oe.bool,
  ignoreAccents: oe.bool,
  a11ySuggestionsListLabel: oe.string,
  value: oe.string,
  onKeyDown: oe.func,
  customSuggestionsContainer: oe.func,
  onSelect: oe.func,
  onBlur: oe.func,
  onChange: oe.func,
  suggestionsPortalHost: typeof Element > "u" ? oe.any : oe.PropTypes.instanceOf(Element),
  inputRef: oe.oneOfType([oe.func, oe.shape({
    current: typeof Element > "u" ? oe.any : oe.instanceOf(Element)
  })]),
  children: oe.oneOfType([oe.element, oe.arrayOf(oe.element)]).isRequired
}, Jo = /* @__PURE__ */ function(t) {
  I0(n, t);
  var e = Bm(n);
  function n(i) {
    var r;
    return P0(this, n), r = e.call(this, i), ye(xe(r), "setContainerElement", function(s) {
      r.containerElement = s;
    }), ye(xe(r), "getInputProps", function() {
      var s = r.props, a = s.readOnly, o = s.disabled, l = s.style, c = Em(
        r.props,
        ["style", "classNames", "className"],
        // substyle props
        Sm(Vh)
      );
      return Ct(Ct(Ct(Ct({}, c), l("input")), {}, {
        value: r.getPlainText(),
        onScroll: r.updateHighlighterScroll
      }, !a && !o && {
        onChange: r.handleChange,
        onSelect: r.handleSelect,
        onKeyDown: r.handleKeyDown,
        onBlur: r.handleBlur,
        onCompositionStart: r.handleCompositionStart,
        onCompositionEnd: r.handleCompositionEnd
      }), r.isOpened() && {
        role: "combobox",
        "aria-controls": r.uuidSuggestionsOverlay,
        "aria-expanded": !0,
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-activedescendant": Ih(r.uuidSuggestionsOverlay, r.state.focusIndex)
      });
    }), ye(xe(r), "renderControl", function() {
      var s = r.props, a = s.singleLine, o = s.style, l = r.getInputProps();
      return /* @__PURE__ */ re.createElement("div", o("control"), r.renderHighlighter(), a ? r.renderInput(l) : r.renderTextarea(l));
    }), ye(xe(r), "renderInput", function(s) {
      return /* @__PURE__ */ re.createElement("input", yt({
        type: "text",
        ref: r.setInputRef
      }, s));
    }), ye(xe(r), "renderTextarea", function(s) {
      return /* @__PURE__ */ re.createElement("textarea", yt({
        ref: r.setInputRef
      }, s));
    }), ye(xe(r), "setInputRef", function(s) {
      r.inputElement = s;
      var a = r.props.inputRef;
      typeof a == "function" ? a(s) : a && (a.current = s);
    }), ye(xe(r), "setSuggestionsElement", function(s) {
      r.suggestionsElement = s;
    }), ye(xe(r), "renderSuggestionsOverlay", function() {
      if (!fo(r.state.selectionStart))
        return null;
      var s = r.state.suggestionsPosition, a = s.position, o = s.left, l = s.top, c = s.right, u = /* @__PURE__ */ re.createElement(Rm, {
        id: r.uuidSuggestionsOverlay,
        style: r.props.style("suggestions"),
        position: a,
        left: o,
        top: l,
        right: c,
        focusIndex: r.state.focusIndex,
        scrollFocusedIntoView: r.state.scrollFocusedIntoView,
        containerRef: r.setSuggestionsElement,
        suggestions: r.state.suggestions,
        customSuggestionsContainer: r.props.customSuggestionsContainer,
        onSelect: r.addMention,
        onMouseDown: r.handleSuggestionsMouseDown,
        onMouseEnter: r.handleSuggestionsMouseEnter,
        isLoading: r.isLoading(),
        isOpened: r.isOpened(),
        ignoreAccents: r.props.ignoreAccents,
        a11ySuggestionsListLabel: r.props.a11ySuggestionsListLabel
      }, r.props.children);
      return r.props.suggestionsPortalHost ? /* @__PURE__ */ Io.createPortal(u, r.props.suggestionsPortalHost) : u;
    }), ye(xe(r), "renderHighlighter", function() {
      var s = r.state, a = s.selectionStart, o = s.selectionEnd, l = r.props, c = l.singleLine, u = l.children, d = l.value, h = l.style;
      return /* @__PURE__ */ re.createElement(Om, {
        containerRef: r.setHighlighterElement,
        style: h("highlighter"),
        value: d,
        singleLine: c,
        selectionStart: a,
        selectionEnd: o,
        onCaretPositionChange: r.handleCaretPositionChange
      }, u);
    }), ye(xe(r), "setHighlighterElement", function(s) {
      r.highlighterElement = s;
    }), ye(xe(r), "handleCaretPositionChange", function(s) {
      r.setState({
        caretPosition: s
      });
    }), ye(xe(r), "getPlainText", function() {
      return wn(r.props.value || "", Jt(r.props.children));
    }), ye(xe(r), "executeOnChange", function(s) {
      for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
        o[l - 1] = arguments[l];
      if (r.props.onChange) {
        var c;
        return (c = r.props).onChange.apply(c, [s].concat(o));
      }
      if (r.props.valueLink) {
        var u;
        return (u = r.props.valueLink).requestChange.apply(u, [s.target.value].concat(o));
      }
    }), ye(xe(r), "handleChange", function(s) {
      if (wr = !1, wm()) {
        var a = document.activeElement && document.activeElement.contentDocument || document;
        if (a.activeElement !== s.target)
          return;
      }
      var o = r.props.value || "", l = Jt(r.props.children), c = s.target.value, u = r.state.selectionStart;
      u == null && (u = s.target.selectionStart);
      var d = r.state.selectionEnd;
      d == null && (d = s.target.selectionEnd);
      var h = pm(o, c, {
        selectionStartBefore: u,
        selectionEndBefore: d,
        selectionEndAfter: s.target.selectionEnd
      }, l);
      c = wn(h, l);
      var g = s.target.selectionStart, b = s.target.selectionEnd, m = !1, p = xc(o, l, g);
      p !== void 0 && r.state.selectionEnd > p && (g = p + (s.nativeEvent.data ? s.nativeEvent.data.length : 0), b = g, m = !0), r.setState({
        selectionStart: g,
        selectionEnd: b,
        setSelectionAfterMentionChange: m
      });
      var x = Ni(h, l);
      s.nativeEvent.isComposing && g === b && r.updateMentionsQueries(r.inputElement.value, g);
      var C = {
        target: {
          value: h
        }
      };
      r.executeOnChange(C, h, c, x);
    }), ye(xe(r), "handleSelect", function(s) {
      if (r.setState({
        selectionStart: s.target.selectionStart,
        selectionEnd: s.target.selectionEnd
      }), !wr) {
        var a = r.inputElement;
        s.target.selectionStart === s.target.selectionEnd ? r.updateMentionsQueries(a.value, s.target.selectionStart) : r.clearSuggestions(), r.updateHighlighterScroll(), r.props.onSelect(s);
      }
    }), ye(xe(r), "handleKeyDown", function(s) {
      var a = Cr(r.state.suggestions);
      if (a === 0 || !r.suggestionsElement) {
        r.props.onKeyDown(s);
        return;
      }
      switch (Object.values(Kn).indexOf(s.keyCode) >= 0 && (s.preventDefault(), s.stopPropagation()), s.keyCode) {
        case Kn.ESC: {
          r.clearSuggestions();
          return;
        }
        case Kn.DOWN: {
          r.shiftFocus(1);
          return;
        }
        case Kn.UP: {
          r.shiftFocus(-1);
          return;
        }
        case Kn.RETURN: {
          r.selectFocused();
          return;
        }
        case Kn.TAB: {
          r.selectFocused();
          return;
        }
        default:
          return;
      }
    }), ye(xe(r), "shiftFocus", function(s) {
      var a = Cr(r.state.suggestions);
      r.setState({
        focusIndex: (a + r.state.focusIndex + s) % a,
        scrollFocusedIntoView: !0
      });
    }), ye(xe(r), "selectFocused", function() {
      var s = r.state, a = s.suggestions, o = s.focusIndex, l = Object.values(a).reduce(function(d, h) {
        var g = h.results, b = h.queryInfo;
        return [].concat(ls(d), ls(g.map(function(m) {
          return {
            result: m,
            queryInfo: b
          };
        })));
      }, [])[o], c = l.result, u = l.queryInfo;
      r.addMention(c, u), r.setState({
        focusIndex: 0
      });
    }), ye(xe(r), "handleBlur", function(s) {
      var a = r._suggestionsMouseDown;
      r._suggestionsMouseDown = !1, a || r.setState({
        selectionStart: null,
        selectionEnd: null
      }), window.setTimeout(function() {
        r.updateHighlighterScroll();
      }, 1), r.props.onBlur(s, a);
    }), ye(xe(r), "handleSuggestionsMouseDown", function(s) {
      r._suggestionsMouseDown = !0;
    }), ye(xe(r), "handleSuggestionsMouseEnter", function(s) {
      r.setState({
        focusIndex: s,
        scrollFocusedIntoView: !1
      });
    }), ye(xe(r), "updateSuggestionsPosition", function() {
      var s = r.state.caretPosition, a = r.props, o = a.suggestionsPortalHost, l = a.allowSuggestionsAboveCursor, c = a.forceSuggestionsAboveCursor;
      if (!(!s || !r.suggestionsElement)) {
        var u = r.suggestionsElement, d = r.highlighterElement, h = d.getBoundingClientRect(), g = va(d, "font-size"), b = {
          left: h.left + s.left,
          top: h.top + s.top + g
        }, m = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if (u) {
          var p = {};
          if (o) {
            p.position = "fixed";
            var x = b.left, C = b.top;
            x -= va(u, "margin-left"), C -= va(u, "margin-top"), x -= d.scrollLeft, C -= d.scrollTop;
            var M = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            x + u.offsetWidth > M ? p.left = Math.max(0, M - u.offsetWidth) : p.left = x, l && C + u.offsetHeight > m && u.offsetHeight < C - g || c ? p.top = Math.max(0, C - u.offsetHeight - g) : p.top = C;
          } else {
            var _ = s.left - d.scrollLeft, A = s.top - d.scrollTop;
            _ + u.offsetWidth > r.containerElement.offsetWidth ? p.right = 0 : p.left = _, l && b.top - d.scrollTop + u.offsetHeight > m && u.offsetHeight < h.top - g - d.scrollTop || c ? p.top = A - u.offsetHeight - g : p.top = A;
          }
          p.left === r.state.suggestionsPosition.left && p.top === r.state.suggestionsPosition.top && p.position === r.state.suggestionsPosition.position || r.setState({
            suggestionsPosition: p
          });
        }
      }
    }), ye(xe(r), "updateHighlighterScroll", function() {
      var s = r.inputElement, a = r.highlighterElement;
      !s || !a || (a.scrollLeft = s.scrollLeft, a.scrollTop = s.scrollTop, a.height = s.height);
    }), ye(xe(r), "handleCompositionStart", function() {
      wr = !0;
    }), ye(xe(r), "handleCompositionEnd", function() {
      wr = !1;
    }), ye(xe(r), "setSelection", function(s, a) {
      if (!(s === null || a === null)) {
        var o = r.inputElement;
        if (o.setSelectionRange)
          o.setSelectionRange(s, a);
        else if (o.createTextRange) {
          var l = o.createTextRange();
          l.collapse(!0), l.moveEnd("character", a), l.moveStart("character", s), l.select();
        }
      }
    }), ye(xe(r), "updateMentionsQueries", function(s, a) {
      r._queryId++, r.suggestions = {}, r.setState({
        suggestions: {}
      });
      var o = r.props.value || "", l = r.props.children, c = Jt(l), u = nt(o, c, a, "NULL");
      if (u !== null) {
        var d = bm(o.substring(0, u), c), h = s.substring(d, a);
        re.Children.forEach(l, function(g, b) {
          if (g) {
            var m = Nm(g.props.trigger, r.props), p = h.match(m);
            if (p) {
              var x = d + h.indexOf(p[1], p.index);
              r.queryData(p[2], b, x, x + p[1].length, s);
            }
          }
        });
      }
    }), ye(xe(r), "clearSuggestions", function() {
      r._queryId++, r.suggestions = {}, r.setState({
        suggestions: {},
        focusIndex: 0
      });
    }), ye(xe(r), "queryData", function(s, a, o, l, c) {
      var u = r.props, d = u.children, h = u.ignoreAccents, g = Ji.toArray(d)[a], b = Vm(g.props.data, h), m = b(s, r.updateSuggestions.bind(null, r._queryId, a, s, o, l, c));
      m instanceof Array && r.updateSuggestions(r._queryId, a, s, o, l, c, m);
    }), ye(xe(r), "updateSuggestions", function(s, a, o, l, c, u, d) {
      if (s === r._queryId) {
        r.suggestions = Ct(Ct({}, r.suggestions), {}, ye({}, a, {
          queryInfo: {
            childIndex: a,
            query: o,
            querySequenceStart: l,
            querySequenceEnd: c,
            plainTextValue: u
          },
          results: d
        }));
        var h = r.state.focusIndex, g = Cr(r.suggestions);
        r.setState({
          suggestions: r.suggestions,
          focusIndex: h >= g ? Math.max(g - 1, 0) : h
        });
      }
    }), ye(xe(r), "addMention", function(s, a) {
      var o = s.id, l = s.display, c = a.childIndex, u = a.querySequenceStart, d = a.querySequenceEnd, h = a.plainTextValue, g = r.props.value || "", b = Jt(r.props.children), m = Ji.toArray(r.props.children)[c], p = m.props, x = p.markup, C = p.displayTransform, M = p.appendSpaceOnAdd, _ = p.onAdd, A = nt(g, b, u, "START"), E = A + d - u, P = xm(x, o, l);
      M && (P += " ");
      var I = Ui(g, A, E, P);
      r.inputElement.focus();
      var U = C(o, l);
      M && (U += " ");
      var Q = u + U.length;
      r.setState({
        selectionStart: Q,
        selectionEnd: Q,
        setSelectionAfterMentionChange: !0
      });
      var T = {
        target: {
          value: I
        }
      }, Y = Ni(I, b), q = Ui(h, u, d, U);
      r.executeOnChange(T, I, q, Y), _ && _(o, l, A, E), r.clearSuggestions();
    }), ye(xe(r), "isLoading", function() {
      var s = !1;
      return re.Children.forEach(r.props.children, function(a) {
        s = s || a && a.props.isLoading;
      }), s;
    }), ye(xe(r), "isOpened", function() {
      return fo(r.state.selectionStart) && (Cr(r.state.suggestions) !== 0 || r.isLoading());
    }), ye(xe(r), "_queryId", 0), r.suggestions = {}, r.uuidSuggestionsOverlay = Math.random().toString(16).substring(2), r.handleCopy = r.handleCopy.bind(xe(r)), r.handleCut = r.handleCut.bind(xe(r)), r.handlePaste = r.handlePaste.bind(xe(r)), r.state = {
      focusIndex: 0,
      selectionStart: null,
      selectionEnd: null,
      suggestions: {},
      caretPosition: null,
      suggestionsPosition: {},
      setSelectionAfterHandlePaste: !1
    }, r;
  }
  return T0(n, [{
    key: "componentDidMount",
    value: function() {
      document.addEventListener("copy", this.handleCopy), document.addEventListener("cut", this.handleCut), document.addEventListener("paste", this.handlePaste), this.updateSuggestionsPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, s) {
      s.suggestionsPosition === this.state.suggestionsPosition && this.updateSuggestionsPosition(), this.state.setSelectionAfterMentionChange && (this.setState({
        setSelectionAfterMentionChange: !1
      }), this.setSelection(this.state.selectionStart, this.state.selectionEnd)), this.state.setSelectionAfterHandlePaste && (this.setState({
        setSelectionAfterHandlePaste: !1
      }), this.setSelection(this.state.selectionStart, this.state.selectionEnd));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("copy", this.handleCopy), document.removeEventListener("cut", this.handleCut), document.removeEventListener("paste", this.handlePaste);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ re.createElement("div", yt({
        ref: this.setContainerElement
      }, this.props.style), this.renderControl(), this.renderSuggestionsOverlay());
    }
  }, {
    key: "handlePaste",
    value: function(r) {
      if (r.target === this.inputElement && this.supportsClipboardActions(r)) {
        r.preventDefault();
        var s = this.state, a = s.selectionStart, o = s.selectionEnd, l = this.props, c = l.value, u = l.children, d = Jt(u), h = nt(c, d, a, "START"), g = nt(c, d, o, "END"), b = r.clipboardData.getData("text/react-mentions"), m = r.clipboardData.getData("text/plain"), p = Ui(c, h, g, b || m).replace(/\r/g, ""), x = wn(p, d), C = {
          target: Ct(Ct({}, r.target), {}, {
            value: p
          })
        };
        this.executeOnChange(C, p, x, Ni(p, d));
        var M = xc(c, d, a), _ = (M || a) + wn(b || m, d).length;
        this.setState({
          selectionStart: _,
          selectionEnd: _,
          setSelectionAfterHandlePaste: !0
        });
      }
    }
  }, {
    key: "saveSelectionToClipboard",
    value: function(r) {
      var s = this.inputElement.selectionStart, a = this.inputElement.selectionEnd, o = this.props, l = o.children, c = o.value, u = Jt(l), d = nt(c, u, s, "START"), h = nt(c, u, a, "END");
      r.clipboardData.setData("text/plain", r.target.value.slice(s, a)), r.clipboardData.setData("text/react-mentions", c.slice(d, h));
    }
  }, {
    key: "supportsClipboardActions",
    value: function(r) {
      return !!r.clipboardData;
    }
  }, {
    key: "handleCopy",
    value: function(r) {
      r.target === this.inputElement && this.supportsClipboardActions(r) && (r.preventDefault(), this.saveSelectionToClipboard(r));
    }
  }, {
    key: "handleCut",
    value: function(r) {
      if (r.target === this.inputElement && this.supportsClipboardActions(r)) {
        r.preventDefault(), this.saveSelectionToClipboard(r);
        var s = this.state, a = s.selectionStart, o = s.selectionEnd, l = this.props, c = l.children, u = l.value, d = Jt(c), h = nt(u, d, a, "START"), g = nt(u, d, o, "END"), b = [u.slice(0, h), u.slice(g)].join(""), m = wn(b, d), p = {
          target: Ct(Ct({}, r.target), {}, {
            value: m
          })
        };
        this.executeOnChange(p, b, m, Ni(u, d));
      }
    }
    // Handle input element's change event
  }]), n;
}(re.Component);
ye(Jo, "propTypes", Vh);
ye(Jo, "defaultProps", {
  ignoreAccents: !1,
  singleLine: !1,
  allowSuggestionsAboveCursor: !1,
  onKeyDown: function() {
    return null;
  },
  onSelect: function() {
    return null;
  },
  onBlur: function() {
    return null;
  }
});
var va = function(e, n) {
  var i = parseFloat(window.getComputedStyle(e, null).getPropertyValue(n));
  return isFinite(i) ? i : 0;
}, Hm = typeof navigator < "u" && /iPhone|iPad|iPod/i.test(navigator.userAgent), jm = $s({
  position: "relative",
  overflowY: "visible",
  input: {
    display: "block",
    width: "100%",
    position: "absolute",
    margin: 0,
    top: 0,
    left: 0,
    boxSizing: "border-box",
    backgroundColor: "transparent",
    fontFamily: "inherit",
    fontSize: "inherit",
    letterSpacing: "inherit"
  },
  "&multiLine": {
    input: Ct({
      height: "100%",
      bottom: 0,
      overflow: "hidden",
      resize: "none"
    }, Hm ? {
      marginTop: 1,
      marginLeft: -3
    } : null)
  }
}, function(t) {
  var e = t.singleLine;
  return {
    "&singleLine": e,
    "&multiLine": !e
  };
}), $m = jm(Jo), Wm = {
  fontWeight: "inherit"
}, Xo = function(e) {
  var n = e.display, i = e.style, r = e.className, s = e.classNames, a = qo(Wm, {
    style: i,
    className: r,
    classNames: s
  });
  return /* @__PURE__ */ re.createElement("strong", a, n);
};
Xo.propTypes = {
  /**
   * Called when a new mention is added in the input
   *
   * Example:
   *
   * ```js
   * function(id, display) {
   *   console.log("user " + display + " was mentioned!");
   * }
   * ```
   */
  onAdd: oe.func,
  onRemove: oe.func,
  renderSuggestion: oe.func,
  trigger: oe.oneOfType([oe.string, oe.instanceOf(RegExp)]),
  markup: oe.string,
  displayTransform: oe.func,
  /**
   * If set to `true` spaces will not interrupt matching suggestions
   */
  allowSpaceInQuery: oe.bool,
  isLoading: oe.bool
};
Xo.defaultProps = {
  trigger: "@",
  markup: "@[__display__](__id__)",
  displayTransform: function(e, n) {
    return n || e;
  },
  onAdd: function() {
    return null;
  },
  onRemove: function() {
    return null;
  },
  renderSuggestion: null,
  isLoading: !1,
  appendSpaceOnAdd: !1
};
function Py({ onSubmit: t, ...e }) {
  const [n, i] = Be(""), r = le(
    (s) => {
      s.preventDefault(), t(n), i("");
    },
    [t, n]
  );
  return /* @__PURE__ */ ae("form", { className: "flex items-stretch", onSubmit: r, children: [
    /* @__PURE__ */ w("div", { className: "w-full flex items-center px-3", children: /* @__PURE__ */ w(
      $m,
      {
        className: e.light ? "mentions-light" : "mentions",
        value: n,
        onChange: (s, a) => i(a),
        singleLine: e.singleLine,
        placeholder: e.placeholder,
        children: /* @__PURE__ */ w(Xo, { trigger: "@", data: e.data })
      }
    ) }),
    /* @__PURE__ */ w(B1, { type: "submit", endIcon: /* @__PURE__ */ w(eg, {}) })
  ] });
}
const Ym = "data:image/gif;base64,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", zm = "data:image/png;base64,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";
function Fy({ fullWidth: t }) {
  const e = de("h-full", {
    "content flex items-center justify-center bg-zinc-800": t
  });
  return /* @__PURE__ */ w("div", { className: e, children: /* @__PURE__ */ w("div", { className: "border rounded-full p-2 w-[260px] h-[110px] flex items-center justify-center bg-white-light", children: /* @__PURE__ */ w("img", { src: Ym, alt: "unbh-loader" }) }) });
}
function Ty({
  className: t,
  message: e,
  onClose: n
}) {
  return /* @__PURE__ */ ae("div", { className: de("maintenance-banner", t), children: [
    /* @__PURE__ */ w("img", { className: "w-7", src: zm, alt: "warning" }),
    /* @__PURE__ */ w("h3", { className: "m-0 text-white mr-1", children: e }),
    /* @__PURE__ */ w("div", { className: "cursor-pointer", onClick: n, children: "X" })
  ] });
}
const Iy = (t) => {
  const e = le(
    (s, a) => de("text-base min-w-[200px]", {
      "bg-white font-bold": t.light && s.id === t.active,
      "bg-gray-lighter font-light text-gray-dark": t.light && s.id !== t.active,
      "bg-black-light font-bold text-white": t.dark && s.id === t.active,
      "bg-gray-darker font-light text-gray-lighter": t.dark && s.id !== t.active,
      "bg-gray-darker font-bold text-white": !t.light && !t.dark && s.id === t.active,
      "bg-gray-dark font-light text-gray-lighter": !t.light && !t.dark && s.id !== t.active
    }),
    [t.active, t.dark, t.light]
  ), n = le(
    (s) => de("p-4 border-t-2", {
      "border-t-primary": s.id === t.active,
      "border-t-transparent cursor-pointer": s.id !== t.active
    }),
    [t.active]
  ), i = ne(
    () => de("p-6", {
      "bg-gray-darker": !t.light && !t.dark,
      "bg-black-light": t.dark,
      "bg-white": t.light
    }),
    [t.light, t.dark]
  ), r = ne(() => {
    const { Component: s, LazyComponent: a, lazyProps: o } = t.tabs.find((l) => l.id === t.active) ?? {};
    return a ? /* @__PURE__ */ w(T1, { children: /* @__PURE__ */ w(a, { ...o || {} }) }) : s;
  }, [t.tabs, t.active]);
  return /* @__PURE__ */ ae("div", { children: [
    /* @__PURE__ */ w("div", { className: "flex", children: t.tabs.map((s, a) => /* @__PURE__ */ w("div", { className: e(s, a), onClick: () => t.setActive(s.id), children: /* @__PURE__ */ w("div", { className: n(s), children: s.title }) }, s.id)) }),
    /* @__PURE__ */ w("div", { className: i, children: r })
  ] });
};
function Ry(t) {
  var n, i;
  const e = le(
    (r) => (r / t.total * 100).toFixed(1),
    [t.total]
  );
  return /* @__PURE__ */ ae("div", { className: "flex flex-col gap-12", children: [
    /* @__PURE__ */ w("div", { className: "flex gap-0.5 h-4", children: (n = t.items) == null ? void 0 : n.map(
      (r) => !!r.count && /* @__PURE__ */ w(
        "div",
        {
          style: { width: e(r.count) + "%" },
          children: /* @__PURE__ */ ae("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ ae("div", { className: "whitespace-nowrap overflow-hidden text-ellipsis text-center text-xs text-gray", children: [
              r.count,
              " (",
              e(r.count),
              "%)"
            ] }),
            /* @__PURE__ */ w(
              "div",
              {
                className: "h-4",
                style: { backgroundColor: r.color }
              }
            )
          ] })
        },
        r.label
      )
    ) }),
    /* @__PURE__ */ w("div", { className: "flex gap-8 items-center", children: (i = t.items) == null ? void 0 : i.map((r) => /* @__PURE__ */ ae("div", { className: "flex gap-2 items-center", children: [
      /* @__PURE__ */ w("div", { className: "w-4 h-4", style: { backgroundColor: r.color } }),
      /* @__PURE__ */ w("div", { className: "text-base font-normal", children: r.label })
    ] }, r.label)) })
  ] });
}
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function dr(t) {
  return t + 0.5 | 0;
}
const tn = (t, e, n) => Math.max(Math.min(t, n), e);
function Vi(t) {
  return tn(dr(t * 2.55), 0, 255);
}
function ln(t) {
  return tn(dr(t * 255), 0, 255);
}
function jt(t) {
  return tn(dr(t / 2.55) / 100, 0, 1);
}
function Ec(t) {
  return tn(dr(t * 100), 0, 100);
}
const pt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, go = [..."0123456789ABCDEF"], Um = (t) => go[t & 15], Qm = (t) => go[(t & 240) >> 4] + go[t & 15], Sr = (t) => (t & 240) >> 4 === (t & 15), Km = (t) => Sr(t.r) && Sr(t.g) && Sr(t.b) && Sr(t.a);
function Gm(t) {
  var e = t.length, n;
  return t[0] === "#" && (e === 4 || e === 5 ? n = {
    r: 255 & pt[t[1]] * 17,
    g: 255 & pt[t[2]] * 17,
    b: 255 & pt[t[3]] * 17,
    a: e === 5 ? pt[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (n = {
    r: pt[t[1]] << 4 | pt[t[2]],
    g: pt[t[3]] << 4 | pt[t[4]],
    b: pt[t[5]] << 4 | pt[t[6]],
    a: e === 9 ? pt[t[7]] << 4 | pt[t[8]] : 255
  })), n;
}
const qm = (t, e) => t < 255 ? e(t) : "";
function Zm(t) {
  var e = Km(t) ? Um : Qm;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + qm(t.a, e) : void 0;
}
const Jm = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Hh(t, e, n) {
  const i = e * Math.min(n, 1 - n), r = (s, a = (s + t / 30) % 12) => n - i * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [r(0), r(8), r(4)];
}
function Xm(t, e, n) {
  const i = (r, s = (r + t / 60) % 6) => n - n * e * Math.max(Math.min(s, 4 - s, 1), 0);
  return [i(5), i(3), i(1)];
}
function e3(t, e, n) {
  const i = Hh(t, 1, 0.5);
  let r;
  for (e + n > 1 && (r = 1 / (e + n), e *= r, n *= r), r = 0; r < 3; r++)
    i[r] *= 1 - e - n, i[r] += e;
  return i;
}
function t3(t, e, n, i, r) {
  return t === r ? (e - n) / i + (e < n ? 6 : 0) : e === r ? (n - t) / i + 2 : (t - e) / i + 4;
}
function el(t) {
  const n = t.r / 255, i = t.g / 255, r = t.b / 255, s = Math.max(n, i, r), a = Math.min(n, i, r), o = (s + a) / 2;
  let l, c, u;
  return s !== a && (u = s - a, c = o > 0.5 ? u / (2 - s - a) : u / (s + a), l = t3(n, i, r, u, s), l = l * 60 + 0.5), [l | 0, c || 0, o];
}
function tl(t, e, n, i) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, n, i)).map(ln);
}
function nl(t, e, n) {
  return tl(Hh, t, e, n);
}
function n3(t, e, n) {
  return tl(e3, t, e, n);
}
function i3(t, e, n) {
  return tl(Xm, t, e, n);
}
function jh(t) {
  return (t % 360 + 360) % 360;
}
function r3(t) {
  const e = Jm.exec(t);
  let n = 255, i;
  if (!e)
    return;
  e[5] !== i && (n = e[6] ? Vi(+e[5]) : ln(+e[5]));
  const r = jh(+e[2]), s = +e[3] / 100, a = +e[4] / 100;
  return e[1] === "hwb" ? i = n3(r, s, a) : e[1] === "hsv" ? i = i3(r, s, a) : i = nl(r, s, a), {
    r: i[0],
    g: i[1],
    b: i[2],
    a: n
  };
}
function s3(t, e) {
  var n = el(t);
  n[0] = jh(n[0] + e), n = nl(n), t.r = n[0], t.g = n[1], t.b = n[2];
}
function a3(t) {
  if (!t)
    return;
  const e = el(t), n = e[0], i = Ec(e[1]), r = Ec(e[2]);
  return t.a < 255 ? `hsla(${n}, ${i}%, ${r}%, ${jt(t.a)})` : `hsl(${n}, ${i}%, ${r}%)`;
}
const kc = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, _c = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function o3() {
  const t = {}, e = Object.keys(_c), n = Object.keys(kc);
  let i, r, s, a, o;
  for (i = 0; i < e.length; i++) {
    for (a = o = e[i], r = 0; r < n.length; r++)
      s = n[r], o = o.replace(s, kc[s]);
    s = parseInt(_c[a], 16), t[o] = [s >> 16 & 255, s >> 8 & 255, s & 255];
  }
  return t;
}
let Er;
function l3(t) {
  Er || (Er = o3(), Er.transparent = [0, 0, 0, 0]);
  const e = Er[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const c3 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function u3(t) {
  const e = c3.exec(t);
  let n = 255, i, r, s;
  if (e) {
    if (e[7] !== i) {
      const a = +e[7];
      n = e[8] ? Vi(a) : tn(a * 255, 0, 255);
    }
    return i = +e[1], r = +e[3], s = +e[5], i = 255 & (e[2] ? Vi(i) : tn(i, 0, 255)), r = 255 & (e[4] ? Vi(r) : tn(r, 0, 255)), s = 255 & (e[6] ? Vi(s) : tn(s, 0, 255)), {
      r: i,
      g: r,
      b: s,
      a: n
    };
  }
}
function d3(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${jt(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const ya = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, Gn = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function h3(t, e, n) {
  const i = Gn(jt(t.r)), r = Gn(jt(t.g)), s = Gn(jt(t.b));
  return {
    r: ln(ya(i + n * (Gn(jt(e.r)) - i))),
    g: ln(ya(r + n * (Gn(jt(e.g)) - r))),
    b: ln(ya(s + n * (Gn(jt(e.b)) - s))),
    a: t.a + n * (e.a - t.a)
  };
}
function kr(t, e, n) {
  if (t) {
    let i = el(t);
    i[e] = Math.max(0, Math.min(i[e] + i[e] * n, e === 0 ? 360 : 1)), i = nl(i), t.r = i[0], t.g = i[1], t.b = i[2];
  }
}
function $h(t, e) {
  return t && Object.assign(e || {}, t);
}
function Mc(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = ln(t[3]))) : (e = $h(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = ln(e.a)), e;
}
function f3(t) {
  return t.charAt(0) === "r" ? u3(t) : r3(t);
}
class tr {
  constructor(e) {
    if (e instanceof tr)
      return e;
    const n = typeof e;
    let i;
    n === "object" ? i = Mc(e) : n === "string" && (i = Gm(e) || l3(e) || f3(e)), this._rgb = i, this._valid = !!i;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = $h(this._rgb);
    return e && (e.a = jt(e.a)), e;
  }
  set rgb(e) {
    this._rgb = Mc(e);
  }
  rgbString() {
    return this._valid ? d3(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? Zm(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? a3(this._rgb) : void 0;
  }
  mix(e, n) {
    if (e) {
      const i = this.rgb, r = e.rgb;
      let s;
      const a = n === s ? 0.5 : n, o = 2 * a - 1, l = i.a - r.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      s = 1 - c, i.r = 255 & c * i.r + s * r.r + 0.5, i.g = 255 & c * i.g + s * r.g + 0.5, i.b = 255 & c * i.b + s * r.b + 0.5, i.a = a * i.a + (1 - a) * r.a, this.rgb = i;
    }
    return this;
  }
  interpolate(e, n) {
    return e && (this._rgb = h3(this._rgb, e._rgb, n)), this;
  }
  clone() {
    return new tr(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = ln(e), this;
  }
  clearer(e) {
    const n = this._rgb;
    return n.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, n = dr(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = n, this;
  }
  opaquer(e) {
    const n = this._rgb;
    return n.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return kr(this._rgb, 2, e), this;
  }
  darken(e) {
    return kr(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return kr(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return kr(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return s3(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function It() {
}
const g3 = /* @__PURE__ */ (() => {
  let t = 0;
  return () => t++;
})();
function De(t) {
  return t === null || typeof t > "u";
}
function Ne(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function Ae(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function qe(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function ft(t, e) {
  return qe(t) ? t : e;
}
function we(t, e) {
  return typeof t > "u" ? e : t;
}
const m3 = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 : +t / e, Wh = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function Pe(t, e, n) {
  if (t && typeof t.call == "function")
    return t.apply(n, e);
}
function Oe(t, e, n, i) {
  let r, s, a;
  if (Ne(t))
    for (s = t.length, r = 0; r < s; r++)
      e.call(n, t[r], r);
  else if (Ae(t))
    for (a = Object.keys(t), s = a.length, r = 0; r < s; r++)
      e.call(n, t[a[r]], a[r]);
}
function ds(t, e) {
  let n, i, r, s;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (n = 0, i = t.length; n < i; ++n)
    if (r = t[n], s = e[n], r.datasetIndex !== s.datasetIndex || r.index !== s.index)
      return !1;
  return !0;
}
function hs(t) {
  if (Ne(t))
    return t.map(hs);
  if (Ae(t)) {
    const e = /* @__PURE__ */ Object.create(null), n = Object.keys(t), i = n.length;
    let r = 0;
    for (; r < i; ++r)
      e[n[r]] = hs(t[n[r]]);
    return e;
  }
  return t;
}
function Yh(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function p3(t, e, n, i) {
  if (!Yh(t))
    return;
  const r = e[t], s = n[t];
  Ae(r) && Ae(s) ? nr(r, s, i) : e[t] = hs(s);
}
function nr(t, e, n) {
  const i = Ne(e) ? e : [
    e
  ], r = i.length;
  if (!Ae(t))
    return t;
  n = n || {};
  const s = n.merger || p3;
  let a;
  for (let o = 0; o < r; ++o) {
    if (a = i[o], !Ae(a))
      continue;
    const l = Object.keys(a);
    for (let c = 0, u = l.length; c < u; ++c)
      s(l[c], t, a, n);
  }
  return t;
}
function Qi(t, e) {
  return nr(t, e, {
    merger: b3
  });
}
function b3(t, e, n) {
  if (!Yh(t))
    return;
  const i = e[t], r = n[t];
  Ae(i) && Ae(r) ? Qi(i, r) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = hs(r));
}
const Oc = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function v3(t) {
  const e = t.split("."), n = [];
  let i = "";
  for (const r of e)
    i += r, i.endsWith("\\") ? i = i.slice(0, -1) + "." : (n.push(i), i = "");
  return n;
}
function y3(t) {
  const e = v3(t);
  return (n) => {
    for (const i of e) {
      if (i === "")
        break;
      n = n && n[i];
    }
    return n;
  };
}
function Rn(t, e) {
  return (Oc[e] || (Oc[e] = y3(e)))(t);
}
function il(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const ir = (t) => typeof t < "u", gn = (t) => typeof t == "function", Dc = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
};
function x3(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const Ye = Math.PI, Ve = 2 * Ye, fs = Number.POSITIVE_INFINITY, A3 = Ye / 180, je = Ye / 2, bn = Ye / 4, Pc = Ye * 2 / 3, nn = Math.log10, cn = Math.sign;
function Gr(t, e, n) {
  return Math.abs(t - e) < n;
}
function Fc(t) {
  const e = Math.round(t);
  t = Gr(t, e, t / 1e3) ? e : t;
  const n = Math.pow(10, Math.floor(nn(t))), i = t / n;
  return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * n;
}
function C3(t) {
  const e = [], n = Math.sqrt(t);
  let i;
  for (i = 1; i < n; i++)
    t % i === 0 && (e.push(i), e.push(t / i));
  return n === (n | 0) && e.push(n), e.sort((r, s) => r - s).pop(), e;
}
function gs(t) {
  return !isNaN(parseFloat(t)) && isFinite(t);
}
function w3(t, e) {
  const n = Math.round(t);
  return n - e <= t && n + e >= t;
}
function zh(t, e, n) {
  let i, r, s;
  for (i = 0, r = t.length; i < r; i++)
    s = t[i][n], isNaN(s) || (e.min = Math.min(e.min, s), e.max = Math.max(e.max, s));
}
function Pt(t) {
  return t * (Ye / 180);
}
function rl(t) {
  return t * (180 / Ye);
}
function Tc(t) {
  if (!qe(t))
    return;
  let e = 1, n = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, n++;
  return n;
}
function Uh(t, e) {
  const n = e.x - t.x, i = e.y - t.y, r = Math.sqrt(n * n + i * i);
  let s = Math.atan2(i, n);
  return s < -0.5 * Ye && (s += Ve), {
    angle: s,
    distance: r
  };
}
function S3(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function Mt(t) {
  return (t % Ve + Ve) % Ve;
}
function ms(t, e, n, i) {
  const r = Mt(t), s = Mt(e), a = Mt(n), o = Mt(s - r), l = Mt(a - r), c = Mt(r - s), u = Mt(r - a);
  return r === s || r === a || i && s === a || o > l && c < u;
}
function dt(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function E3(t) {
  return dt(t, -32768, 32767);
}
function En(t, e, n, i = 1e-6) {
  return t >= Math.min(e, n) - i && t <= Math.max(e, n) + i;
}
function sl(t, e, n) {
  n = n || ((a) => t[a] < e);
  let i = t.length - 1, r = 0, s;
  for (; i - r > 1; )
    s = r + i >> 1, n(s) ? r = s : i = s;
  return {
    lo: r,
    hi: i
  };
}
const mo = (t, e, n, i) => sl(t, n, i ? (r) => {
  const s = t[r][e];
  return s < n || s === n && t[r + 1][e] === n;
} : (r) => t[r][e] < n), k3 = (t, e, n) => sl(t, n, (i) => t[i][e] >= n);
function _3(t, e, n) {
  let i = 0, r = t.length;
  for (; i < r && t[i] < e; )
    i++;
  for (; r > i && t[r - 1] > n; )
    r--;
  return i > 0 || r < t.length ? t.slice(i, r) : t;
}
const Qh = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function M3(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), Qh.forEach((n) => {
    const i = "_onData" + il(n), r = t[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      value(...s) {
        const a = r.apply(this, s);
        return t._chartjs.listeners.forEach((o) => {
          typeof o[i] == "function" && o[i](...s);
        }), a;
      }
    });
  });
}
function Ic(t, e) {
  const n = t._chartjs;
  if (!n)
    return;
  const i = n.listeners, r = i.indexOf(e);
  r !== -1 && i.splice(r, 1), !(i.length > 0) && (Qh.forEach((s) => {
    delete t[s];
  }), delete t._chartjs);
}
function Kh(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const Gh = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function qh(t, e) {
  let n = [], i = !1;
  return function(...r) {
    n = r, i || (i = !0, Gh.call(window, () => {
      i = !1, t.apply(e, n);
    }));
  };
}
function O3(t, e) {
  let n;
  return function(...i) {
    return e ? (clearTimeout(n), n = setTimeout(t, e, i)) : t.apply(this, i), e;
  };
}
const Zh = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", ht = (t, e, n) => t === "start" ? e : t === "end" ? n : (e + n) / 2, D3 = (t, e, n, i) => t === (i ? "left" : "right") ? n : t === "center" ? (e + n) / 2 : e, _r = (t) => t === 0 || t === 1, Rc = (t, e, n) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * Ve / n)), Bc = (t, e, n) => Math.pow(2, -10 * t) * Math.sin((t - e) * Ve / n) + 1, Ki = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * je) + 1,
  easeOutSine: (t) => Math.sin(t * je),
  easeInOutSine: (t) => -0.5 * (Math.cos(Ye * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => _r(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => _r(t) ? t : Rc(t, 0.075, 0.3),
  easeOutElastic: (t) => _r(t) ? t : Bc(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return _r(t) ? t : t < 0.5 ? 0.5 * Rc(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * Bc(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - Ki.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? Ki.easeInBounce(t * 2) * 0.5 : Ki.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function Jh(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function Lc(t) {
  return Jh(t) ? t : new tr(t);
}
function xa(t) {
  return Jh(t) ? t : new tr(t).saturate(0.5).darken(0.1).hexString();
}
const P3 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], F3 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function T3(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: F3
    },
    numbers: {
      type: "number",
      properties: P3
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function I3(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Nc = /* @__PURE__ */ new Map();
function R3(t, e) {
  e = e || {};
  const n = t + JSON.stringify(e);
  let i = Nc.get(n);
  return i || (i = new Intl.NumberFormat(t, e), Nc.set(n, i)), i;
}
function Ws(t, e, n) {
  return R3(e, n).format(t);
}
const Xh = {
  values(t) {
    return Ne(t) ? t : "" + t;
  },
  numeric(t, e, n) {
    if (t === 0)
      return "0";
    const i = this.chart.options.locale;
    let r, s = t;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (r = "scientific"), s = B3(t, n);
    }
    const a = nn(Math.abs(s)), o = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), l = {
      notation: r,
      minimumFractionDigits: o,
      maximumFractionDigits: o
    };
    return Object.assign(l, this.options.ticks.format), Ws(t, i, l);
  },
  logarithmic(t, e, n) {
    if (t === 0)
      return "0";
    const i = n[e].significand || t / Math.pow(10, Math.floor(nn(t)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(i) || e > 0.8 * n.length ? Xh.numeric.call(this, t, e, n) : "";
  }
};
function B3(t, e) {
  let n = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(n) >= 1 && t !== Math.floor(t) && (n = t - Math.floor(t)), n;
}
var Ys = {
  formatters: Xh
};
function L3(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, n) => n.lineWidth,
      tickColor: (e, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ys.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const Bn = /* @__PURE__ */ Object.create(null), po = /* @__PURE__ */ Object.create(null);
function Gi(t, e) {
  if (!e)
    return t;
  const n = e.split(".");
  for (let i = 0, r = n.length; i < r; ++i) {
    const s = n[i];
    t = t[s] || (t[s] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function Aa(t, e, n) {
  return typeof e == "string" ? nr(Gi(t, e), n) : nr(Gi(t, ""), e);
}
class N3 {
  constructor(e, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (i) => i.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (i, r) => xa(r.backgroundColor), this.hoverBorderColor = (i, r) => xa(r.borderColor), this.hoverColor = (i, r) => xa(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(n);
  }
  set(e, n) {
    return Aa(this, e, n);
  }
  get(e) {
    return Gi(this, e);
  }
  describe(e, n) {
    return Aa(po, e, n);
  }
  override(e, n) {
    return Aa(Bn, e, n);
  }
  route(e, n, i, r) {
    const s = Gi(this, e), a = Gi(this, i), o = "_" + n;
    Object.defineProperties(s, {
      [o]: {
        value: s[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[o], c = a[r];
          return Ae(l) ? Object.assign({}, c, l) : we(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((n) => n(this));
  }
}
var He = /* @__PURE__ */ new N3({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  T3,
  I3,
  L3
]);
function V3(t) {
  return !t || De(t.size) || De(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function ps(t, e, n, i, r) {
  let s = e[r];
  return s || (s = e[r] = t.measureText(r).width, n.push(r)), s > i && (i = s), i;
}
function H3(t, e, n, i) {
  i = i || {};
  let r = i.data = i.data || {}, s = i.garbageCollect = i.garbageCollect || [];
  i.font !== e && (r = i.data = {}, s = i.garbageCollect = [], i.font = e), t.save(), t.font = e;
  let a = 0;
  const o = n.length;
  let l, c, u, d, h;
  for (l = 0; l < o; l++)
    if (d = n[l], d != null && !Ne(d))
      a = ps(t, r, s, a, d);
    else if (Ne(d))
      for (c = 0, u = d.length; c < u; c++)
        h = d[c], h != null && !Ne(h) && (a = ps(t, r, s, a, h));
  t.restore();
  const g = s.length / 2;
  if (g > n.length) {
    for (l = 0; l < g; l++)
      delete r[s[l]];
    s.splice(0, g);
  }
  return a;
}
function vn(t, e, n) {
  const i = t.currentDevicePixelRatio, r = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((e - r) * i) / i + r;
}
function Vc(t, e) {
  e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore();
}
function Hc(t, e, n, i) {
  ef(t, e, n, i, null);
}
function ef(t, e, n, i, r) {
  let s, a, o, l, c, u, d, h;
  const g = e.pointStyle, b = e.rotation, m = e.radius;
  let p = (b || 0) * A3;
  if (g && typeof g == "object" && (s = g.toString(), s === "[object HTMLImageElement]" || s === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(n, i), t.rotate(p), t.drawImage(g, -g.width / 2, -g.height / 2, g.width, g.height), t.restore();
    return;
  }
  if (!(isNaN(m) || m <= 0)) {
    switch (t.beginPath(), g) {
      default:
        r ? t.ellipse(n, i, r / 2, m, 0, 0, Ve) : t.arc(n, i, m, 0, Ve), t.closePath();
        break;
      case "triangle":
        u = r ? r / 2 : m, t.moveTo(n + Math.sin(p) * u, i - Math.cos(p) * m), p += Pc, t.lineTo(n + Math.sin(p) * u, i - Math.cos(p) * m), p += Pc, t.lineTo(n + Math.sin(p) * u, i - Math.cos(p) * m), t.closePath();
        break;
      case "rectRounded":
        c = m * 0.516, l = m - c, a = Math.cos(p + bn) * l, d = Math.cos(p + bn) * (r ? r / 2 - c : l), o = Math.sin(p + bn) * l, h = Math.sin(p + bn) * (r ? r / 2 - c : l), t.arc(n - d, i - o, c, p - Ye, p - je), t.arc(n + h, i - a, c, p - je, p), t.arc(n + d, i + o, c, p, p + je), t.arc(n - h, i + a, c, p + je, p + Ye), t.closePath();
        break;
      case "rect":
        if (!b) {
          l = Math.SQRT1_2 * m, u = r ? r / 2 : l, t.rect(n - u, i - l, 2 * u, 2 * l);
          break;
        }
        p += bn;
      case "rectRot":
        d = Math.cos(p) * (r ? r / 2 : m), a = Math.cos(p) * m, o = Math.sin(p) * m, h = Math.sin(p) * (r ? r / 2 : m), t.moveTo(n - d, i - o), t.lineTo(n + h, i - a), t.lineTo(n + d, i + o), t.lineTo(n - h, i + a), t.closePath();
        break;
      case "crossRot":
        p += bn;
      case "cross":
        d = Math.cos(p) * (r ? r / 2 : m), a = Math.cos(p) * m, o = Math.sin(p) * m, h = Math.sin(p) * (r ? r / 2 : m), t.moveTo(n - d, i - o), t.lineTo(n + d, i + o), t.moveTo(n + h, i - a), t.lineTo(n - h, i + a);
        break;
      case "star":
        d = Math.cos(p) * (r ? r / 2 : m), a = Math.cos(p) * m, o = Math.sin(p) * m, h = Math.sin(p) * (r ? r / 2 : m), t.moveTo(n - d, i - o), t.lineTo(n + d, i + o), t.moveTo(n + h, i - a), t.lineTo(n - h, i + a), p += bn, d = Math.cos(p) * (r ? r / 2 : m), a = Math.cos(p) * m, o = Math.sin(p) * m, h = Math.sin(p) * (r ? r / 2 : m), t.moveTo(n - d, i - o), t.lineTo(n + d, i + o), t.moveTo(n + h, i - a), t.lineTo(n - h, i + a);
        break;
      case "line":
        a = r ? r / 2 : Math.cos(p) * m, o = Math.sin(p) * m, t.moveTo(n - a, i - o), t.lineTo(n + a, i + o);
        break;
      case "dash":
        t.moveTo(n, i), t.lineTo(n + Math.cos(p) * (r ? r / 2 : m), i + Math.sin(p) * m);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function ti(t, e, n) {
  return n = n || 0.5, !e || t && t.x > e.left - n && t.x < e.right + n && t.y > e.top - n && t.y < e.bottom + n;
}
function al(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function ol(t) {
  t.restore();
}
function j3(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), De(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function $3(t, e, n, i, r) {
  if (r.strikethrough || r.underline) {
    const s = t.measureText(i), a = e - s.actualBoundingBoxLeft, o = e + s.actualBoundingBoxRight, l = n - s.actualBoundingBoxAscent, c = n + s.actualBoundingBoxDescent, u = r.strikethrough ? (l + c) / 2 : c;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = r.decorationWidth || 2, t.moveTo(a, u), t.lineTo(o, u), t.stroke();
  }
}
function W3(t, e) {
  const n = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = n;
}
function vi(t, e, n, i, r, s = {}) {
  const a = Ne(e) ? e : [
    e
  ], o = s.strokeWidth > 0 && s.strokeColor !== "";
  let l, c;
  for (t.save(), t.font = r.string, j3(t, s), l = 0; l < a.length; ++l)
    c = a[l], s.backdrop && W3(t, s.backdrop), o && (s.strokeColor && (t.strokeStyle = s.strokeColor), De(s.strokeWidth) || (t.lineWidth = s.strokeWidth), t.strokeText(c, n, i, s.maxWidth)), t.fillText(c, n, i, s.maxWidth), $3(t, n, i, c, s), i += Number(r.lineHeight);
  t.restore();
}
function rr(t, e) {
  const { x: n, y: i, w: r, h: s, radius: a } = e;
  t.arc(n + a.topLeft, i + a.topLeft, a.topLeft, 1.5 * Ye, Ye, !0), t.lineTo(n, i + s - a.bottomLeft), t.arc(n + a.bottomLeft, i + s - a.bottomLeft, a.bottomLeft, Ye, je, !0), t.lineTo(n + r - a.bottomRight, i + s), t.arc(n + r - a.bottomRight, i + s - a.bottomRight, a.bottomRight, je, 0, !0), t.lineTo(n + r, i + a.topRight), t.arc(n + r - a.topRight, i + a.topRight, a.topRight, 0, -je, !0), t.lineTo(n + a.topLeft, i);
}
const Y3 = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, z3 = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function U3(t, e) {
  const n = ("" + t).match(Y3);
  if (!n || n[1] === "normal")
    return e * 1.2;
  switch (t = +n[2], n[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const Q3 = (t) => +t || 0;
function ll(t, e) {
  const n = {}, i = Ae(e), r = i ? Object.keys(e) : e, s = Ae(t) ? i ? (a) => we(t[a], t[e[a]]) : (a) => t[a] : () => t;
  for (const a of r)
    n[a] = Q3(s(a));
  return n;
}
function tf(t) {
  return ll(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Dn(t) {
  return ll(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function rt(t) {
  const e = tf(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function et(t, e) {
  t = t || {}, e = e || He.font;
  let n = we(t.size, e.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let i = we(t.style, e.style);
  i && !("" + i).match(z3) && (console.warn('Invalid font style specified: "' + i + '"'), i = void 0);
  const r = {
    family: we(t.family, e.family),
    lineHeight: U3(we(t.lineHeight, e.lineHeight), n),
    size: n,
    style: i,
    weight: we(t.weight, e.weight),
    string: ""
  };
  return r.string = V3(r), r;
}
function Mr(t, e, n, i) {
  let r, s, a;
  for (r = 0, s = t.length; r < s; ++r)
    if (a = t[r], a !== void 0 && a !== void 0)
      return a;
}
function K3(t, e, n) {
  const { min: i, max: r } = t, s = Wh(e, (r - i) / 2), a = (o, l) => n && o === 0 ? 0 : o + l;
  return {
    min: a(i, -Math.abs(s)),
    max: a(r, s)
  };
}
function jn(t, e) {
  return Object.assign(Object.create(t), e);
}
function cl(t, e = [
  ""
], n, i, r = () => t[0]) {
  const s = n || t;
  typeof i > "u" && (i = af("_fallback", t));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: s,
    _fallback: i,
    _getTarget: r,
    override: (o) => cl([
      o,
      ...t
    ], e, s, i)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(o, l) {
      return delete o[l], delete o._keys, delete t[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(o, l) {
      return rf(o, l, () => np(l, e, t, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(o, l) {
      return Reflect.getOwnPropertyDescriptor(o._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(o, l) {
      return $c(o).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(o) {
      return $c(o);
    },
    /**
    * A trap for setting property values.
    */
    set(o, l, c) {
      const u = o._storage || (o._storage = r());
      return o[l] = u[l] = c, delete o._keys, !0;
    }
  });
}
function yi(t, e, n, i) {
  const r = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: nf(t, i),
    setContext: (s) => yi(t, s, n, i),
    override: (s) => yi(t.override(s), e, n, i)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(s, a) {
      return delete s[a], delete t[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(s, a, o) {
      return rf(s, a, () => q3(s, a, o));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(s, a) {
      return s._descriptors.allKeys ? Reflect.has(t, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(s, a) {
      return Reflect.has(t, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(s, a, o) {
      return t[a] = o, delete s[a], !0;
    }
  });
}
function nf(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = e.scriptable, _indexable: i = e.indexable, _allKeys: r = e.allKeys } = t;
  return {
    allKeys: r,
    scriptable: n,
    indexable: i,
    isScriptable: gn(n) ? n : () => n,
    isIndexable: gn(i) ? i : () => i
  };
}
const G3 = (t, e) => t ? t + il(e) : e, ul = (t, e) => Ae(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function rf(t, e, n) {
  if (Object.prototype.hasOwnProperty.call(t, e))
    return t[e];
  const i = n();
  return t[e] = i, i;
}
function q3(t, e, n) {
  const { _proxy: i, _context: r, _subProxy: s, _descriptors: a } = t;
  let o = i[e];
  return gn(o) && a.isScriptable(e) && (o = Z3(e, o, t, n)), Ne(o) && o.length && (o = J3(e, o, t, a.isIndexable)), ul(e, o) && (o = yi(o, r, s && s[e], a)), o;
}
function Z3(t, e, n, i) {
  const { _proxy: r, _context: s, _subProxy: a, _stack: o } = n;
  if (o.has(t))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + t);
  o.add(t);
  let l = e(s, a || i);
  return o.delete(t), ul(t, l) && (l = dl(r._scopes, r, t, l)), l;
}
function J3(t, e, n, i) {
  const { _proxy: r, _context: s, _subProxy: a, _descriptors: o } = n;
  if (typeof s.index < "u" && i(t))
    return e[s.index % e.length];
  if (Ae(e[0])) {
    const l = e, c = r._scopes.filter((u) => u !== l);
    e = [];
    for (const u of l) {
      const d = dl(c, r, t, u);
      e.push(yi(d, s, a && a[t], o));
    }
  }
  return e;
}
function sf(t, e, n) {
  return gn(t) ? t(e, n) : t;
}
const X3 = (t, e) => t === !0 ? e : typeof t == "string" ? Rn(e, t) : void 0;
function ep(t, e, n, i, r) {
  for (const s of e) {
    const a = X3(n, s);
    if (a) {
      t.add(a);
      const o = sf(a._fallback, n, r);
      if (typeof o < "u" && o !== n && o !== i)
        return o;
    } else if (a === !1 && typeof i < "u" && n !== i)
      return null;
  }
  return !1;
}
function dl(t, e, n, i) {
  const r = e._rootScopes, s = sf(e._fallback, n, i), a = [
    ...t,
    ...r
  ], o = /* @__PURE__ */ new Set();
  o.add(i);
  let l = jc(o, a, n, s || n, i);
  return l === null || typeof s < "u" && s !== n && (l = jc(o, a, s, l, i), l === null) ? !1 : cl(Array.from(o), [
    ""
  ], r, s, () => tp(e, n, i));
}
function jc(t, e, n, i, r) {
  for (; n; )
    n = ep(t, e, n, i, r);
  return n;
}
function tp(t, e, n) {
  const i = t._getTarget();
  e in i || (i[e] = {});
  const r = i[e];
  return Ne(r) && Ae(n) ? n : r || {};
}
function np(t, e, n, i) {
  let r;
  for (const s of e)
    if (r = af(G3(s, t), n), typeof r < "u")
      return ul(t, r) ? dl(n, i, t, r) : r;
}
function af(t, e) {
  for (const n of e) {
    if (!n)
      continue;
    const i = n[t];
    if (typeof i < "u")
      return i;
  }
}
function $c(t) {
  let e = t._keys;
  return e || (e = t._keys = ip(t._scopes)), e;
}
function ip(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const i of Object.keys(n).filter((r) => !r.startsWith("_")))
      e.add(i);
  return Array.from(e);
}
function hl() {
  return typeof window < "u" && typeof document < "u";
}
function fl(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function bs(t, e, n) {
  let i;
  return typeof t == "string" ? (i = parseInt(t, 10), t.indexOf("%") !== -1 && (i = i / 100 * e.parentNode[n])) : i = t, i;
}
const zs = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function rp(t, e) {
  return zs(t).getPropertyValue(e);
}
const sp = [
  "top",
  "right",
  "bottom",
  "left"
];
function Pn(t, e, n) {
  const i = {};
  n = n ? "-" + n : "";
  for (let r = 0; r < 4; r++) {
    const s = sp[r];
    i[s] = parseFloat(t[e + "-" + s + n]) || 0;
  }
  return i.width = i.left + i.right, i.height = i.top + i.bottom, i;
}
const ap = (t, e, n) => (t > 0 || e > 0) && (!n || !n.shadowRoot);
function op(t, e) {
  const n = t.touches, i = n && n.length ? n[0] : t, { offsetX: r, offsetY: s } = i;
  let a = !1, o, l;
  if (ap(r, s, t.target))
    o = r, l = s;
  else {
    const c = e.getBoundingClientRect();
    o = i.clientX - c.left, l = i.clientY - c.top, a = !0;
  }
  return {
    x: o,
    y: l,
    box: a
  };
}
function An(t, e) {
  if ("native" in t)
    return t;
  const { canvas: n, currentDevicePixelRatio: i } = e, r = zs(n), s = r.boxSizing === "border-box", a = Pn(r, "padding"), o = Pn(r, "border", "width"), { x: l, y: c, box: u } = op(t, n), d = a.left + (u && o.left), h = a.top + (u && o.top);
  let { width: g, height: b } = e;
  return s && (g -= a.width + o.width, b -= a.height + o.height), {
    x: Math.round((l - d) / g * n.width / i),
    y: Math.round((c - h) / b * n.height / i)
  };
}
function lp(t, e, n) {
  let i, r;
  if (e === void 0 || n === void 0) {
    const s = fl(t);
    if (!s)
      e = t.clientWidth, n = t.clientHeight;
    else {
      const a = s.getBoundingClientRect(), o = zs(s), l = Pn(o, "border", "width"), c = Pn(o, "padding");
      e = a.width - c.width - l.width, n = a.height - c.height - l.height, i = bs(o.maxWidth, s, "clientWidth"), r = bs(o.maxHeight, s, "clientHeight");
    }
  }
  return {
    width: e,
    height: n,
    maxWidth: i || fs,
    maxHeight: r || fs
  };
}
const Or = (t) => Math.round(t * 10) / 10;
function cp(t, e, n, i) {
  const r = zs(t), s = Pn(r, "margin"), a = bs(r.maxWidth, t, "clientWidth") || fs, o = bs(r.maxHeight, t, "clientHeight") || fs, l = lp(t, e, n);
  let { width: c, height: u } = l;
  if (r.boxSizing === "content-box") {
    const h = Pn(r, "border", "width"), g = Pn(r, "padding");
    c -= g.width + h.width, u -= g.height + h.height;
  }
  return c = Math.max(0, c - s.width), u = Math.max(0, i ? c / i : u - s.height), c = Or(Math.min(c, a, l.maxWidth)), u = Or(Math.min(u, o, l.maxHeight)), c && !u && (u = Or(c / 2)), (e !== void 0 || n !== void 0) && i && l.height && u > l.height && (u = l.height, c = Or(Math.floor(u * i))), {
    width: c,
    height: u
  };
}
function Wc(t, e, n) {
  const i = e || 1, r = Math.floor(t.height * i), s = Math.floor(t.width * i);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const a = t.canvas;
  return a.style && (n || !a.style.height && !a.style.width) && (a.style.height = `${t.height}px`, a.style.width = `${t.width}px`), t.currentDevicePixelRatio !== i || a.height !== r || a.width !== s ? (t.currentDevicePixelRatio = i, a.height = r, a.width = s, t.ctx.setTransform(i, 0, 0, i, 0, 0), !0) : !1;
}
const up = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    hl() && (window.addEventListener("test", null, e), window.removeEventListener("test", null, e));
  } catch {
  }
  return t;
}();
function Yc(t, e) {
  const n = rp(t, e), i = n && n.match(/^(\d+)(\.\d+)?px$/);
  return i ? +i[1] : void 0;
}
const dp = function(t, e) {
  return {
    x(n) {
      return t + t + e - n;
    },
    setWidth(n) {
      e = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, i) {
      return n - i;
    },
    leftForLtr(n, i) {
      return n - i;
    }
  };
}, hp = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function ai(t, e, n) {
  return t ? dp(e, n) : hp();
}
function of(t, e) {
  let n, i;
  (e === "ltr" || e === "rtl") && (n = t.canvas.style, i = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", e, "important"), t.prevTextDirection = i);
}
function lf(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class fp {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, n, i, r) {
    const s = n.listeners[r], a = n.duration;
    s.forEach((o) => o({
      chart: e,
      initial: n.initial,
      numSteps: a,
      currentStep: Math.min(i - n.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Gh.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let n = 0;
    this._charts.forEach((i, r) => {
      if (!i.running || !i.items.length)
        return;
      const s = i.items;
      let a = s.length - 1, o = !1, l;
      for (; a >= 0; --a)
        l = s[a], l._active ? (l._total > i.duration && (i.duration = l._total), l.tick(e), o = !0) : (s[a] = s[s.length - 1], s.pop());
      o && (r.draw(), this._notify(r, i, e, "progress")), s.length || (i.running = !1, this._notify(r, i, e, "complete"), i.initial = !1), n += s.length;
    }), this._lastDate = e, n === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const n = this._charts;
    let i = n.get(e);
    return i || (i = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(e, i)), i;
  }
  listen(e, n, i) {
    this._getAnims(e).listeners[n].push(i);
  }
  add(e, n) {
    !n || !n.length || this._getAnims(e).items.push(...n);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const n = this._charts.get(e);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((i, r) => Math.max(i, r._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const n = this._charts.get(e);
    return !(!n || !n.running || !n.items.length);
  }
  stop(e) {
    const n = this._charts.get(e);
    if (!n || !n.items.length)
      return;
    const i = n.items;
    let r = i.length - 1;
    for (; r >= 0; --r)
      i[r].cancel();
    n.items = [], this._notify(e, n, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var Lt = /* @__PURE__ */ new fp();
const zc = "transparent", gp = {
  boolean(t, e, n) {
    return n > 0.5 ? e : t;
  },
  color(t, e, n) {
    const i = Lc(t || zc), r = i.valid && Lc(e || zc);
    return r && r.valid ? r.mix(i, n).hexString() : e;
  },
  number(t, e, n) {
    return t + (e - t) * n;
  }
};
class mp {
  constructor(e, n, i, r) {
    const s = n[i];
    r = Mr([
      e.to,
      r,
      s,
      e.from
    ]);
    const a = Mr([
      e.from,
      s,
      r
    ]);
    this._active = !0, this._fn = e.fn || gp[e.type || typeof a], this._easing = Ki[e.easing] || Ki.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = n, this._prop = i, this._from = a, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, n, i) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], s = i - this._start, a = this._duration - s;
      this._start = i, this._duration = Math.floor(Math.max(a, e.duration)), this._total += s, this._loop = !!e.loop, this._to = Mr([
        e.to,
        n,
        r,
        e.from
      ]), this._from = Mr([
        e.from,
        r,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const n = e - this._start, i = this._duration, r = this._prop, s = this._from, a = this._loop, o = this._to;
    let l;
    if (this._active = s !== o && (a || n < i), !this._active) {
      this._target[r] = o, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[r] = s;
      return;
    }
    l = n / i % 2, l = a && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[r] = this._fn(s, o, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((n, i) => {
      e.push({
        res: n,
        rej: i
      });
    });
  }
  _notify(e) {
    const n = e ? "res" : "rej", i = this._promises || [];
    for (let r = 0; r < i.length; r++)
      i[r][n]();
  }
}
class cf {
  constructor(e, n) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(e) {
    if (!Ae(e))
      return;
    const n = Object.keys(He.animation), i = this._properties;
    Object.getOwnPropertyNames(e).forEach((r) => {
      const s = e[r];
      if (!Ae(s))
        return;
      const a = {};
      for (const o of n)
        a[o] = s[o];
      (Ne(s.properties) && s.properties || [
        r
      ]).forEach((o) => {
        (o === r || !i.has(o)) && i.set(o, a);
      });
    });
  }
  _animateOptions(e, n) {
    const i = n.options, r = bp(e, i);
    if (!r)
      return [];
    const s = this._createAnimations(r, i);
    return i.$shared && pp(e.options.$animations, i).then(() => {
      e.options = i;
    }, () => {
    }), s;
  }
  _createAnimations(e, n) {
    const i = this._properties, r = [], s = e.$animations || (e.$animations = {}), a = Object.keys(n), o = Date.now();
    let l;
    for (l = a.length - 1; l >= 0; --l) {
      const c = a[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        r.push(...this._animateOptions(e, n));
        continue;
      }
      const u = n[c];
      let d = s[c];
      const h = i.get(c);
      if (d)
        if (h && d.active()) {
          d.update(h, u, o);
          continue;
        } else
          d.cancel();
      if (!h || !h.duration) {
        e[c] = u;
        continue;
      }
      s[c] = d = new mp(h, e, c, u), r.push(d);
    }
    return r;
  }
  update(e, n) {
    if (this._properties.size === 0) {
      Object.assign(e, n);
      return;
    }
    const i = this._createAnimations(e, n);
    if (i.length)
      return Lt.add(this._chart, i), !0;
  }
}
function pp(t, e) {
  const n = [], i = Object.keys(e);
  for (let r = 0; r < i.length; r++) {
    const s = t[i[r]];
    s && s.active() && n.push(s.wait());
  }
  return Promise.all(n);
}
function bp(t, e) {
  if (!e)
    return;
  let n = t.options;
  if (!n) {
    t.options = e;
    return;
  }
  return n.$shared && (t.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function Uc(t, e) {
  const n = t && t.options || {}, i = n.reverse, r = n.min === void 0 ? e : 0, s = n.max === void 0 ? e : 0;
  return {
    start: i ? s : r,
    end: i ? r : s
  };
}
function vp(t, e, n) {
  if (n === !1)
    return !1;
  const i = Uc(t, n), r = Uc(e, n);
  return {
    top: r.end,
    right: i.end,
    bottom: r.start,
    left: i.start
  };
}
function yp(t) {
  let e, n, i, r;
  return Ae(t) ? (e = t.top, n = t.right, i = t.bottom, r = t.left) : e = n = i = r = t, {
    top: e,
    right: n,
    bottom: i,
    left: r,
    disabled: t === !1
  };
}
function uf(t, e) {
  const n = [], i = t._getSortedDatasetMetas(e);
  let r, s;
  for (r = 0, s = i.length; r < s; ++r)
    n.push(i[r].index);
  return n;
}
function Qc(t, e, n, i = {}) {
  const r = t.keys, s = i.mode === "single";
  let a, o, l, c;
  if (e !== null) {
    for (a = 0, o = r.length; a < o; ++a) {
      if (l = +r[a], l === n) {
        if (i.all)
          continue;
        break;
      }
      c = t.values[l], qe(c) && (s || e === 0 || cn(e) === cn(c)) && (e += c);
    }
    return e;
  }
}
function xp(t) {
  const e = Object.keys(t), n = new Array(e.length);
  let i, r, s;
  for (i = 0, r = e.length; i < r; ++i)
    s = e[i], n[i] = {
      x: s,
      y: t[s]
    };
  return n;
}
function Kc(t, e) {
  const n = t && t.options.stacked;
  return n || n === void 0 && e.stack !== void 0;
}
function Ap(t, e, n) {
  return `${t.id}.${e.id}.${n.stack || n.type}`;
}
function Cp(t) {
  const { min: e, max: n, minDefined: i, maxDefined: r } = t.getUserBounds();
  return {
    min: i ? e : Number.NEGATIVE_INFINITY,
    max: r ? n : Number.POSITIVE_INFINITY
  };
}
function wp(t, e, n) {
  const i = t[e] || (t[e] = {});
  return i[n] || (i[n] = {});
}
function Gc(t, e, n, i) {
  for (const r of e.getMatchingVisibleMetas(i).reverse()) {
    const s = t[r.index];
    if (n && s > 0 || !n && s < 0)
      return r.index;
  }
  return null;
}
function qc(t, e) {
  const { chart: n, _cachedMeta: i } = t, r = n._stacks || (n._stacks = {}), { iScale: s, vScale: a, index: o } = i, l = s.axis, c = a.axis, u = Ap(s, a, i), d = e.length;
  let h;
  for (let g = 0; g < d; ++g) {
    const b = e[g], { [l]: m, [c]: p } = b, x = b._stacks || (b._stacks = {});
    h = x[c] = wp(r, u, m), h[o] = p, h._top = Gc(h, a, !0, i.type), h._bottom = Gc(h, a, !1, i.type);
    const C = h._visualValues || (h._visualValues = {});
    C[o] = p;
  }
}
function Ca(t, e) {
  const n = t.scales;
  return Object.keys(n).filter((i) => n[i].axis === e).shift();
}
function Sp(t, e) {
  return jn(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function Ep(t, e, n) {
  return jn(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: e,
    mode: "default",
    type: "data"
  });
}
function Di(t, e) {
  const n = t.controller.index, i = t.vScale && t.vScale.axis;
  if (i) {
    e = e || t._parsed;
    for (const r of e) {
      const s = r._stacks;
      if (!s || s[i] === void 0 || s[i][n] === void 0)
        return;
      delete s[i][n], s[i]._visualValues !== void 0 && s[i]._visualValues[n] !== void 0 && delete s[i]._visualValues[n];
    }
  }
}
const wa = (t) => t === "reset" || t === "none", Zc = (t, e) => e ? t : Object.assign({}, t), kp = (t, e, n) => t && !e.hidden && e._stacked && {
  keys: uf(n, !0),
  values: null
};
class oi {
  constructor(e, n) {
    this.chart = e, this._ctx = e.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = Kc(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && Di(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, n = this._cachedMeta, i = this.getDataset(), r = (d, h, g, b) => d === "x" ? h : d === "r" ? b : g, s = n.xAxisID = we(i.xAxisID, Ca(e, "x")), a = n.yAxisID = we(i.yAxisID, Ca(e, "y")), o = n.rAxisID = we(i.rAxisID, Ca(e, "r")), l = n.indexAxis, c = n.iAxisID = r(l, s, a, o), u = n.vAxisID = r(l, a, s, o);
    n.xScale = this.getScaleForId(s), n.yScale = this.getScaleForId(a), n.rScale = this.getScaleForId(o), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const n = this._cachedMeta;
    return e === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && Ic(this._data, this), e._stacked && Di(e);
  }
  _dataCheck() {
    const e = this.getDataset(), n = e.data || (e.data = []), i = this._data;
    if (Ae(n))
      this._data = xp(n);
    else if (i !== n) {
      if (i) {
        Ic(i, this);
        const r = this._cachedMeta;
        Di(r), r._parsed = [];
      }
      n && Object.isExtensible(n) && M3(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const n = this._cachedMeta, i = this.getDataset();
    let r = !1;
    this._dataCheck();
    const s = n._stacked;
    n._stacked = Kc(n.vScale, n), n.stack !== i.stack && (r = !0, Di(n), n.stack = i.stack), this._resyncElements(e), (r || s !== n._stacked) && qc(this, n._parsed);
  }
  configure() {
    const e = this.chart.config, n = e.datasetScopeKeys(this._type), i = e.getOptionScopes(this.getDataset(), n, !0);
    this.options = e.createResolver(i, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, n) {
    const { _cachedMeta: i, _data: r } = this, { iScale: s, _stacked: a } = i, o = s.axis;
    let l = e === 0 && n === r.length ? !0 : i._sorted, c = e > 0 && i._parsed[e - 1], u, d, h;
    if (this._parsing === !1)
      i._parsed = r, i._sorted = !0, h = r;
    else {
      Ne(r[e]) ? h = this.parseArrayData(i, r, e, n) : Ae(r[e]) ? h = this.parseObjectData(i, r, e, n) : h = this.parsePrimitiveData(i, r, e, n);
      const g = () => d[o] === null || c && d[o] < c[o];
      for (u = 0; u < n; ++u)
        i._parsed[u + e] = d = h[u], l && (g() && (l = !1), c = d);
      i._sorted = l;
    }
    a && qc(this, h);
  }
  parsePrimitiveData(e, n, i, r) {
    const { iScale: s, vScale: a } = e, o = s.axis, l = a.axis, c = s.getLabels(), u = s === a, d = new Array(r);
    let h, g, b;
    for (h = 0, g = r; h < g; ++h)
      b = h + i, d[h] = {
        [o]: u || s.parse(c[b], b),
        [l]: a.parse(n[b], b)
      };
    return d;
  }
  parseArrayData(e, n, i, r) {
    const { xScale: s, yScale: a } = e, o = new Array(r);
    let l, c, u, d;
    for (l = 0, c = r; l < c; ++l)
      u = l + i, d = n[u], o[l] = {
        x: s.parse(d[0], u),
        y: a.parse(d[1], u)
      };
    return o;
  }
  parseObjectData(e, n, i, r) {
    const { xScale: s, yScale: a } = e, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(r);
    let u, d, h, g;
    for (u = 0, d = r; u < d; ++u)
      h = u + i, g = n[h], c[u] = {
        x: s.parse(Rn(g, o), h),
        y: a.parse(Rn(g, l), h)
      };
    return c;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, n, i) {
    const r = this.chart, s = this._cachedMeta, a = n[e.axis], o = {
      keys: uf(r, !0),
      values: n._stacks[e.axis]._visualValues
    };
    return Qc(o, a, s.index, {
      mode: i
    });
  }
  updateRangeFromParsed(e, n, i, r) {
    const s = i[n.axis];
    let a = s === null ? NaN : s;
    const o = r && i._stacks[n.axis];
    r && o && (r.values = o, a = Qc(r, s, this._cachedMeta.index)), e.min = Math.min(e.min, a), e.max = Math.max(e.max, a);
  }
  getMinMax(e, n) {
    const i = this._cachedMeta, r = i._parsed, s = i._sorted && e === i.iScale, a = r.length, o = this._getOtherScale(e), l = kp(n, i, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = Cp(o);
    let h, g;
    function b() {
      g = r[h];
      const m = g[o.axis];
      return !qe(g[e.axis]) || u > m || d < m;
    }
    for (h = 0; h < a && !(!b() && (this.updateRangeFromParsed(c, e, g, l), s)); ++h)
      ;
    if (s) {
      for (h = a - 1; h >= 0; --h)
        if (!b()) {
          this.updateRangeFromParsed(c, e, g, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(e) {
    const n = this._cachedMeta._parsed, i = [];
    let r, s, a;
    for (r = 0, s = n.length; r < s; ++r)
      a = n[r][e.axis], qe(a) && i.push(a);
    return i;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, i = n.iScale, r = n.vScale, s = this.getParsed(e);
    return {
      label: i ? "" + i.getLabelForValue(s[i.axis]) : "",
      value: r ? "" + r.getLabelForValue(s[r.axis]) : ""
    };
  }
  _update(e) {
    const n = this._cachedMeta;
    this.update(e || "default"), n._clip = yp(we(this.options.clip, vp(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, n = this.chart, i = this._cachedMeta, r = i.data || [], s = n.chartArea, a = [], o = this._drawStart || 0, l = this._drawCount || r.length - o, c = this.options.drawActiveElementsOnTop;
    let u;
    for (i.dataset && i.dataset.draw(e, s, o, l), u = o; u < o + l; ++u) {
      const d = r[u];
      d.hidden || (d.active && c ? a.push(d) : d.draw(e, s));
    }
    for (u = 0; u < a.length; ++u)
      a[u].draw(e, s);
  }
  getStyle(e, n) {
    const i = n ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(i) : this.resolveDataElementOptions(e || 0, i);
  }
  getContext(e, n, i) {
    const r = this.getDataset();
    let s;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[e];
      s = a.$context || (a.$context = Ep(this.getContext(), e, a)), s.parsed = this.getParsed(e), s.raw = r.data[e], s.index = s.dataIndex = e;
    } else
      s = this.$context || (this.$context = Sp(this.chart.getContext(), this.index)), s.dataset = r, s.index = s.datasetIndex = this.index;
    return s.active = !!n, s.mode = i, s;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, e);
  }
  _resolveElementOptions(e, n = "default", i) {
    const r = n === "active", s = this._cachedDataOpts, a = e + "-" + n, o = s[a], l = this.enableOptionSharing && ir(i);
    if (o)
      return Zc(o, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, e), d = r ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], h = c.getOptionScopes(this.getDataset(), u), g = Object.keys(He.elements[e]), b = () => this.getContext(i, r, n), m = c.resolveNamedOptions(h, g, b, d);
    return m.$shared && (m.$shared = l, s[a] = Object.freeze(Zc(m, l))), m;
  }
  _resolveAnimations(e, n, i) {
    const r = this.chart, s = this._cachedDataOpts, a = `animation-${n}`, o = s[a];
    if (o)
      return o;
    let l;
    if (r.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), h = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(h, this.getContext(e, i, n));
    }
    const c = new cf(r, l && l.animations);
    return l && l._cacheable && (s[a] = Object.freeze(c)), c;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, n) {
    return !n || wa(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, n) {
    const i = this.resolveDataElementOptions(e, n), r = this._sharedOptions, s = this.getSharedOptions(i), a = this.includeOptions(n, s) || s !== r;
    return this.updateSharedOptions(s, n, i), {
      sharedOptions: s,
      includeOptions: a
    };
  }
  updateElement(e, n, i, r) {
    wa(r) ? Object.assign(e, i) : this._resolveAnimations(n, r).update(e, i);
  }
  updateSharedOptions(e, n, i) {
    e && !wa(n) && this._resolveAnimations(void 0, n).update(e, i);
  }
  _setStyle(e, n, i, r) {
    e.active = r;
    const s = this.getStyle(n, r);
    this._resolveAnimations(n, i, r).update(e, {
      options: !r && this.getSharedOptions(s) || s
    });
  }
  removeHoverStyle(e, n, i) {
    this._setStyle(e, i, "active", !1);
  }
  setHoverStyle(e, n, i) {
    this._setStyle(e, i, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const n = this._data, i = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const r = i.length, s = n.length, a = Math.min(s, r);
    a && this.parse(0, a), s > r ? this._insertElements(r, s - r, e) : s < r && this._removeElements(s, r - s);
  }
  _insertElements(e, n, i = !0) {
    const r = this._cachedMeta, s = r.data, a = e + n;
    let o;
    const l = (c) => {
      for (c.length += n, o = c.length - 1; o >= a; o--)
        c[o] = c[o - n];
    };
    for (l(s), o = e; o < a; ++o)
      s[o] = new this.dataElementType();
    this._parsing && l(r._parsed), this.parse(e, n), i && this.updateElements(s, e, n, "reset");
  }
  updateElements(e, n, i, r) {
  }
  _removeElements(e, n) {
    const i = this._cachedMeta;
    if (this._parsing) {
      const r = i._parsed.splice(e, n);
      i._stacked && Di(i, r);
    }
    i.data.splice(e, n);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [n, i, r] = e;
      this[n](i, r);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, n) {
    n && this._sync([
      "_removeElements",
      e,
      n
    ]);
    const i = arguments.length - 2;
    i && this._sync([
      "_insertElements",
      e,
      i
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
ge(oi, "defaults", {}), ge(oi, "datasetElementType", null), ge(oi, "dataElementType", null);
function _p(t, e) {
  if (!t._cache.$bar) {
    const n = t.getMatchingVisibleMetas(e);
    let i = [];
    for (let r = 0, s = n.length; r < s; r++)
      i = i.concat(n[r].controller.getAllParsedValues(t));
    t._cache.$bar = Kh(i.sort((r, s) => r - s));
  }
  return t._cache.$bar;
}
function Mp(t) {
  const e = t.iScale, n = _p(e, t.type);
  let i = e._length, r, s, a, o;
  const l = () => {
    a === 32767 || a === -32768 || (ir(o) && (i = Math.min(i, Math.abs(a - o) || i)), o = a);
  };
  for (r = 0, s = n.length; r < s; ++r)
    a = e.getPixelForValue(n[r]), l();
  for (o = void 0, r = 0, s = e.ticks.length; r < s; ++r)
    a = e.getPixelForTick(r), l();
  return i;
}
function Op(t, e, n, i) {
  const r = n.barThickness;
  let s, a;
  return De(r) ? (s = e.min * n.categoryPercentage, a = n.barPercentage) : (s = r * i, a = 1), {
    chunk: s / i,
    ratio: a,
    start: e.pixels[t] - s / 2
  };
}
function Dp(t, e, n, i) {
  const r = e.pixels, s = r[t];
  let a = t > 0 ? r[t - 1] : null, o = t < r.length - 1 ? r[t + 1] : null;
  const l = n.categoryPercentage;
  a === null && (a = s - (o === null ? e.end - e.start : o - s)), o === null && (o = s + s - a);
  const c = s - (s - Math.min(a, o)) / 2 * l;
  return {
    chunk: Math.abs(o - a) / 2 * l / i,
    ratio: n.barPercentage,
    start: c
  };
}
function Pp(t, e, n, i) {
  const r = n.parse(t[0], i), s = n.parse(t[1], i), a = Math.min(r, s), o = Math.max(r, s);
  let l = a, c = o;
  Math.abs(a) > Math.abs(o) && (l = o, c = a), e[n.axis] = c, e._custom = {
    barStart: l,
    barEnd: c,
    start: r,
    end: s,
    min: a,
    max: o
  };
}
function df(t, e, n, i) {
  return Ne(t) ? Pp(t, e, n, i) : e[n.axis] = n.parse(t, i), e;
}
function Jc(t, e, n, i) {
  const r = t.iScale, s = t.vScale, a = r.getLabels(), o = r === s, l = [];
  let c, u, d, h;
  for (c = n, u = n + i; c < u; ++c)
    h = e[c], d = {}, d[r.axis] = o || r.parse(a[c], c), l.push(df(h, d, s, c));
  return l;
}
function Sa(t) {
  return t && t.barStart !== void 0 && t.barEnd !== void 0;
}
function Fp(t, e, n) {
  return t !== 0 ? cn(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= n ? 1 : -1);
}
function Tp(t) {
  let e, n, i, r, s;
  return t.horizontal ? (e = t.base > t.x, n = "left", i = "right") : (e = t.base < t.y, n = "bottom", i = "top"), e ? (r = "end", s = "start") : (r = "start", s = "end"), {
    start: n,
    end: i,
    reverse: e,
    top: r,
    bottom: s
  };
}
function Ip(t, e, n, i) {
  let r = e.borderSkipped;
  const s = {};
  if (!r) {
    t.borderSkipped = s;
    return;
  }
  if (r === !0) {
    t.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: a, end: o, reverse: l, top: c, bottom: u } = Tp(t);
  r === "middle" && n && (t.enableBorderRadius = !0, (n._top || 0) === i ? r = c : (n._bottom || 0) === i ? r = u : (s[Xc(u, a, o, l)] = !0, r = c)), s[Xc(r, a, o, l)] = !0, t.borderSkipped = s;
}
function Xc(t, e, n, i) {
  return i ? (t = Rp(t, e, n), t = eu(t, n, e)) : t = eu(t, e, n), t;
}
function Rp(t, e, n) {
  return t === e ? n : t === n ? e : t;
}
function eu(t, e, n) {
  return t === "start" ? e : t === "end" ? n : t;
}
function Bp(t, { inflateAmount: e }, n) {
  t.inflateAmount = e === "auto" ? n === 1 ? 0.33 : 0 : e;
}
class qr extends oi {
  parsePrimitiveData(e, n, i, r) {
    return Jc(e, n, i, r);
  }
  parseArrayData(e, n, i, r) {
    return Jc(e, n, i, r);
  }
  parseObjectData(e, n, i, r) {
    const { iScale: s, vScale: a } = e, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = s.axis === "x" ? o : l, u = a.axis === "x" ? o : l, d = [];
    let h, g, b, m;
    for (h = i, g = i + r; h < g; ++h)
      m = n[h], b = {}, b[s.axis] = s.parse(Rn(m, c), h), d.push(df(Rn(m, u), b, a, h));
    return d;
  }
  updateRangeFromParsed(e, n, i, r) {
    super.updateRangeFromParsed(e, n, i, r);
    const s = i._custom;
    s && n === this._cachedMeta.vScale && (e.min = Math.min(e.min, s.min), e.max = Math.max(e.max, s.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, { iScale: i, vScale: r } = n, s = this.getParsed(e), a = s._custom, o = Sa(a) ? "[" + a.start + ", " + a.end + "]" : "" + r.getLabelForValue(s[r.axis]);
    return {
      label: "" + i.getLabelForValue(s[i.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const e = this._cachedMeta;
    e.stack = this.getDataset().stack;
  }
  update(e) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, e);
  }
  updateElements(e, n, i, r) {
    const s = r === "reset", { index: a, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: h } = this._getSharedOptions(n, r);
    for (let g = n; g < n + i; g++) {
      const b = this.getParsed(g), m = s || De(b[o.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(g), p = this._calculateBarIndexPixels(g, u), x = (b._stacks || {})[o.axis], C = {
        horizontal: c,
        base: m.base,
        enableBorderRadius: !x || Sa(b._custom) || a === x._top || a === x._bottom,
        x: c ? m.head : p.center,
        y: c ? p.center : m.head,
        height: c ? p.size : Math.abs(m.size),
        width: c ? Math.abs(m.size) : p.size
      };
      h && (C.options = d || this.resolveDataElementOptions(g, e[g].active ? "active" : r));
      const M = C.options || e[g].options;
      Ip(C, M, x, a), Bp(C, M, u.ratio), this.updateElement(e[g], g, C, r);
    }
  }
  _getStacks(e, n) {
    const { iScale: i } = this._cachedMeta, r = i.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), s = i.options.stacked, a = [], o = (l) => {
      const c = l.controller.getParsed(n), u = c && c[l.vScale.axis];
      if (De(u) || isNaN(u))
        return !0;
    };
    for (const l of r)
      if (!(n !== void 0 && o(l)) && ((s === !1 || a.indexOf(l.stack) === -1 || s === void 0 && l.stack === void 0) && a.push(l.stack), l.index === e))
        break;
    return a.length || a.push(void 0), a;
  }
  _getStackCount(e) {
    return this._getStacks(void 0, e).length;
  }
  _getStackIndex(e, n, i) {
    const r = this._getStacks(e, i), s = n !== void 0 ? r.indexOf(n) : -1;
    return s === -1 ? r.length - 1 : s;
  }
  _getRuler() {
    const e = this.options, n = this._cachedMeta, i = n.iScale, r = [];
    let s, a;
    for (s = 0, a = n.data.length; s < a; ++s)
      r.push(i.getPixelForValue(this.getParsed(s)[i.axis], s));
    const o = e.barThickness;
    return {
      min: o || Mp(n),
      pixels: r,
      start: i._startPixel,
      end: i._endPixel,
      stackCount: this._getStackCount(),
      scale: i,
      grouped: e.grouped,
      ratio: o ? 1 : e.categoryPercentage * e.barPercentage
    };
  }
  _calculateBarValuePixels(e) {
    const { _cachedMeta: { vScale: n, _stacked: i, index: r }, options: { base: s, minBarLength: a } } = this, o = s || 0, l = this.getParsed(e), c = l._custom, u = Sa(c);
    let d = l[n.axis], h = 0, g = i ? this.applyStack(n, l, i) : d, b, m;
    g !== d && (h = g - d, g = d), u && (d = c.barStart, g = c.barEnd - c.barStart, d !== 0 && cn(d) !== cn(c.barEnd) && (h = 0), h += d);
    const p = !De(s) && !u ? s : h;
    let x = n.getPixelForValue(p);
    if (this.chart.getDataVisibility(e) ? b = n.getPixelForValue(h + g) : b = x, m = b - x, Math.abs(m) < a) {
      m = Fp(m, n, o) * a, d === o && (x -= m / 2);
      const C = n.getPixelForDecimal(0), M = n.getPixelForDecimal(1), _ = Math.min(C, M), A = Math.max(C, M);
      x = Math.max(Math.min(x, A), _), b = x + m, i && !u && (l._stacks[n.axis]._visualValues[r] = n.getValueForPixel(b) - n.getValueForPixel(x));
    }
    if (x === n.getPixelForValue(o)) {
      const C = cn(m) * n.getLineWidthForValue(o) / 2;
      x += C, m -= C;
    }
    return {
      size: m,
      base: x,
      head: b,
      center: b + m / 2
    };
  }
  _calculateBarIndexPixels(e, n) {
    const i = n.scale, r = this.options, s = r.skipNull, a = we(r.maxBarThickness, 1 / 0);
    let o, l;
    if (n.grouped) {
      const c = s ? this._getStackCount(e) : n.stackCount, u = r.barThickness === "flex" ? Dp(e, n, r, c) : Op(e, n, r, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, s ? e : void 0);
      o = u.start + u.chunk * d + u.chunk / 2, l = Math.min(a, u.chunk * u.ratio);
    } else
      o = i.getPixelForValue(this.getParsed(e)[i.axis], e), l = Math.min(a, n.min * n.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const e = this._cachedMeta, n = e.vScale, i = e.data, r = i.length;
    let s = 0;
    for (; s < r; ++s)
      this.getParsed(s)[n.axis] !== null && i[s].draw(this._ctx);
  }
}
ge(qr, "id", "bar"), ge(qr, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), ge(qr, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
function Lp(t, e, n) {
  let i = 1, r = 1, s = 0, a = 0;
  if (e < Ve) {
    const o = t, l = o + e, c = Math.cos(o), u = Math.sin(o), d = Math.cos(l), h = Math.sin(l), g = (M, _, A) => ms(M, o, l, !0) ? 1 : Math.max(_, _ * n, A, A * n), b = (M, _, A) => ms(M, o, l, !0) ? -1 : Math.min(_, _ * n, A, A * n), m = g(0, c, d), p = g(je, u, h), x = b(Ye, c, d), C = b(Ye + je, u, h);
    i = (m - x) / 2, r = (p - C) / 2, s = -(m + x) / 2, a = -(p + C) / 2;
  }
  return {
    ratioX: i,
    ratioY: r,
    offsetX: s,
    offsetY: a
  };
}
class Hi extends oi {
  constructor(e, n) {
    super(e, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(e, n) {
    const i = this.getDataset().data, r = this._cachedMeta;
    if (this._parsing === !1)
      r._parsed = i;
    else {
      let s = (l) => +i[l];
      if (Ae(i[e])) {
        const { key: l = "value" } = this._parsing;
        s = (c) => +Rn(i[c], l);
      }
      let a, o;
      for (a = e, o = e + n; a < o; ++a)
        r._parsed[a] = s(a);
    }
  }
  _getRotation() {
    return Pt(this.options.rotation - 90);
  }
  _getCircumference() {
    return Pt(this.options.circumference);
  }
  _getRotationExtents() {
    let e = Ve, n = -Ve;
    for (let i = 0; i < this.chart.data.datasets.length; ++i)
      if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
        const r = this.chart.getDatasetMeta(i).controller, s = r._getRotation(), a = r._getCircumference();
        e = Math.min(e, s), n = Math.max(n, s + a);
      }
    return {
      rotation: e,
      circumference: n - e
    };
  }
  update(e) {
    const n = this.chart, { chartArea: i } = n, r = this._cachedMeta, s = r.data, a = this.getMaxBorderWidth() + this.getMaxOffset(s) + this.options.spacing, o = Math.max((Math.min(i.width, i.height) - a) / 2, 0), l = Math.min(m3(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: h, ratioY: g, offsetX: b, offsetY: m } = Lp(d, u, l), p = (i.width - a) / h, x = (i.height - a) / g, C = Math.max(Math.min(p, x) / 2, 0), M = Wh(this.options.radius, C), _ = Math.max(M * l, 0), A = (M - _) / this._getVisibleDatasetWeightTotal();
    this.offsetX = b * M, this.offsetY = m * M, r.total = this.calculateTotal(), this.outerRadius = M - A * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - A * c, 0), this.updateElements(s, 0, s.length, e);
  }
  _circumference(e, n) {
    const i = this.options, r = this._cachedMeta, s = this._getCircumference();
    return n && i.animation.animateRotate || !this.chart.getDataVisibility(e) || r._parsed[e] === null || r.data[e].hidden ? 0 : this.calculateCircumference(r._parsed[e] * s / Ve);
  }
  updateElements(e, n, i, r) {
    const s = r === "reset", a = this.chart, o = a.chartArea, c = a.options.animation, u = (o.left + o.right) / 2, d = (o.top + o.bottom) / 2, h = s && c.animateScale, g = h ? 0 : this.innerRadius, b = h ? 0 : this.outerRadius, { sharedOptions: m, includeOptions: p } = this._getSharedOptions(n, r);
    let x = this._getRotation(), C;
    for (C = 0; C < n; ++C)
      x += this._circumference(C, s);
    for (C = n; C < n + i; ++C) {
      const M = this._circumference(C, s), _ = e[C], A = {
        x: u + this.offsetX,
        y: d + this.offsetY,
        startAngle: x,
        endAngle: x + M,
        circumference: M,
        outerRadius: b,
        innerRadius: g
      };
      p && (A.options = m || this.resolveDataElementOptions(C, _.active ? "active" : r)), x += M, this.updateElement(_, C, A, r);
    }
  }
  calculateTotal() {
    const e = this._cachedMeta, n = e.data;
    let i = 0, r;
    for (r = 0; r < n.length; r++) {
      const s = e._parsed[r];
      s !== null && !isNaN(s) && this.chart.getDataVisibility(r) && !n[r].hidden && (i += Math.abs(s));
    }
    return i;
  }
  calculateCircumference(e) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(e) ? Ve * (Math.abs(e) / n) : 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, i = this.chart, r = i.data.labels || [], s = Ws(n._parsed[e], i.options.locale);
    return {
      label: r[e] || "",
      value: s
    };
  }
  getMaxBorderWidth(e) {
    let n = 0;
    const i = this.chart;
    let r, s, a, o, l;
    if (!e) {
      for (r = 0, s = i.data.datasets.length; r < s; ++r)
        if (i.isDatasetVisible(r)) {
          a = i.getDatasetMeta(r), e = a.data, o = a.controller;
          break;
        }
    }
    if (!e)
      return 0;
    for (r = 0, s = e.length; r < s; ++r)
      l = o.resolveDataElementOptions(r), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(e) {
    let n = 0;
    for (let i = 0, r = e.length; i < r; ++i) {
      const s = this.resolveDataElementOptions(i);
      n = Math.max(n, s.offset || 0, s.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(e) {
    let n = 0;
    for (let i = 0; i < e; ++i)
      this.chart.isDatasetVisible(i) && (n += this._getRingWeight(i));
    return n;
  }
  _getRingWeight(e) {
    return Math.max(we(this.chart.data.datasets[e].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
ge(Hi, "id", "doughnut"), ge(Hi, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), ge(Hi, "descriptors", {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing" && !e.startsWith("borderDash") && !e.startsWith("hoverBorderDash")
}), ge(Hi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const n = e.data;
          if (n.labels.length && n.datasets.length) {
            const { labels: { pointStyle: i, color: r } } = e.legend.options;
            return n.labels.map((s, a) => {
              const l = e.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: s,
                fillStyle: l.backgroundColor,
                strokeStyle: l.borderColor,
                fontColor: r,
                lineWidth: l.borderWidth,
                pointStyle: i,
                hidden: !e.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(e, n, i) {
        i.chart.toggleDataVisibility(n.index), i.chart.update();
      }
    }
  }
});
function yn() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class gl {
  constructor(e) {
    ge(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(gl.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return yn();
  }
  parse() {
    return yn();
  }
  format() {
    return yn();
  }
  add() {
    return yn();
  }
  diff() {
    return yn();
  }
  startOf() {
    return yn();
  }
  endOf() {
    return yn();
  }
}
var Np = {
  _date: gl
};
function Vp(t, e, n, i) {
  const { controller: r, data: s, _sorted: a } = t, o = r._cachedMeta.iScale;
  if (o && e === o.axis && e !== "r" && a && s.length) {
    const l = o._reversePixels ? k3 : mo;
    if (i) {
      if (r._sharedOptions) {
        const c = s[0], u = typeof c.getRange == "function" && c.getRange(e);
        if (u) {
          const d = l(s, e, n - u), h = l(s, e, n + u);
          return {
            lo: d.lo,
            hi: h.hi
          };
        }
      }
    } else
      return l(s, e, n);
  }
  return {
    lo: 0,
    hi: s.length - 1
  };
}
function hr(t, e, n, i, r) {
  const s = t.getSortedVisibleDatasetMetas(), a = n[e];
  for (let o = 0, l = s.length; o < l; ++o) {
    const { index: c, data: u } = s[o], { lo: d, hi: h } = Vp(s[o], e, a, r);
    for (let g = d; g <= h; ++g) {
      const b = u[g];
      b.skip || i(b, c, g);
    }
  }
}
function Hp(t) {
  const e = t.indexOf("x") !== -1, n = t.indexOf("y") !== -1;
  return function(i, r) {
    const s = e ? Math.abs(i.x - r.x) : 0, a = n ? Math.abs(i.y - r.y) : 0;
    return Math.sqrt(Math.pow(s, 2) + Math.pow(a, 2));
  };
}
function Ea(t, e, n, i, r) {
  const s = [];
  return !r && !t.isPointInArea(e) || hr(t, n, e, function(o, l, c) {
    !r && !ti(o, t.chartArea, 0) || o.inRange(e.x, e.y, i) && s.push({
      element: o,
      datasetIndex: l,
      index: c
    });
  }, !0), s;
}
function jp(t, e, n, i) {
  let r = [];
  function s(a, o, l) {
    const { startAngle: c, endAngle: u } = a.getProps([
      "startAngle",
      "endAngle"
    ], i), { angle: d } = Uh(a, {
      x: e.x,
      y: e.y
    });
    ms(d, c, u) && r.push({
      element: a,
      datasetIndex: o,
      index: l
    });
  }
  return hr(t, n, e, s), r;
}
function $p(t, e, n, i, r, s) {
  let a = [];
  const o = Hp(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, h) {
    const g = u.inRange(e.x, e.y, r);
    if (i && !g)
      return;
    const b = u.getCenterPoint(r);
    if (!(!!s || t.isPointInArea(b)) && !g)
      return;
    const p = o(e, b);
    p < l ? (a = [
      {
        element: u,
        datasetIndex: d,
        index: h
      }
    ], l = p) : p === l && a.push({
      element: u,
      datasetIndex: d,
      index: h
    });
  }
  return hr(t, n, e, c), a;
}
function ka(t, e, n, i, r, s) {
  return !s && !t.isPointInArea(e) ? [] : n === "r" && !i ? jp(t, e, n, r) : $p(t, e, n, i, r, s);
}
function tu(t, e, n, i, r) {
  const s = [], a = n === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return hr(t, n, e, (l, c, u) => {
    l[a](e[n], r) && (s.push({
      element: l,
      datasetIndex: c,
      index: u
    }), o = o || l.inRange(e.x, e.y, r));
  }), i && !o ? [] : s;
}
var Wp = {
  evaluateInteractionItems: hr,
  modes: {
    index(t, e, n, i) {
      const r = An(e, t), s = n.axis || "x", a = n.includeInvisible || !1, o = n.intersect ? Ea(t, r, s, i, a) : ka(t, r, s, !1, i, a), l = [];
      return o.length ? (t.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = o[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(t, e, n, i) {
      const r = An(e, t), s = n.axis || "xy", a = n.includeInvisible || !1;
      let o = n.intersect ? Ea(t, r, s, i, a) : ka(t, r, s, !1, i, a);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = t.getDatasetMeta(l).data;
        o = [];
        for (let u = 0; u < c.length; ++u)
          o.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return o;
    },
    point(t, e, n, i) {
      const r = An(e, t), s = n.axis || "xy", a = n.includeInvisible || !1;
      return Ea(t, r, s, i, a);
    },
    nearest(t, e, n, i) {
      const r = An(e, t), s = n.axis || "xy", a = n.includeInvisible || !1;
      return ka(t, r, s, n.intersect, i, a);
    },
    x(t, e, n, i) {
      const r = An(e, t);
      return tu(t, r, "x", n.intersect, i);
    },
    y(t, e, n, i) {
      const r = An(e, t);
      return tu(t, r, "y", n.intersect, i);
    }
  }
};
const hf = [
  "left",
  "top",
  "right",
  "bottom"
];
function Pi(t, e) {
  return t.filter((n) => n.pos === e);
}
function nu(t, e) {
  return t.filter((n) => hf.indexOf(n.pos) === -1 && n.box.axis === e);
}
function Fi(t, e) {
  return t.sort((n, i) => {
    const r = e ? i : n, s = e ? n : i;
    return r.weight === s.weight ? r.index - s.index : r.weight - s.weight;
  });
}
function Yp(t) {
  const e = [];
  let n, i, r, s, a, o;
  for (n = 0, i = (t || []).length; n < i; ++n)
    r = t[n], { position: s, options: { stack: a, stackWeight: o = 1 } } = r, e.push({
      index: n,
      box: r,
      pos: s,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: a && s + a,
      stackWeight: o
    });
  return e;
}
function zp(t) {
  const e = {};
  for (const n of t) {
    const { stack: i, pos: r, stackWeight: s } = n;
    if (!i || !hf.includes(r))
      continue;
    const a = e[i] || (e[i] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += s;
  }
  return e;
}
function Up(t, e) {
  const n = zp(t), { vBoxMaxWidth: i, hBoxMaxHeight: r } = e;
  let s, a, o;
  for (s = 0, a = t.length; s < a; ++s) {
    o = t[s];
    const { fullSize: l } = o.box, c = n[o.stack], u = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = u ? u * i : l && e.availableWidth, o.height = r) : (o.width = i, o.height = u ? u * r : l && e.availableHeight);
  }
  return n;
}
function Qp(t) {
  const e = Yp(t), n = Fi(e.filter((c) => c.box.fullSize), !0), i = Fi(Pi(e, "left"), !0), r = Fi(Pi(e, "right")), s = Fi(Pi(e, "top"), !0), a = Fi(Pi(e, "bottom")), o = nu(e, "x"), l = nu(e, "y");
  return {
    fullSize: n,
    leftAndTop: i.concat(s),
    rightAndBottom: r.concat(l).concat(a).concat(o),
    chartArea: Pi(e, "chartArea"),
    vertical: i.concat(r).concat(l),
    horizontal: s.concat(a).concat(o)
  };
}
function iu(t, e, n, i) {
  return Math.max(t[n], e[n]) + Math.max(t[i], e[i]);
}
function ff(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function Kp(t, e, n, i) {
  const { pos: r, box: s } = n, a = t.maxPadding;
  if (!Ae(r)) {
    n.size && (t[r] -= n.size);
    const d = i[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? s.height : s.width), n.size = d.size / d.count, t[r] += n.size;
  }
  s.getPadding && ff(a, s.getPadding());
  const o = Math.max(0, e.outerWidth - iu(a, t, "left", "right")), l = Math.max(0, e.outerHeight - iu(a, t, "top", "bottom")), c = o !== t.w, u = l !== t.h;
  return t.w = o, t.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function Gp(t) {
  const e = t.maxPadding;
  function n(i) {
    const r = Math.max(e[i] - t[i], 0);
    return t[i] += r, r;
  }
  t.y += n("top"), t.x += n("left"), n("right"), n("bottom");
}
function qp(t, e) {
  const n = e.maxPadding;
  function i(r) {
    const s = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return r.forEach((a) => {
      s[a] = Math.max(e[a], n[a]);
    }), s;
  }
  return i(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function ji(t, e, n, i) {
  const r = [];
  let s, a, o, l, c, u;
  for (s = 0, a = t.length, c = 0; s < a; ++s) {
    o = t[s], l = o.box, l.update(o.width || e.w, o.height || e.h, qp(o.horizontal, e));
    const { same: d, other: h } = Kp(e, n, o, i);
    c |= d && r.length, u = u || h, l.fullSize || r.push(o);
  }
  return c && ji(r, e, n, i) || u;
}
function Dr(t, e, n, i, r) {
  t.top = n, t.left = e, t.right = e + i, t.bottom = n + r, t.width = i, t.height = r;
}
function ru(t, e, n, i) {
  const r = n.padding;
  let { x: s, y: a } = e;
  for (const o of t) {
    const l = o.box, c = i[o.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const d = e.w * u, h = c.size || l.height;
      ir(c.start) && (a = c.start), l.fullSize ? Dr(l, r.left, a, n.outerWidth - r.right - r.left, h) : Dr(l, e.left + c.placed, a, d, h), c.start = a, c.placed += d, a = l.bottom;
    } else {
      const d = e.h * u, h = c.size || l.width;
      ir(c.start) && (s = c.start), l.fullSize ? Dr(l, s, r.top, h, n.outerHeight - r.bottom - r.top) : Dr(l, s, e.top + c.placed, h, d), c.start = s, c.placed += d, s = l.right;
    }
  }
  e.x = s, e.y = a;
}
var rn = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            e.draw(n);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const n = t.boxes ? t.boxes.indexOf(e) : -1;
    n !== -1 && t.boxes.splice(n, 1);
  },
  configure(t, e, n) {
    e.fullSize = n.fullSize, e.position = n.position, e.weight = n.weight;
  },
  update(t, e, n, i) {
    if (!t)
      return;
    const r = rt(t.options.layout.padding), s = Math.max(e - r.width, 0), a = Math.max(n - r.height, 0), o = Qp(t.boxes), l = o.vertical, c = o.horizontal;
    Oe(t.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const u = l.reduce((m, p) => p.box.options && p.box.options.display === !1 ? m : m + 1, 0) || 1, d = Object.freeze({
      outerWidth: e,
      outerHeight: n,
      padding: r,
      availableWidth: s,
      availableHeight: a,
      vBoxMaxWidth: s / 2 / u,
      hBoxMaxHeight: a / 2
    }), h = Object.assign({}, r);
    ff(h, rt(i));
    const g = Object.assign({
      maxPadding: h,
      w: s,
      h: a,
      x: r.left,
      y: r.top
    }, r), b = Up(l.concat(c), d);
    ji(o.fullSize, g, d, b), ji(l, g, d, b), ji(c, g, d, b) && ji(l, g, d, b), Gp(g), ru(o.leftAndTop, g, d, b), g.x += g.w, g.y += g.h, ru(o.rightAndBottom, g, d, b), t.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, Oe(o.chartArea, (m) => {
      const p = m.box;
      Object.assign(p, t.chartArea), p.update(g.w, g.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class gf {
  acquireContext(e, n) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, n, i) {
  }
  removeEventListener(e, n, i) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, n, i, r) {
    return n = Math.max(0, n || e.width), i = i || e.height, {
      width: n,
      height: Math.max(0, r ? Math.floor(n / r) : i)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class Zp extends gf {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const Zr = "$chartjs", Jp = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, su = (t) => t === null || t === "";
function Xp(t, e) {
  const n = t.style, i = t.getAttribute("height"), r = t.getAttribute("width");
  if (t[Zr] = {
    initial: {
      height: i,
      width: r,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", su(r)) {
    const s = Yc(t, "width");
    s !== void 0 && (t.width = s);
  }
  if (su(i))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const s = Yc(t, "height");
      s !== void 0 && (t.height = s);
    }
  return t;
}
const mf = up ? {
  passive: !0
} : !1;
function e6(t, e, n) {
  t && t.addEventListener(e, n, mf);
}
function t6(t, e, n) {
  t && t.canvas && t.canvas.removeEventListener(e, n, mf);
}
function n6(t, e) {
  const n = Jp[t.type] || t.type, { x: i, y: r } = An(t, e);
  return {
    type: n,
    chart: e,
    native: t,
    x: i !== void 0 ? i : null,
    y: r !== void 0 ? r : null
  };
}
function vs(t, e) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
}
function i6(t, e, n) {
  const i = t.canvas, r = new MutationObserver((s) => {
    let a = !1;
    for (const o of s)
      a = a || vs(o.addedNodes, i), a = a && !vs(o.removedNodes, i);
    a && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
function r6(t, e, n) {
  const i = t.canvas, r = new MutationObserver((s) => {
    let a = !1;
    for (const o of s)
      a = a || vs(o.removedNodes, i), a = a && !vs(o.addedNodes, i);
    a && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
const sr = /* @__PURE__ */ new Map();
let au = 0;
function pf() {
  const t = window.devicePixelRatio;
  t !== au && (au = t, sr.forEach((e, n) => {
    n.currentDevicePixelRatio !== t && e();
  }));
}
function s6(t, e) {
  sr.size || window.addEventListener("resize", pf), sr.set(t, e);
}
function a6(t) {
  sr.delete(t), sr.size || window.removeEventListener("resize", pf);
}
function o6(t, e, n) {
  const i = t.canvas, r = i && fl(i);
  if (!r)
    return;
  const s = qh((o, l) => {
    const c = r.clientWidth;
    n(o, l), c < r.clientWidth && n();
  }, window), a = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || s(c, u);
  });
  return a.observe(r), s6(t, s), a;
}
function _a(t, e, n) {
  n && n.disconnect(), e === "resize" && a6(t);
}
function l6(t, e, n) {
  const i = t.canvas, r = qh((s) => {
    t.ctx !== null && n(n6(s, t));
  }, t);
  return e6(i, e, r), r;
}
class c6 extends gf {
  acquireContext(e, n) {
    const i = e && e.getContext && e.getContext("2d");
    return i && i.canvas === e ? (Xp(e, n), i) : null;
  }
  releaseContext(e) {
    const n = e.canvas;
    if (!n[Zr])
      return !1;
    const i = n[Zr].initial;
    [
      "height",
      "width"
    ].forEach((s) => {
      const a = i[s];
      De(a) ? n.removeAttribute(s) : n.setAttribute(s, a);
    });
    const r = i.style || {};
    return Object.keys(r).forEach((s) => {
      n.style[s] = r[s];
    }), n.width = n.width, delete n[Zr], !0;
  }
  addEventListener(e, n, i) {
    this.removeEventListener(e, n);
    const r = e.$proxies || (e.$proxies = {}), a = {
      attach: i6,
      detach: r6,
      resize: o6
    }[n] || l6;
    r[n] = a(e, n, i);
  }
  removeEventListener(e, n) {
    const i = e.$proxies || (e.$proxies = {}), r = i[n];
    if (!r)
      return;
    ({
      attach: _a,
      detach: _a,
      resize: _a
    }[n] || t6)(e, n, r), i[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, n, i, r) {
    return cp(e, n, i, r);
  }
  isAttached(e) {
    const n = fl(e);
    return !!(n && n.isConnected);
  }
}
function u6(t) {
  return !hl() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? Zp : c6;
}
var Hr;
let Si = (Hr = class {
  constructor() {
    ge(this, "x");
    ge(this, "y");
    ge(this, "active", !1);
    ge(this, "options");
    ge(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: n, y: i } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: i
    };
  }
  hasValue() {
    return gs(this.x) && gs(this.y);
  }
  getProps(e, n) {
    const i = this.$animations;
    if (!n || !i)
      return this;
    const r = {};
    return e.forEach((s) => {
      r[s] = i[s] && i[s].active() ? i[s]._to : this[s];
    }), r;
  }
}, ge(Hr, "defaults", {}), ge(Hr, "defaultRoutes"), Hr);
function d6(t, e) {
  const n = t.options.ticks, i = h6(t), r = Math.min(n.maxTicksLimit || i, i), s = n.major.enabled ? g6(e) : [], a = s.length, o = s[0], l = s[a - 1], c = [];
  if (a > r)
    return m6(e, c, s, a / r), c;
  const u = f6(s, e, r);
  if (a > 0) {
    let d, h;
    const g = a > 1 ? Math.round((l - o) / (a - 1)) : null;
    for (Pr(e, c, u, De(g) ? 0 : o - g, o), d = 0, h = a - 1; d < h; d++)
      Pr(e, c, u, s[d], s[d + 1]);
    return Pr(e, c, u, l, De(g) ? e.length : l + g), c;
  }
  return Pr(e, c, u), c;
}
function h6(t) {
  const e = t.options.offset, n = t._tickSize(), i = t._length / n + (e ? 0 : 1), r = t._maxLength / n;
  return Math.floor(Math.min(i, r));
}
function f6(t, e, n) {
  const i = p6(t), r = e.length / n;
  if (!i)
    return Math.max(r, 1);
  const s = C3(i);
  for (let a = 0, o = s.length - 1; a < o; a++) {
    const l = s[a];
    if (l > r)
      return l;
  }
  return Math.max(r, 1);
}
function g6(t) {
  const e = [];
  let n, i;
  for (n = 0, i = t.length; n < i; n++)
    t[n].major && e.push(n);
  return e;
}
function m6(t, e, n, i) {
  let r = 0, s = n[0], a;
  for (i = Math.ceil(i), a = 0; a < t.length; a++)
    a === s && (e.push(t[a]), r++, s = n[r * i]);
}
function Pr(t, e, n, i, r) {
  const s = we(i, 0), a = Math.min(we(r, t.length), t.length);
  let o = 0, l, c, u;
  for (n = Math.ceil(n), r && (l = r - i, n = l / Math.floor(l / n)), u = s; u < 0; )
    o++, u = Math.round(s + o * n);
  for (c = Math.max(s, 0); c < a; c++)
    c === u && (e.push(t[c]), o++, u = Math.round(s + o * n));
}
function p6(t) {
  const e = t.length;
  let n, i;
  if (e < 2)
    return !1;
  for (i = t[0], n = 1; n < e; ++n)
    if (t[n] - t[n - 1] !== i)
      return !1;
  return i;
}
const b6 = (t) => t === "left" ? "right" : t === "right" ? "left" : t, ou = (t, e, n) => e === "top" || e === "left" ? t[e] + n : t[e] - n, lu = (t, e) => Math.min(e || t, t);
function cu(t, e) {
  const n = [], i = t.length / e, r = t.length;
  let s = 0;
  for (; s < r; s += i)
    n.push(t[Math.floor(s)]);
  return n;
}
function v6(t, e, n) {
  const i = t.ticks.length, r = Math.min(e, i - 1), s = t._startPixel, a = t._endPixel, o = 1e-6;
  let l = t.getPixelForTick(r), c;
  if (!(n && (i === 1 ? c = Math.max(l - s, a - l) : e === 0 ? c = (t.getPixelForTick(1) - l) / 2 : c = (l - t.getPixelForTick(r - 1)) / 2, l += r < e ? c : -c, l < s - o || l > a + o)))
    return l;
}
function y6(t, e) {
  Oe(t, (n) => {
    const i = n.gc, r = i.length / 2;
    let s;
    if (r > e) {
      for (s = 0; s < r; ++s)
        delete n.data[i[s]];
      i.splice(0, r);
    }
  });
}
function Ti(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function uu(t, e) {
  if (!t.display)
    return 0;
  const n = et(t.font, e), i = rt(t.padding);
  return (Ne(t.text) ? t.text.length : 1) * n.lineHeight + i.height;
}
function x6(t, e) {
  return jn(t, {
    scale: e,
    type: "scale"
  });
}
function A6(t, e, n) {
  return jn(t, {
    tick: n,
    index: e,
    type: "tick"
  });
}
function C6(t, e, n) {
  let i = Zh(t);
  return (n && e !== "right" || !n && e === "right") && (i = b6(i)), i;
}
function w6(t, e, n, i) {
  const { top: r, left: s, bottom: a, right: o, chart: l } = t, { chartArea: c, scales: u } = l;
  let d = 0, h, g, b;
  const m = a - r, p = o - s;
  if (t.isHorizontal()) {
    if (g = ht(i, s, o), Ae(n)) {
      const x = Object.keys(n)[0], C = n[x];
      b = u[x].getPixelForValue(C) + m - e;
    } else
      n === "center" ? b = (c.bottom + c.top) / 2 + m - e : b = ou(t, n, e);
    h = o - s;
  } else {
    if (Ae(n)) {
      const x = Object.keys(n)[0], C = n[x];
      g = u[x].getPixelForValue(C) - p + e;
    } else
      n === "center" ? g = (c.left + c.right) / 2 - p + e : g = ou(t, n, e);
    b = ht(i, a, r), d = n === "left" ? -je : je;
  }
  return {
    titleX: g,
    titleY: b,
    maxWidth: h,
    rotation: d
  };
}
class $n extends Si {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, n) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: n, _suggestedMin: i, _suggestedMax: r } = this;
    return e = ft(e, Number.POSITIVE_INFINITY), n = ft(n, Number.NEGATIVE_INFINITY), i = ft(i, Number.POSITIVE_INFINITY), r = ft(r, Number.NEGATIVE_INFINITY), {
      min: ft(e, i),
      max: ft(n, r),
      minDefined: qe(e),
      maxDefined: qe(n)
    };
  }
  getMinMax(e) {
    let { min: n, max: i, minDefined: r, maxDefined: s } = this.getUserBounds(), a;
    if (r && s)
      return {
        min: n,
        max: i
      };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      a = o[l].controller.getMinMax(this, e), r || (n = Math.min(n, a.min)), s || (i = Math.max(i, a.max));
    return n = s && n > i ? i : n, i = r && n > i ? n : i, {
      min: ft(n, ft(i, n)),
      max: ft(i, ft(n, i))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Pe(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, n, i) {
    const { beginAtZero: r, grace: s, ticks: a } = this.options, o = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = n, this._margins = i = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, i), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + i.left + i.right : this.height + i.top + i.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = K3(this, s, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? cu(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = d6(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, n, i;
    this.isHorizontal() ? (n = this.left, i = this.right) : (n = this.top, i = this.bottom, e = !e), this._startPixel = n, this._endPixel = i, this._reversePixels = e, this._length = i - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Pe(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Pe(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Pe(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), Pe(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Pe(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const n = this.options.ticks;
    let i, r, s;
    for (i = 0, r = e.length; i < r; i++)
      s = e[i], s.label = Pe(n.callback, [
        s.value,
        i,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    Pe(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Pe(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, n = e.ticks, i = lu(this.ticks.length, e.ticks.maxTicksLimit), r = n.minRotation || 0, s = n.maxRotation;
    let a = r, o, l, c;
    if (!this._isVisible() || !n.display || r >= s || i <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, h = u.highest.height, g = dt(this.chart.width - d, 0, this.maxWidth);
    o = e.offset ? this.maxWidth / i : g / (i - 1), d + 6 > o && (o = g / (i - (e.offset ? 0.5 : 1)), l = this.maxHeight - Ti(e.grid) - n.padding - uu(e.title, this.chart.options.font), c = Math.sqrt(d * d + h * h), a = rl(Math.min(Math.asin(dt((u.highest.height + 6) / o, -1, 1)), Math.asin(dt(l / c, -1, 1)) - Math.asin(dt(h / c, -1, 1)))), a = Math.max(r, Math.min(s, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    Pe(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Pe(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: i, title: r, grid: s } } = this, a = this._isVisible(), o = this.isHorizontal();
    if (a) {
      const l = uu(r, n.options.font);
      if (o ? (e.width = this.maxWidth, e.height = Ti(s) + l) : (e.height = this.maxHeight, e.width = Ti(s) + l), i.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: h } = this._getLabelSizes(), g = i.padding * 2, b = Pt(this.labelRotation), m = Math.cos(b), p = Math.sin(b);
        if (o) {
          const x = i.mirror ? 0 : p * d.width + m * h.height;
          e.height = Math.min(this.maxHeight, e.height + x + g);
        } else {
          const x = i.mirror ? 0 : m * d.width + p * h.height;
          e.width = Math.min(this.maxWidth, e.width + x + g);
        }
        this._calculatePadding(c, u, p, m);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, n, i, r) {
    const { ticks: { align: s, padding: a }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, g = 0;
      l ? c ? (h = r * e.width, g = i * n.height) : (h = i * e.height, g = r * n.width) : s === "start" ? g = n.width : s === "end" ? h = e.width : s !== "inner" && (h = e.width / 2, g = n.width / 2), this.paddingLeft = Math.max((h - u + a) * this.width / (this.width - u), 0), this.paddingRight = Math.max((g - d + a) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = e.height / 2;
      s === "start" ? (u = 0, d = e.height) : s === "end" && (u = n.height, d = 0), this.paddingTop = u + a, this.paddingBottom = d + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Pe(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: n } = this.options;
    return n === "top" || n === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let n, i;
    for (n = 0, i = e.length; n < i; n++)
      De(e[n].label) && (e.splice(n, 1), i--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const n = this.options.ticks.sampleSize;
      let i = this.ticks;
      n < i.length && (i = cu(i, n)), this._labelSizes = e = this._computeLabelSizes(i, i.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, n, i) {
    const { ctx: r, _longestTextCache: s } = this, a = [], o = [], l = Math.floor(n / lu(n, i));
    let c = 0, u = 0, d, h, g, b, m, p, x, C, M, _, A;
    for (d = 0; d < n; d += l) {
      if (b = e[d].label, m = this._resolveTickFontOptions(d), r.font = p = m.string, x = s[p] = s[p] || {
        data: {},
        gc: []
      }, C = m.lineHeight, M = _ = 0, !De(b) && !Ne(b))
        M = ps(r, x.data, x.gc, M, b), _ = C;
      else if (Ne(b))
        for (h = 0, g = b.length; h < g; ++h)
          A = b[h], !De(A) && !Ne(A) && (M = ps(r, x.data, x.gc, M, A), _ += C);
      a.push(M), o.push(_), c = Math.max(M, c), u = Math.max(_, u);
    }
    y6(s, n);
    const E = a.indexOf(c), P = o.indexOf(u), I = (U) => ({
      width: a[U] || 0,
      height: o[U] || 0
    });
    return {
      first: I(0),
      last: I(n - 1),
      widest: I(E),
      highest: I(P),
      widths: a,
      heights: o
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, n) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const n = this._startPixel + e * this._length;
    return E3(this._alignToPixels ? vn(this.chart, n, 0) : n);
  }
  getDecimalForPixel(e) {
    const n = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: n } = this;
    return e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0;
  }
  getContext(e) {
    const n = this.ticks || [];
    if (e >= 0 && e < n.length) {
      const i = n[e];
      return i.$context || (i.$context = A6(this.getContext(), e, i));
    }
    return this.$context || (this.$context = x6(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, n = Pt(this.labelRotation), i = Math.abs(Math.cos(n)), r = Math.abs(Math.sin(n)), s = this._getLabelSizes(), a = e.autoSkipPadding || 0, o = s ? s.widest.width + a : 0, l = s ? s.highest.height + a : 0;
    return this.isHorizontal() ? l * i > o * r ? o / i : l / r : l * r < o * i ? l / i : o / r;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const n = this.axis, i = this.chart, r = this.options, { grid: s, position: a, border: o } = r, l = s.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), h = Ti(s), g = [], b = o.setContext(this.getContext()), m = b.display ? b.width : 0, p = m / 2, x = function(R) {
      return vn(i, R, m);
    };
    let C, M, _, A, E, P, I, U, Q, T, Y, q;
    if (a === "top")
      C = x(this.bottom), P = this.bottom - h, U = C - p, T = x(e.top) + p, q = e.bottom;
    else if (a === "bottom")
      C = x(this.top), T = e.top, q = x(e.bottom) - p, P = C + p, U = this.top + h;
    else if (a === "left")
      C = x(this.right), E = this.right - h, I = C - p, Q = x(e.left) + p, Y = e.right;
    else if (a === "right")
      C = x(this.left), Q = e.left, Y = x(e.right) - p, E = C + p, I = this.left + h;
    else if (n === "x") {
      if (a === "center")
        C = x((e.top + e.bottom) / 2 + 0.5);
      else if (Ae(a)) {
        const R = Object.keys(a)[0], B = a[R];
        C = x(this.chart.scales[R].getPixelForValue(B));
      }
      T = e.top, q = e.bottom, P = C + p, U = P + h;
    } else if (n === "y") {
      if (a === "center")
        C = x((e.left + e.right) / 2);
      else if (Ae(a)) {
        const R = Object.keys(a)[0], B = a[R];
        C = x(this.chart.scales[R].getPixelForValue(B));
      }
      E = C - p, I = E - h, Q = e.left, Y = e.right;
    }
    const $ = we(r.ticks.maxTicksLimit, d), N = Math.max(1, Math.ceil(d / $));
    for (M = 0; M < d; M += N) {
      const R = this.getContext(M), B = s.setContext(R), j = o.setContext(R), y = B.lineWidth, v = B.color, k = j.dash || [], S = j.dashOffset, f = B.tickWidth, D = B.tickColor, V = B.tickBorderDash || [], z = B.tickBorderDashOffset;
      _ = v6(this, M, l), _ !== void 0 && (A = vn(i, _, y), c ? E = I = Q = Y = A : P = U = T = q = A, g.push({
        tx1: E,
        ty1: P,
        tx2: I,
        ty2: U,
        x1: Q,
        y1: T,
        x2: Y,
        y2: q,
        width: y,
        color: v,
        borderDash: k,
        borderDashOffset: S,
        tickWidth: f,
        tickColor: D,
        tickBorderDash: V,
        tickBorderDashOffset: z
      }));
    }
    return this._ticksLength = d, this._borderValue = C, g;
  }
  _computeLabelItems(e) {
    const n = this.axis, i = this.options, { position: r, ticks: s } = i, a = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = s, h = Ti(i.grid), g = h + u, b = d ? -u : g, m = -Pt(this.labelRotation), p = [];
    let x, C, M, _, A, E, P, I, U, Q, T, Y, q = "middle";
    if (r === "top")
      E = this.bottom - b, P = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      E = this.top + b, P = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const N = this._getYAxisLabelAlignment(h);
      P = N.textAlign, A = N.x;
    } else if (r === "right") {
      const N = this._getYAxisLabelAlignment(h);
      P = N.textAlign, A = N.x;
    } else if (n === "x") {
      if (r === "center")
        E = (e.top + e.bottom) / 2 + g;
      else if (Ae(r)) {
        const N = Object.keys(r)[0], R = r[N];
        E = this.chart.scales[N].getPixelForValue(R) + g;
      }
      P = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (r === "center")
        A = (e.left + e.right) / 2 - g;
      else if (Ae(r)) {
        const N = Object.keys(r)[0], R = r[N];
        A = this.chart.scales[N].getPixelForValue(R);
      }
      P = this._getYAxisLabelAlignment(h).textAlign;
    }
    n === "y" && (l === "start" ? q = "top" : l === "end" && (q = "bottom"));
    const $ = this._getLabelSizes();
    for (x = 0, C = o.length; x < C; ++x) {
      M = o[x], _ = M.label;
      const N = s.setContext(this.getContext(x));
      I = this.getPixelForTick(x) + s.labelOffset, U = this._resolveTickFontOptions(x), Q = U.lineHeight, T = Ne(_) ? _.length : 1;
      const R = T / 2, B = N.color, j = N.textStrokeColor, y = N.textStrokeWidth;
      let v = P;
      a ? (A = I, P === "inner" && (x === C - 1 ? v = this.options.reverse ? "left" : "right" : x === 0 ? v = this.options.reverse ? "right" : "left" : v = "center"), r === "top" ? c === "near" || m !== 0 ? Y = -T * Q + Q / 2 : c === "center" ? Y = -$.highest.height / 2 - R * Q + Q : Y = -$.highest.height + Q / 2 : c === "near" || m !== 0 ? Y = Q / 2 : c === "center" ? Y = $.highest.height / 2 - R * Q : Y = $.highest.height - T * Q, d && (Y *= -1), m !== 0 && !N.showLabelBackdrop && (A += Q / 2 * Math.sin(m))) : (E = I, Y = (1 - T) * Q / 2);
      let k;
      if (N.showLabelBackdrop) {
        const S = rt(N.backdropPadding), f = $.heights[x], D = $.widths[x];
        let V = Y - S.top, z = 0 - S.left;
        switch (q) {
          case "middle":
            V -= f / 2;
            break;
          case "bottom":
            V -= f;
            break;
        }
        switch (P) {
          case "center":
            z -= D / 2;
            break;
          case "right":
            z -= D;
            break;
          case "inner":
            x === C - 1 ? z -= D : x > 0 && (z -= D / 2);
            break;
        }
        k = {
          left: z,
          top: V,
          width: D + S.width,
          height: f + S.height,
          color: N.backdropColor
        };
      }
      p.push({
        label: _,
        font: U,
        textOffset: Y,
        options: {
          rotation: m,
          color: B,
          strokeColor: j,
          strokeWidth: y,
          textAlign: v,
          textBaseline: q,
          translation: [
            A,
            E
          ],
          backdrop: k
        }
      });
    }
    return p;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: n } = this.options;
    if (-Pt(this.labelRotation))
      return e === "top" ? "left" : "right";
    let r = "center";
    return n.align === "start" ? r = "left" : n.align === "end" ? r = "right" : n.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(e) {
    const { position: n, ticks: { crossAlign: i, mirror: r, padding: s } } = this.options, a = this._getLabelSizes(), o = e + s, l = a.widest.width;
    let c, u;
    return n === "left" ? r ? (u = this.right + s, i === "near" ? c = "left" : i === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - o, i === "near" ? c = "right" : i === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? r ? (u = this.left + s, i === "near" ? c = "right" : i === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + o, i === "near" ? c = "left" : i === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: n }, left: i, top: r, width: s, height: a } = this;
    n && (e.save(), e.fillStyle = n, e.fillRect(i, r, s, a), e.restore());
  }
  getLineWidthForValue(e) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const r = this.ticks.findIndex((s) => s.value === e);
    return r >= 0 ? n.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(e) {
    const n = this.options.grid, i = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let s, a;
    const o = (l, c, u) => {
      !u.width || !u.color || (i.save(), i.lineWidth = u.width, i.strokeStyle = u.color, i.setLineDash(u.borderDash || []), i.lineDashOffset = u.borderDashOffset, i.beginPath(), i.moveTo(l.x, l.y), i.lineTo(c.x, c.y), i.stroke(), i.restore());
    };
    if (n.display)
      for (s = 0, a = r.length; s < a; ++s) {
        const l = r[s];
        n.drawOnChartArea && o({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && o({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: n, options: { border: i, grid: r } } = this, s = i.setContext(this.getContext()), a = i.display ? s.width : 0;
    if (!a)
      return;
    const o = r.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, h;
    this.isHorizontal() ? (c = vn(e, this.left, a) - a / 2, u = vn(e, this.right, o) + o / 2, d = h = l) : (d = vn(e, this.top, a) - a / 2, h = vn(e, this.bottom, o) + o / 2, c = u = l), n.save(), n.lineWidth = s.width, n.strokeStyle = s.color, n.beginPath(), n.moveTo(c, d), n.lineTo(u, h), n.stroke(), n.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const i = this.ctx, r = this._computeLabelArea();
    r && al(i, r);
    const s = this.getLabelItems(e);
    for (const a of s) {
      const o = a.options, l = a.font, c = a.label, u = a.textOffset;
      vi(i, c, 0, u, l, o);
    }
    r && ol(i);
  }
  drawTitle() {
    const { ctx: e, options: { position: n, title: i, reverse: r } } = this;
    if (!i.display)
      return;
    const s = et(i.font), a = rt(i.padding), o = i.align;
    let l = s.lineHeight / 2;
    n === "bottom" || n === "center" || Ae(n) ? (l += a.bottom, Ne(i.text) && (l += s.lineHeight * (i.text.length - 1))) : l += a.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: h } = w6(this, l, n, o);
    vi(e, i.text, 0, 0, s, {
      color: i.color,
      maxWidth: d,
      rotation: h,
      textAlign: C6(o, n, r),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, n = e.ticks && e.ticks.z || 0, i = we(e.grid && e.grid.z, -1), r = we(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== $n.prototype.draw ? [
      {
        z: n,
        draw: (s) => {
          this.draw(s);
        }
      }
    ] : [
      {
        z: i,
        draw: (s) => {
          this.drawBackground(), this.drawGrid(s), this.drawTitle();
        }
      },
      {
        z: r,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (s) => {
          this.drawLabels(s);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const n = this.chart.getSortedVisibleDatasetMetas(), i = this.axis + "AxisID", r = [];
    let s, a;
    for (s = 0, a = n.length; s < a; ++s) {
      const o = n[s];
      o[i] === this.id && (!e || o.type === e) && r.push(o);
    }
    return r;
  }
  _resolveTickFontOptions(e) {
    const n = this.options.ticks.setContext(this.getContext(e));
    return et(n.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class Fr {
  constructor(e, n, i) {
    this.type = e, this.scope = n, this.override = i, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const n = Object.getPrototypeOf(e);
    let i;
    k6(n) && (i = this.register(n));
    const r = this.items, s = e.id, a = this.scope + "." + s;
    if (!s)
      throw new Error("class does not have id: " + e);
    return s in r || (r[s] = e, S6(e, a, i), this.override && He.override(e.id, e.overrides)), a;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const n = this.items, i = e.id, r = this.scope;
    i in n && delete n[i], r && i in He[r] && (delete He[r][i], this.override && delete Bn[i]);
  }
}
function S6(t, e, n) {
  const i = nr(/* @__PURE__ */ Object.create(null), [
    n ? He.get(n) : {},
    He.get(e),
    t.defaults
  ]);
  He.set(e, i), t.defaultRoutes && E6(e, t.defaultRoutes), t.descriptors && He.describe(e, t.descriptors);
}
function E6(t, e) {
  Object.keys(e).forEach((n) => {
    const i = n.split("."), r = i.pop(), s = [
      t
    ].concat(i).join("."), a = e[n].split("."), o = a.pop(), l = a.join(".");
    He.route(s, r, l, o);
  });
}
function k6(t) {
  return "id" in t && "defaults" in t;
}
class _6 {
  constructor() {
    this.controllers = new Fr(oi, "datasets", !0), this.elements = new Fr(Si, "elements"), this.plugins = new Fr(Object, "plugins"), this.scales = new Fr($n, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, n, i) {
    [
      ...n
    ].forEach((r) => {
      const s = i || this._getRegistryForType(r);
      i || s.isForType(r) || s === this.plugins && r.id ? this._exec(e, s, r) : Oe(r, (a) => {
        const o = i || this._getRegistryForType(a);
        this._exec(e, o, a);
      });
    });
  }
  _exec(e, n, i) {
    const r = il(e);
    Pe(i["before" + r], [], i), n[e](i), Pe(i["after" + r], [], i);
  }
  _getRegistryForType(e) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const i = this._typedRegistries[n];
      if (i.isForType(e))
        return i;
    }
    return this.plugins;
  }
  _get(e, n, i) {
    const r = n.get(e);
    if (r === void 0)
      throw new Error('"' + e + '" is not a registered ' + i + ".");
    return r;
  }
}
var _t = /* @__PURE__ */ new _6();
class M6 {
  constructor() {
    this._init = [];
  }
  notify(e, n, i, r) {
    n === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const s = r ? this._descriptors(e).filter(r) : this._descriptors(e), a = this._notify(s, e, n, i);
    return n === "afterDestroy" && (this._notify(s, e, "stop"), this._notify(this._init, e, "uninstall")), a;
  }
  _notify(e, n, i, r) {
    r = r || {};
    for (const s of e) {
      const a = s.plugin, o = a[i], l = [
        n,
        r,
        s.options
      ];
      if (Pe(o, l, a) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    De(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), n;
  }
  _createDescriptors(e, n) {
    const i = e && e.config, r = we(i.options && i.options.plugins, {}), s = O6(i);
    return r === !1 && !n ? [] : P6(e, s, r, n);
  }
  _notifyStateChanges(e) {
    const n = this._oldCache || [], i = this._cache, r = (s, a) => s.filter((o) => !a.some((l) => o.plugin.id === l.plugin.id));
    this._notify(r(n, i), e, "stop"), this._notify(r(i, n), e, "start");
  }
}
function O6(t) {
  const e = {}, n = [], i = Object.keys(_t.plugins.items);
  for (let s = 0; s < i.length; s++)
    n.push(_t.getPlugin(i[s]));
  const r = t.plugins || [];
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    n.indexOf(a) === -1 && (n.push(a), e[a.id] = !0);
  }
  return {
    plugins: n,
    localIds: e
  };
}
function D6(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function P6(t, { plugins: e, localIds: n }, i, r) {
  const s = [], a = t.getContext();
  for (const o of e) {
    const l = o.id, c = D6(i[l], r);
    c !== null && s.push({
      plugin: o,
      options: F6(t.config, {
        plugin: o,
        local: n[l]
      }, c, a)
    });
  }
  return s;
}
function F6(t, { plugin: e, local: n }, i, r) {
  const s = t.pluginScopeKeys(e), a = t.getOptionScopes(i, s);
  return n && e.defaults && a.push(e.defaults), t.createResolver(a, r, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function bo(t, e) {
  const n = He.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || n.indexAxis || "x";
}
function T6(t, e) {
  let n = t;
  return t === "_index_" ? n = e : t === "_value_" && (n = e === "x" ? "y" : "x"), n;
}
function I6(t, e) {
  return t === e ? "_index_" : "_value_";
}
function du(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function R6(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function vo(t, ...e) {
  if (du(t))
    return t;
  for (const n of e) {
    const i = n.axis || R6(n.position) || t.length > 1 && du(t[0].toLowerCase());
    if (i)
      return i;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function hu(t, e, n) {
  if (n[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function B6(t, e) {
  if (e.data && e.data.datasets) {
    const n = e.data.datasets.filter((i) => i.xAxisID === t || i.yAxisID === t);
    if (n.length)
      return hu(t, "x", n[0]) || hu(t, "y", n[0]);
  }
  return {};
}
function L6(t, e) {
  const n = Bn[t.type] || {
    scales: {}
  }, i = e.scales || {}, r = bo(t.type, e), s = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach((a) => {
    const o = i[a];
    if (!Ae(o))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (o._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const l = vo(a, o, B6(a, t), He.scales[o.type]), c = I6(l, r), u = n.scales || {};
    s[a] = Qi(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      o,
      u[l],
      u[c]
    ]);
  }), t.data.datasets.forEach((a) => {
    const o = a.type || t.type, l = a.indexAxis || bo(o, e), u = (Bn[o] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const h = T6(d, l), g = a[h + "AxisID"] || h;
      s[g] = s[g] || /* @__PURE__ */ Object.create(null), Qi(s[g], [
        {
          axis: h
        },
        i[g],
        u[d]
      ]);
    });
  }), Object.keys(s).forEach((a) => {
    const o = s[a];
    Qi(o, [
      He.scales[o.type],
      He.scale
    ]);
  }), s;
}
function bf(t) {
  const e = t.options || (t.options = {});
  e.plugins = we(e.plugins, {}), e.scales = L6(t, e);
}
function vf(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function N6(t) {
  return t = t || {}, t.data = vf(t.data), bf(t), t;
}
const fu = /* @__PURE__ */ new Map(), yf = /* @__PURE__ */ new Set();
function Tr(t, e) {
  let n = fu.get(t);
  return n || (n = e(), fu.set(t, n), yf.add(n)), n;
}
const Ii = (t, e, n) => {
  const i = Rn(e, n);
  i !== void 0 && t.add(i);
};
class V6 {
  constructor(e) {
    this._config = N6(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = vf(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), bf(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return Tr(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, n) {
    return Tr(`${e}.transition.${n}`, () => [
      [
        `datasets.${e}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, n) {
    return Tr(`${e}-${n}`, () => [
      [
        `datasets.${e}.elements.${n}`,
        `datasets.${e}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const n = e.id, i = this.type;
    return Tr(`${i}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, n) {
    const i = this._scopeCache;
    let r = i.get(e);
    return (!r || n) && (r = /* @__PURE__ */ new Map(), i.set(e, r)), r;
  }
  getOptionScopes(e, n, i) {
    const { options: r, type: s } = this, a = this._cachedScopes(e, i), o = a.get(n);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      e && (l.add(e), u.forEach((d) => Ii(l, e, d))), u.forEach((d) => Ii(l, r, d)), u.forEach((d) => Ii(l, Bn[s] || {}, d)), u.forEach((d) => Ii(l, He, d)), u.forEach((d) => Ii(l, po, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), yf.has(n) && a.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: e, type: n } = this;
    return [
      e,
      Bn[n] || {},
      He.datasets[n] || {},
      {
        type: n
      },
      He,
      po
    ];
  }
  resolveNamedOptions(e, n, i, r = [
    ""
  ]) {
    const s = {
      $shared: !0
    }, { resolver: a, subPrefixes: o } = gu(this._resolverCache, e, r);
    let l = a;
    if (j6(a, n)) {
      s.$shared = !1, i = gn(i) ? i() : i;
      const c = this.createResolver(e, i, o);
      l = yi(a, i, c);
    }
    for (const c of n)
      s[c] = l[c];
    return s;
  }
  createResolver(e, n, i = [
    ""
  ], r) {
    const { resolver: s } = gu(this._resolverCache, e, i);
    return Ae(n) ? yi(s, n, void 0, r) : s;
  }
}
function gu(t, e, n) {
  let i = t.get(e);
  i || (i = /* @__PURE__ */ new Map(), t.set(e, i));
  const r = n.join();
  let s = i.get(r);
  return s || (s = {
    resolver: cl(e, n),
    subPrefixes: n.filter((o) => !o.toLowerCase().includes("hover"))
  }, i.set(r, s)), s;
}
const H6 = (t) => Ae(t) && Object.getOwnPropertyNames(t).some((e) => gn(t[e]));
function j6(t, e) {
  const { isScriptable: n, isIndexable: i } = nf(t);
  for (const r of e) {
    const s = n(r), a = i(r), o = (a || s) && t[r];
    if (s && (gn(o) || H6(o)) || a && Ne(o))
      return !0;
  }
  return !1;
}
var $6 = "4.4.2";
const W6 = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function mu(t, e) {
  return t === "top" || t === "bottom" || W6.indexOf(t) === -1 && e === "x";
}
function pu(t, e) {
  return function(n, i) {
    return n[t] === i[t] ? n[e] - i[e] : n[t] - i[t];
  };
}
function bu(t) {
  const e = t.chart, n = e.options.animation;
  e.notifyPlugins("afterRender"), Pe(n && n.onComplete, [
    t
  ], e);
}
function Y6(t) {
  const e = t.chart, n = e.options.animation;
  Pe(n && n.onProgress, [
    t
  ], e);
}
function xf(t) {
  return hl() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const Jr = {}, vu = (t) => {
  const e = xf(t);
  return Object.values(Jr).filter((n) => n.canvas === e).pop();
};
function z6(t, e, n) {
  const i = Object.keys(t);
  for (const r of i) {
    const s = +r;
    if (s >= e) {
      const a = t[r];
      delete t[r], (n > 0 || s > e) && (t[s + n] = a);
    }
  }
}
function U6(t, e, n, i) {
  return !n || t.type === "mouseout" ? null : i ? e : t;
}
function Ir(t, e, n) {
  return t.options.clip ? t[n] : e[n];
}
function Q6(t, e) {
  const { xScale: n, yScale: i } = t;
  return n && i ? {
    left: Ir(n, e, "left"),
    right: Ir(n, e, "right"),
    top: Ir(i, e, "top"),
    bottom: Ir(i, e, "bottom")
  } : e;
}
var qt;
let fr = (qt = class {
  static register(...e) {
    _t.add(...e), yu();
  }
  static unregister(...e) {
    _t.remove(...e), yu();
  }
  constructor(e, n) {
    const i = this.config = new V6(n), r = xf(e), s = vu(r);
    if (s)
      throw new Error("Canvas is already in use. Chart with ID '" + s.id + "' must be destroyed before the canvas with ID '" + s.canvas.id + "' can be reused.");
    const a = i.createResolver(i.chartOptionScopes(), this.getContext());
    this.platform = new (i.platform || u6(r))(), this.platform.updateConfig(i);
    const o = this.platform.acquireContext(r, a.aspectRatio), l = o && o.canvas, c = l && l.height, u = l && l.width;
    if (this.id = g3(), this.ctx = o, this.canvas = l, this.width = u, this.height = c, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new M6(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = O3((d) => this.update(d), a.resizeDelay || 0), this._dataChanges = [], Jr[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Lt.listen(this, "complete", bu), Lt.listen(this, "progress", Y6), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: n }, width: i, height: r, _aspectRatio: s } = this;
    return De(e) ? n && s ? s : r ? i / r : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return _t;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Wc(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return Vc(this.canvas, this.ctx), this;
  }
  stop() {
    return Lt.stop(this), this;
  }
  resize(e, n) {
    Lt.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: n
    } : this._resize(e, n);
  }
  _resize(e, n) {
    const i = this.options, r = this.canvas, s = i.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(r, e, n, s), o = i.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, Wc(this, o, !0) && (this.notifyPlugins("resize", {
      size: a
    }), Pe(i.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    Oe(n, (i, r) => {
      i.id = r;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, n = e.scales, i = this.scales, r = Object.keys(i).reduce((a, o) => (a[o] = !1, a), {});
    let s = [];
    n && (s = s.concat(Object.keys(n).map((a) => {
      const o = n[a], l = vo(a, o), c = l === "r", u = l === "x";
      return {
        options: o,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), Oe(s, (a) => {
      const o = a.options, l = o.id, c = vo(l, o), u = we(o.type, a.dtype);
      (o.position === void 0 || mu(o.position, c) !== mu(a.dposition)) && (o.position = a.dposition), r[l] = !0;
      let d = null;
      if (l in i && i[l].type === u)
        d = i[l];
      else {
        const h = _t.getScale(u);
        d = new h({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), i[d.id] = d;
      }
      d.init(o, e);
    }), Oe(r, (a, o) => {
      a || delete i[o];
    }), Oe(i, (a) => {
      rn.configure(this, a, a.options), rn.addBox(this, a);
    });
  }
  _updateMetasets() {
    const e = this._metasets, n = this.data.datasets.length, i = e.length;
    if (e.sort((r, s) => r.index - s.index), i > n) {
      for (let r = n; r < i; ++r)
        this._destroyDatasetMeta(r);
      e.splice(n, i - n);
    }
    this._sortedMetasets = e.slice(0).sort(pu("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: n } } = this;
    e.length > n.length && delete this._stacks, e.forEach((i, r) => {
      n.filter((s) => s === i._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const e = [], n = this.data.datasets;
    let i, r;
    for (this._removeUnreferencedMetasets(), i = 0, r = n.length; i < r; i++) {
      const s = n[i];
      let a = this.getDatasetMeta(i);
      const o = s.type || this.config.type;
      if (a.type && a.type !== o && (this._destroyDatasetMeta(i), a = this.getDatasetMeta(i)), a.type = o, a.indexAxis = s.indexAxis || bo(o, this.options), a.order = s.order || 0, a.index = i, a.label = "" + s.label, a.visible = this.isDatasetVisible(i), a.controller)
        a.controller.updateIndex(i), a.controller.linkScales();
      else {
        const l = _t.getController(o), { datasetElementType: c, dataElementType: u } = He.datasets[o];
        Object.assign(l, {
          dataElementType: _t.getElement(u),
          datasetElementType: c && _t.getElement(c)
        }), a.controller = new l(this, i), e.push(a.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    Oe(this.data.datasets, (e, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const n = this.config;
    n.update();
    const i = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !i.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const s = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), h = !r && s.indexOf(d) === -1;
      d.buildOrUpdateElements(h), a = Math.max(+d.getMaxOverflow(), a);
    }
    a = this._minPadding = i.layout.autoPadding ? a : 0, this._updateLayout(a), r || Oe(s, (c) => {
      c.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(pu("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    Oe(this.scales, (e) => {
      rn.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, n = new Set(Object.keys(this._listeners)), i = new Set(e.events);
    (!Dc(n, i) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, n = this._getUniformDataChanges() || [];
    for (const { method: i, start: r, count: s } of n) {
      const a = i === "_removeElements" ? -s : s;
      z6(e, r, a);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, i = (s) => new Set(e.filter((a) => a[0] === s).map((a, o) => o + "," + a.splice(1).join(","))), r = i(0);
    for (let s = 1; s < n; s++)
      if (!Dc(r, i(s)))
        return;
    return Array.from(r).map((s) => s.split(",")).map((s) => ({
      method: s[1],
      start: +s[2],
      count: +s[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    rn.update(this, this.width, this.height, e);
    const n = this.chartArea, i = n.width <= 0 || n.height <= 0;
    this._layers = [], Oe(this.boxes, (r) => {
      i && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, s) => {
      r._idx = s;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, i = this.data.datasets.length; n < i; ++n)
        this._updateDataset(n, gn(e) ? e({
          datasetIndex: n
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, n) {
    const i = this.getDatasetMeta(e), r = {
      meta: i,
      index: e,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (i.controller._update(n), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Lt.has(this) ? this.attached && !Lt.running(this) && Lt.start(this) : (this.draw(), bu({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: i, height: r } = this._resizeBeforeDraw;
      this._resize(i, r), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (e = 0; e < n.length && n[e].z <= 0; ++e)
      n[e].draw(this.chartArea);
    for (this._drawDatasets(); e < n.length; ++e)
      n[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const n = this._sortedMetasets, i = [];
    let r, s;
    for (r = 0, s = n.length; r < s; ++r) {
      const a = n[r];
      (!e || a.visible) && i.push(a);
    }
    return i;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let n = e.length - 1; n >= 0; --n)
      this._drawDataset(e[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const n = this.ctx, i = e._clip, r = !i.disabled, s = Q6(e, this.chartArea), a = {
      meta: e,
      index: e.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", a) !== !1 && (r && al(n, {
      left: i.left === !1 ? 0 : s.left - i.left,
      right: i.right === !1 ? this.width : s.right + i.right,
      top: i.top === !1 ? 0 : s.top - i.top,
      bottom: i.bottom === !1 ? this.height : s.bottom + i.bottom
    }), e.controller.draw(), r && ol(n), a.cancelable = !1, this.notifyPlugins("afterDatasetDraw", a));
  }
  isPointInArea(e) {
    return ti(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, n, i, r) {
    const s = Wp.modes[n];
    return typeof s == "function" ? s(this, e, i, r) : [];
  }
  getDatasetMeta(e) {
    const n = this.data.datasets[e], i = this._metasets;
    let r = i.filter((s) => s && s._dataset === n).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: e,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, i.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = jn(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const n = this.data.datasets[e];
    if (!n)
      return !1;
    const i = this.getDatasetMeta(e);
    return typeof i.hidden == "boolean" ? !i.hidden : !n.hidden;
  }
  setDatasetVisibility(e, n) {
    const i = this.getDatasetMeta(e);
    i.hidden = !n;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, n, i) {
    const r = i ? "show" : "hide", s = this.getDatasetMeta(e), a = s.controller._resolveAnimations(void 0, r);
    ir(n) ? (s.data[n].hidden = !i, this.update()) : (this.setDatasetVisibility(e, i), a.update(s, {
      visible: i
    }), this.update((o) => o.datasetIndex === e ? r : void 0));
  }
  hide(e, n) {
    this._updateVisibility(e, n, !1);
  }
  show(e, n) {
    this._updateVisibility(e, n, !0);
  }
  _destroyDatasetMeta(e) {
    const n = this._metasets[e];
    n && n.controller && n.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, n;
    for (this.stop(), Lt.remove(this), e = 0, n = this.data.datasets.length; e < n; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: n } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), Vc(e, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Jr[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, n = this.platform, i = (s, a) => {
      n.addEventListener(this, s, a), e[s] = a;
    }, r = (s, a, o) => {
      s.offsetX = a, s.offsetY = o, this._eventHandler(s);
    };
    Oe(this.options.events, (s) => i(s, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, n = this.platform, i = (l, c) => {
      n.addEventListener(this, l, c), e[l] = c;
    }, r = (l, c) => {
      e[l] && (n.removeEventListener(this, l, c), delete e[l]);
    }, s = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let a;
    const o = () => {
      r("attach", o), this.attached = !0, this.resize(), i("resize", s), i("detach", a);
    };
    a = () => {
      this.attached = !1, r("resize", s), this._stop(), this._resize(0, 0), i("attach", o);
    }, n.isAttached(this.canvas) ? o() : a();
  }
  unbindEvents() {
    Oe(this._listeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._listeners = {}, Oe(this._responsiveListeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, n, i) {
    const r = i ? "set" : "remove";
    let s, a, o, l;
    for (n === "dataset" && (s = this.getDatasetMeta(e[0].datasetIndex), s.controller["_" + r + "DatasetHoverStyle"]()), o = 0, l = e.length; o < l; ++o) {
      a = e[o];
      const c = a && this.getDatasetMeta(a.datasetIndex).controller;
      c && c[r + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const n = this._active || [], i = e.map(({ datasetIndex: s, index: a }) => {
      const o = this.getDatasetMeta(s);
      if (!o)
        throw new Error("No dataset found at index " + s);
      return {
        datasetIndex: s,
        element: o.data[a],
        index: a
      };
    });
    !ds(i, n) && (this._active = i, this._lastEvent = null, this._updateHoverStyles(i, n));
  }
  notifyPlugins(e, n, i) {
    return this._plugins.notify(this, e, n, i);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((n) => n.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, n, i) {
    const r = this.options.hover, s = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), a = s(n, e), o = i ? e : s(e, n);
    a.length && this.updateHoverStyle(a, r.mode, !1), o.length && r.mode && this.updateHoverStyle(o, r.mode, !0);
  }
  _eventHandler(e, n) {
    const i = {
      event: e,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, r = (a) => (a.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", i, r) === !1)
      return;
    const s = this._handleEvent(e, n, i.inChartArea);
    return i.cancelable = !1, this.notifyPlugins("afterEvent", i, r), (s || i.changed) && this.render(), this;
  }
  _handleEvent(e, n, i) {
    const { _active: r = [], options: s } = this, a = n, o = this._getActiveElements(e, r, i, a), l = x3(e), c = U6(e, this._lastEvent, i, l);
    i && (this._lastEvent = null, Pe(s.onHover, [
      e,
      o,
      this
    ], this), l && Pe(s.onClick, [
      e,
      o,
      this
    ], this));
    const u = !ds(o, r);
    return (u || n) && (this._active = o, this._updateHoverStyles(o, r, n)), this._lastEvent = c, u;
  }
  _getActiveElements(e, n, i, r) {
    if (e.type === "mouseout")
      return [];
    if (!i)
      return n;
    const s = this.options.hover;
    return this.getElementsAtEventForMode(e, s.mode, s, r);
  }
}, ge(qt, "defaults", He), ge(qt, "instances", Jr), ge(qt, "overrides", Bn), ge(qt, "registry", _t), ge(qt, "version", $6), ge(qt, "getChart", vu), qt);
function yu() {
  return Oe(fr.instances, (t) => t._plugins.invalidate());
}
function K6(t, e, n) {
  const { startAngle: i, pixelMargin: r, x: s, y: a, outerRadius: o, innerRadius: l } = e;
  let c = r / o;
  t.beginPath(), t.arc(s, a, o, i - c, n + c), l > r ? (c = r / l, t.arc(s, a, l, n + c, i - c, !0)) : t.arc(s, a, r, n + je, i - je), t.closePath(), t.clip();
}
function G6(t) {
  return ll(t, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function q6(t, e, n, i) {
  const r = G6(t.options.borderRadius), s = (n - e) / 2, a = Math.min(s, i * e / 2), o = (l) => {
    const c = (n - Math.min(s, l)) * i / 2;
    return dt(l, 0, Math.min(s, c));
  };
  return {
    outerStart: o(r.outerStart),
    outerEnd: o(r.outerEnd),
    innerStart: dt(r.innerStart, 0, a),
    innerEnd: dt(r.innerEnd, 0, a)
  };
}
function qn(t, e, n, i) {
  return {
    x: n + t * Math.cos(e),
    y: i + t * Math.sin(e)
  };
}
function ys(t, e, n, i, r, s) {
  const { x: a, y: o, startAngle: l, pixelMargin: c, innerRadius: u } = e, d = Math.max(e.outerRadius + i + n - c, 0), h = u > 0 ? u + i + n + c : 0;
  let g = 0;
  const b = r - l;
  if (i) {
    const N = u > 0 ? u - i : 0, R = d > 0 ? d - i : 0, B = (N + R) / 2, j = B !== 0 ? b * B / (B + i) : b;
    g = (b - j) / 2;
  }
  const m = Math.max(1e-3, b * d - n / Ye) / d, p = (b - m) / 2, x = l + p + g, C = r - p - g, { outerStart: M, outerEnd: _, innerStart: A, innerEnd: E } = q6(e, h, d, C - x), P = d - M, I = d - _, U = x + M / P, Q = C - _ / I, T = h + A, Y = h + E, q = x + A / T, $ = C - E / Y;
  if (t.beginPath(), s) {
    const N = (U + Q) / 2;
    if (t.arc(a, o, d, U, N), t.arc(a, o, d, N, Q), _ > 0) {
      const y = qn(I, Q, a, o);
      t.arc(y.x, y.y, _, Q, C + je);
    }
    const R = qn(Y, C, a, o);
    if (t.lineTo(R.x, R.y), E > 0) {
      const y = qn(Y, $, a, o);
      t.arc(y.x, y.y, E, C + je, $ + Math.PI);
    }
    const B = (C - E / h + (x + A / h)) / 2;
    if (t.arc(a, o, h, C - E / h, B, !0), t.arc(a, o, h, B, x + A / h, !0), A > 0) {
      const y = qn(T, q, a, o);
      t.arc(y.x, y.y, A, q + Math.PI, x - je);
    }
    const j = qn(P, x, a, o);
    if (t.lineTo(j.x, j.y), M > 0) {
      const y = qn(P, U, a, o);
      t.arc(y.x, y.y, M, x - je, U);
    }
  } else {
    t.moveTo(a, o);
    const N = Math.cos(U) * d + a, R = Math.sin(U) * d + o;
    t.lineTo(N, R);
    const B = Math.cos(Q) * d + a, j = Math.sin(Q) * d + o;
    t.lineTo(B, j);
  }
  t.closePath();
}
function Z6(t, e, n, i, r) {
  const { fullCircles: s, startAngle: a, circumference: o } = e;
  let l = e.endAngle;
  if (s) {
    ys(t, e, n, i, l, r);
    for (let c = 0; c < s; ++c)
      t.fill();
    isNaN(o) || (l = a + (o % Ve || Ve));
  }
  return ys(t, e, n, i, l, r), t.fill(), l;
}
function J6(t, e, n, i, r) {
  const { fullCircles: s, startAngle: a, circumference: o, options: l } = e, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: h } = l, g = l.borderAlign === "inner";
  if (!c)
    return;
  t.setLineDash(d || []), t.lineDashOffset = h, g ? (t.lineWidth = c * 2, t.lineJoin = u || "round") : (t.lineWidth = c, t.lineJoin = u || "bevel");
  let b = e.endAngle;
  if (s) {
    ys(t, e, n, i, b, r);
    for (let m = 0; m < s; ++m)
      t.stroke();
    isNaN(o) || (b = a + (o % Ve || Ve));
  }
  g && K6(t, e, b), s || (ys(t, e, n, i, b, r), t.stroke());
}
class $i extends Si {
  constructor(n) {
    super();
    ge(this, "circumference");
    ge(this, "endAngle");
    ge(this, "fullCircles");
    ge(this, "innerRadius");
    ge(this, "outerRadius");
    ge(this, "pixelMargin");
    ge(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, n && Object.assign(this, n);
  }
  inRange(n, i, r) {
    const s = this.getProps([
      "x",
      "y"
    ], r), { angle: a, distance: o } = Uh(s, {
      x: n,
      y: i
    }), { startAngle: l, endAngle: c, innerRadius: u, outerRadius: d, circumference: h } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), g = (this.options.spacing + this.options.borderWidth) / 2, m = we(h, c - l) >= Ve || ms(a, l, c), p = En(o, u + g, d + g);
    return m && p;
  }
  getCenterPoint(n) {
    const { x: i, y: r, startAngle: s, endAngle: a, innerRadius: o, outerRadius: l } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], n), { offset: c, spacing: u } = this.options, d = (s + a) / 2, h = (o + l + u + c) / 2;
    return {
      x: i + Math.cos(d) * h,
      y: r + Math.sin(d) * h
    };
  }
  tooltipPosition(n) {
    return this.getCenterPoint(n);
  }
  draw(n) {
    const { options: i, circumference: r } = this, s = (i.offset || 0) / 4, a = (i.spacing || 0) / 2, o = i.circular;
    if (this.pixelMargin = i.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > Ve ? Math.floor(r / Ve) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    n.save();
    const l = (this.startAngle + this.endAngle) / 2;
    n.translate(Math.cos(l) * s, Math.sin(l) * s);
    const c = 1 - Math.sin(Math.min(Ye, r || 0)), u = s * c;
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, Z6(n, this, u, a, o), J6(n, this, u, a, o), n.restore();
  }
}
ge($i, "id", "arc"), ge($i, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), ge($i, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), ge($i, "descriptors", {
  _scriptable: !0,
  _indexable: (n) => n !== "borderDash"
});
function Af(t, e) {
  const { x: n, y: i, base: r, width: s, height: a } = t.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let o, l, c, u, d;
  return t.horizontal ? (d = a / 2, o = Math.min(n, r), l = Math.max(n, r), c = i - d, u = i + d) : (d = s / 2, o = n - d, l = n + d, c = Math.min(i, r), u = Math.max(i, r)), {
    left: o,
    top: c,
    right: l,
    bottom: u
  };
}
function sn(t, e, n, i) {
  return t ? 0 : dt(e, n, i);
}
function X6(t, e, n) {
  const i = t.options.borderWidth, r = t.borderSkipped, s = tf(i);
  return {
    t: sn(r.top, s.top, 0, n),
    r: sn(r.right, s.right, 0, e),
    b: sn(r.bottom, s.bottom, 0, n),
    l: sn(r.left, s.left, 0, e)
  };
}
function e5(t, e, n) {
  const { enableBorderRadius: i } = t.getProps([
    "enableBorderRadius"
  ]), r = t.options.borderRadius, s = Dn(r), a = Math.min(e, n), o = t.borderSkipped, l = i || Ae(r);
  return {
    topLeft: sn(!l || o.top || o.left, s.topLeft, 0, a),
    topRight: sn(!l || o.top || o.right, s.topRight, 0, a),
    bottomLeft: sn(!l || o.bottom || o.left, s.bottomLeft, 0, a),
    bottomRight: sn(!l || o.bottom || o.right, s.bottomRight, 0, a)
  };
}
function t5(t) {
  const e = Af(t), n = e.right - e.left, i = e.bottom - e.top, r = X6(t, n / 2, i / 2), s = e5(t, n / 2, i / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: n,
      h: i,
      radius: s
    },
    inner: {
      x: e.left + r.l,
      y: e.top + r.t,
      w: n - r.l - r.r,
      h: i - r.t - r.b,
      radius: {
        topLeft: Math.max(0, s.topLeft - Math.max(r.t, r.l)),
        topRight: Math.max(0, s.topRight - Math.max(r.t, r.r)),
        bottomLeft: Math.max(0, s.bottomLeft - Math.max(r.b, r.l)),
        bottomRight: Math.max(0, s.bottomRight - Math.max(r.b, r.r))
      }
    }
  };
}
function Ma(t, e, n, i) {
  const r = e === null, s = n === null, o = t && !(r && s) && Af(t, i);
  return o && (r || En(e, o.left, o.right)) && (s || En(n, o.top, o.bottom));
}
function n5(t) {
  return t.topLeft || t.topRight || t.bottomLeft || t.bottomRight;
}
function i5(t, e) {
  t.rect(e.x, e.y, e.w, e.h);
}
function Oa(t, e, n = {}) {
  const i = t.x !== n.x ? -e : 0, r = t.y !== n.y ? -e : 0, s = (t.x + t.w !== n.x + n.w ? e : 0) - i, a = (t.y + t.h !== n.y + n.h ? e : 0) - r;
  return {
    x: t.x + i,
    y: t.y + r,
    w: t.w + s,
    h: t.h + a,
    radius: t.radius
  };
}
class Xr extends Si {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: n, options: { borderColor: i, backgroundColor: r } } = this, { inner: s, outer: a } = t5(this), o = n5(a.radius) ? rr : i5;
    e.save(), (a.w !== s.w || a.h !== s.h) && (e.beginPath(), o(e, Oa(a, n, s)), e.clip(), o(e, Oa(s, -n, a)), e.fillStyle = i, e.fill("evenodd")), e.beginPath(), o(e, Oa(s, n)), e.fillStyle = r, e.fill(), e.restore();
  }
  inRange(e, n, i) {
    return Ma(this, e, n, i);
  }
  inXRange(e, n) {
    return Ma(this, e, null, n);
  }
  inYRange(e, n) {
    return Ma(this, null, e, n);
  }
  getCenterPoint(e) {
    const { x: n, y: i, base: r, horizontal: s } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: s ? (n + r) / 2 : n,
      y: s ? i : (i + r) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
ge(Xr, "id", "bar"), ge(Xr, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), ge(Xr, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const xu = (t, e) => {
  let { boxHeight: n = e, boxWidth: i = e } = t;
  return t.usePointStyle && (n = Math.min(n, e), i = t.pointStyleWidth || Math.min(i, e)), {
    boxWidth: i,
    boxHeight: n,
    itemHeight: Math.max(e, n)
  };
}, r5 = (t, e) => t !== null && e !== null && t.datasetIndex === e.datasetIndex && t.index === e.index;
class Au extends Si {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n, i) {
    this.maxWidth = e, this.maxHeight = n, this._margins = i, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let n = Pe(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (n = n.filter((i) => e.filter(i, this.chart.data))), e.sort && (n = n.sort((i, r) => e.sort(i, r, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: e, ctx: n } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const i = e.labels, r = et(i.font), s = r.size, a = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = xu(i, s);
    let c, u;
    n.font = r.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(a, s, o, l) + 10) : (u = this.maxHeight, c = this._fitCols(a, r, o, l) + 10), this.width = Math.min(c, e.maxWidth || this.maxWidth), this.height = Math.min(u, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, n, i, r) {
    const { ctx: s, maxWidth: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = r + o;
    let d = e;
    s.textAlign = "left", s.textBaseline = "middle";
    let h = -1, g = -u;
    return this.legendItems.forEach((b, m) => {
      const p = i + n / 2 + s.measureText(b.text).width;
      (m === 0 || c[c.length - 1] + p + 2 * o > a) && (d += u, c[c.length - (m > 0 ? 0 : 1)] = 0, g += u, h++), l[m] = {
        left: 0,
        top: g,
        row: h,
        width: p,
        height: r
      }, c[c.length - 1] += p + o;
    }), d;
  }
  _fitCols(e, n, i, r) {
    const { ctx: s, maxHeight: a, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = a - e;
    let d = o, h = 0, g = 0, b = 0, m = 0;
    return this.legendItems.forEach((p, x) => {
      const { itemWidth: C, itemHeight: M } = s5(i, n, s, p, r);
      x > 0 && g + M + 2 * o > u && (d += h + o, c.push({
        width: h,
        height: g
      }), b += h + o, m++, h = g = 0), l[x] = {
        left: b,
        top: g,
        col: m,
        width: C,
        height: M
      }, h = Math.max(h, C), g += M + o;
    }), d += h, c.push({
      width: h,
      height: g
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: i, labels: { padding: r }, rtl: s } } = this, a = ai(s, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = ht(i, this.left + r, this.right - this.lineWidths[o]);
      for (const c of n)
        o !== c.row && (o = c.row, l = ht(i, this.left + r, this.right - this.lineWidths[o])), c.top += this.top + e + r, c.left = a.leftForLtr(a.x(l), c.width), l += c.width + r;
    } else {
      let o = 0, l = ht(i, this.top + e + r, this.bottom - this.columnSizes[o].height);
      for (const c of n)
        c.col !== o && (o = c.col, l = ht(i, this.top + e + r, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + r, c.left = a.leftForLtr(a.x(c.left), c.width), l += c.height + r;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      al(e, this), this._draw(), ol(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: n, lineWidths: i, ctx: r } = this, { align: s, labels: a } = e, o = He.color, l = ai(e.rtl, this.left, this.width), c = et(a.font), { padding: u } = a, d = c.size, h = d / 2;
    let g;
    this.drawTitle(), r.textAlign = l.textAlign("left"), r.textBaseline = "middle", r.lineWidth = 0.5, r.font = c.string;
    const { boxWidth: b, boxHeight: m, itemHeight: p } = xu(a, d), x = function(E, P, I) {
      if (isNaN(b) || b <= 0 || isNaN(m) || m < 0)
        return;
      r.save();
      const U = we(I.lineWidth, 1);
      if (r.fillStyle = we(I.fillStyle, o), r.lineCap = we(I.lineCap, "butt"), r.lineDashOffset = we(I.lineDashOffset, 0), r.lineJoin = we(I.lineJoin, "miter"), r.lineWidth = U, r.strokeStyle = we(I.strokeStyle, o), r.setLineDash(we(I.lineDash, [])), a.usePointStyle) {
        const Q = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: I.pointStyle,
          rotation: I.rotation,
          borderWidth: U
        }, T = l.xPlus(E, b / 2), Y = P + h;
        ef(r, Q, T, Y, a.pointStyleWidth && b);
      } else {
        const Q = P + Math.max((d - m) / 2, 0), T = l.leftForLtr(E, b), Y = Dn(I.borderRadius);
        r.beginPath(), Object.values(Y).some((q) => q !== 0) ? rr(r, {
          x: T,
          y: Q,
          w: b,
          h: m,
          radius: Y
        }) : r.rect(T, Q, b, m), r.fill(), U !== 0 && r.stroke();
      }
      r.restore();
    }, C = function(E, P, I) {
      vi(r, I.text, E, P + p / 2, c, {
        strikethrough: I.hidden,
        textAlign: l.textAlign(I.textAlign)
      });
    }, M = this.isHorizontal(), _ = this._computeTitleHeight();
    M ? g = {
      x: ht(s, this.left + u, this.right - i[0]),
      y: this.top + u + _,
      line: 0
    } : g = {
      x: this.left + u,
      y: ht(s, this.top + _ + u, this.bottom - n[0].height),
      line: 0
    }, of(this.ctx, e.textDirection);
    const A = p + u;
    this.legendItems.forEach((E, P) => {
      r.strokeStyle = E.fontColor, r.fillStyle = E.fontColor;
      const I = r.measureText(E.text).width, U = l.textAlign(E.textAlign || (E.textAlign = a.textAlign)), Q = b + h + I;
      let T = g.x, Y = g.y;
      l.setWidth(this.width), M ? P > 0 && T + Q + u > this.right && (Y = g.y += A, g.line++, T = g.x = ht(s, this.left + u, this.right - i[g.line])) : P > 0 && Y + A > this.bottom && (T = g.x = T + n[g.line].width + u, g.line++, Y = g.y = ht(s, this.top + _ + u, this.bottom - n[g.line].height));
      const q = l.x(T);
      if (x(q, Y, E), T = D3(U, T + b + h, M ? T + Q : this.right, e.rtl), C(l.x(T), Y, E), M)
        g.x += Q + u;
      else if (typeof E.text != "string") {
        const $ = c.lineHeight;
        g.y += Cf(E, $) + u;
      } else
        g.y += A;
    }), lf(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, n = e.title, i = et(n.font), r = rt(n.padding);
    if (!n.display)
      return;
    const s = ai(e.rtl, this.left, this.width), a = this.ctx, o = n.position, l = i.size / 2, c = r.top + l;
    let u, d = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), u = this.top + c, d = ht(e.align, d, this.right - h);
    else {
      const b = this.columnSizes.reduce((m, p) => Math.max(m, p.height), 0);
      u = c + ht(e.align, this.top, this.bottom - b - e.labels.padding - this._computeTitleHeight());
    }
    const g = ht(o, d, d + h);
    a.textAlign = s.textAlign(Zh(o)), a.textBaseline = "middle", a.strokeStyle = n.color, a.fillStyle = n.color, a.font = i.string, vi(a, n.text, g, u, i);
  }
  _computeTitleHeight() {
    const e = this.options.title, n = et(e.font), i = rt(e.padding);
    return e.display ? n.lineHeight + i.height : 0;
  }
  _getLegendItemAt(e, n) {
    let i, r, s;
    if (En(e, this.left, this.right) && En(n, this.top, this.bottom)) {
      for (s = this.legendHitBoxes, i = 0; i < s.length; ++i)
        if (r = s[i], En(e, r.left, r.left + r.width) && En(n, r.top, r.top + r.height))
          return this.legendItems[i];
    }
    return null;
  }
  handleEvent(e) {
    const n = this.options;
    if (!l5(e.type, n))
      return;
    const i = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const r = this._hoveredItem, s = r5(r, i);
      r && !s && Pe(n.onLeave, [
        e,
        r,
        this
      ], this), this._hoveredItem = i, i && !s && Pe(n.onHover, [
        e,
        i,
        this
      ], this);
    } else
      i && Pe(n.onClick, [
        e,
        i,
        this
      ], this);
  }
}
function s5(t, e, n, i, r) {
  const s = a5(i, t, e, n), a = o5(r, i, e.lineHeight);
  return {
    itemWidth: s,
    itemHeight: a
  };
}
function a5(t, e, n, i) {
  let r = t.text;
  return r && typeof r != "string" && (r = r.reduce((s, a) => s.length > a.length ? s : a)), e + n.size / 2 + i.measureText(r).width;
}
function o5(t, e, n) {
  let i = t;
  return typeof e.text != "string" && (i = Cf(e, n)), i;
}
function Cf(t, e) {
  const n = t.text ? t.text.length : 0;
  return e * n;
}
function l5(t, e) {
  return !!((t === "mousemove" || t === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (t === "click" || t === "mouseup"));
}
var c5 = {
  id: "legend",
  _element: Au,
  start(t, e, n) {
    const i = t.legend = new Au({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    rn.configure(t, i, n), rn.addBox(t, i);
  },
  stop(t) {
    rn.removeBox(t, t.legend), delete t.legend;
  },
  beforeUpdate(t, e, n) {
    const i = t.legend;
    rn.configure(t, i, n), i.options = n;
  },
  afterUpdate(t) {
    const e = t.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(t, e) {
    e.replay || t.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(t, e, n) {
      const i = e.datasetIndex, r = n.chart;
      r.isDatasetVisible(i) ? (r.hide(i), e.hidden = !0) : (r.show(i), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (t) => t.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(t) {
        const e = t.data.datasets, { labels: { usePointStyle: n, pointStyle: i, textAlign: r, color: s, useBorderRadius: a, borderRadius: o } } = t.legend.options;
        return t._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(n ? 0 : void 0), u = rt(c.borderWidth);
          return {
            text: e[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: s,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: i || c.pointStyle,
            rotation: c.rotation,
            textAlign: r || c.textAlign,
            borderRadius: a && (o || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (t) => t.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (t) => !t.startsWith("on"),
    labels: {
      _scriptable: (t) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(t)
    }
  }
};
const Wi = {
  average(t) {
    if (!t.length)
      return !1;
    let e, n, i = /* @__PURE__ */ new Set(), r = 0, s = 0;
    for (e = 0, n = t.length; e < n; ++e) {
      const o = t[e].element;
      if (o && o.hasValue()) {
        const l = o.tooltipPosition();
        i.add(l.x), r += l.y, ++s;
      }
    }
    return {
      x: [
        ...i
      ].reduce((o, l) => o + l) / i.size,
      y: r / s
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let n = e.x, i = e.y, r = Number.POSITIVE_INFINITY, s, a, o;
    for (s = 0, a = t.length; s < a; ++s) {
      const l = t[s].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = S3(e, c);
        u < r && (r = u, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      n = l.x, i = l.y;
    }
    return {
      x: n,
      y: i
    };
  }
};
function kt(t, e) {
  return e && (Ne(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function Nt(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function u5(t, e) {
  const { element: n, datasetIndex: i, index: r } = e, s = t.getDatasetMeta(i).controller, { label: a, value: o } = s.getLabelAndValue(r);
  return {
    chart: t,
    label: a,
    parsed: s.getParsed(r),
    raw: t.data.datasets[i].data[r],
    formattedValue: o,
    dataset: s.getDataset(),
    dataIndex: r,
    datasetIndex: i,
    element: n
  };
}
function Cu(t, e) {
  const n = t.chart.ctx, { body: i, footer: r, title: s } = t, { boxWidth: a, boxHeight: o } = e, l = et(e.bodyFont), c = et(e.titleFont), u = et(e.footerFont), d = s.length, h = r.length, g = i.length, b = rt(e.padding);
  let m = b.height, p = 0, x = i.reduce((_, A) => _ + A.before.length + A.lines.length + A.after.length, 0);
  if (x += t.beforeBody.length + t.afterBody.length, d && (m += d * c.lineHeight + (d - 1) * e.titleSpacing + e.titleMarginBottom), x) {
    const _ = e.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    m += g * _ + (x - g) * l.lineHeight + (x - 1) * e.bodySpacing;
  }
  h && (m += e.footerMarginTop + h * u.lineHeight + (h - 1) * e.footerSpacing);
  let C = 0;
  const M = function(_) {
    p = Math.max(p, n.measureText(_).width + C);
  };
  return n.save(), n.font = c.string, Oe(t.title, M), n.font = l.string, Oe(t.beforeBody.concat(t.afterBody), M), C = e.displayColors ? a + 2 + e.boxPadding : 0, Oe(i, (_) => {
    Oe(_.before, M), Oe(_.lines, M), Oe(_.after, M);
  }), C = 0, n.font = u.string, Oe(t.footer, M), n.restore(), p += b.width, {
    width: p,
    height: m
  };
}
function d5(t, e) {
  const { y: n, height: i } = e;
  return n < i / 2 ? "top" : n > t.height - i / 2 ? "bottom" : "center";
}
function h5(t, e, n, i) {
  const { x: r, width: s } = i, a = n.caretSize + n.caretPadding;
  if (t === "left" && r + s + a > e.width || t === "right" && r - s - a < 0)
    return !0;
}
function f5(t, e, n, i) {
  const { x: r, width: s } = n, { width: a, chartArea: { left: o, right: l } } = t;
  let c = "center";
  return i === "center" ? c = r <= (o + l) / 2 ? "left" : "right" : r <= s / 2 ? c = "left" : r >= a - s / 2 && (c = "right"), h5(c, t, e, n) && (c = "center"), c;
}
function wu(t, e, n) {
  const i = n.yAlign || e.yAlign || d5(t, n);
  return {
    xAlign: n.xAlign || e.xAlign || f5(t, e, n, i),
    yAlign: i
  };
}
function g5(t, e) {
  let { x: n, width: i } = t;
  return e === "right" ? n -= i : e === "center" && (n -= i / 2), n;
}
function m5(t, e, n) {
  let { y: i, height: r } = t;
  return e === "top" ? i += n : e === "bottom" ? i -= r + n : i -= r / 2, i;
}
function Su(t, e, n, i) {
  const { caretSize: r, caretPadding: s, cornerRadius: a } = t, { xAlign: o, yAlign: l } = n, c = r + s, { topLeft: u, topRight: d, bottomLeft: h, bottomRight: g } = Dn(a);
  let b = g5(e, o);
  const m = m5(e, l, c);
  return l === "center" ? o === "left" ? b += c : o === "right" && (b -= c) : o === "left" ? b -= Math.max(u, h) + r : o === "right" && (b += Math.max(d, g) + r), {
    x: dt(b, 0, i.width - e.width),
    y: dt(m, 0, i.height - e.height)
  };
}
function Rr(t, e, n) {
  const i = rt(n.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - i.right : t.x + i.left;
}
function Eu(t) {
  return kt([], Nt(t));
}
function p5(t, e, n) {
  return jn(t, {
    tooltip: e,
    tooltipItems: n,
    type: "tooltip"
  });
}
function ku(t, e) {
  const n = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return n ? t.override(n) : t;
}
const wf = {
  beforeTitle: It,
  title(t) {
    if (t.length > 0) {
      const e = t[0], n = e.chart.data.labels, i = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (i > 0 && e.dataIndex < i)
        return n[e.dataIndex];
    }
    return "";
  },
  afterTitle: It,
  beforeBody: It,
  beforeLabel: It,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const n = t.formattedValue;
    return De(n) || (e += n), e;
  },
  labelColor(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: It,
  afterBody: It,
  beforeFooter: It,
  footer: It,
  afterFooter: It
};
function st(t, e, n, i) {
  const r = t[e].call(n, i);
  return typeof r > "u" ? wf[e].call(n, i) : r;
}
class yo extends Si {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const n = this.chart, i = this.options.setContext(this.getContext()), r = i.enabled && n.options.animation && i.animations, s = new cf(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(s)), s;
  }
  getContext() {
    return this.$context || (this.$context = p5(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, n) {
    const { callbacks: i } = n, r = st(i, "beforeTitle", this, e), s = st(i, "title", this, e), a = st(i, "afterTitle", this, e);
    let o = [];
    return o = kt(o, Nt(r)), o = kt(o, Nt(s)), o = kt(o, Nt(a)), o;
  }
  getBeforeBody(e, n) {
    return Eu(st(n.callbacks, "beforeBody", this, e));
  }
  getBody(e, n) {
    const { callbacks: i } = n, r = [];
    return Oe(e, (s) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, o = ku(i, s);
      kt(a.before, Nt(st(o, "beforeLabel", this, s))), kt(a.lines, st(o, "label", this, s)), kt(a.after, Nt(st(o, "afterLabel", this, s))), r.push(a);
    }), r;
  }
  getAfterBody(e, n) {
    return Eu(st(n.callbacks, "afterBody", this, e));
  }
  getFooter(e, n) {
    const { callbacks: i } = n, r = st(i, "beforeFooter", this, e), s = st(i, "footer", this, e), a = st(i, "afterFooter", this, e);
    let o = [];
    return o = kt(o, Nt(r)), o = kt(o, Nt(s)), o = kt(o, Nt(a)), o;
  }
  _createItems(e) {
    const n = this._active, i = this.chart.data, r = [], s = [], a = [];
    let o = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      o.push(u5(this.chart, n[l]));
    return e.filter && (o = o.filter((u, d, h) => e.filter(u, d, h, i))), e.itemSort && (o = o.sort((u, d) => e.itemSort(u, d, i))), Oe(o, (u) => {
      const d = ku(e.callbacks, u);
      r.push(st(d, "labelColor", this, u)), s.push(st(d, "labelPointStyle", this, u)), a.push(st(d, "labelTextColor", this, u));
    }), this.labelColors = r, this.labelPointStyles = s, this.labelTextColors = a, this.dataPoints = o, o;
  }
  update(e, n) {
    const i = this.options.setContext(this.getContext()), r = this._active;
    let s, a = [];
    if (!r.length)
      this.opacity !== 0 && (s = {
        opacity: 0
      });
    else {
      const o = Wi[i.position].call(this, r, this._eventPosition);
      a = this._createItems(i), this.title = this.getTitle(a, i), this.beforeBody = this.getBeforeBody(a, i), this.body = this.getBody(a, i), this.afterBody = this.getAfterBody(a, i), this.footer = this.getFooter(a, i);
      const l = this._size = Cu(this, i), c = Object.assign({}, o, l), u = wu(this.chart, i, c), d = Su(i, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, s = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, s && this._resolveAnimations().update(this, s), e && i.external && i.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(e, n, i, r) {
    const s = this.getCaretPosition(e, i, r);
    n.lineTo(s.x1, s.y1), n.lineTo(s.x2, s.y2), n.lineTo(s.x3, s.y3);
  }
  getCaretPosition(e, n, i) {
    const { xAlign: r, yAlign: s } = this, { caretSize: a, cornerRadius: o } = i, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = Dn(o), { x: h, y: g } = e, { width: b, height: m } = n;
    let p, x, C, M, _, A;
    return s === "center" ? (_ = g + m / 2, r === "left" ? (p = h, x = p - a, M = _ + a, A = _ - a) : (p = h + b, x = p + a, M = _ - a, A = _ + a), C = p) : (r === "left" ? x = h + Math.max(l, u) + a : r === "right" ? x = h + b - Math.max(c, d) - a : x = this.caretX, s === "top" ? (M = g, _ = M - a, p = x - a, C = x + a) : (M = g + m, _ = M + a, p = x + a, C = x - a), A = M), {
      x1: p,
      x2: x,
      x3: C,
      y1: M,
      y2: _,
      y3: A
    };
  }
  drawTitle(e, n, i) {
    const r = this.title, s = r.length;
    let a, o, l;
    if (s) {
      const c = ai(i.rtl, this.x, this.width);
      for (e.x = Rr(this, i.titleAlign, i), n.textAlign = c.textAlign(i.titleAlign), n.textBaseline = "middle", a = et(i.titleFont), o = i.titleSpacing, n.fillStyle = i.titleColor, n.font = a.string, l = 0; l < s; ++l)
        n.fillText(r[l], c.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + o, l + 1 === s && (e.y += i.titleMarginBottom - o);
    }
  }
  _drawColorBox(e, n, i, r, s) {
    const a = this.labelColors[i], o = this.labelPointStyles[i], { boxHeight: l, boxWidth: c } = s, u = et(s.bodyFont), d = Rr(this, "left", s), h = r.x(d), g = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, b = n.y + g;
    if (s.usePointStyle) {
      const m = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, p = r.leftForLtr(h, c) + c / 2, x = b + l / 2;
      e.strokeStyle = s.multiKeyBackground, e.fillStyle = s.multiKeyBackground, Hc(e, m, p, x), e.strokeStyle = a.borderColor, e.fillStyle = a.backgroundColor, Hc(e, m, p, x);
    } else {
      e.lineWidth = Ae(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, e.strokeStyle = a.borderColor, e.setLineDash(a.borderDash || []), e.lineDashOffset = a.borderDashOffset || 0;
      const m = r.leftForLtr(h, c), p = r.leftForLtr(r.xPlus(h, 1), c - 2), x = Dn(a.borderRadius);
      Object.values(x).some((C) => C !== 0) ? (e.beginPath(), e.fillStyle = s.multiKeyBackground, rr(e, {
        x: m,
        y: b,
        w: c,
        h: l,
        radius: x
      }), e.fill(), e.stroke(), e.fillStyle = a.backgroundColor, e.beginPath(), rr(e, {
        x: p,
        y: b + 1,
        w: c - 2,
        h: l - 2,
        radius: x
      }), e.fill()) : (e.fillStyle = s.multiKeyBackground, e.fillRect(m, b, c, l), e.strokeRect(m, b, c, l), e.fillStyle = a.backgroundColor, e.fillRect(p, b + 1, c - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[i];
  }
  drawBody(e, n, i) {
    const { body: r } = this, { bodySpacing: s, bodyAlign: a, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: u } = i, d = et(i.bodyFont);
    let h = d.lineHeight, g = 0;
    const b = ai(i.rtl, this.x, this.width), m = function(I) {
      n.fillText(I, b.x(e.x + g), e.y + h / 2), e.y += h + s;
    }, p = b.textAlign(a);
    let x, C, M, _, A, E, P;
    for (n.textAlign = a, n.textBaseline = "middle", n.font = d.string, e.x = Rr(this, p, i), n.fillStyle = i.bodyColor, Oe(this.beforeBody, m), g = o && p !== "right" ? a === "center" ? c / 2 + u : c + 2 + u : 0, _ = 0, E = r.length; _ < E; ++_) {
      for (x = r[_], C = this.labelTextColors[_], n.fillStyle = C, Oe(x.before, m), M = x.lines, o && M.length && (this._drawColorBox(n, e, _, b, i), h = Math.max(d.lineHeight, l)), A = 0, P = M.length; A < P; ++A)
        m(M[A]), h = d.lineHeight;
      Oe(x.after, m);
    }
    g = 0, h = d.lineHeight, Oe(this.afterBody, m), e.y -= s;
  }
  drawFooter(e, n, i) {
    const r = this.footer, s = r.length;
    let a, o;
    if (s) {
      const l = ai(i.rtl, this.x, this.width);
      for (e.x = Rr(this, i.footerAlign, i), e.y += i.footerMarginTop, n.textAlign = l.textAlign(i.footerAlign), n.textBaseline = "middle", a = et(i.footerFont), n.fillStyle = i.footerColor, n.font = a.string, o = 0; o < s; ++o)
        n.fillText(r[o], l.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + i.footerSpacing;
    }
  }
  drawBackground(e, n, i, r) {
    const { xAlign: s, yAlign: a } = this, { x: o, y: l } = e, { width: c, height: u } = i, { topLeft: d, topRight: h, bottomLeft: g, bottomRight: b } = Dn(r.cornerRadius);
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.beginPath(), n.moveTo(o + d, l), a === "top" && this.drawCaret(e, n, i, r), n.lineTo(o + c - h, l), n.quadraticCurveTo(o + c, l, o + c, l + h), a === "center" && s === "right" && this.drawCaret(e, n, i, r), n.lineTo(o + c, l + u - b), n.quadraticCurveTo(o + c, l + u, o + c - b, l + u), a === "bottom" && this.drawCaret(e, n, i, r), n.lineTo(o + g, l + u), n.quadraticCurveTo(o, l + u, o, l + u - g), a === "center" && s === "left" && this.drawCaret(e, n, i, r), n.lineTo(o, l + d), n.quadraticCurveTo(o, l, o + d, l), n.closePath(), n.fill(), r.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(e) {
    const n = this.chart, i = this.$animations, r = i && i.x, s = i && i.y;
    if (r || s) {
      const a = Wi[e.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const o = this._size = Cu(this, e), l = Object.assign({}, a, this._size), c = wu(n, e, l), u = Su(e, l, c, n);
      (r._to !== u.x || s._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const n = this.options.setContext(this.getContext());
    let i = this.opacity;
    if (!i)
      return;
    this._updateAnimationTarget(n);
    const r = {
      width: this.width,
      height: this.height
    }, s = {
      x: this.x,
      y: this.y
    };
    i = Math.abs(i) < 1e-3 ? 0 : i;
    const a = rt(n.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && o && (e.save(), e.globalAlpha = i, this.drawBackground(s, e, r, n), of(e, n.textDirection), s.y += a.top, this.drawTitle(s, e, n), this.drawBody(s, e, n), this.drawFooter(s, e, n), lf(e, n.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, n) {
    const i = this._active, r = e.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), s = !ds(i, r), a = this._positionChanged(r, n);
    (s || a) && (this._active = r, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, n, i = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, s = this._active || [], a = this._getActiveElements(e, s, n, i), o = this._positionChanged(a, e), l = n || !ds(a, s) || o;
    return l && (this._active = a, (r.enabled || r.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(e, n, i, r) {
    const s = this.options;
    if (e.type === "mouseout")
      return [];
    if (!r)
      return n.filter((o) => this.chart.data.datasets[o.datasetIndex] && this.chart.getDatasetMeta(o.datasetIndex).controller.getParsed(o.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(e, s.mode, s, i);
    return s.reverse && a.reverse(), a;
  }
  _positionChanged(e, n) {
    const { caretX: i, caretY: r, options: s } = this, a = Wi[s.position].call(this, e, n);
    return a !== !1 && (i !== a.x || r !== a.y);
  }
}
ge(yo, "positioners", Wi);
var Sf = {
  id: "tooltip",
  _element: yo,
  positioners: Wi,
  afterInit(t, e, n) {
    n && (t.tooltip = new yo({
      chart: t,
      options: n
    }));
  },
  beforeUpdate(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  reset(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const n = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const n = e.replay;
      t.tooltip.handleEvent(e.event, n, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: wf
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const b5 = (t, e, n, i) => (typeof e == "string" ? (n = t.push(e) - 1, i.unshift({
  index: n,
  label: e
})) : isNaN(e) && (n = null), n);
function v5(t, e, n, i) {
  const r = t.indexOf(e);
  if (r === -1)
    return b5(t, e, n, i);
  const s = t.lastIndexOf(e);
  return r !== s ? n : r;
}
const y5 = (t, e) => t === null ? null : dt(Math.round(t), 0, e);
function _u(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class xo extends $n {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const n = this._addedLabels;
    if (n.length) {
      const i = this.getLabels();
      for (const { index: r, label: s } of n)
        i[r] === s && i.splice(r, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, n) {
    if (De(e))
      return null;
    const i = this.getLabels();
    return n = isFinite(n) && i[n] === e ? n : v5(i, e, we(n, e), this._addedLabels), y5(n, i.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: i, max: r } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (i = 0), n || (r = this.getLabels().length - 1)), this.min = i, this.max = r;
  }
  buildTicks() {
    const e = this.min, n = this.max, i = this.options.offset, r = [];
    let s = this.getLabels();
    s = e === 0 && n === s.length - 1 ? s : s.slice(e, n + 1), this._valueRange = Math.max(s.length - (i ? 0 : 1), 1), this._startValue = this.min - (i ? 0.5 : 0);
    for (let a = e; a <= n; a++)
      r.push({
        value: a
      });
    return r;
  }
  getLabelForValue(e) {
    return _u.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ge(xo, "id", "category"), ge(xo, "defaults", {
  ticks: {
    callback: _u
  }
});
function x5(t, e) {
  const n = [], { bounds: r, step: s, min: a, max: o, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: h } = t, g = s || 1, b = u - 1, { min: m, max: p } = e, x = !De(a), C = !De(o), M = !De(c), _ = (p - m) / (d + 1);
  let A = Fc((p - m) / b / g) * g, E, P, I, U;
  if (A < 1e-14 && !x && !C)
    return [
      {
        value: m
      },
      {
        value: p
      }
    ];
  U = Math.ceil(p / A) - Math.floor(m / A), U > b && (A = Fc(U * A / b / g) * g), De(l) || (E = Math.pow(10, l), A = Math.ceil(A * E) / E), r === "ticks" ? (P = Math.floor(m / A) * A, I = Math.ceil(p / A) * A) : (P = m, I = p), x && C && s && w3((o - a) / s, A / 1e3) ? (U = Math.round(Math.min((o - a) / A, u)), A = (o - a) / U, P = a, I = o) : M ? (P = x ? a : P, I = C ? o : I, U = c - 1, A = (I - P) / U) : (U = (I - P) / A, Gr(U, Math.round(U), A / 1e3) ? U = Math.round(U) : U = Math.ceil(U));
  const Q = Math.max(Tc(A), Tc(P));
  E = Math.pow(10, De(l) ? Q : l), P = Math.round(P * E) / E, I = Math.round(I * E) / E;
  let T = 0;
  for (x && (h && P !== a ? (n.push({
    value: a
  }), P < a && T++, Gr(Math.round((P + T * A) * E) / E, a, Mu(a, _, t)) && T++) : P < a && T++); T < U; ++T) {
    const Y = Math.round((P + T * A) * E) / E;
    if (C && Y > o)
      break;
    n.push({
      value: Y
    });
  }
  return C && h && I !== o ? n.length && Gr(n[n.length - 1].value, o, Mu(o, _, t)) ? n[n.length - 1].value = o : n.push({
    value: o
  }) : (!C || I === o) && n.push({
    value: I
  }), n;
}
function Mu(t, e, { horizontal: n, minRotation: i }) {
  const r = Pt(i), s = (n ? Math.sin(r) : Math.cos(r)) || 1e-3, a = 0.75 * e * ("" + t).length;
  return Math.min(e / s, a);
}
class xs extends $n {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    return De(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: n, maxDefined: i } = this.getUserBounds();
    let { min: r, max: s } = this;
    const a = (l) => r = n ? r : l, o = (l) => s = i ? s : l;
    if (e) {
      const l = cn(r), c = cn(s);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && a(0);
    }
    if (r === s) {
      let l = s === 0 ? 1 : Math.abs(s * 0.05);
      o(s + l), e || a(r - l);
    }
    this.min = r, this.max = s;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: n, stepSize: i } = e, r;
    return i ? (r = Math.ceil(this.max / i) - Math.floor(this.min / i) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${i} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), n = n || 11), n && (r = Math.min(n, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, n = e.ticks;
    let i = this.getTickLimit();
    i = Math.max(2, i);
    const r = {
      maxTicks: i,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, s = this._range || this, a = x5(r, s);
    return e.bounds === "ticks" && zh(a, this, "value"), e.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const e = this.ticks;
    let n = this.min, i = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const r = (i - n) / Math.max(e.length - 1, 1) / 2;
      n -= r, i += r;
    }
    this._startValue = n, this._endValue = i, this._valueRange = i - n;
  }
  getLabelForValue(e) {
    return Ws(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class Ao extends xs {
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = qe(e) ? e : 0, this.max = qe(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), n = e ? this.width : this.height, i = Pt(this.options.ticks.minRotation), r = (e ? Math.sin(i) : Math.cos(i)) || 1e-3, s = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, s.lineHeight / r));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
ge(Ao, "id", "linear"), ge(Ao, "defaults", {
  ticks: {
    callback: Ys.formatters.numeric
  }
});
const ar = (t) => Math.floor(nn(t)), xn = (t, e) => Math.pow(10, ar(t) + e);
function Ou(t) {
  return t / Math.pow(10, ar(t)) === 1;
}
function Du(t, e, n) {
  const i = Math.pow(10, n), r = Math.floor(t / i);
  return Math.ceil(e / i) - r;
}
function A5(t, e) {
  const n = e - t;
  let i = ar(n);
  for (; Du(t, e, i) > 10; )
    i++;
  for (; Du(t, e, i) < 10; )
    i--;
  return Math.min(i, ar(t));
}
function C5(t, { min: e, max: n }) {
  e = ft(t.min, e);
  const i = [], r = ar(e);
  let s = A5(e, n), a = s < 0 ? Math.pow(10, Math.abs(s)) : 1;
  const o = Math.pow(10, s), l = r > s ? Math.pow(10, r) : 0, c = Math.round((e - l) * a) / a, u = Math.floor((e - l) / o / 10) * o * 10;
  let d = Math.floor((c - u) / Math.pow(10, s)), h = ft(t.min, Math.round((l + u + d * Math.pow(10, s)) * a) / a);
  for (; h < n; )
    i.push({
      value: h,
      major: Ou(h),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (s++, d = 2, a = s >= 0 ? 1 : a), h = Math.round((l + u + d * Math.pow(10, s)) * a) / a;
  const g = ft(t.max, h);
  return i.push({
    value: g,
    major: Ou(g),
    significand: d
  }), i;
}
class Pu extends $n {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    const i = xs.prototype.parse.apply(this, [
      e,
      n
    ]);
    if (i === 0) {
      this._zero = !0;
      return;
    }
    return qe(i) && i > 0 ? i : null;
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = qe(e) ? Math.max(0, e) : null, this.max = qe(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !qe(this._userMin) && (this.min = e === xn(this.min, 0) ? xn(this.min, -1) : xn(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let i = this.min, r = this.max;
    const s = (o) => i = e ? i : o, a = (o) => r = n ? r : o;
    i === r && (i <= 0 ? (s(1), a(10)) : (s(xn(i, -1)), a(xn(r, 1)))), i <= 0 && s(xn(r, -1)), r <= 0 && a(xn(i, 1)), this.min = i, this.max = r;
  }
  buildTicks() {
    const e = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, i = C5(n, this);
    return e.bounds === "ticks" && zh(i, this, "value"), e.reverse ? (i.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), i;
  }
  getLabelForValue(e) {
    return e === void 0 ? "0" : Ws(e, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const e = this.min;
    super.configure(), this._startValue = nn(e), this._valueRange = nn(this.max) - nn(e);
  }
  getPixelForValue(e) {
    return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (nn(e) - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    const n = this.getDecimalForPixel(e);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
ge(Pu, "id", "logarithmic"), ge(Pu, "defaults", {
  ticks: {
    callback: Ys.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Co(t) {
  const e = t.ticks;
  if (e.display && t.display) {
    const n = rt(e.backdropPadding);
    return we(e.font && e.font.size, He.font.size) + n.height;
  }
  return 0;
}
function w5(t, e, n) {
  return n = Ne(n) ? n : [
    n
  ], {
    w: H3(t, e.string, n),
    h: n.length * e.lineHeight
  };
}
function Fu(t, e, n, i, r) {
  return t === i || t === r ? {
    start: e - n / 2,
    end: e + n / 2
  } : t < i || t > r ? {
    start: e - n,
    end: e
  } : {
    start: e,
    end: e + n
  };
}
function S5(t) {
  const e = {
    l: t.left + t._padding.left,
    r: t.right - t._padding.right,
    t: t.top + t._padding.top,
    b: t.bottom - t._padding.bottom
  }, n = Object.assign({}, e), i = [], r = [], s = t._pointLabels.length, a = t.options.pointLabels, o = a.centerPointLabels ? Ye / s : 0;
  for (let l = 0; l < s; l++) {
    const c = a.setContext(t.getPointLabelContext(l));
    r[l] = c.padding;
    const u = t.getPointPosition(l, t.drawingArea + r[l], o), d = et(c.font), h = w5(t.ctx, d, t._pointLabels[l]);
    i[l] = h;
    const g = Mt(t.getIndexAngle(l) + o), b = Math.round(rl(g)), m = Fu(b, u.x, h.w, 0, 180), p = Fu(b, u.y, h.h, 90, 270);
    E5(n, e, g, m, p);
  }
  t.setCenterPoint(e.l - n.l, n.r - e.r, e.t - n.t, n.b - e.b), t._pointLabelItems = M5(t, i, r);
}
function E5(t, e, n, i, r) {
  const s = Math.abs(Math.sin(n)), a = Math.abs(Math.cos(n));
  let o = 0, l = 0;
  i.start < e.l ? (o = (e.l - i.start) / s, t.l = Math.min(t.l, e.l - o)) : i.end > e.r && (o = (i.end - e.r) / s, t.r = Math.max(t.r, e.r + o)), r.start < e.t ? (l = (e.t - r.start) / a, t.t = Math.min(t.t, e.t - l)) : r.end > e.b && (l = (r.end - e.b) / a, t.b = Math.max(t.b, e.b + l));
}
function k5(t, e, n) {
  const i = t.drawingArea, { extra: r, additionalAngle: s, padding: a, size: o } = n, l = t.getPointPosition(e, i + r + a, s), c = Math.round(rl(Mt(l.angle + je))), u = P5(l.y, o.h, c), d = O5(c), h = D5(l.x, o.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: h,
    top: u,
    right: h + o.w,
    bottom: u + o.h
  };
}
function _5(t, e) {
  if (!e)
    return !0;
  const { left: n, top: i, right: r, bottom: s } = t;
  return !(ti({
    x: n,
    y: i
  }, e) || ti({
    x: n,
    y: s
  }, e) || ti({
    x: r,
    y: i
  }, e) || ti({
    x: r,
    y: s
  }, e));
}
function M5(t, e, n) {
  const i = [], r = t._pointLabels.length, s = t.options, { centerPointLabels: a, display: o } = s.pointLabels, l = {
    extra: Co(s) / 2,
    additionalAngle: a ? Ye / r : 0
  };
  let c;
  for (let u = 0; u < r; u++) {
    l.padding = n[u], l.size = e[u];
    const d = k5(t, u, l);
    i.push(d), o === "auto" && (d.visible = _5(d, c), d.visible && (c = d));
  }
  return i;
}
function O5(t) {
  return t === 0 || t === 180 ? "center" : t < 180 ? "left" : "right";
}
function D5(t, e, n) {
  return n === "right" ? t -= e : n === "center" && (t -= e / 2), t;
}
function P5(t, e, n) {
  return n === 90 || n === 270 ? t -= e / 2 : (n > 270 || n < 90) && (t -= e), t;
}
function F5(t, e, n) {
  const { left: i, top: r, right: s, bottom: a } = n, { backdropColor: o } = e;
  if (!De(o)) {
    const l = Dn(e.borderRadius), c = rt(e.backdropPadding);
    t.fillStyle = o;
    const u = i - c.left, d = r - c.top, h = s - i + c.width, g = a - r + c.height;
    Object.values(l).some((b) => b !== 0) ? (t.beginPath(), rr(t, {
      x: u,
      y: d,
      w: h,
      h: g,
      radius: l
    }), t.fill()) : t.fillRect(u, d, h, g);
  }
}
function T5(t, e) {
  const { ctx: n, options: { pointLabels: i } } = t;
  for (let r = e - 1; r >= 0; r--) {
    const s = t._pointLabelItems[r];
    if (!s.visible)
      continue;
    const a = i.setContext(t.getPointLabelContext(r));
    F5(n, a, s);
    const o = et(a.font), { x: l, y: c, textAlign: u } = s;
    vi(n, t._pointLabels[r], l, c + o.lineHeight / 2, o, {
      color: a.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function Ef(t, e, n, i) {
  const { ctx: r } = t;
  if (n)
    r.arc(t.xCenter, t.yCenter, e, 0, Ve);
  else {
    let s = t.getPointPosition(0, e);
    r.moveTo(s.x, s.y);
    for (let a = 1; a < i; a++)
      s = t.getPointPosition(a, e), r.lineTo(s.x, s.y);
  }
}
function I5(t, e, n, i, r) {
  const s = t.ctx, a = e.circular, { color: o, lineWidth: l } = e;
  !a && !i || !o || !l || n < 0 || (s.save(), s.strokeStyle = o, s.lineWidth = l, s.setLineDash(r.dash), s.lineDashOffset = r.dashOffset, s.beginPath(), Ef(t, n, a, i), s.closePath(), s.stroke(), s.restore());
}
function R5(t, e, n) {
  return jn(t, {
    label: n,
    index: e,
    type: "pointLabel"
  });
}
class Br extends xs {
  constructor(e) {
    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const e = this._padding = rt(Co(this.options) / 2), n = this.width = this.maxWidth - e.width, i = this.height = this.maxHeight - e.height;
    this.xCenter = Math.floor(this.left + n / 2 + e.left), this.yCenter = Math.floor(this.top + i / 2 + e.top), this.drawingArea = Math.floor(Math.min(n, i) / 2);
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!1);
    this.min = qe(e) && !isNaN(e) ? e : 0, this.max = qe(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Co(this.options));
  }
  generateTickLabels(e) {
    xs.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((n, i) => {
      const r = Pe(this.options.pointLabels.callback, [
        n,
        i
      ], this);
      return r || r === 0 ? r : "";
    }).filter((n, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const e = this.options;
    e.display && e.pointLabels.display ? S5(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(e, n, i, r) {
    this.xCenter += Math.floor((e - n) / 2), this.yCenter += Math.floor((i - r) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, n, i, r));
  }
  getIndexAngle(e) {
    const n = Ve / (this._pointLabels.length || 1), i = this.options.startAngle || 0;
    return Mt(e * n + Pt(i));
  }
  getDistanceFromCenterForValue(e) {
    if (De(e))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - e) * n : (e - this.min) * n;
  }
  getValueForDistanceFromCenter(e) {
    if (De(e))
      return NaN;
    const n = e / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(e) {
    const n = this._pointLabels || [];
    if (e >= 0 && e < n.length) {
      const i = n[e];
      return R5(this.getContext(), e, i);
    }
  }
  getPointPosition(e, n, i = 0) {
    const r = this.getIndexAngle(e) - je + i;
    return {
      x: Math.cos(r) * n + this.xCenter,
      y: Math.sin(r) * n + this.yCenter,
      angle: r
    };
  }
  getPointPositionForValue(e, n) {
    return this.getPointPosition(e, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(e) {
    return this.getPointPositionForValue(e || 0, this.getBaseValue());
  }
  getPointLabelPosition(e) {
    const { left: n, top: i, right: r, bottom: s } = this._pointLabelItems[e];
    return {
      left: n,
      top: i,
      right: r,
      bottom: s
    };
  }
  drawBackground() {
    const { backgroundColor: e, grid: { circular: n } } = this.options;
    if (e) {
      const i = this.ctx;
      i.save(), i.beginPath(), Ef(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), i.closePath(), i.fillStyle = e, i.fill(), i.restore();
    }
  }
  drawGrid() {
    const e = this.ctx, n = this.options, { angleLines: i, grid: r, border: s } = n, a = this._pointLabels.length;
    let o, l, c;
    if (n.pointLabels.display && T5(this, a), r.display && this.ticks.forEach((u, d) => {
      if (d !== 0 || d === 0 && this.min < 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const h = this.getContext(d), g = r.setContext(h), b = s.setContext(h);
        I5(this, g, l, a, b);
      }
    }), i.display) {
      for (e.save(), o = a - 1; o >= 0; o--) {
        const u = i.setContext(this.getPointLabelContext(o)), { color: d, lineWidth: h } = u;
        !h || !d || (e.lineWidth = h, e.strokeStyle = d, e.setLineDash(u.borderDash), e.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), c = this.getPointPosition(o, l), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(c.x, c.y), e.stroke());
      }
      e.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const e = this.ctx, n = this.options, i = n.ticks;
    if (!i.display)
      return;
    const r = this.getIndexAngle(0);
    let s, a;
    e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(r), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && this.min >= 0 && !n.reverse)
        return;
      const c = i.setContext(this.getContext(l)), u = et(c.font);
      if (s = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        e.font = u.string, a = e.measureText(o.label).width, e.fillStyle = c.backdropColor;
        const d = rt(c.backdropPadding);
        e.fillRect(-a / 2 - d.left, -s - u.size / 2 - d.top, a + d.width, u.size + d.height);
      }
      vi(e, o.label, 0, -s, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), e.restore();
  }
  drawTitle() {
  }
}
ge(Br, "id", "radialLinear"), ge(Br, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Ys.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), ge(Br, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), ge(Br, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const Us = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, lt = /* @__PURE__ */ Object.keys(Us);
function Tu(t, e) {
  return t - e;
}
function Iu(t, e) {
  if (De(e))
    return null;
  const n = t._adapter, { parser: i, round: r, isoWeekday: s } = t._parseOpts;
  let a = e;
  return typeof i == "function" && (a = i(a)), qe(a) || (a = typeof i == "string" ? n.parse(a, i) : n.parse(a)), a === null ? null : (r && (a = r === "week" && (gs(s) || s === !0) ? n.startOf(a, "isoWeek", s) : n.startOf(a, r)), +a);
}
function Ru(t, e, n, i) {
  const r = lt.length;
  for (let s = lt.indexOf(t); s < r - 1; ++s) {
    const a = Us[lt[s]], o = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((n - e) / (o * a.size)) <= i)
      return lt[s];
  }
  return lt[r - 1];
}
function B5(t, e, n, i, r) {
  for (let s = lt.length - 1; s >= lt.indexOf(n); s--) {
    const a = lt[s];
    if (Us[a].common && t._adapter.diff(r, i, a) >= e - 1)
      return a;
  }
  return lt[n ? lt.indexOf(n) : 0];
}
function L5(t) {
  for (let e = lt.indexOf(t) + 1, n = lt.length; e < n; ++e)
    if (Us[lt[e]].common)
      return lt[e];
}
function Bu(t, e, n) {
  if (!n)
    t[e] = !0;
  else if (n.length) {
    const { lo: i, hi: r } = sl(n, e), s = n[i] >= e ? n[i] : n[r];
    t[s] = !0;
  }
}
function N5(t, e, n, i) {
  const r = t._adapter, s = +r.startOf(e[0].value, i), a = e[e.length - 1].value;
  let o, l;
  for (o = s; o <= a; o = +r.add(o, 1, i))
    l = n[o], l >= 0 && (e[l].major = !0);
  return e;
}
function Lu(t, e, n) {
  const i = [], r = {}, s = e.length;
  let a, o;
  for (a = 0; a < s; ++a)
    o = e[a], r[o] = a, i.push({
      value: o,
      major: !1
    });
  return s === 0 || !n ? i : N5(t, i, r, n);
}
class As extends $n {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, n = {}) {
    const i = e.time || (e.time = {}), r = this._adapter = new Np._date(e.adapters.date);
    r.init(n), Qi(i.displayFormats, r.formats()), this._parseOpts = {
      parser: i.parser,
      round: i.round,
      isoWeekday: i.isoWeekday
    }, super.init(e), this._normalized = n.normalized;
  }
  parse(e, n) {
    return e === void 0 ? null : Iu(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, n = this._adapter, i = e.time.unit || "day";
    let { min: r, max: s, minDefined: a, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !a && !isNaN(c.min) && (r = Math.min(r, c.min)), !o && !isNaN(c.max) && (s = Math.max(s, c.max));
    }
    (!a || !o) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), r = qe(r) && !isNaN(r) ? r : +n.startOf(Date.now(), i), s = qe(s) && !isNaN(s) ? s : +n.endOf(Date.now(), i) + 1, this.min = Math.min(r, s - 1), this.max = Math.max(r + 1, s);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    return e.length && (n = e[0], i = e[e.length - 1]), {
      min: n,
      max: i
    };
  }
  buildTicks() {
    const e = this.options, n = e.time, i = e.ticks, r = i.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const s = this.min, a = this.max, o = _3(r, s, a);
    return this._unit = n.unit || (i.autoSkip ? Ru(n.minUnit, this.min, this.max, this._getLabelCapacity(s)) : B5(this, o.length, n.minUnit, this.min, this.max)), this._majorUnit = !i.major.enabled || this._unit === "year" ? void 0 : L5(this._unit), this.initOffsets(r), e.reverse && o.reverse(), Lu(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let n = 0, i = 0, r, s;
    this.options.offset && e.length && (r = this.getDecimalForValue(e[0]), e.length === 1 ? n = 1 - r : n = (this.getDecimalForValue(e[1]) - r) / 2, s = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? i = s : i = (s - this.getDecimalForValue(e[e.length - 2])) / 2);
    const a = e.length < 3 ? 0.5 : 0.25;
    n = dt(n, 0, a), i = dt(i, 0, a), this._offsets = {
      start: n,
      end: i,
      factor: 1 / (n + 1 + i)
    };
  }
  _generate() {
    const e = this._adapter, n = this.min, i = this.max, r = this.options, s = r.time, a = s.unit || Ru(s.minUnit, n, i, this._getLabelCapacity(n)), o = we(r.ticks.stepSize, 1), l = a === "week" ? s.isoWeekday : !1, c = gs(l) || l === !0, u = {};
    let d = n, h, g;
    if (c && (d = +e.startOf(d, "isoWeek", l)), d = +e.startOf(d, c ? "day" : a), e.diff(i, n, a) > 1e5 * o)
      throw new Error(n + " and " + i + " are too far apart with stepSize of " + o + " " + a);
    const b = r.ticks.source === "data" && this.getDataTimestamps();
    for (h = d, g = 0; h < i; h = +e.add(h, o, a), g++)
      Bu(u, h, b);
    return (h === i || r.bounds === "ticks" || g === 1) && Bu(u, h, b), Object.keys(u).sort(Tu).map((m) => +m);
  }
  getLabelForValue(e) {
    const n = this._adapter, i = this.options.time;
    return i.tooltipFormat ? n.format(e, i.tooltipFormat) : n.format(e, i.displayFormats.datetime);
  }
  format(e, n) {
    const r = this.options.time.displayFormats, s = this._unit, a = n || r[s];
    return this._adapter.format(e, a);
  }
  _tickFormatFunction(e, n, i, r) {
    const s = this.options, a = s.ticks.callback;
    if (a)
      return Pe(a, [
        e,
        n,
        i
      ], this);
    const o = s.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && o[l], d = c && o[c], h = i[n], g = c && d && h && h.major;
    return this._adapter.format(e, r || (g ? d : u));
  }
  generateTickLabels(e) {
    let n, i, r;
    for (n = 0, i = e.length; n < i; ++n)
      r = e[n], r.label = this._tickFormatFunction(r.value, n, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const n = this._offsets, i = this.getDecimalForValue(e);
    return this.getPixelForDecimal((n.start + i) * n.factor);
  }
  getValueForPixel(e) {
    const n = this._offsets, i = this.getDecimalForPixel(e) / n.factor - n.end;
    return this.min + i * (this.max - this.min);
  }
  _getLabelSize(e) {
    const n = this.options.ticks, i = this.ctx.measureText(e).width, r = Pt(this.isHorizontal() ? n.maxRotation : n.minRotation), s = Math.cos(r), a = Math.sin(r), o = this._resolveTickFontOptions(0).size;
    return {
      w: i * s + o * a,
      h: i * a + o * s
    };
  }
  _getLabelCapacity(e) {
    const n = this.options.time, i = n.displayFormats, r = i[n.unit] || i.millisecond, s = this._tickFormatFunction(e, 0, Lu(this, [
      e
    ], this._majorUnit), r), a = this._getLabelSize(s), o = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], n, i;
    if (e.length)
      return e;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (n = 0, i = r.length; n < i; ++n)
      e = e.concat(r[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let n, i;
    if (e.length)
      return e;
    const r = this.getLabels();
    for (n = 0, i = r.length; n < i; ++n)
      e.push(Iu(this, r[n]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return Kh(e.sort(Tu));
  }
}
ge(As, "id", "time"), ge(As, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Lr(t, e, n) {
  let i = 0, r = t.length - 1, s, a, o, l;
  n ? (e >= t[i].pos && e <= t[r].pos && ({ lo: i, hi: r } = mo(t, "pos", e)), { pos: s, time: o } = t[i], { pos: a, time: l } = t[r]) : (e >= t[i].time && e <= t[r].time && ({ lo: i, hi: r } = mo(t, "time", e)), { time: s, pos: o } = t[i], { time: a, pos: l } = t[r]);
  const c = a - s;
  return c ? o + (l - o) * (e - s) / c : o;
}
class Nu extends As {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(e);
    this._minPos = Lr(n, this.min), this._tableRange = Lr(n, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: n, max: i } = this, r = [], s = [];
    let a, o, l, c, u;
    for (a = 0, o = e.length; a < o; ++a)
      c = e[a], c >= n && c <= i && r.push(c);
    if (r.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: i,
          pos: 1
        }
      ];
    for (a = 0, o = r.length; a < o; ++a)
      u = r[a + 1], l = r[a - 1], c = r[a], Math.round((u + l) / 2) !== c && s.push({
        time: c,
        pos: a / (o - 1)
      });
    return s;
  }
  _generate() {
    const e = this.min, n = this.max;
    let i = super.getDataTimestamps();
    return (!i.includes(e) || !i.length) && i.splice(0, 0, e), (!i.includes(n) || i.length === 1) && i.push(n), i.sort((r, s) => r - s);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const n = this.getDataTimestamps(), i = this.getLabelTimestamps();
    return n.length && i.length ? e = this.normalize(n.concat(i)) : e = n.length ? n : i, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Lr(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const n = this._offsets, i = this.getDecimalForPixel(e) / n.factor - n.end;
    return Lr(this._table, i * this._tableRange + this._minPos, !0);
  }
}
ge(Nu, "id", "timeseries"), ge(Nu, "defaults", As.defaults);
const kf = "label";
function Vu(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function V5(t, e) {
  const n = t.options;
  n && e && Object.assign(n, e);
}
function _f(t, e) {
  t.labels = e;
}
function Mf(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : kf;
  const i = [];
  t.datasets = e.map((r) => {
    const s = t.datasets.find((a) => a[n] === r[n]);
    return !s || !r.data || i.includes(s) ? {
      ...r
    } : (i.push(s), Object.assign(s, r), s);
  });
}
function H5(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : kf;
  const n = {
    labels: [],
    datasets: []
  };
  return _f(n, t.labels), Mf(n, t.datasets, e), n;
}
function j5(t, e) {
  const { height: n = 150, width: i = 300, redraw: r = !1, datasetIdKey: s, type: a, data: o, options: l, plugins: c = [], fallbackContent: u, updateMode: d, ...h } = t, g = Se(null), b = Se(), m = () => {
    g.current && (b.current = new fr(g.current, {
      type: a,
      data: H5(o, s),
      options: l && {
        ...l
      },
      plugins: c
    }), Vu(e, b.current));
  }, p = () => {
    Vu(e, null), b.current && (b.current.destroy(), b.current = null);
  };
  return Fe(() => {
    !r && b.current && l && V5(b.current, l);
  }, [
    r,
    l
  ]), Fe(() => {
    !r && b.current && _f(b.current.config.data, o.labels);
  }, [
    r,
    o.labels
  ]), Fe(() => {
    !r && b.current && o.datasets && Mf(b.current.config.data, o.datasets, s);
  }, [
    r,
    o.datasets
  ]), Fe(() => {
    b.current && (r ? (p(), setTimeout(m)) : b.current.update(d));
  }, [
    r,
    l,
    o.labels,
    o.datasets,
    d
  ]), Fe(() => {
    b.current && (p(), setTimeout(m));
  }, [
    a
  ]), Fe(() => (m(), () => p()), []), /* @__PURE__ */ re.createElement("canvas", Object.assign({
    ref: g,
    role: "img",
    height: n,
    width: i
  }, h), u);
}
const $5 = /* @__PURE__ */ or(j5);
function Of(t, e) {
  return fr.register(e), /* @__PURE__ */ or((n, i) => /* @__PURE__ */ re.createElement($5, Object.assign({}, n, {
    ref: i,
    type: t
  })));
}
const W5 = /* @__PURE__ */ Of("bar", qr), Y5 = /* @__PURE__ */ Of("doughnut", Hi);
fr.register($i, Sf, c5);
const z5 = {
  cutout: "67%",
  spacing: 1.5
};
function Ny(t) {
  var i;
  const e = le(
    (r) => (r / t.total * 100).toFixed(1),
    [t.total]
  ), n = ne(
    () => {
      var r, s;
      return {
        labels: [],
        datasets: [
          {
            label: "Requests",
            data: ((r = t.items) == null ? void 0 : r.map((a) => a.count)) ?? [],
            backgroundColor: ((s = t.items) == null ? void 0 : s.map((a) => a.color)) ?? [],
            borderWidth: 0
          }
        ]
      };
    },
    [t.items]
  );
  return /* @__PURE__ */ ae("div", { className: "grid grid-cols-2 gap-12", children: [
    /* @__PURE__ */ w("div", { className: "w-full", children: /* @__PURE__ */ w(Y5, { data: n, options: z5 }) }),
    /* @__PURE__ */ w("div", { className: "flex flex-col gap-4 pt-2", children: (i = t.items) == null ? void 0 : i.map((r) => /* @__PURE__ */ ae("div", { className: "flex gap-2 items-center", children: [
      /* @__PURE__ */ w("div", { className: "w-4 h-4", style: { backgroundColor: r.color } }),
      /* @__PURE__ */ w("div", { className: "text-base font-normal", children: r.label }),
      /* @__PURE__ */ ae("div", { className: "text-sm leading-normal font-light text-gray", children: [
        r.count,
        " ",
        !!r.count && `(${e(r.count)}%)`
      ] })
    ] }, r.label)) })
  ] });
}
fr.register(xo, Ao, Xr, Sf);
const U5 = {
  indexAxis: "y",
  responsive: !0,
  maintainAspectRatio: !1,
  elements: {
    bar: {
      borderWidth: 0
    }
  },
  plugins: {
    legend: {
      display: !1
    },
    title: {
      display: !1
    }
  }
};
function Vy(t) {
  const e = ne(
    () => {
      var i, r;
      return {
        labels: ((i = t.items) == null ? void 0 : i.map((s) => s.label)) ?? [],
        datasets: [
          {
            label: t.label,
            data: ((r = t.items) == null ? void 0 : r.map((s) => s.count)) ?? [],
            backgroundColor: t.color
          }
        ]
      };
    },
    [t.items, t.label, t.color]
  ), n = ne(
    () => {
      var i;
      return t.barHeight * ((((i = t.items) == null ? void 0 : i.length) ?? 0) + 1);
    },
    [t.barHeight, t.items]
  );
  return /* @__PURE__ */ w("div", { className: "w-full", style: { height: n }, children: /* @__PURE__ */ w(W5, { data: e, options: U5 }) });
}
const Q5 = function() {
  const [t, e] = Be({ minWidth: 0, left: 0, top: 0 }), n = Se(null), i = Se(null), r = le(() => {
    var x, C;
    const s = (x = n.current) == null ? void 0 : x.getBoundingClientRect(), a = (C = i.current) == null ? void 0 : C.getBoundingClientRect(), o = (s == null ? void 0 : s.top) || 0, l = (s == null ? void 0 : s.height) || 0, c = (s == null ? void 0 : s.width) || 0, u = (a == null ? void 0 : a.height) || 0, d = (a == null ? void 0 : a.width) || 0, h = window.innerHeight, g = window.innerWidth, b = (s == null ? void 0 : s.width) || 0;
    let m = (s == null ? void 0 : s.left) || 0, p = o + l - 1;
    p + u > h && (p = p - l - u + 1), m + d > g && (m = m - (d - c)), p >= 0 && m >= 0 && e({
      minWidth: b,
      left: Math.round(m),
      top: Math.round(p)
    });
  }, []);
  return Fe(() => (r(), window.addEventListener("resize", r), window.addEventListener("scroll", r), () => {
    window.removeEventListener("resize", r), window.removeEventListener("scroll", r);
  }), [r]), {
    styles: t,
    fieldRef: n,
    optionsRef: i,
    handlePosition: r
  };
};
function Hu({
  onChange: t,
  renderInput: e,
  renderOption: n,
  ...i
}) {
  const { styles: r, fieldRef: s, optionsRef: a, handlePosition: o } = Q5(), l = ne(
    () => de("inline-block", {
      "w-full": i.fullWidth
    }),
    [i.fullWidth]
  ), c = le(
    (x) => de("w-full relative inline-flex justify-between items-center", {
      "input-plain": i.plain && !i.light,
      "input-plain-light": i.plain && i.light,
      "input-light": !i.plain && i.light,
      "input-dark": !i.plain && !i.light,
      "input-disabled": i.disabled,
      "border-red bg-error bg-no-repeat bg-[right_0.75rem_center] bg-[length:20px_20px] pr-12": i.error,
      "text-gray": !i.value,
      "ring-2 ring-inset ring-white": x
    }),
    [i.disabled, i.light, i.error, i.value, i.plain]
  ), u = le(
    (x) => de("text-lg -my-0.5", {
      "text-white": !i.disabled && !i.light,
      "text-gray-dark": i.light,
      "rotate-90": !x,
      "-rotate-90 -ml-1 mr-1": x
    }),
    [i.disabled, i.light, i.plain]
  ), d = ne(
    () => de("p-3 cursor-pointer", {
      "bg-gray-dark hover:bg-gray-light text-white": !i.light,
      "bg-white-light hover:bg-primary-lighter text-gray-dark": i.light
    }),
    [i.light, i.plain]
  ), h = ne(
    () => de("overflow-hidden overflow-ellipsis whitespace-nowrap", {
      "mr-8": !i.plain,
      "mr-2": i.plain
    }),
    [i.plain]
  ), g = ne(
    () => [
      ...i.allowEmpty ? [
        {
          label: i.emptyLabel ?? /* @__PURE__ */ w(on, { children: " " }),
          short: i.emptyLabel ?? /* @__PURE__ */ w(on, { children: " " }),
          value: ""
        }
      ] : [],
      ...i.items
    ],
    [i.items, i.allowEmpty, i.emptyLabel]
  ), b = ne(
    () => i.multiple ? g.filter(
      (x) => {
        var C;
        return (C = i.value) == null ? void 0 : C.includes(x.value);
      }
    ) : g.find((x) => x.value === i.value),
    [i.multiple, i.value, g]
  ), m = ne(
    () => {
      var x;
      return i.multiple ? g.filter(
        (C) => {
          var M;
          return (M = i.value) == null ? void 0 : M.includes(C.value);
        }
      ).map((C) => C.label).join(", ") : (x = g.find((C) => C.value === i.value)) == null ? void 0 : x.label;
    },
    [i.multiple, i.value, g]
  ), p = le(
    (x) => {
      t == null || t({
        target: {
          name: i.name,
          value: x
        }
      });
    },
    [t, i.name]
  );
  return /* @__PURE__ */ w("div", { ref: s, className: l, children: /* @__PURE__ */ w(
    en,
    {
      value: i.value,
      multiple: i.multiple,
      disabled: i.disabled,
      onChange: p,
      children: ({ open: x }) => /* @__PURE__ */ ae(on, { children: [
        /* @__PURE__ */ ae(
          en.Button,
          {
            onClick: () => setTimeout(o, 0),
            className: c(x),
            children: [
              /* @__PURE__ */ w("div", { className: h, children: m ? e ? e(b) : m : i.placeholder }),
              /* @__PURE__ */ w("div", { className: u(x), children: /* @__PURE__ */ w(xi, {}) })
            ]
          }
        ),
        /* @__PURE__ */ w(
          en.Options,
          {
            ref: a,
            className: "fixed border border-gray-light bg-white-light z-50 max-h-[300px] overflow-auto no-scrollbar",
            style: r,
            children: g.map((C) => /* @__PURE__ */ w(
              en.Option,
              {
                value: C.value,
                className: d,
                children: n ? n(C) : C.label
              },
              `${C.label}-${C.value}`
            ))
          }
        )
      ] })
    }
  ) });
}
function K5(t) {
  const e = ne(
    () => de(
      "inline-flex gap-2 text-red text-xs font-normal leading-5 items-center mt-1",
      {
        "w-full": t.fullWidth
      }
    ),
    [t.fullWidth]
  );
  return /* @__PURE__ */ w("div", { className: e, children: t.message });
}
function G5(t) {
  const e = ne(
    () => de({
      "input-label-light": t.light,
      "input-label-dark": !t.light,
      "w-full": t.fullWidth
    }),
    [t.light, t.fullWidth]
  ), n = ne(
    () => de("block text-xs leading-4 font-normal mt-1", {
      "text-gray-dark": t.light,
      "text-gray-light": !t.light,
      "w-full": t.fullWidth
    }),
    [t.light, t.fullWidth]
  );
  return /* @__PURE__ */ ae("label", { htmlFor: t.htmlFor, className: e, children: [
    /* @__PURE__ */ w("span", { children: t.label }),
    t.helpText && /* @__PURE__ */ w("span", { className: n, children: t.helpText })
  ] });
}
const ju = 1, Zn = 1e6;
function Hy({ onChange: t, onBlur: e, ...n }) {
  const i = le(
    (_) => _ ? n.float && _.includes(".") ? parseFloat(_.endsWith(".") ? `${_}0` : _) : parseInt(_) : 0,
    [n.float]
  ), r = le(
    (_) => {
      const A = String(_ || "").replace(/[^\d.]/g, ""), E = (A.match(/\./g) || []).length;
      return E > 0 ? E > 1 ? n.float ? A.substring(0, A.lastIndexOf(".")) : A.substring(0, A.indexOf(".")) : n.float ? A : A.substring(0, A.indexOf(".")) : A;
    },
    [n.float]
  ), s = le(
    (_) => {
      const A = r(_);
      return A ? A.includes(".") ? A.endsWith(".") ? `${A}0` : A : n.float ? `${A}.0` : A : "";
    },
    [n.float]
  ), [a, o] = Be(s(n.value || "")), l = ne(
    () => de("w-full", {
      "input-plain": n.plain,
      "input-light": !n.plain && n.light,
      "input-dark": !n.plain && !n.light,
      "input-disabled": n.disabled,
      "pr-24": !n.error,
      "border-red bg-error bg-no-repeat bg-[right_6rem_center] bg-[length:20px_20px] pr-32": n.error
    }),
    [n.disabled, n.light, n.plain, n.error]
  ), c = ne(
    () => de("w-11 h-full leading-none text-center", {
      "text-white": !n.disabled && !n.light && !n.plain,
      "text-gray-dark": n.light || n.plain
    }),
    [n.disabled, n.light, n.plain]
  ), u = ne(
    () => de("w-px inline-block h-5", {
      "bg-gray-light": !n.disabled,
      "bg-gray-dark": n.disabled
    }),
    [n.disabled]
  ), d = ne(
    () => de("inline-block relative", {
      "w-full": n.fullWidth
    }),
    [n.fullWidth]
  ), h = le(
    (_) => {
      t == null || t({
        target: {
          name: n.name,
          value: _
        }
      });
    },
    [t, n.name]
  ), g = le(
    (_) => {
      e == null || e({
        target: {
          name: n.name,
          value: _
        }
      });
    },
    [e, n.name]
  ), b = le(
    (_) => (typeof n.max > "u" || _ <= n.max) && (typeof n.min > "u" || _ >= n.min),
    [n.min, n.max]
  ), m = le(
    (_) => {
      const A = s(_.target.value), E = r(_.target.value);
      o(E), h(A);
    },
    [h, o, s, r]
  ), p = le(
    (_) => {
      n.min && _ < n.min ? (o(String(n.min)), h(String(n.min)), g(String(n.min))) : n.max && _ > n.max && (o(String(n.max)), h(String(n.max)), g(String(n.max)));
    },
    [n.min, n.max, h]
  ), x = le(
    (_) => {
      const A = s(_.target.value), E = i(_.target.value);
      !E || b(E) ? (o(_.target.value), h(A), g(A)) : p(E);
    },
    [n.min, n.max, h, p, b, s, i, o]
  ), C = le(() => {
    const _ = i(a), A = (_ * Zn + ju * Zn) / Zn;
    b(A) ? (o(String(A)), h(String(A)), g(String(A))) : p(_);
  }, [n.float, a, h, p, b]), M = le(() => {
    const _ = i(a), A = (_ * Zn - ju * Zn) / Zn;
    b(A) ? (o(String(A)), h(String(A)), g(String(A))) : p(_);
  }, [n.float, a, h, p, b]);
  return Fe(() => {
    const _ = i(a);
    a && !b(_) && p(_);
  }, [n.min, n.max]), /* @__PURE__ */ ae("div", { className: d, children: [
    /* @__PURE__ */ w(
      "input",
      {
        type: "text",
        id: n.id ?? n.name,
        name: n.name,
        value: a,
        min: n.min,
        max: n.max,
        disabled: n.disabled,
        placeholder: n.placeholder,
        onChange: m,
        onBlur: x,
        className: l
      }
    ),
    /* @__PURE__ */ ae("div", { className: "absolute -top-px right-0 h-full inline-flex items-center", children: [
      /* @__PURE__ */ w("button", { type: "button", onClick: M, className: c, children: /* @__PURE__ */ w(og, {}) }),
      /* @__PURE__ */ w("span", { className: u }),
      /* @__PURE__ */ w("button", { type: "button", onClick: C, className: c, children: /* @__PURE__ */ w(J2, {}) })
    ] })
  ] });
}
function jy({ onChange: t, ...e }) {
  const n = ne(
    () => de("select-none", {
      "flex-row gap-6": e.direction !== "column",
      "flex-col gap-2": e.direction === "column",
      "inline-flex": !e.fullWidth,
      "w-full flex justify-around": e.fullWidth
    }),
    [e.direction, e.fullWidth]
  ), i = ne(
    () => de("input-checkbox", {
      "input-checkbox-disabled": e.disabled,
      "input-checkbox-default": !e.error,
      "input-checkbox-light": e.light,
      "input-checkbox-error": e.error
    }),
    [e.disabled, e.error, e.light]
  ), r = le(
    (a) => {
      t == null || t({
        target: {
          name: e.name,
          value: a
        }
      });
    },
    [t, e.name]
  ), s = le(
    (a) => {
      const o = e.value ?? [];
      o.includes(a.target.value) ? r(o.filter((l) => l !== a.target.value)) : r([...o, a.target.value]);
    },
    [e.value, r]
  );
  return /* @__PURE__ */ w("div", { className: n, children: e.items.map((a) => {
    var o;
    return /* @__PURE__ */ ae(
      "label",
      {
        className: i,
        htmlFor: [e.id ?? e.name, a.value].join("-"),
        children: [
          /* @__PURE__ */ w(
            "input",
            {
              type: "checkbox",
              id: [e.id ?? e.name, a.value].join("-"),
              name: e.name,
              value: a.value,
              checked: (o = e.value) == null ? void 0 : o.includes(a.value),
              disabled: e.disabled,
              onChange: s,
              className: "hidden"
            }
          ),
          /* @__PURE__ */ w("span", { children: a.title })
        ]
      },
      [e.id ?? e.name, a.value].join("-")
    );
  }) });
}
function $y(t) {
  const [e, n] = Be(t.value ?? ""), i = ne(
    () => de({
      "flex-row gap-6": t.direction !== "column",
      "flex-col gap-2": t.direction === "column",
      "inline-flex": !t.fullWidth,
      "w-full flex justify-around": t.fullWidth
    }),
    [t.direction, t.fullWidth]
  ), r = ne(
    () => de("input-radio", {
      "input-radio-disabled": t.disabled,
      "input-radio-default": !t.error,
      "input-radio-light": t.light,
      "input-radio-error": t.error
    }),
    [t.disabled, t.error]
  );
  return /* @__PURE__ */ w("div", { className: i, children: t.items.map((s) => {
    const a = [t.id ?? t.name, s.value].join("-");
    return /* @__PURE__ */ ae("label", { className: r, htmlFor: a, children: [
      /* @__PURE__ */ w(
        "input",
        {
          type: "radio",
          id: a,
          name: t.name,
          value: s.value,
          checked: s.value === e,
          disabled: t.disabled,
          onChange: (o) => {
            var l;
            (l = t.onChange) == null || l.call(t, o), n(s.value);
          },
          className: "hidden"
        }
      ),
      /* @__PURE__ */ w("span", { children: s.title })
    ] }, a);
  }) });
}
function Wy(t) {
  const e = ne(
    () => de("gap-4", {
      "flex-col": t.direction === "column",
      "inline-flex": !t.fullWidth,
      "w-full flex": t.fullWidth
    }),
    [t.fullWidth, t.direction]
  ), n = ne(
    () => de("has-tooltip", {
      "input-radio-box-dark": !t.light,
      "input-radio-box-light": t.light,
      "input-radio-box-disabled-dark": t.disabled && !t.light,
      "input-radio-box-disabled-light": t.disabled && t.light,
      "input-radio-box-default-dark": !t.error && !t.light,
      "input-radio-box-default-light": !t.error && t.light,
      "input-radio-box-error": t.error,
      "w-full": t.fullWidth
    }),
    [t.disabled, t.error, t.fullWidth, t.light]
  ), i = le(
    (s) => de("flex gap-4 px-4 py-3 items-center", {
      "pr-10": !!s.image
    }),
    []
  ), r = le(
    (s) => de("inline-block w-5 h-5 rounded-full text-xl leading-4", {
      "text-gray-light": t.disabled,
      "text-red": !t.disabled && !!t.error,
      "text-green-input": !t.disabled && !t.error && !t.light,
      "text-primary": !t.disabled && !t.error && t.light,
      "opacity-0": s.value !== t.value,
      "absolute top-3 right-4 mt-px bg-gray-darker": (!!s.image || !!s.description) && !t.light,
      "absolute top-3 right-4 mt-px bg-white-light": (!!s.image || !!s.description) && t.light
    }),
    [t.value, t.error, t.disabled, t.light]
  );
  return /* @__PURE__ */ w("div", { className: e, children: t.items.map((s) => /* @__PURE__ */ ae(
    "label",
    {
      className: n,
      htmlFor: [t.id ?? t.name, s.value].join("-"),
      children: [
        /* @__PURE__ */ w(
          "input",
          {
            type: "radio",
            id: [t.id ?? t.name, s.value].join("-"),
            name: t.name,
            value: s.value,
            checked: s.value === t.value,
            disabled: t.disabled,
            onChange: t.onChange,
            className: "hidden"
          }
        ),
        s.tooltip && /* @__PURE__ */ w("span", { className: "tooltip", children: s.tooltip }),
        s.image && /* @__PURE__ */ w("img", { src: s.image, alt: s.title, className: "block" }),
        /* @__PURE__ */ ae("div", { className: i(s), children: [
          s.icon,
          /* @__PURE__ */ w("span", { className: "inline-block text-base w-full font-normal leading-6", children: s.title }),
          /* @__PURE__ */ w("span", { className: r(s), children: /* @__PURE__ */ w(rg, {}) })
        ] }),
        s.description && /* @__PURE__ */ w("span", { className: "block text-xs font-light leading-5 pb-4	px-4", children: s.description })
      ]
    },
    [t.id ?? t.name, s.value].join("-")
  )) });
}
function Yy({ onChange: t, ...e }) {
  const n = ne(
    () => de("gap-4", {
      "flex-col": e.direction === "column",
      "inline-flex": !e.fullWidth,
      "w-full flex": e.fullWidth
    }),
    [e.fullWidth, e.direction]
  ), i = ne(
    () => de({
      "input-check-box-dark": !e.light,
      "input-check-box-light": e.light,
      "input-check-box-disabled-dark": e.disabled && !e.light,
      "input-check-box-disabled-light": e.disabled && e.light,
      "input-check-box-default-dark": !e.error && !e.light,
      "input-check-box-default-light": !e.error && e.light,
      "input-check-box-error": e.error,
      "w-full": e.fullWidth
    }),
    [e.disabled, e.error, e.light]
  ), r = le(
    (l) => de("flex gap-4 px-4 py-3 items-center", {
      "pr-10": !!l.image
    }),
    []
  ), s = le(
    (l) => {
      var c, u, d, h, g, b, m, p, x, C;
      return de("inline-block w-5 h-5 ring-1 text-lg leading-none", {
        "text-gray-darker bg-gray-light ring-gray-light": e.disabled && ((c = e.value) == null ? void 0 : c.includes(l.value)),
        "text-gray-darker bg-red ring-red": !e.disabled && !!e.error && ((u = e.value) == null ? void 0 : u.includes(l.value)),
        "text-gray-dark bg-gray-dark ring-red": !e.light && !e.disabled && !!e.error && !((d = e.value) != null && d.includes(l.value)),
        "text-gray-dark bg-white-light ring-red": e.light && !e.disabled && !!e.error && !((h = e.value) != null && h.includes(l.value)),
        "text-gray-darker bg-green-input ring-green-input": !e.disabled && !e.error && ((g = e.value) == null ? void 0 : g.includes(l.value)) && !l.image && !e.light,
        "text-gray-darker bg-green-input ring-gray-darker": !e.disabled && !e.error && ((b = e.value) == null ? void 0 : b.includes(l.value)) && l.image && !e.light,
        "text-white-light bg-primary ring-primary": !e.disabled && !e.error && ((m = e.value) == null ? void 0 : m.includes(l.value)) && !l.image && e.light,
        "text-white-light bg-primary ring-gray-light": !e.disabled && !e.error && ((p = e.value) == null ? void 0 : p.includes(l.value)) && l.image && e.light,
        "text-gray-dark bg-gray-dark ring-gray-light": !e.light && !e.error && !((x = e.value) != null && x.includes(l.value)),
        "text-white-light bg-white-light ring-gray-light": e.light && !e.error && !((C = e.value) != null && C.includes(l.value)),
        "absolute top-3 right-4 mt-px": !!l.image || !!l.description
      });
    },
    [e.value, e.error, e.disabled, e.light]
  ), a = le(
    (l) => {
      t == null || t({
        target: {
          name: e.name,
          value: l
        }
      });
    },
    [t, e.name]
  ), o = le(
    (l) => {
      const c = e.value ?? [];
      c.includes(l.target.value) ? a(c.filter((u) => u !== l.target.value)) : a([...c, l.target.value]);
    },
    [e.value, a]
  );
  return /* @__PURE__ */ w("div", { className: n, children: e.items.map((l) => {
    var c;
    return /* @__PURE__ */ ae(
      "label",
      {
        className: i,
        htmlFor: [e.id ?? e.name, l.value].join("-"),
        children: [
          /* @__PURE__ */ w(
            "input",
            {
              type: "checkbox",
              id: [e.id ?? e.name, l.value].join("-"),
              name: e.name,
              value: l.value,
              checked: (c = e.value) == null ? void 0 : c.includes(l.value),
              disabled: e.disabled,
              onChange: o,
              className: "hidden"
            }
          ),
          l.image && /* @__PURE__ */ w("img", { src: l.image, alt: l.title, className: "block" }),
          /* @__PURE__ */ ae("div", { className: r(l), children: [
            l.icon,
            /* @__PURE__ */ w("span", { className: "inline-block text-base w-full font-normal leading-6", children: l.title }),
            /* @__PURE__ */ w("span", { className: s(l), children: /* @__PURE__ */ w(ng, {}) })
          ] }),
          l.description && /* @__PURE__ */ w("span", { className: "block text-xs font-light leading-5 pb-4 px-4", children: l.description })
        ]
      },
      [e.id ?? e.name, l.value].join("-")
    );
  }) });
}
function zy(t) {
  const e = ne(
    () => de("inline-flex items-center gap-4", {
      "w-full": t.fullWidth,
      "input-plain": t.plain,
      "input-light": !t.plain && t.light,
      "input-dark": !t.plain && !t.light,
      "input-disabled": t.disabled,
      "border-red bg-error bg-no-repeat bg-[right_0.75rem_center] bg-[length:20px_20px] pr-12": t.error
    }),
    [t.disabled, t.light, t.plain, t.error, t.fullWidth]
  );
  return /* @__PURE__ */ ae("div", { className: e, children: [
    t.startIcon && /* @__PURE__ */ w("div", { className: "contents text-lg", children: t.startIcon }),
    /* @__PURE__ */ w(
      "input",
      {
        type: t.type ?? "text",
        id: t.id ?? t.name,
        name: t.name,
        value: t.value,
        placeholder: t.placeholder,
        autoFocus: t.autoFocus,
        disabled: t.disabled,
        onChange: t.onChange,
        onBlur: t.onBlur,
        autoComplete: "off",
        className: "w-full appearance-none !bg-transparent outline-none"
      }
    ),
    t.endIcon && /* @__PURE__ */ w("div", { className: "contents text-lg", children: t.endIcon })
  ] });
}
function Uy(t) {
  const e = ne(
    () => de("min-h-[120px]", {
      "input-plain": t.plain,
      "input-light": !t.plain && t.light,
      "input-dark": !t.plain && !t.light,
      "resize-none": !t.resize,
      "input-disabled": t.disabled,
      "w-full": t.fullWidth,
      "border-red bg-error bg-no-repeat bg-[right_0.75rem_bottom_0.75rem] bg-[length:20px_20px] pr-12": t.error
    }),
    [
      t.disabled,
      t.light,
      t.plain,
      t.error,
      t.resize,
      t.fullWidth
    ]
  );
  return /* @__PURE__ */ w(
    "textarea",
    {
      id: t.id ?? t.name,
      name: t.name,
      value: t.value,
      placeholder: t.placeholder,
      disabled: t.disabled,
      onChange: t.onChange,
      className: e
    }
  );
}
var Df = { exports: {} };
(function(t, e) {
  (function(n, i) {
    t.exports = i();
  })(ei, function() {
    var n = 1e3, i = 6e4, r = 36e5, s = "millisecond", a = "second", o = "minute", l = "hour", c = "day", u = "week", d = "month", h = "quarter", g = "year", b = "date", m = "Invalid Date", p = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, x = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, C = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function($) {
      var N = ["th", "st", "nd", "rd"], R = $ % 100;
      return "[" + $ + (N[(R - 20) % 10] || N[R] || N[0]) + "]";
    } }, M = function($, N, R) {
      var B = String($);
      return !B || B.length >= N ? $ : "" + Array(N + 1 - B.length).join(R) + $;
    }, _ = { s: M, z: function($) {
      var N = -$.utcOffset(), R = Math.abs(N), B = Math.floor(R / 60), j = R % 60;
      return (N <= 0 ? "+" : "-") + M(B, 2, "0") + ":" + M(j, 2, "0");
    }, m: function $(N, R) {
      if (N.date() < R.date())
        return -$(R, N);
      var B = 12 * (R.year() - N.year()) + (R.month() - N.month()), j = N.clone().add(B, d), y = R - j < 0, v = N.clone().add(B + (y ? -1 : 1), d);
      return +(-(B + (R - j) / (y ? j - v : v - j)) || 0);
    }, a: function($) {
      return $ < 0 ? Math.ceil($) || 0 : Math.floor($);
    }, p: function($) {
      return { M: d, y: g, w: u, d: c, D: b, h: l, m: o, s: a, ms: s, Q: h }[$] || String($ || "").toLowerCase().replace(/s$/, "");
    }, u: function($) {
      return $ === void 0;
    } }, A = "en", E = {};
    E[A] = C;
    var P = "$isDayjsObject", I = function($) {
      return $ instanceof Y || !(!$ || !$[P]);
    }, U = function $(N, R, B) {
      var j;
      if (!N)
        return A;
      if (typeof N == "string") {
        var y = N.toLowerCase();
        E[y] && (j = y), R && (E[y] = R, j = y);
        var v = N.split("-");
        if (!j && v.length > 1)
          return $(v[0]);
      } else {
        var k = N.name;
        E[k] = N, j = k;
      }
      return !B && j && (A = j), j || !B && A;
    }, Q = function($, N) {
      if (I($))
        return $.clone();
      var R = typeof N == "object" ? N : {};
      return R.date = $, R.args = arguments, new Y(R);
    }, T = _;
    T.l = U, T.i = I, T.w = function($, N) {
      return Q($, { locale: N.$L, utc: N.$u, x: N.$x, $offset: N.$offset });
    };
    var Y = function() {
      function $(R) {
        this.$L = U(R.locale, null, !0), this.parse(R), this.$x = this.$x || R.x || {}, this[P] = !0;
      }
      var N = $.prototype;
      return N.parse = function(R) {
        this.$d = function(B) {
          var j = B.date, y = B.utc;
          if (j === null)
            return /* @__PURE__ */ new Date(NaN);
          if (T.u(j))
            return /* @__PURE__ */ new Date();
          if (j instanceof Date)
            return new Date(j);
          if (typeof j == "string" && !/Z$/i.test(j)) {
            var v = j.match(p);
            if (v) {
              var k = v[2] - 1 || 0, S = (v[7] || "0").substring(0, 3);
              return y ? new Date(Date.UTC(v[1], k, v[3] || 1, v[4] || 0, v[5] || 0, v[6] || 0, S)) : new Date(v[1], k, v[3] || 1, v[4] || 0, v[5] || 0, v[6] || 0, S);
            }
          }
          return new Date(j);
        }(R), this.init();
      }, N.init = function() {
        var R = this.$d;
        this.$y = R.getFullYear(), this.$M = R.getMonth(), this.$D = R.getDate(), this.$W = R.getDay(), this.$H = R.getHours(), this.$m = R.getMinutes(), this.$s = R.getSeconds(), this.$ms = R.getMilliseconds();
      }, N.$utils = function() {
        return T;
      }, N.isValid = function() {
        return this.$d.toString() !== m;
      }, N.isSame = function(R, B) {
        var j = Q(R);
        return this.startOf(B) <= j && j <= this.endOf(B);
      }, N.isAfter = function(R, B) {
        return Q(R) < this.startOf(B);
      }, N.isBefore = function(R, B) {
        return this.endOf(B) < Q(R);
      }, N.$g = function(R, B, j) {
        return T.u(R) ? this[B] : this.set(j, R);
      }, N.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, N.valueOf = function() {
        return this.$d.getTime();
      }, N.startOf = function(R, B) {
        var j = this, y = !!T.u(B) || B, v = T.p(R), k = function(Z, G) {
          var X = T.w(j.$u ? Date.UTC(j.$y, G, Z) : new Date(j.$y, G, Z), j);
          return y ? X : X.endOf(c);
        }, S = function(Z, G) {
          return T.w(j.toDate()[Z].apply(j.toDate("s"), (y ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(G)), j);
        }, f = this.$W, D = this.$M, V = this.$D, z = "set" + (this.$u ? "UTC" : "");
        switch (v) {
          case g:
            return y ? k(1, 0) : k(31, 11);
          case d:
            return y ? k(1, D) : k(0, D + 1);
          case u:
            var H = this.$locale().weekStart || 0, K = (f < H ? f + 7 : f) - H;
            return k(y ? V - K : V + (6 - K), D);
          case c:
          case b:
            return S(z + "Hours", 0);
          case l:
            return S(z + "Minutes", 1);
          case o:
            return S(z + "Seconds", 2);
          case a:
            return S(z + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, N.endOf = function(R) {
        return this.startOf(R, !1);
      }, N.$set = function(R, B) {
        var j, y = T.p(R), v = "set" + (this.$u ? "UTC" : ""), k = (j = {}, j[c] = v + "Date", j[b] = v + "Date", j[d] = v + "Month", j[g] = v + "FullYear", j[l] = v + "Hours", j[o] = v + "Minutes", j[a] = v + "Seconds", j[s] = v + "Milliseconds", j)[y], S = y === c ? this.$D + (B - this.$W) : B;
        if (y === d || y === g) {
          var f = this.clone().set(b, 1);
          f.$d[k](S), f.init(), this.$d = f.set(b, Math.min(this.$D, f.daysInMonth())).$d;
        } else
          k && this.$d[k](S);
        return this.init(), this;
      }, N.set = function(R, B) {
        return this.clone().$set(R, B);
      }, N.get = function(R) {
        return this[T.p(R)]();
      }, N.add = function(R, B) {
        var j, y = this;
        R = Number(R);
        var v = T.p(B), k = function(D) {
          var V = Q(y);
          return T.w(V.date(V.date() + Math.round(D * R)), y);
        };
        if (v === d)
          return this.set(d, this.$M + R);
        if (v === g)
          return this.set(g, this.$y + R);
        if (v === c)
          return k(1);
        if (v === u)
          return k(7);
        var S = (j = {}, j[o] = i, j[l] = r, j[a] = n, j)[v] || 1, f = this.$d.getTime() + R * S;
        return T.w(f, this);
      }, N.subtract = function(R, B) {
        return this.add(-1 * R, B);
      }, N.format = function(R) {
        var B = this, j = this.$locale();
        if (!this.isValid())
          return j.invalidDate || m;
        var y = R || "YYYY-MM-DDTHH:mm:ssZ", v = T.z(this), k = this.$H, S = this.$m, f = this.$M, D = j.weekdays, V = j.months, z = j.meridiem, H = function(G, X, W, ie) {
          return G && (G[X] || G(B, y)) || W[X].slice(0, ie);
        }, K = function(G) {
          return T.s(k % 12 || 12, G, "0");
        }, Z = z || function(G, X, W) {
          var ie = G < 12 ? "AM" : "PM";
          return W ? ie.toLowerCase() : ie;
        };
        return y.replace(x, function(G, X) {
          return X || function(W) {
            switch (W) {
              case "YY":
                return String(B.$y).slice(-2);
              case "YYYY":
                return T.s(B.$y, 4, "0");
              case "M":
                return f + 1;
              case "MM":
                return T.s(f + 1, 2, "0");
              case "MMM":
                return H(j.monthsShort, f, V, 3);
              case "MMMM":
                return H(V, f);
              case "D":
                return B.$D;
              case "DD":
                return T.s(B.$D, 2, "0");
              case "d":
                return String(B.$W);
              case "dd":
                return H(j.weekdaysMin, B.$W, D, 2);
              case "ddd":
                return H(j.weekdaysShort, B.$W, D, 3);
              case "dddd":
                return D[B.$W];
              case "H":
                return String(k);
              case "HH":
                return T.s(k, 2, "0");
              case "h":
                return K(1);
              case "hh":
                return K(2);
              case "a":
                return Z(k, S, !0);
              case "A":
                return Z(k, S, !1);
              case "m":
                return String(S);
              case "mm":
                return T.s(S, 2, "0");
              case "s":
                return String(B.$s);
              case "ss":
                return T.s(B.$s, 2, "0");
              case "SSS":
                return T.s(B.$ms, 3, "0");
              case "Z":
                return v;
            }
            return null;
          }(G) || v.replace(":", "");
        });
      }, N.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, N.diff = function(R, B, j) {
        var y, v = this, k = T.p(B), S = Q(R), f = (S.utcOffset() - this.utcOffset()) * i, D = this - S, V = function() {
          return T.m(v, S);
        };
        switch (k) {
          case g:
            y = V() / 12;
            break;
          case d:
            y = V();
            break;
          case h:
            y = V() / 3;
            break;
          case u:
            y = (D - f) / 6048e5;
            break;
          case c:
            y = (D - f) / 864e5;
            break;
          case l:
            y = D / r;
            break;
          case o:
            y = D / i;
            break;
          case a:
            y = D / n;
            break;
          default:
            y = D;
        }
        return j ? y : T.a(y);
      }, N.daysInMonth = function() {
        return this.endOf(d).$D;
      }, N.$locale = function() {
        return E[this.$L];
      }, N.locale = function(R, B) {
        if (!R)
          return this.$L;
        var j = this.clone(), y = U(R, B, !0);
        return y && (j.$L = y), j;
      }, N.clone = function() {
        return T.w(this.$d, this);
      }, N.toDate = function() {
        return new Date(this.valueOf());
      }, N.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, N.toISOString = function() {
        return this.$d.toISOString();
      }, N.toString = function() {
        return this.$d.toUTCString();
      }, $;
    }(), q = Y.prototype;
    return Q.prototype = q, [["$ms", s], ["$s", a], ["$m", o], ["$H", l], ["$W", c], ["$M", d], ["$y", g], ["$D", b]].forEach(function($) {
      q[$[1]] = function(N) {
        return this.$g(N, $[0], $[1]);
      };
    }), Q.extend = function($, N) {
      return $.$i || ($(N, Y, Q), $.$i = !0), Q;
    }, Q.locale = U, Q.isDayjs = I, Q.unix = function($) {
      return Q(1e3 * $);
    }, Q.en = E[A], Q.Ls = E, Q.p = {}, Q;
  });
})(Df);
var q5 = Df.exports;
const pe = /* @__PURE__ */ Ut(q5), ze = (t, e, ...n) => !t || e == null ? /* @__PURE__ */ new Date() : new Date(t, e, ...n), Re = (t) => ({
  D: t.getDate(),
  M: t.getMonth(),
  Y: t.getFullYear()
}), Z5 = (t) => t.getDay(), Ke = (t) => ze(Re(t).Y, Re(t).M, Re(t).D), wo = (t) => ze(Re(t).Y, Re(t).M + 1, 0).getDate(), li = (t, e, n) => {
  const { Y: i, M: r, D: s } = Re(t), a = n === "date" ? s + e : n === "month" && s > wo(ze(i, r + e, 1)) ? wo(ze(i, r + e, 1)) : s;
  return ze(i + (n === "year" ? e : 0), r + (n === "month" ? e : 0), a);
}, $u = (t, e, n) => li(t, 0 - e, n), Pf = (t, e) => +t - +e, Cs = (t, e, n) => t.toLocaleDateString(e, n), Ff = (t, { locale: e, monthName: n }) => Cs(t, e, { month: n }), Wu = (t, e, n, i) => i && i.h != null && i.m != null ? ze(t, e, n, i.h, i.m) : void 0, J5 = (t, { locale: e, hour: n, minute: i, second: r, hour12: s }) => t.toLocaleTimeString(e, {
  hour: n,
  minute: i,
  second: r,
  hour12: s
}), ws = (t) => `${t < 10 ? 0 : ""}${t}`, X5 = (t, e) => {
  const n = t >= 12 ? "pm" : "am";
  return `${ws(t % 12 || 12)}:${ws(e)} ${n}`;
}, e7 = (t, { hour12: e }) => {
  const n = t.getHours(), i = t.getMinutes();
  return e ? X5(n, i) : `${ws(n)}:${ws(i)}`;
}, Yu = (t, e) => t.concat(e).sort(Pf), zu = (t, e, n) => {
  let [i, r] = [t, e];
  return t && e && ([i, r] = [t, e].sort(n)), [i, r];
}, t7 = (t, e) => e ? e.includes(t) : !1, n7 = (t, e = []) => {
  const { M: n, D: i } = Re(t);
  return e.some((r) => {
    const { M: s, D: a } = Re(r);
    return n === s && i === a;
  });
}, i7 = (t, { day: e, date: n } = {}) => t7(t.getDay(), e) || n7(t, n);
var r7 = 42;
function Uu(t, e) {
  return (Z5(t) + 7 - e) % 7;
}
function s7(t, e, { mode: n, startDay: i }) {
  const r = ze(e, t, 1), s = wo(r), a = Uu(r, i), o = n === "static" ? r7 : a + s + 6 - Uu(ze(e, t, s), i);
  return {
    start: a,
    length: o
  };
}
const Je = (t, e) => +t == +e, Ss = (t, e) => t < e, So = (t, e) => t > e, Qu = (t, e, n) => So(e, t) && Ss(e, n) || Ss(e, t) && So(e, n), Ln = (t, e) => !!t && So(e, t), Nn = (t, e) => !!t && Ss(e, t), Qs = (t, e) => t.some((n) => Je(Ke(n), Ke(e))), a7 = (t, e) => !!e && t < Re(e).M, o7 = (t, e) => !!e && t < Re(e).Y, l7 = (t, e) => !!e && t > Re(e).M, c7 = (t, e) => !!e && t > Re(e).Y, u7 = (t, e) => !!e && t >= Re(e).Y, d7 = (t, e) => !!e && t <= Re(e).Y;
var Ku = {
  mode: "static",
  offsets: [0],
  startDay: 0
}, h7 = {
  mode: "decade",
  /*
   * The default value for the numberOfYears is 12
   * it consists of 10 years + 1 year before + 1 year after
   */
  numberOfYears: 12,
  step: 10
}, f7 = {
  mode: "single",
  toggle: !1,
  selectSameDate: !1
}, g7 = {
  interval: 30,
  useLocales: !1
}, m7 = {
  locale: "en-GB",
  day: "2-digit",
  year: "numeric",
  weekday: "short",
  monthName: "long",
  hour: "2-digit",
  minute: "2-digit",
  hour12: void 0,
  second: void 0
};
function p7({ selectedDates: t = [], onDatesChange: e, focusDate: n, offsetDate: i, onOffsetChange: r, calendar: s = {}, dates: a = {}, locale: o, time: l = {}, exclude: c = {}, years: u }) {
  const { minDate: d, maxDate: h, ...g } = a, { offsets: b = [], ...m } = s, { minTime: p, maxTime: x, ...C } = l, [M, _] = zu(d, h, Pf), [A, E] = zu(p, x, (I, U) => I.h - U.h), P = n && Qs(t, n) ? n : void 0;
  return {
    selectedDates: t,
    onDatesChange: e,
    offsetDate: i,
    onOffsetChange: r,
    focusDate: P,
    calendar: {
      ...Ku,
      ...m,
      offsets: Ku.offsets.concat(b)
    },
    years: { ...h7, ...u },
    dates: {
      ...f7,
      ...g,
      minDate: M && Ke(M),
      maxDate: _ && Ke(_)
    },
    locale: {
      ...m7,
      ...o
    },
    time: {
      ...g7,
      minTime: A,
      maxTime: E,
      ...C
    },
    exclude: c
  };
}
function qi(t) {
  return t === "range";
}
const Gu = "range-start", qu = "range-end", Zu = "will-be-range-start", Ju = "will-be-range-end", b7 = (t, e, n, i) => {
  if (!qi(i) || n.length === 0)
    return "";
  const [r, s] = n;
  return r && s ? Je(t, Ke(r)) ? Je(Ke(r), Ke(s)) ? `${Gu} ${qu}` : Gu : Je(t, Ke(s)) ? qu : Qu(Ke(r), t, Ke(s)) ? "in-range" : "" : !s && e ? Qu(Ke(r), t, e) ? "will-be-in-range" : Ss(e, Ke(r)) ? Je(t, e) ? Zu : Je(t, Ke(r)) ? Ju : "" : Je(t, Ke(r)) ? Zu : Je(t, e) ? Ju : "" : "";
}, v7 = (t, e, n, { rangeEnd: i }, r) => {
  const { dates: { mode: s, minDate: a, maxDate: o }, locale: l, calendar: c, exclude: u } = r, { locale: d, day: h, year: g } = l, { M: b, Y: m } = Re(e), { start: p, length: x } = s7(b, m, c), C = Array(x).fill(0).map((M, _) => {
    const A = ze(m, b, _ + 1 - p);
    return {
      $date: A,
      active: Je(t, A),
      day: Cs(A, d, { day: h }),
      now: Je(Ke(ze()), A),
      range: b7(A, i, n, s),
      disabled: Nn(a, A) || Ln(o, A) || i7(A, u),
      selected: Qs(n, A),
      inCurrentMonth: Re(A).M === b
    };
  });
  return {
    year: Cs(e, d, { year: g }),
    month: Ff(e, l),
    days: C
  };
}, y7 = ({ selectedDates: t, state: e, config: n, offsetDate: i }) => n.calendar.offsets.map((r) => v7(i, li(i, r, "month"), t, e, n));
var x7 = ({ days: t }, { locale: { locale: e, weekday: n } }) => [0, 1, 2, 3, 4, 5, 6].map((i) => Cs(t[i].$date, e, { weekday: n }));
const A7 = (t) => {
  const e = y7(t);
  return ne(() => ({
    calendars: e,
    weekDays: x7(e[0], t.config)
  }), [e, t.config]);
}, un = (...t) => (...e) => t.forEach((n) => n == null ? void 0 : n(...e)), ci = (t) => (e, n) => t(n), Xu = (t) => (...e) => {
  t();
}, dn = (t, e, n = {}, i = !1) => ({
  role: "button",
  tabIndex: 0,
  ...t ? {
    disabled: !0,
    "aria-disabled": !0
  } : {
    onClick(r) {
      e(r);
    }
  },
  ...i ? { "aria-selected": !0 } : {},
  ...n
});
var Tf = "SET_FOCUS_DATE", If = "SET_OFFSET_DATE", Rf = "SET_RANGE_END", Bf = "SET_YEAR", C7 = (t, e) => {
  switch (e.type) {
    case Tf:
      return {
        ...t,
        focusDate: e.date
      };
    case If:
      return {
        ...t,
        offsetDate: e.date
      };
    case Rf:
      return {
        ...t,
        rangeEnd: e.date
      };
    case Bf:
      return {
        ...t,
        offsetYear: e.year
      };
    default:
      return t;
  }
}, Eo = (t, e) => {
  t({ type: Tf, date: e });
}, w7 = (t, e) => {
  t({ type: If, date: e });
}, ed = (t, e) => {
  t({ type: Rf, date: e });
}, td = (t, e) => {
  t({ type: Bf, year: e });
};
const es = ({ dispatch: t, config: { onOffsetChange: e, offsetDate: n } }) => (i) => {
  !e && !n && w7(t, i), e && e(i);
}, nd = (t, { days: e, months: n, years: i }) => {
  let r = t;
  return e && e !== 0 && (r = li(r, e, "date")), n && n !== 0 && (r = li(r, n, "month")), i && i !== 0 && (r = li(r, i, "year")), r;
}, id = (t, { days: e = 0, months: n = 0, years: i = 0 }, r) => !r || Je(t, r) ? t : e !== 0 ? Da(t, r, e, "date") : n !== 0 ? Da(t, r, n, "month") : i !== 0 ? Da(t, r, i, "year") : t, Da = (t, e, n, i) => {
  const r = li(t, n, i);
  return n > 0 ? Ln(e, r) ? $u(e, n, i) : t : Nn(e, r) ? $u(e, n, i) : t;
}, S7 = (t) => {
  const { config: { dates: e } } = t, { minDate: n, maxDate: i } = e, r = le((o, { disabled: l, onClick: c, ...u } = {}) => {
    const d = id(t.offsetDate, o, i), h = nd(d, o), g = !!l || Ln(i, h);
    return dn(g, (b) => un(c, ci(es(t)))(b, h), u);
  }, [i, t]), s = le(({ days: o = 0, months: l = 0, years: c = 0 }, { disabled: u, onClick: d, ...h } = {}) => {
    const g = {
      days: -o,
      months: -l,
      years: -c
    }, b = id(t.offsetDate, g, n), m = nd(b, g), p = !!u || Nn(n, m);
    return dn(p, (x) => un(d, ci(es(t)))(x, m), h);
  }, [n, t]), a = le((o, { disabled: l, onClick: c, ...u } = {}) => {
    const d = !!l || Nn(n, o) || Ln(i, o);
    return dn(d, (h) => un(c, ci(es(t)))(h, o), u);
  }, [t, i, n]);
  return {
    addOffset: r,
    setOffset: a,
    subtractOffset: s
  };
}, E7 = (t, e, n) => Ln(e, n) ? e : Nn(t, n) ? t : n, k7 = (t) => t - t % 10 - 1, _7 = (t, e) => t - (e / 2 - (e % 2 === 0 ? 1 : 0)), M7 = (t, e) => t - e + 1, Lf = (t) => t === "exact", O7 = (t, { mode: e, numberOfYears: n }) => Lf(e) ? M7(t, n) : e === "decade" ? k7(t) : _7(t, n), D7 = (t) => {
  const { selectedDates: e, offsetDate: n, focusDate: i, dates: { minDate: r, maxDate: s }, years: a } = t, o = n || (e.length > 0 ? e[e.length - 1] : E7(r, s, Ke(ze())));
  return {
    focusDate: i,
    rangeEnd: null,
    offsetDate: o,
    offsetYear: O7(Re(o).Y, a)
  };
}, P7 = (t) => {
  const e = p7(t), [n, i] = Rd(C7, D7(e));
  return {
    dispatch: i,
    selectedDates: e.selectedDates,
    offsetDate: e.offsetDate || n.offsetDate,
    state: n,
    config: e
  };
}, F7 = (t, e, { mode: n, toggle: i, limit: r }) => i && Qs(t, e) ? t.filter((s) => !Je(Ke(s), e)) : n === "multiple" ? !r || t.length < r ? Yu(t, e) : t : qi(n) ? t.length === 2 ? [e] : Yu(t, e) : [e], T7 = ({ config: t, selectedDates: e, dispatch: n }) => {
  const { onDatesChange: i, dates: { mode: r, toggle: s, selectSameDate: a } } = t;
  return { dayButton: le(({ $date: l, selected: c, disabled: u, active: d }, { onClick: h, disabled: g, ...b } = {}) => dn(u || !!g, (m) => {
    c && !s && (e.forEach((p) => {
      Je(Ke(p), l) && Eo(n, p);
    }), !qi(r) || !a) || (qi(r) && e.length === 1 && ed(n, null), un(h, ci((p) => {
      const x = F7(e, p, t.dates);
      Eo(n, Qs(x, p) ? p : void 0), i(x);
    }))(m, l));
  }, {
    ...b,
    ...qi(r) && e.length === 1 && {
      onMouseEnter() {
        ed(n, l);
      }
    },
    tabIndex: d ? 0 : -1
  }, c), [
    r,
    s,
    t.dates,
    i,
    e,
    n,
    a
  ]) };
};
var I7 = (t, e, n, { minDate: i, maxDate: r }) => {
  const { M: s, Y: a } = Re(t), { Y: o, M: l } = Re(ze());
  return Array(12).fill(0).map((c, u) => {
    const d = ze(a, u, 1);
    return {
      $date: d,
      month: Ff(d, n),
      selected: e.some((h) => {
        const { M: g, Y: b } = Re(h);
        return b === a && g === u;
      }),
      active: s === u,
      now: u === l && a === o,
      disabled: a7(u, i) && d7(a, i) || l7(u, r) && u7(a, r)
    };
  });
};
const R7 = ({ selectedDates: t, offsetDate: e, config: { locale: n, dates: i } }) => ne(() => ({
  months: I7(e, t, n, i)
}), [i, n, e, t]);
var B7 = (t, { time: e, locale: n }) => {
  const i = ze(), { interval: r, minTime: s, maxTime: a, useLocales: o } = e, { Y: l, M: c, D: u } = Re(t || i), d = 1440 / r, h = Wu(l, c, u, s), g = Wu(l, c, u, a);
  return Array(d).fill(0).map((b, m) => {
    const p = ze(l, c, u, 0, m * r), x = !t || Nn(h, p) || Ln(g, p);
    return {
      $date: p,
      disabled: x,
      now: Je(p, i),
      selected: t ? Je(t, p) : !1,
      time: o ? J5(p, n) : e7(p, n)
    };
  });
};
const L7 = ({ state: { focusDate: t }, config: e }) => ne(() => ({
  time: B7(t, e)
}), [t, e]), N7 = ({ selectedDates: t, state: { focusDate: e }, config: { onDatesChange: n }, dispatch: i }) => ({ timeButton: le(({ $date: s, selected: a, disabled: o, now: l }, { onClick: c, disabled: u, ...d } = {}) => dn(o || !!u, (h) => {
  a || un(c, ci((g) => {
    const b = t.map((m) => Je(e, m) ? g : m);
    Eo(i, g), n(b);
  }))(h, s);
}, {
  ...d,
  tabIndex: a || l ? 0 : -1
}, a), [t, n, i, e]) }), V7 = (t, e, n, { numberOfYears: i }, { minDate: r, maxDate: s }) => {
  const { Y: a, M: o, D: l } = Re(e), { Y: c } = Re(ze());
  return Array(i).fill(0).map((u, d) => {
    const h = t + d;
    return {
      $date: ze(h, o, l),
      active: a === h,
      disabled: o7(h, r) || c7(h, s),
      now: h === c,
      selected: n.some((b) => Re(b).Y === h),
      year: h
    };
  });
}, H7 = ({ selectedDates: t, state: { offsetDate: e, offsetYear: n }, config: { years: i, dates: r } }) => ne(() => ({
  years: V7(n, e, t, i, r)
}), [e, n, t, i, r]), j7 = (t) => {
  const { state: { offsetYear: e, offsetDate: n }, config: { dates: i, years: r }, dispatch: s } = t, { minDate: a, maxDate: o } = i, { step: l, numberOfYears: c, mode: u } = r, { D: d, M: h } = Re(n), g = le(({ $date: p, disabled: x, selected: C, active: M }, { onClick: _, disabled: A, ...E } = {}) => dn(!!A || x, (P) => un(_, ci(es(t)))(P, p), {
    ...E,
    tabIndex: M ? 0 : -1
  }, C), [t]), b = le(({ onClick: p, disabled: x, ...C } = {}) => {
    const M = ze(e + c - 1, h, d), _ = !!x || Ln(o, M) || Lf(u) && !!o && Je(o, M);
    return dn(_, (A) => un(p, Xu(() => td(s, e + l)))(A), C);
  }, [o, s, e, l, d, h, c, u]), m = le(({ onClick: p, disabled: x, ...C } = {}) => {
    const M = !!x || Nn(a, ze(e, h, d));
    return dn(M, (_) => un(p, Xu(() => td(s, e - l)))(_), C);
  }, [a, s, e, l, h, d]);
  return {
    yearButton: g,
    nextYearsButton: b,
    previousYearsButton: m
  };
};
zt({});
var Nf = zt({}), pn = () => Et(Nf), $7 = ({ children: t, config: e }) => re.createElement(Nf.Provider, { value: P7(e) }, t);
const Vf = () => A7(pn()), ml = () => T7(pn()), W7 = () => R7(pn()), Y7 = () => L7(pn()), z7 = () => N7(pn()), U7 = () => H7(pn()), Q7 = () => j7(pn()), Hf = () => S7(pn());
var ko = { exports: {} }, Pa, rd;
function K7() {
  if (rd)
    return Pa;
  rd = 1;
  function t(y) {
    return y && typeof y == "object" && "default" in y ? y.default : y;
  }
  var e = t(re), n = Io;
  function i(y, v) {
    for (var k = Object.getOwnPropertyNames(v), S = 0; S < k.length; S++) {
      var f = k[S], D = Object.getOwnPropertyDescriptor(v, f);
      D && D.configurable && y[f] === void 0 && Object.defineProperty(y, f, D);
    }
    return y;
  }
  function r() {
    return (r = Object.assign || function(y) {
      for (var v = 1; v < arguments.length; v++) {
        var k = arguments[v];
        for (var S in k)
          Object.prototype.hasOwnProperty.call(k, S) && (y[S] = k[S]);
      }
      return y;
    }).apply(this, arguments);
  }
  function s(y, v) {
    y.prototype = Object.create(v.prototype), i(y.prototype.constructor = y, v);
  }
  function a(y, v) {
    if (y == null)
      return {};
    var k, S, f = {}, D = Object.keys(y);
    for (S = 0; S < D.length; S++)
      k = D[S], 0 <= v.indexOf(k) || (f[k] = y[k]);
    return f;
  }
  function o(y) {
    if (y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return y;
  }
  var l = function(y, v, k, S, f, D, V, z) {
    if (!y) {
      var H;
      if (v === void 0)
        H = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var K = [k, S, f, D, V, z], Z = 0;
        (H = new Error(v.replace(/%s/g, function() {
          return K[Z++];
        }))).name = "Invariant Violation";
      }
      throw H.framesToPop = 1, H;
    }
  }, c = l;
  function u(y, v, k) {
    if ("selectionStart" in y && "selectionEnd" in y)
      y.selectionStart = v, y.selectionEnd = k;
    else {
      var S = y.createTextRange();
      S.collapse(!0), S.moveStart("character", v), S.moveEnd("character", k - v), S.select();
    }
  }
  function d(y) {
    var v = 0, k = 0;
    if ("selectionStart" in y && "selectionEnd" in y)
      v = y.selectionStart, k = y.selectionEnd;
    else {
      var S = document.selection.createRange();
      S.parentElement() === y && (v = -S.moveStart("character", -y.value.length), k = -S.moveEnd("character", -y.value.length));
    }
    return { start: v, end: k, length: k - v };
  }
  var h = { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, g = "_";
  function b(y, v, k) {
    var S = "", f = "", D = null, V = [];
    if (v === void 0 && (v = g), k == null && (k = h), !y || typeof y != "string")
      return { maskChar: v, formatChars: k, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
    var z = !1;
    return y.split("").forEach(function(H) {
      z = !z && H === "\\" || (z || !k[H] ? (V.push(S.length), S.length === V.length - 1 && (f += H)) : D = S.length + 1, S += H, !1);
    }), { maskChar: v, formatChars: k, prefix: f, mask: S, lastEditablePosition: D, permanents: V };
  }
  function m(y, v) {
    return y.permanents.indexOf(v) !== -1;
  }
  function p(y, v, k) {
    var S = y.mask, f = y.formatChars;
    if (!k)
      return !1;
    if (m(y, v))
      return S[v] === k;
    var D = f[S[v]];
    return new RegExp(D).test(k);
  }
  function x(y, v) {
    return v.split("").every(function(k, S) {
      return m(y, S) || !p(y, S, k);
    });
  }
  function C(y, v) {
    var k = y.maskChar, S = y.prefix;
    if (!k) {
      for (; v.length > S.length && m(y, v.length - 1); )
        v = v.slice(0, v.length - 1);
      return v.length;
    }
    for (var f = S.length, D = v.length; D >= S.length; D--) {
      var V = v[D];
      if (!m(y, D) && p(y, D, V)) {
        f = D + 1;
        break;
      }
    }
    return f;
  }
  function M(y, v) {
    return C(y, v) === y.mask.length;
  }
  function _(y, v) {
    var k = y.maskChar, S = y.mask, f = y.prefix;
    if (!k) {
      for ((v = E(y, "", v, 0)).length < f.length && (v = f); v.length < S.length && m(y, v.length); )
        v += S[v.length];
      return v;
    }
    if (v)
      return E(y, _(y, ""), v, 0);
    for (var D = 0; D < S.length; D++)
      m(y, D) ? v += S[D] : v += k;
    return v;
  }
  function A(y, v, k, S) {
    var f = k + S, D = y.maskChar, V = y.mask, z = y.prefix, H = v.split("");
    if (D)
      return H.map(function(Z, G) {
        return G < k || f <= G ? Z : m(y, G) ? V[G] : D;
      }).join("");
    for (var K = f; K < H.length; K++)
      m(y, K) && (H[K] = "");
    return k = Math.max(z.length, k), H.splice(k, f - k), v = H.join(""), _(y, v);
  }
  function E(y, v, k, S) {
    var f = y.mask, D = y.maskChar, V = y.prefix, z = k.split(""), H = M(y, v);
    return !D && S > v.length && (v += f.slice(v.length, S)), z.every(function(K) {
      for (; W = K, m(y, X = S) && W !== f[X]; ) {
        if (S >= v.length && (v += f[S]), Z = K, G = S, D && m(y, G) && Z === D)
          return !0;
        if (++S >= f.length)
          return !1;
      }
      var Z, G, X, W;
      return !p(y, S, K) && K !== D || (S < v.length ? v = D || H || S < V.length ? v.slice(0, S) + K + v.slice(S + 1) : (v = v.slice(0, S) + K + v.slice(S), _(y, v)) : D || (v += K), ++S < f.length);
    }), v;
  }
  function P(y, v, k, S) {
    var f = y.mask, D = y.maskChar, V = k.split(""), z = S;
    return V.every(function(H) {
      for (; Z = H, m(y, K = S) && Z !== f[K]; )
        if (++S >= f.length)
          return !1;
      var K, Z;
      return (p(y, S, H) || H === D) && S++, S < f.length;
    }), S - z;
  }
  function I(y, v) {
    for (var k = v; 0 <= k; --k)
      if (!m(y, k))
        return k;
    return null;
  }
  function U(y, v) {
    for (var k = y.mask, S = v; S < k.length; ++S)
      if (!m(y, S))
        return S;
    return null;
  }
  function Q(y) {
    return y || y === 0 ? y + "" : "";
  }
  function T(y, v, k, S, f) {
    var D = y.mask, V = y.prefix, z = y.lastEditablePosition, H = v, K = "", Z = 0, G = 0, X = Math.min(f.start, k.start);
    return k.end > f.start ? G = (Z = P(y, S, K = H.slice(f.start, k.end), X)) ? f.length : 0 : H.length < S.length && (G = S.length - H.length), H = S, G && (G === 1 && !f.length && (X = f.start === k.start ? U(y, k.start) : I(y, k.start)), H = A(y, H, X, G)), H = E(y, H, K, X), (X += Z) >= D.length ? X = D.length : X < V.length && !Z ? X = V.length : X >= V.length && X < z && Z && (X = U(y, X)), K || (K = null), { value: H = _(y, H), enteredString: K, selection: { start: X, end: X } };
  }
  function Y() {
    var y = new RegExp("windows", "i"), v = new RegExp("phone", "i"), k = navigator.userAgent;
    return y.test(k) && v.test(k);
  }
  function q(y) {
    return typeof y == "function";
  }
  function $() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function N() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function R(y) {
    return (N() ? $() : function() {
      return setTimeout(y, 1e3 / 60);
    })(y);
  }
  function B(y) {
    (N() || clearTimeout)(y);
  }
  var j = function(y) {
    function v(S) {
      var f = y.call(this, S) || this;
      f.focused = !1, f.mounted = !1, f.previousSelection = null, f.selectionDeferId = null, f.saveSelectionLoopDeferId = null, f.saveSelectionLoop = function() {
        f.previousSelection = f.getSelection(), f.saveSelectionLoopDeferId = R(f.saveSelectionLoop);
      }, f.runSaveSelectionLoop = function() {
        f.saveSelectionLoopDeferId === null && f.saveSelectionLoop();
      }, f.stopSaveSelectionLoop = function() {
        f.saveSelectionLoopDeferId !== null && (B(f.saveSelectionLoopDeferId), f.saveSelectionLoopDeferId = null, f.previousSelection = null);
      }, f.getInputDOMNode = function() {
        if (!f.mounted)
          return null;
        var ie = n.findDOMNode(o(o(f))), J = typeof window < "u" && ie instanceof window.Element;
        if (ie && !J)
          return null;
        if (ie.nodeName !== "INPUT" && (ie = ie.querySelector("input")), !ie)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return ie;
      }, f.getInputValue = function() {
        var ie = f.getInputDOMNode();
        return ie ? ie.value : null;
      }, f.setInputValue = function(ie) {
        var J = f.getInputDOMNode();
        J && (f.value = ie, J.value = ie);
      }, f.setCursorToEnd = function() {
        var ie = C(f.maskOptions, f.value), J = U(f.maskOptions, ie);
        J !== null && f.setCursorPosition(J);
      }, f.setSelection = function(ie, J, ce) {
        ce === void 0 && (ce = {});
        var fe = f.getInputDOMNode(), me = f.isFocused();
        fe && me && (ce.deferred || u(fe, ie, J), f.selectionDeferId !== null && B(f.selectionDeferId), f.selectionDeferId = R(function() {
          f.selectionDeferId = null, u(fe, ie, J);
        }), f.previousSelection = { start: ie, end: J, length: Math.abs(J - ie) });
      }, f.getSelection = function() {
        return d(f.getInputDOMNode());
      }, f.getCursorPosition = function() {
        return f.getSelection().start;
      }, f.setCursorPosition = function(ie) {
        f.setSelection(ie, ie);
      }, f.isFocused = function() {
        return f.focused;
      }, f.getBeforeMaskedValueChangeConfig = function() {
        var ie = f.maskOptions, J = ie.mask, ce = ie.maskChar, fe = ie.permanents, me = ie.formatChars;
        return { mask: J, maskChar: ce, permanents: fe, alwaysShowMask: !!f.props.alwaysShowMask, formatChars: me };
      }, f.isInputAutofilled = function(ie, J, ce, fe) {
        var me = f.getInputDOMNode();
        try {
          if (me.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return !f.focused || fe.end < ce.length && J.end === ie.length;
      }, f.onChange = function(ie) {
        var J = o(o(f)).beforePasteState, ce = o(o(f)).previousSelection, fe = f.props.beforeMaskedValueChange, me = f.getInputValue(), O = f.value, F = f.getSelection();
        f.isInputAutofilled(me, F, O, ce) && (O = _(f.maskOptions, ""), ce = { start: 0, end: 0, length: 0 }), J && (ce = J.selection, O = J.value, F = { start: ce.start + me.length, end: ce.start + me.length, length: 0 }, me = O.slice(0, ce.start) + me + O.slice(ce.end), f.beforePasteState = null);
        var L = T(f.maskOptions, me, F, O, ce), se = L.enteredString, te = L.selection, ee = L.value;
        if (q(fe)) {
          var he = fe({ value: ee, selection: te }, { value: O, selection: ce }, se, f.getBeforeMaskedValueChangeConfig());
          ee = he.value, te = he.selection;
        }
        f.setInputValue(ee), q(f.props.onChange) && f.props.onChange(ie), f.isWindowsPhoneBrowser ? f.setSelection(te.start, te.end, { deferred: !0 }) : f.setSelection(te.start, te.end);
      }, f.onFocus = function(ie) {
        var J = f.props.beforeMaskedValueChange, ce = f.maskOptions, fe = ce.mask, me = ce.prefix;
        if (f.focused = !0, f.mounted = !0, fe) {
          if (f.value)
            C(f.maskOptions, f.value) < f.maskOptions.mask.length && f.setCursorToEnd();
          else {
            var O = _(f.maskOptions, me), F = _(f.maskOptions, O), L = C(f.maskOptions, F), se = U(f.maskOptions, L), te = { start: se, end: se };
            if (q(J)) {
              var ee = J({ value: F, selection: te }, { value: f.value, selection: null }, null, f.getBeforeMaskedValueChangeConfig());
              F = ee.value, te = ee.selection;
            }
            var he = F !== f.getInputValue();
            he && f.setInputValue(F), he && q(f.props.onChange) && f.props.onChange(ie), f.setSelection(te.start, te.end);
          }
          f.runSaveSelectionLoop();
        }
        q(f.props.onFocus) && f.props.onFocus(ie);
      }, f.onBlur = function(ie) {
        var J = f.props.beforeMaskedValueChange, ce = f.maskOptions.mask;
        if (f.stopSaveSelectionLoop(), f.focused = !1, ce && !f.props.alwaysShowMask && x(f.maskOptions, f.value)) {
          var fe = "";
          q(J) && (fe = J({ value: fe, selection: null }, { value: f.value, selection: f.previousSelection }, null, f.getBeforeMaskedValueChangeConfig()).value);
          var me = fe !== f.getInputValue();
          me && f.setInputValue(fe), me && q(f.props.onChange) && f.props.onChange(ie);
        }
        q(f.props.onBlur) && f.props.onBlur(ie);
      }, f.onMouseDown = function(ie) {
        if (!f.focused && document.addEventListener) {
          f.mouseDownX = ie.clientX, f.mouseDownY = ie.clientY, f.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var J = function ce(fe) {
            if (document.removeEventListener("mouseup", ce), f.focused) {
              var me = Math.abs(fe.clientX - f.mouseDownX), O = Math.abs(fe.clientY - f.mouseDownY), F = Math.max(me, O), L = (/* @__PURE__ */ new Date()).getTime() - f.mouseDownTime;
              (F <= 10 && L <= 200 || F <= 5 && L <= 300) && f.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", J);
        }
        q(f.props.onMouseDown) && f.props.onMouseDown(ie);
      }, f.onPaste = function(ie) {
        q(f.props.onPaste) && f.props.onPaste(ie), ie.defaultPrevented || (f.beforePasteState = { value: f.getInputValue(), selection: f.getSelection() }, f.setInputValue(""));
      }, f.handleRef = function(ie) {
        f.props.children == null && q(f.props.inputRef) && f.props.inputRef(ie);
      };
      var D = S.mask, V = S.maskChar, z = S.formatChars, H = S.alwaysShowMask, K = S.beforeMaskedValueChange, Z = S.defaultValue, G = S.value;
      f.maskOptions = b(D, V, z), Z == null && (Z = ""), G == null && (G = Z);
      var X = Q(G);
      if (f.maskOptions.mask && (H || X) && (X = _(f.maskOptions, X), q(K))) {
        var W = S.value;
        S.value == null && (W = Z), X = K({ value: X, selection: null }, { value: W = Q(W), selection: null }, null, f.getBeforeMaskedValueChangeConfig()).value;
      }
      return f.value = X, f;
    }
    s(v, y);
    var k = v.prototype;
    return k.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = Y(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, k.componentDidUpdate = function() {
      var S = this.previousSelection, f = this.props, D = f.beforeMaskedValueChange, V = f.alwaysShowMask, z = f.mask, H = f.maskChar, K = f.formatChars, Z = this.maskOptions, G = V || this.isFocused(), X = this.props.value != null, W = X ? Q(this.props.value) : this.value, ie = S ? S.start : null;
      if (this.maskOptions = b(z, H, K), this.maskOptions.mask) {
        !Z.mask && this.isFocused() && this.runSaveSelectionLoop();
        var J = this.maskOptions.mask && this.maskOptions.mask !== Z.mask;
        if (Z.mask || X || (W = this.getInputValue()), (J || this.maskOptions.mask && (W || G)) && (W = _(this.maskOptions, W)), J) {
          var ce = C(this.maskOptions, W);
          (ie === null || ce < ie) && (ie = M(this.maskOptions, W) ? ce : U(this.maskOptions, ce));
        }
        !this.maskOptions.mask || !x(this.maskOptions, W) || G || X && this.props.value || (W = "");
        var fe = { start: ie, end: ie };
        if (q(D)) {
          var me = D({ value: W, selection: fe }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
          W = me.value, fe = me.selection;
        }
        this.value = W;
        var O = this.getInputValue() !== this.value;
        O ? (this.setInputValue(this.value), this.forceUpdate()) : J && this.forceUpdate();
        var F = !1;
        fe.start != null && fe.end != null && (F = !S || S.start !== fe.start || S.end !== fe.end), (F || O) && this.setSelection(fe.start, fe.end);
      } else
        Z.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, k.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && B(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, k.render = function() {
      var S, f = this.props, D = (f.mask, f.alwaysShowMask, f.maskChar, f.formatChars, f.inputRef, f.beforeMaskedValueChange, f.children), V = a(f, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
      if (D) {
        q(D) || c(!1);
        var z = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], H = r({}, V);
        z.forEach(function(Z) {
          return delete H[Z];
        }), S = D(H), z.filter(function(Z) {
          return S.props[Z] != null && S.props[Z] !== V[Z];
        }).length && c(!1);
      } else
        S = e.createElement("input", r({ ref: this.handleRef }, V));
      var K = { onFocus: this.onFocus, onBlur: this.onBlur };
      return this.maskOptions.mask && (V.disabled || V.readOnly || (K.onChange = this.onChange, K.onPaste = this.onPaste, K.onMouseDown = this.onMouseDown), V.value != null && (K.value = this.value)), S = e.cloneElement(S, K);
    }, v;
  }(e.Component);
  return Pa = j, Pa;
}
var Fa, sd;
function G7() {
  if (sd)
    return Fa;
  sd = 1;
  var t = process.env.NODE_ENV !== "production", e = function() {
  };
  if (t) {
    var n = function(r, s) {
      var a = arguments.length;
      s = new Array(a > 1 ? a - 1 : 0);
      for (var o = 1; o < a; o++)
        s[o - 1] = arguments[o];
      var l = 0, c = "Warning: " + r.replace(/%s/g, function() {
        return s[l++];
      });
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
    e = function(i, r, s) {
      var a = arguments.length;
      s = new Array(a > 2 ? a - 2 : 0);
      for (var o = 2; o < a; o++)
        s[o - 2] = arguments[o];
      if (r === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      i || n.apply(null, [r].concat(s));
    };
  }
  return Fa = e, Fa;
}
var Ta, ad;
function q7() {
  if (ad)
    return Ta;
  ad = 1;
  function t(y) {
    return y && typeof y == "object" && "default" in y ? y.default : y;
  }
  var e = t(re), n = Io, i = t(wh), r = t(G7());
  function s(y, v) {
    for (var k = Object.getOwnPropertyNames(v), S = 0; S < k.length; S++) {
      var f = k[S], D = Object.getOwnPropertyDescriptor(v, f);
      D && D.configurable && y[f] === void 0 && Object.defineProperty(y, f, D);
    }
    return y;
  }
  function a() {
    return a = Object.assign || function(y) {
      for (var v = 1; v < arguments.length; v++) {
        var k = arguments[v];
        for (var S in k)
          Object.prototype.hasOwnProperty.call(k, S) && (y[S] = k[S]);
      }
      return y;
    }, a.apply(this, arguments);
  }
  function o(y, v) {
    y.prototype = Object.create(v.prototype), y.prototype.constructor = y, s(y, v);
  }
  function l(y, v) {
    if (y == null)
      return {};
    var k = {}, S = Object.keys(y), f, D;
    for (D = 0; D < S.length; D++)
      f = S[D], !(v.indexOf(f) >= 0) && (k[f] = y[f]);
    return k;
  }
  function c(y) {
    if (y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return y;
  }
  function u(y, v, k) {
    if ("selectionStart" in y && "selectionEnd" in y)
      y.selectionStart = v, y.selectionEnd = k;
    else {
      var S = y.createTextRange();
      S.collapse(!0), S.moveStart("character", v), S.moveEnd("character", k - v), S.select();
    }
  }
  function d(y) {
    var v = 0, k = 0;
    if ("selectionStart" in y && "selectionEnd" in y)
      v = y.selectionStart, k = y.selectionEnd;
    else {
      var S = document.selection.createRange();
      S.parentElement() === y && (v = -S.moveStart("character", -y.value.length), k = -S.moveEnd("character", -y.value.length));
    }
    return {
      start: v,
      end: k,
      length: k - v
    };
  }
  var h = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
  }, g = "_";
  function b(y, v, k) {
    var S = "", f = "", D = null, V = [];
    if (v === void 0 && (v = g), k == null && (k = h), !y || typeof y != "string")
      return {
        maskChar: v,
        formatChars: k,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    var z = !1;
    return y.split("").forEach(function(H) {
      !z && H === "\\" ? z = !0 : (z || !k[H] ? (V.push(S.length), S.length === V.length - 1 && (f += H)) : D = S.length + 1, S += H, z = !1);
    }), {
      maskChar: v,
      formatChars: k,
      prefix: f,
      mask: S,
      lastEditablePosition: D,
      permanents: V
    };
  }
  function m(y, v) {
    return y.permanents.indexOf(v) !== -1;
  }
  function p(y, v, k) {
    var S = y.mask, f = y.formatChars;
    if (!k)
      return !1;
    if (m(y, v))
      return S[v] === k;
    var D = S[v], V = f[D];
    return new RegExp(V).test(k);
  }
  function x(y, v) {
    return v.split("").every(function(k, S) {
      return m(y, S) || !p(y, S, k);
    });
  }
  function C(y, v) {
    var k = y.maskChar, S = y.prefix;
    if (!k) {
      for (; v.length > S.length && m(y, v.length - 1); )
        v = v.slice(0, v.length - 1);
      return v.length;
    }
    for (var f = S.length, D = v.length; D >= S.length; D--) {
      var V = v[D], z = !m(y, D) && p(y, D, V);
      if (z) {
        f = D + 1;
        break;
      }
    }
    return f;
  }
  function M(y, v) {
    return C(y, v) === y.mask.length;
  }
  function _(y, v) {
    var k = y.maskChar, S = y.mask, f = y.prefix;
    if (!k) {
      for (v = E(y, "", v, 0), v.length < f.length && (v = f); v.length < S.length && m(y, v.length); )
        v += S[v.length];
      return v;
    }
    if (v) {
      var D = _(y, "");
      return E(y, D, v, 0);
    }
    for (var V = 0; V < S.length; V++)
      m(y, V) ? v += S[V] : v += k;
    return v;
  }
  function A(y, v, k, S) {
    var f = k + S, D = y.maskChar, V = y.mask, z = y.prefix, H = v.split("");
    if (!D) {
      for (var K = f; K < H.length; K++)
        m(y, K) && (H[K] = "");
      return k = Math.max(z.length, k), H.splice(k, f - k), v = H.join(""), _(y, v);
    }
    return H.map(function(Z, G) {
      return G < k || G >= f ? Z : m(y, G) ? V[G] : D;
    }).join("");
  }
  function E(y, v, k, S) {
    var f = y.mask, D = y.maskChar, V = y.prefix, z = k.split(""), H = M(y, v), K = function(X, W) {
      return !m(y, X) || W === f[X];
    }, Z = function(X, W) {
      return !D || !m(y, W) || X !== D;
    };
    return !D && S > v.length && (v += f.slice(v.length, S)), z.every(function(G) {
      for (; !K(S, G); ) {
        if (S >= v.length && (v += f[S]), !Z(G, S))
          return !0;
        if (S++, S >= f.length)
          return !1;
      }
      var X = p(y, S, G) || G === D;
      return X ? (S < v.length ? D || H || S < V.length ? v = v.slice(0, S) + G + v.slice(S + 1) : (v = v.slice(0, S) + G + v.slice(S), v = _(y, v)) : D || (v += G), S++, S < f.length) : !0;
    }), v;
  }
  function P(y, v, k, S) {
    var f = y.mask, D = y.maskChar, V = k.split(""), z = S, H = function(Z, G) {
      return !m(y, Z) || G === f[Z];
    };
    return V.every(function(K) {
      for (; !H(S, K); )
        if (S++, S >= f.length)
          return !1;
      var Z = p(y, S, K) || K === D;
      return Z && S++, S < f.length;
    }), S - z;
  }
  function I(y, v) {
    for (var k = v; k >= 0; --k)
      if (!m(y, k))
        return k;
    return null;
  }
  function U(y, v) {
    for (var k = y.mask, S = v; S < k.length; ++S)
      if (!m(y, S))
        return S;
    return null;
  }
  function Q(y) {
    return !y && y !== 0 ? "" : y + "";
  }
  function T(y, v, k, S, f) {
    var D = y.mask, V = y.prefix, z = y.lastEditablePosition, H = v, K = "", Z = 0, G = 0, X = Math.min(f.start, k.start);
    if (k.end > f.start ? (K = H.slice(f.start, k.end), Z = P(y, S, K, X), Z ? G = f.length : G = 0) : H.length < S.length && (G = S.length - H.length), H = S, G) {
      if (G === 1 && !f.length) {
        var W = f.start === k.start;
        X = W ? U(y, k.start) : I(y, k.start);
      }
      H = A(y, H, X, G);
    }
    return H = E(y, H, K, X), X = X + Z, X >= D.length ? X = D.length : X < V.length && !Z ? X = V.length : X >= V.length && X < z && Z && (X = U(y, X)), H = _(y, H), K || (K = null), {
      value: H,
      enteredString: K,
      selection: {
        start: X,
        end: X
      }
    };
  }
  function Y() {
    var y = new RegExp("windows", "i"), v = new RegExp("phone", "i"), k = navigator.userAgent;
    return y.test(k) && v.test(k);
  }
  function q(y) {
    return typeof y == "function";
  }
  function $() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function N() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function R(y) {
    var v = !!N(), k;
    return v ? k = $() : k = function() {
      return setTimeout(y, 1e3 / 60);
    }, k(y);
  }
  function B(y) {
    var v = N() || clearTimeout;
    v(y);
  }
  var j = /* @__PURE__ */ function(y) {
    o(v, y);
    function v(S) {
      var f;
      f = y.call(this, S) || this, f.focused = !1, f.mounted = !1, f.previousSelection = null, f.selectionDeferId = null, f.saveSelectionLoopDeferId = null, f.saveSelectionLoop = function() {
        f.previousSelection = f.getSelection(), f.saveSelectionLoopDeferId = R(f.saveSelectionLoop);
      }, f.runSaveSelectionLoop = function() {
        f.saveSelectionLoopDeferId === null && f.saveSelectionLoop();
      }, f.stopSaveSelectionLoop = function() {
        f.saveSelectionLoopDeferId !== null && (B(f.saveSelectionLoopDeferId), f.saveSelectionLoopDeferId = null, f.previousSelection = null);
      }, f.getInputDOMNode = function() {
        if (!f.mounted)
          return null;
        var J = n.findDOMNode(c(c(f))), ce = typeof window < "u" && J instanceof window.Element;
        if (J && !ce)
          return null;
        if (J.nodeName !== "INPUT" && (J = J.querySelector("input")), !J)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return J;
      }, f.getInputValue = function() {
        var J = f.getInputDOMNode();
        return J ? J.value : null;
      }, f.setInputValue = function(J) {
        var ce = f.getInputDOMNode();
        ce && (f.value = J, ce.value = J);
      }, f.setCursorToEnd = function() {
        var J = C(f.maskOptions, f.value), ce = U(f.maskOptions, J);
        ce !== null && f.setCursorPosition(ce);
      }, f.setSelection = function(J, ce, fe) {
        fe === void 0 && (fe = {});
        var me = f.getInputDOMNode(), O = f.isFocused();
        if (!(!me || !O)) {
          var F = fe, L = F.deferred;
          L || u(me, J, ce), f.selectionDeferId !== null && B(f.selectionDeferId), f.selectionDeferId = R(function() {
            f.selectionDeferId = null, u(me, J, ce);
          }), f.previousSelection = {
            start: J,
            end: ce,
            length: Math.abs(ce - J)
          };
        }
      }, f.getSelection = function() {
        var J = f.getInputDOMNode();
        return d(J);
      }, f.getCursorPosition = function() {
        return f.getSelection().start;
      }, f.setCursorPosition = function(J) {
        f.setSelection(J, J);
      }, f.isFocused = function() {
        return f.focused;
      }, f.getBeforeMaskedValueChangeConfig = function() {
        var J = f.maskOptions, ce = J.mask, fe = J.maskChar, me = J.permanents, O = J.formatChars, F = f.props.alwaysShowMask;
        return {
          mask: ce,
          maskChar: fe,
          permanents: me,
          alwaysShowMask: !!F,
          formatChars: O
        };
      }, f.isInputAutofilled = function(J, ce, fe, me) {
        var O = f.getInputDOMNode();
        try {
          if (O.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return f.focused ? me.end < fe.length && ce.end === J.length : !0;
      }, f.onChange = function(J) {
        var ce = c(c(f)), fe = ce.beforePasteState, me = c(c(f)), O = me.previousSelection, F = f.props.beforeMaskedValueChange, L = f.getInputValue(), se = f.value, te = f.getSelection();
        f.isInputAutofilled(L, te, se, O) && (se = _(f.maskOptions, ""), O = {
          start: 0,
          end: 0,
          length: 0
        }), fe && (O = fe.selection, se = fe.value, te = {
          start: O.start + L.length,
          end: O.start + L.length,
          length: 0
        }, L = se.slice(0, O.start) + L + se.slice(O.end), f.beforePasteState = null);
        var ee = T(f.maskOptions, L, te, se, O), he = ee.enteredString, ve = ee.selection, Le = ee.value;
        if (q(F)) {
          var tt = F({
            value: Le,
            selection: ve
          }, {
            value: se,
            selection: O
          }, he, f.getBeforeMaskedValueChangeConfig());
          Le = tt.value, ve = tt.selection;
        }
        f.setInputValue(Le), q(f.props.onChange) && f.props.onChange(J), f.isWindowsPhoneBrowser ? f.setSelection(ve.start, ve.end, {
          deferred: !0
        }) : f.setSelection(ve.start, ve.end);
      }, f.onFocus = function(J) {
        var ce = f.props.beforeMaskedValueChange, fe = f.maskOptions, me = fe.mask, O = fe.prefix;
        if (f.focused = !0, f.mounted = !0, me) {
          if (f.value)
            C(f.maskOptions, f.value) < f.maskOptions.mask.length && f.setCursorToEnd();
          else {
            var F = _(f.maskOptions, O), L = _(f.maskOptions, F), se = C(f.maskOptions, L), te = U(f.maskOptions, se), ee = {
              start: te,
              end: te
            };
            if (q(ce)) {
              var he = ce({
                value: L,
                selection: ee
              }, {
                value: f.value,
                selection: null
              }, null, f.getBeforeMaskedValueChangeConfig());
              L = he.value, ee = he.selection;
            }
            var ve = L !== f.getInputValue();
            ve && f.setInputValue(L), ve && q(f.props.onChange) && f.props.onChange(J), f.setSelection(ee.start, ee.end);
          }
          f.runSaveSelectionLoop();
        }
        q(f.props.onFocus) && f.props.onFocus(J);
      }, f.onBlur = function(J) {
        var ce = f.props.beforeMaskedValueChange, fe = f.maskOptions.mask;
        if (f.stopSaveSelectionLoop(), f.focused = !1, fe && !f.props.alwaysShowMask && x(f.maskOptions, f.value)) {
          var me = "";
          if (q(ce)) {
            var O = ce({
              value: me,
              selection: null
            }, {
              value: f.value,
              selection: f.previousSelection
            }, null, f.getBeforeMaskedValueChangeConfig());
            me = O.value;
          }
          var F = me !== f.getInputValue();
          F && f.setInputValue(me), F && q(f.props.onChange) && f.props.onChange(J);
        }
        q(f.props.onBlur) && f.props.onBlur(J);
      }, f.onMouseDown = function(J) {
        if (!f.focused && document.addEventListener) {
          f.mouseDownX = J.clientX, f.mouseDownY = J.clientY, f.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var ce = function fe(me) {
            if (document.removeEventListener("mouseup", fe), !!f.focused) {
              var O = Math.abs(me.clientX - f.mouseDownX), F = Math.abs(me.clientY - f.mouseDownY), L = Math.max(O, F), se = (/* @__PURE__ */ new Date()).getTime() - f.mouseDownTime;
              (L <= 10 && se <= 200 || L <= 5 && se <= 300) && f.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", ce);
        }
        q(f.props.onMouseDown) && f.props.onMouseDown(J);
      }, f.onPaste = function(J) {
        q(f.props.onPaste) && f.props.onPaste(J), J.defaultPrevented || (f.beforePasteState = {
          value: f.getInputValue(),
          selection: f.getSelection()
        }, f.setInputValue(""));
      }, f.handleRef = function(J) {
        f.props.children == null && q(f.props.inputRef) && f.props.inputRef(J);
      };
      var D = S.mask, V = S.maskChar, z = S.formatChars, H = S.alwaysShowMask, K = S.beforeMaskedValueChange, Z = S.defaultValue, G = S.value;
      f.maskOptions = b(D, V, z), Z == null && (Z = ""), G == null && (G = Z);
      var X = Q(G);
      if (f.maskOptions.mask && (H || X) && (X = _(f.maskOptions, X), q(K))) {
        var W = S.value;
        S.value == null && (W = Z), W = Q(W);
        var ie = K({
          value: X,
          selection: null
        }, {
          value: W,
          selection: null
        }, null, f.getBeforeMaskedValueChangeConfig());
        X = ie.value;
      }
      return f.value = X, f;
    }
    var k = v.prototype;
    return k.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = Y(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, k.componentDidUpdate = function() {
      var f = this.previousSelection, D = this.props, V = D.beforeMaskedValueChange, z = D.alwaysShowMask, H = D.mask, K = D.maskChar, Z = D.formatChars, G = this.maskOptions, X = z || this.isFocused(), W = this.props.value != null, ie = W ? Q(this.props.value) : this.value, J = f ? f.start : null;
      if (this.maskOptions = b(H, K, Z), this.maskOptions.mask)
        !G.mask && this.isFocused() && this.runSaveSelectionLoop();
      else {
        G.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
        return;
      }
      var ce = this.maskOptions.mask && this.maskOptions.mask !== G.mask;
      if (!G.mask && !W && (ie = this.getInputValue()), (ce || this.maskOptions.mask && (ie || X)) && (ie = _(this.maskOptions, ie)), ce) {
        var fe = C(this.maskOptions, ie);
        (J === null || fe < J) && (M(this.maskOptions, ie) ? J = fe : J = U(this.maskOptions, fe));
      }
      this.maskOptions.mask && x(this.maskOptions, ie) && !X && (!W || !this.props.value) && (ie = "");
      var me = {
        start: J,
        end: J
      };
      if (q(V)) {
        var O = V({
          value: ie,
          selection: me
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        ie = O.value, me = O.selection;
      }
      this.value = ie;
      var F = this.getInputValue() !== this.value;
      F ? (this.setInputValue(this.value), this.forceUpdate()) : ce && this.forceUpdate();
      var L = !1;
      me.start != null && me.end != null && (L = !f || f.start !== me.start || f.end !== me.end), (L || F) && this.setSelection(me.start, me.end);
    }, k.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && B(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, k.render = function() {
      var f = this.props, D = f.mask;
      f.alwaysShowMask;
      var V = f.maskChar, z = f.formatChars, H = f.inputRef;
      f.beforeMaskedValueChange;
      var K = f.children, Z = l(f, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]), G;
      if (process.env.NODE_ENV !== "production" && r(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !Z.maxLength || !b(D, V, z).mask,
        "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length."
      ), K) {
        q(K) || (process.env.NODE_ENV !== "production" ? i(!1, "react-input-mask: children must be a function") : i(!1));
        var X = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], W = a({}, Z);
        X.forEach(function(ce) {
          return delete W[ce];
        }), G = K(W);
        var ie = X.filter(function(ce) {
          return G.props[ce] != null && G.props[ce] !== Z[ce];
        });
        ie.length && (process.env.NODE_ENV !== "production" ? i(!1, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + ie.join(", ")) : i(!1)), process.env.NODE_ENV !== "production" && r(!H, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
      } else
        G = e.createElement("input", a({
          ref: this.handleRef
        }, Z));
      var J = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      return this.maskOptions.mask && (!Z.disabled && !Z.readOnly && (J.onChange = this.onChange, J.onPaste = this.onPaste, J.onMouseDown = this.onMouseDown), Z.value != null && (J.value = this.value)), G = e.cloneElement(G, J), G;
    }, v;
  }(e.Component);
  return Ta = j, Ta;
}
process.env.NODE_ENV === "production" ? ko.exports = K7() : ko.exports = q7();
var Z7 = ko.exports;
const jf = /* @__PURE__ */ Ut(Z7);
var $f = { exports: {} };
(function(t, e) {
  (function(n, i) {
    t.exports = i();
  })(ei, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, i = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, s = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, o = {}, l = function(m) {
      return (m = +m) + (m > 68 ? 1900 : 2e3);
    }, c = function(m) {
      return function(p) {
        this[m] = +p;
      };
    }, u = [/[+-]\d\d:?(\d\d)?|Z/, function(m) {
      (this.zone || (this.zone = {})).offset = function(p) {
        if (!p || p === "Z")
          return 0;
        var x = p.match(/([+-]|\d\d)/g), C = 60 * x[1] + (+x[2] || 0);
        return C === 0 ? 0 : x[0] === "+" ? -C : C;
      }(m);
    }], d = function(m) {
      var p = o[m];
      return p && (p.indexOf ? p : p.s.concat(p.f));
    }, h = function(m, p) {
      var x, C = o.meridiem;
      if (C) {
        for (var M = 1; M <= 24; M += 1)
          if (m.indexOf(C(M, 0, p)) > -1) {
            x = M > 12;
            break;
          }
      } else
        x = m === (p ? "pm" : "PM");
      return x;
    }, g = { A: [a, function(m) {
      this.afternoon = h(m, !1);
    }], a: [a, function(m) {
      this.afternoon = h(m, !0);
    }], S: [/\d/, function(m) {
      this.milliseconds = 100 * +m;
    }], SS: [r, function(m) {
      this.milliseconds = 10 * +m;
    }], SSS: [/\d{3}/, function(m) {
      this.milliseconds = +m;
    }], s: [s, c("seconds")], ss: [s, c("seconds")], m: [s, c("minutes")], mm: [s, c("minutes")], H: [s, c("hours")], h: [s, c("hours")], HH: [s, c("hours")], hh: [s, c("hours")], D: [s, c("day")], DD: [r, c("day")], Do: [a, function(m) {
      var p = o.ordinal, x = m.match(/\d+/);
      if (this.day = x[0], p)
        for (var C = 1; C <= 31; C += 1)
          p(C).replace(/\[|\]/g, "") === m && (this.day = C);
    }], M: [s, c("month")], MM: [r, c("month")], MMM: [a, function(m) {
      var p = d("months"), x = (d("monthsShort") || p.map(function(C) {
        return C.slice(0, 3);
      })).indexOf(m) + 1;
      if (x < 1)
        throw new Error();
      this.month = x % 12 || x;
    }], MMMM: [a, function(m) {
      var p = d("months").indexOf(m) + 1;
      if (p < 1)
        throw new Error();
      this.month = p % 12 || p;
    }], Y: [/[+-]?\d+/, c("year")], YY: [r, function(m) {
      this.year = l(m);
    }], YYYY: [/\d{4}/, c("year")], Z: u, ZZ: u };
    function b(m) {
      var p, x;
      p = m, x = o && o.formats;
      for (var C = (m = p.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(U, Q, T) {
        var Y = T && T.toUpperCase();
        return Q || x[T] || n[T] || x[Y].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(q, $, N) {
          return $ || N.slice(1);
        });
      })).match(i), M = C.length, _ = 0; _ < M; _ += 1) {
        var A = C[_], E = g[A], P = E && E[0], I = E && E[1];
        C[_] = I ? { regex: P, parser: I } : A.replace(/^\[|\]$/g, "");
      }
      return function(U) {
        for (var Q = {}, T = 0, Y = 0; T < M; T += 1) {
          var q = C[T];
          if (typeof q == "string")
            Y += q.length;
          else {
            var $ = q.regex, N = q.parser, R = U.slice(Y), B = $.exec(R)[0];
            N.call(Q, B), U = U.replace(B, "");
          }
        }
        return function(j) {
          var y = j.afternoon;
          if (y !== void 0) {
            var v = j.hours;
            y ? v < 12 && (j.hours += 12) : v === 12 && (j.hours = 0), delete j.afternoon;
          }
        }(Q), Q;
      };
    }
    return function(m, p, x) {
      x.p.customParseFormat = !0, m && m.parseTwoDigitYear && (l = m.parseTwoDigitYear);
      var C = p.prototype, M = C.parse;
      C.parse = function(_) {
        var A = _.date, E = _.utc, P = _.args;
        this.$u = E;
        var I = P[1];
        if (typeof I == "string") {
          var U = P[2] === !0, Q = P[3] === !0, T = U || Q, Y = P[2];
          Q && (Y = P[2]), o = this.$locale(), !U && Y && (o = x.Ls[Y]), this.$d = function(R, B, j) {
            try {
              if (["x", "X"].indexOf(B) > -1)
                return new Date((B === "X" ? 1e3 : 1) * R);
              var y = b(B)(R), v = y.year, k = y.month, S = y.day, f = y.hours, D = y.minutes, V = y.seconds, z = y.milliseconds, H = y.zone, K = /* @__PURE__ */ new Date(), Z = S || (v || k ? 1 : K.getDate()), G = v || K.getFullYear(), X = 0;
              v && !k || (X = k > 0 ? k - 1 : K.getMonth());
              var W = f || 0, ie = D || 0, J = V || 0, ce = z || 0;
              return H ? new Date(Date.UTC(G, X, Z, W, ie, J, ce + 60 * H.offset * 1e3)) : j ? new Date(Date.UTC(G, X, Z, W, ie, J, ce)) : new Date(G, X, Z, W, ie, J, ce);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(A, I, E), this.init(), Y && Y !== !0 && (this.$L = this.locale(Y).$L), T && A != this.format(I) && (this.$d = /* @__PURE__ */ new Date("")), o = {};
        } else if (I instanceof Array)
          for (var q = I.length, $ = 1; $ <= q; $ += 1) {
            P[1] = I[$ - 1];
            var N = x.apply(this, P);
            if (N.isValid()) {
              this.$d = N.$d, this.$L = N.$L, this.init();
              break;
            }
            $ === q && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          M.call(this, _);
      };
    };
  });
})($f);
var J7 = $f.exports;
const X7 = /* @__PURE__ */ Ut(J7);
function _o({
  onClick: t,
  min: e,
  max: n,
  light: i,
  hidePrev: r,
  hideNext: s,
  index: a = 0,
  offset: o = 1
}) {
  const { calendars: l, weekDays: c } = Vf(), { dayButton: u } = ml(), { addOffset: d, subtractOffset: h, setOffset: g } = Hf(), { year: b, month: m, days: p } = l[a], x = ne(
    () => de("p-3", {
      "bg-gray-dark text-white": !i,
      "bg-white-light text-gray-dark": i
    }),
    [i]
  ), C = ne(
    () => de({
      "text-white": !i,
      "text-gray-dark": i
    }),
    [i]
  ), M = le(
    (T) => de(
      "w-10 h-10 text-center",
      {
        "text-gray-light": T.disabled || P,
        invisible: !T.inCurrentMonth
      },
      i ? {
        "text-gray-dark": !T.disabled && !P && !T.selected && !T.range,
        "hover:bg-primary-lighter": !T.selected && !T.disabled && !P && !T.range,
        "bg-white-lighter": !T.selected,
        "text-white bg-primary": !T.disabled && !P && (T.selected || T.range && !["in-range", "will-be-in-range"].includes(T.range)),
        "text-gray-dark bg-primary-lighter": [
          "in-range",
          "will-be-in-range"
        ].includes(T.range)
      } : {
        "text-white": !T.disabled && !P && T.range !== "in-range",
        "hover:bg-gray-light": !T.selected && !T.disabled && !P && !T.range,
        "bg-gray-dark": !T.selected,
        "bg-green-input": !T.disabled && !P && (T.selected || T.range && !["in-range", "will-be-in-range"].includes(T.range)),
        "bg-gray-light": ["in-range", "will-be-in-range"].includes(
          T.range
        )
      }
    ),
    [i]
  ), { monthStart: _, monthEnd: A, selectedInvalid: E, invalidMinMax: P } = ne(() => {
    var R;
    const T = (R = p.find((B) => B.selected)) == null ? void 0 : R.disabled, Y = p.filter((B) => B.inCurrentMonth), q = Y[0].$date, $ = pe(Y[Y.length - 1].$date).endOf("day").toDate(), N = e && n && pe(e).isAfter(n);
    return {
      monthStart: q,
      monthEnd: $,
      selectedInvalid: T,
      invalidMinMax: N
    };
  }, [p, e, n]), I = le((T) => {
    T == null || T.stopPropagation(), t == null || t(T);
  }, []), U = ne(
    () => E ? h({ months: o }, { disabled: !1 }) : g(pe(A).subtract(o, "month").toDate()),
    [E, A]
  ), Q = ne(
    () => E ? d({ months: o }, { disabled: !1 }) : g(pe(_).add(o, "month").toDate()),
    [E, _]
  );
  return /* @__PURE__ */ ae("main", { className: x, children: [
    /* @__PURE__ */ ae("header", { children: [
      /* @__PURE__ */ ae("div", { className: "flex font-normal text-base justify-between items-center mb-6", children: [
        r ? /* @__PURE__ */ w("span", {}) : /* @__PURE__ */ w(
          "button",
          {
            ...U,
            type: "button",
            className: "text-xl disabled:text-gray-light",
            children: /* @__PURE__ */ w(Rs, {})
          }
        ),
        /* @__PURE__ */ ae("p", { className: C, children: [
          m,
          " ",
          b
        ] }),
        s ? /* @__PURE__ */ w("span", {}) : /* @__PURE__ */ w(
          "button",
          {
            ...Q,
            type: "button",
            className: "text-xl disabled:text-gray-light",
            children: /* @__PURE__ */ w(xi, {})
          }
        )
      ] }),
      /* @__PURE__ */ w("ul", { className: "grid grid-cols-7", children: c.map((T) => /* @__PURE__ */ w(
        "li",
        {
          className: "text-center text-gray-lighter font-normal w-10 py-2 px-1",
          children: T.substring(0, 2)
        },
        `${m}-${T}`
      )) })
    ] }),
    /* @__PURE__ */ w("ul", { className: "grid grid-cols-7", children: p.map((T) => /* @__PURE__ */ w("li", { className: M(T), children: /* @__PURE__ */ w(
      "button",
      {
        ...u(T, { onClick: I }),
        disabled: T.disabled || P,
        type: "button",
        className: "w-full py-2 px-1",
        children: T.day
      }
    ) }, T.$date.toDateString())) })
  ] });
}
const e4 = [
  {
    label: "This week",
    from: pe().startOf("week").add(1, "day"),
    to: pe()
  },
  {
    label: "Last week",
    from: pe().subtract(1, "week").startOf("week").add(1, "day"),
    to: pe().subtract(1, "week").endOf("week").add(1, "day")
  },
  {
    label: "This month",
    from: pe().startOf("month"),
    to: pe()
  },
  {
    label: "Last month",
    from: pe().subtract(1, "month").startOf("month"),
    to: pe().subtract(1, "month").endOf("month")
  },
  {
    label: "Last 30 days",
    from: pe().subtract(30, "days").startOf("day"),
    to: pe()
  },
  {
    label: "Last 90 days",
    from: pe().subtract(90, "days").startOf("day"),
    to: pe()
  },
  {
    label: "Last 12 months",
    from: pe().subtract(12, "months").startOf("day"),
    to: pe()
  },
  {
    label: "This year",
    from: pe().startOf("year"),
    to: pe()
  },
  {
    label: "Last year",
    from: pe().subtract(1, "year").startOf("year"),
    to: pe().subtract(1, "year").endOf("year")
  }
];
function t4({ onSetRange: t, ...e }) {
  const n = ne(
    () => de("p-3 w-[145px] flex flex-col gap-2 border-r", {
      "bg-white-light": e.light,
      "bg-gray-dark": !e.light
    }),
    [e.light]
  ), i = ne(
    () => de(
      "py-1 px-2 cursor-pointer text-sm font-normal rounded-full hover:font-bold",
      {
        "hover:text-primary hover:bg-primary-lighter": e.light,
        "text-white hover:bg-green-input": !e.light
      }
    ),
    [e.light]
  );
  return /* @__PURE__ */ w("ul", { className: n, children: e4.map((r) => /* @__PURE__ */ w("li", { children: /* @__PURE__ */ w(
    "div",
    {
      onClick: () => t(r.from, r.to),
      className: i,
      children: r.label
    }
  ) }, r.label)) });
}
function n4({ onSetRange: t, ...e }) {
  return /* @__PURE__ */ ae("div", { className: "flex", children: [
    /* @__PURE__ */ w(t4, { onSetRange: t, light: e.light }),
    /* @__PURE__ */ w(
      _o,
      {
        hideNext: !0,
        index: 1,
        offset: 1,
        light: e.light,
        min: e.min,
        max: e.max
      }
    ),
    /* @__PURE__ */ w(
      _o,
      {
        hidePrev: !0,
        index: 0,
        offset: 2,
        light: e.light,
        min: e.min,
        max: e.max
      }
    )
  ] });
}
const Wf = (t) => de("p-3", {
  "bg-gray-dark text-white": !t,
  "bg-white-light text-grey-dark": t
}), Yf = (t, e) => de(
  "text-center font-normal py-2 px-1",
  e ? {
    "text-gray-dark": !t.disabled,
    "bg-white-lighter": !t.selected,
    "hover:bg-primary-ligther": !t.disabled && !t.selected,
    "text-white bg-primary": t.selected
  } : {
    "text-white": !t.disabled,
    "text-gray-light": t.disabled,
    "bg-gray-dark": !t.selected,
    "bg-green-input": t.selected && !t.disabled,
    "hover:bg-gray-light": !t.disabled && !t.selected
  }
), i4 = ({
  onClick: t,
  min: e,
  max: n,
  light: i,
  hidePrev: r,
  hideNext: s,
  index: a = 0,
  offset: o = 1
}) => {
  const { calendars: l } = Vf(), { months: c } = W7(), { dayButton: u } = ml(), { setOffset: d } = Hf(), { year: h } = l[a], g = ne(
    () => e && n && pe(e).isAfter(n),
    [e, n]
  ), b = ne(() => pe().set("year", +h), [h]), m = ne(() => Wf(i), [i]), p = le(
    (_) => Yf(_, i),
    [i]
  ), x = le(
    (_) => {
      _ == null || _.stopPropagation(), t == null || t(_);
    },
    [t]
  ), C = ne(() => d(b.subtract(o, "year").toDate()), [o, b]), M = ne(() => d(b.add(o, "year").toDate()), [o, b]);
  return /* @__PURE__ */ ae("div", { className: m, children: [
    /* @__PURE__ */ ae("div", { className: "flex font-normal text-base justify-between items-center mb-6 px-2", children: [
      r ? /* @__PURE__ */ w("span", {}) : /* @__PURE__ */ w(
        "button",
        {
          type: "button",
          className: "flex items-center gap-1",
          ...C,
          children: /* @__PURE__ */ w(Rs, {})
        }
      ),
      /* @__PURE__ */ w("h2", { className: "text-lg font-bold", children: h }),
      s ? null : /* @__PURE__ */ w(
        "button",
        {
          type: "button",
          className: "flex items-center gap-1",
          ...M,
          children: /* @__PURE__ */ w(xi, {})
        }
      )
    ] }),
    /* @__PURE__ */ w("ul", { className: "grid grid-cols-3 items-center gap-x-2 gap-y-2", children: c.map((_) => {
      const A = {
        $date: pe(_.$date).set("year", +h).toDate(),
        day: "01",
        inCurrentMonth: !1,
        range: ""
      };
      return /* @__PURE__ */ w("li", { className: p(_), children: /* @__PURE__ */ w(
        "button",
        {
          ...u(A, { onClick: x }),
          disabled: _.disabled || g,
          type: "button",
          children: _.month
        }
      ) }, _.$date.toDateString());
    }) })
  ] });
};
function r4({ onClick: t, light: e }) {
  const { time: n } = Y7(), { timeButton: i } = z7(), r = le(
    (a) => de("text-center text-xs", {
      "text-white": !a.disabled && !e,
      "text-gray-dark": !a.disabled && e,
      "text-gray-light": a.disabled,
      "hover:bg-gray-light": !a.selected && !a.disabled && !e,
      "hover:bg-gray-lighter": !a.selected && !a.disabled && e,
      "bg-gray-dark": !a.selected && !e,
      "bg-white-light": !a.selected && e,
      "bg-green-input": a.selected
    }),
    [e]
  ), s = le((a) => {
    a == null || a.stopPropagation(), t == null || t(a);
  }, []);
  return /* @__PURE__ */ w("ul", { className: "grid grid-cols-7 bg-gray-dark", children: n.map((a) => /* @__PURE__ */ w("li", { className: r(a), children: /* @__PURE__ */ w(
    "button",
    {
      ...i(a, { onClick: s }),
      type: "button",
      className: "w-full py-2 px-1",
      children: a.time
    }
  ) }, a.$date.toString())) });
}
const s4 = ({
  onClick: t,
  min: e,
  max: n,
  light: i,
  hidePrev: r,
  hideNext: s
}) => {
  const { years: a } = U7(), { dayButton: o } = ml(), { previousYearsButton: l, nextYearsButton: c } = Q7(), u = ne(
    () => e && n && pe(e).isAfter(n),
    [e, n]
  ), d = le(
    (b) => {
      b == null || b.stopPropagation(), t == null || t(b);
    },
    [t]
  ), h = ne(() => Wf(i), [i]), g = le(
    (b) => Yf(b, i),
    [i]
  );
  return /* @__PURE__ */ ae("div", { className: h, children: [
    /* @__PURE__ */ ae("div", { className: "flex justify-between items-center text-base font-normal mb-6 px-2", children: [
      r ? null : /* @__PURE__ */ w(
        "button",
        {
          type: "button",
          className: "flex items-center gap-1",
          ...l(),
          children: /* @__PURE__ */ w(Rs, {})
        }
      ),
      /* @__PURE__ */ w("h2", { className: "text-lg font-bold", children: `${a[0].year} - ${a[a.length - 1].year}` }),
      s ? null : /* @__PURE__ */ w(
        "button",
        {
          type: "button",
          className: "flex items-center gap-1",
          ...c(),
          children: /* @__PURE__ */ w(xi, {})
        }
      )
    ] }),
    /* @__PURE__ */ w("ul", { className: "grid grid-cols-3 items-center gap-x-2 gap-y-2", children: a.map((b) => {
      const m = {
        $date: b.$date,
        day: "01",
        inCurrentMonth: !1,
        range: ""
      };
      return /* @__PURE__ */ w("li", { className: g(b), children: /* @__PURE__ */ w(
        "button",
        {
          ...o(m, { onClick: d }),
          disabled: b.disabled || u,
          type: "button",
          children: b.year
        }
      ) }, b.$date.toDateString());
    }) })
  ] });
};
function a4({ picker: t = "date", ...e }) {
  const n = ne(() => {
    let i = /* @__PURE__ */ w(
      _o,
      {
        light: e.light,
        min: e.min,
        max: e.max,
        onClick: e.onClick
      }
    );
    return t === "month" ? i = /* @__PURE__ */ w(
      i4,
      {
        light: e.light,
        min: e.min,
        max: e.max,
        onClick: e.onClick
      }
    ) : t === "year" && (i = /* @__PURE__ */ w(
      s4,
      {
        light: e.light,
        min: e.min,
        max: e.max,
        onClick: e.onClick
      }
    )), i;
  }, [t, e.light, e.min, e.max]);
  return /* @__PURE__ */ ae(on, { children: [
    n,
    e.time && /* @__PURE__ */ w(r4, { light: e.light, onClick: e.onClick })
  ] });
}
pe.extend(X7);
const At = " - ", od = "DD/MM/YYYY", Ia = "99/99/9999", o4 = "DD/MM/YYYY HH:mm", l4 = "99/99/9999 99:99";
function Qy({
  onChange: t,
  popupPosition: e = "bottom",
  picker: n,
  ...i
}) {
  const [r, s] = Be(!1), a = i.format ?? (i.mode !== "range" && i.time ? o4 : od), o = i.mask ?? (i.mode !== "range" ? i.time ? l4 : Ia : [Ia, Ia].join(At)), [l, c] = Be(() => {
    if (i.mode !== "range")
      return i.value ? new Date(i.value) : void 0;
    if (!i.value || i.value.length === 0)
      return [];
    {
      const [E, P] = i.value.split(At);
      return [new Date(E), new Date(P)];
    }
  }), [u, d] = Be(() => {
    if (i.mode !== "range")
      return i.value ? pe(i.value).format(a) : "";
    if (!i.value || i.value.length === 0)
      return "";
    if (i.value.length === 1)
      return [
        pe(i.value[0]).format(a),
        pe(i.value[0]).format(a)
      ].join(At);
    {
      const [E, P] = i.value.split(At);
      return [
        pe(E).format(a),
        pe(P).format(a)
      ].join(At);
    }
  }), h = ne(
    () => de("inline-block relative", {
      "w-full": i.fullWidth,
      "pointer-events-none": i.disabled
    }),
    [i.fullWidth, i.disabled]
  ), g = ne(
    () => de("absolute z-50", {
      "shadow-lg -top-px": e === "bottom",
      "bottom-12": e === "top",
      "left-0": i.anchor !== "right",
      "right-0": i.anchor === "right",
      "w-full min-w-[304px]": i.fullWidth && i.mode !== "range",
      "w-[304px]": !i.fullWidth && i.mode !== "range",
      "w-full min-w-[753px]": i.fullWidth && i.mode === "range",
      "w-[753px]": !i.fullWidth && i.mode === "range"
    }),
    [i.fullWidth, i.mode, i.anchor, e]
  ), b = ne(
    () => de("w-full", {
      "input-plain": i.plain,
      "input-light": !i.plain && i.light,
      "input-dark": !i.plain && !i.light,
      "input-disabled": i.disabled,
      "pr-12": !i.error,
      "border-red bg-error bg-no-repeat bg-[right_0.75rem_center] bg-[length:20px_20px] pr-24": i.error,
      "ring-2 ring-inset ring-white": r
    }),
    [i.disabled, i.light, i.plain, i.error, r]
  ), m = ne(
    () => de("absolute top-px bottom-0 w-11 py-2.5 text-center cursor-pointer", {
      "text-white": !i.disabled && !i.light && !i.plain,
      "text-gray-dark": i.light || i.plain,
      "right-0": !i.error,
      "right-10": i.error
    }),
    [i.disabled, i.error, i.light, i.plain]
  ), p = le(
    (E) => {
      t == null || t({
        target: {
          name: i.name,
          value: E
        }
      });
    },
    [t, i.name]
  ), x = le(
    (E) => {
      var P, I, U, Q;
      if (i.mode !== "range") {
        const T = pe(E[0]).format(a);
        d(T), c(E[0]), p(E[0].toISOString()), !i.time && s(!1);
      } else if (E.length === 1) {
        const T = [
          pe(E[0]).startOf("day").format(a),
          pe(E[0]).endOf("day").format(a)
        ];
        d(T.join(At)), c(E), p(
          [
            (P = pe(E[0]).startOf("day")) == null ? void 0 : P.toISOString(),
            (I = pe(E[0]).endOf("day")) == null ? void 0 : I.toISOString()
          ].join(At)
        );
      } else {
        const T = [
          pe(E[0]).startOf("day").format(a),
          pe(E[1]).endOf("day").format(a)
        ];
        d(T.join(At)), c(E), p(
          [
            (U = pe(E[0]).startOf("day")) == null ? void 0 : U.toISOString(),
            (Q = pe(E[1]).endOf("day")) == null ? void 0 : Q.toISOString()
          ].join(At)
        ), E.length === 2 && s(!1);
      }
    },
    [i.time, i.mode, p, a]
  ), C = le(
    (E) => {
      if (i.mode !== "range") {
        const P = pe(E.target.value, a, !0);
        d(E.target.value), P.isValid() ? (s(!1), c(P.toDate()), p(P.toISOString()), setTimeout(() => s(!0), 0)) : (c(void 0), p(""));
      }
    },
    [l, p, a]
  ), M = le(
    (E, P) => {
      var U, Q;
      const I = [
        E.startOf("day").format(a),
        P.endOf("day").format(a)
      ];
      d(I.join(At)), c([E.toDate(), P.toDate()]), p(
        [
          (U = E.startOf("day")) == null ? void 0 : U.toISOString(),
          (Q = P.endOf("day")) == null ? void 0 : Q.toISOString()
        ].join(At)
      );
    },
    [p, a]
  ), _ = ne(
    () => l ? Array.isArray(l) ? l : [l] : [],
    [l]
  ), A = ne(() => {
    const E = i.mode !== "range" ? pe(l) : void 0, P = pe(i.min), I = pe(i.max);
    return {
      onDatesChange: x,
      selectedDates: _,
      calendar: {
        mode: "fluid",
        startDay: 1,
        offsets: i.mode !== "range" ? void 0 : [-1]
      },
      dates: {
        mode: i.mode,
        minDate: i.min,
        maxDate: i.max,
        selectSameDate: i.mode === "range"
      },
      time: {
        interval: 30,
        minTime: i.min && E && E.isSame(P, "day") ? { h: P.get("hours"), m: P.get("minutes") } : void 0,
        maxTime: i.max && E && E.isSame(I, "day") ? { h: I.get("hours"), m: I.get("minutes") } : void 0
      }
    };
  }, [_, x, i.min, i.max, i.mode]);
  return /* @__PURE__ */ ae("div", { className: h, children: [
    /* @__PURE__ */ w(
      jf,
      {
        type: "text",
        autoComplete: "off",
        id: i.id,
        name: i.name,
        mask: o,
        value: u,
        maskChar: "_",
        placeholder: i.placeholder,
        disabled: i.disabled,
        readOnly: i.mode === "range",
        onChange: C,
        onClick: () => s(!0),
        className: b
      }
    ),
    /* @__PURE__ */ w("div", { className: m, onClick: () => s(!i.disabled), children: /* @__PURE__ */ w(tg, {}) }),
    /* @__PURE__ */ w("div", { className: "relative", children: r && /* @__PURE__ */ ae(on, { children: [
      /* @__PURE__ */ w(
        "div",
        {
          className: "fixed inset-0 z-40",
          onClick: () => s(!1)
        }
      ),
      /* @__PURE__ */ w($7, { config: A, children: /* @__PURE__ */ w("div", { className: g, children: i.mode === "range" ? /* @__PURE__ */ w(
        n4,
        {
          onSetRange: M,
          light: i.light || i.plain,
          min: i.min,
          max: i.max
        }
      ) : /* @__PURE__ */ w(
        a4,
        {
          light: i.light || i.plain,
          min: i.min,
          max: i.max,
          picker: n,
          onClick: () => s(!1)
        }
      ) }) })
    ] }) })
  ] });
}
const c4 = "999 99 99 999";
function Ky({ onChange: t, ...e }) {
  const [n, i] = Be(
    () => (e.value || "").split(" ").slice(1).join(" ")
  ), [r, s] = Be(
    () => {
      const C = (e.value || "").split(" ")[0];
      return e.items.find((M) => M.prefix === C);
    }
  ), a = ne(
    () => de("inline-block relative", {
      "w-full": e.fullWidth,
      "pointer-events-none": e.disabled
    }),
    [e.fullWidth, e.disabled]
  ), o = ne(
    () => de("w-full pl-32", {
      "input-plain": e.plain,
      "input-light": !e.plain && e.light,
      "input-dark": !e.plain && !e.light,
      "input-disabled": e.disabled,
      "border-red bg-error bg-no-repeat bg-[right_0.75rem_center] bg-[length:20px_20px] pr-12": e.error
    }),
    [e.disabled, e.light, e.plain, e.error]
  ), l = ne(
    () => de(
      "absolute left-0 top-0 w-32 h-full inline-flex justify-between items-center text-base leading-none",
      {
        "text-white": !e.disabled && !e.light && !e.plain,
        "text-gray-dark": e.light || e.plain
      }
    ),
    [e.disabled, e.light, e.plain]
  ), c = ne(
    () => de("w-px inline-block h-5", {
      "bg-gray-light": !e.disabled,
      "bg-gray-dark": e.disabled
    }),
    [e.disabled]
  ), u = le(
    (C) => de("text-lg", {
      "text-white": !e.disabled && !e.light && !e.plain,
      "text-gray-dark": e.light || e.plain,
      "rotate-90": !C,
      "-rotate-90 -translate-x-1": C
    }),
    [e.disabled, e.light, e.plain]
  ), d = ne(
    () => de("p-3 cursor-pointer flex justify-start items-center", {
      "bg-gray-dark hover:bg-gray-light text-white": !e.light && !e.plain,
      "bg-white-light hover:bg-primary-lighter text-gray-dark": e.light || e.plain
    }),
    [e.light, e.plain]
  ), h = ne(
    () => de("ml-2", {
      "text-gray-lighter": !e.light && !e.plain,
      "text-gray": e.light || e.plain
    }),
    [e.light, e.plain]
  ), g = ne(
    () => de("w-[22px] h-[16px] border", {
      "border-gray-light": !e.disabled,
      "border-gray-dark opacity-50": e.disabled
    }),
    [e.disabled]
  ), b = le(
    (C) => de("h-full w-20 px-3 relative", {
      "border-gray-light": !e.disabled,
      "border-gray-dark opacity-50": e.disabled,
      "ring-2 ring-inset ring-white": C
    }),
    [e.disabled]
  ), m = le(
    (C) => {
      t == null || t({
        target: {
          name: e.name,
          value: C
        }
      });
    },
    [t, e.name]
  ), p = le(
    (C) => {
      i(C.target.value), m(
        [(r == null ? void 0 : r.prefix) ?? "", C.target.value ?? ""].join(" ")
      );
    },
    [r, m]
  ), x = le(
    (C) => {
      s(C), m([C.prefix ?? "", n ?? ""].join(" "));
    },
    [n, m]
  );
  return /* @__PURE__ */ ae("div", { className: a, children: [
    /* @__PURE__ */ ae("div", { className: l, children: [
      /* @__PURE__ */ w("div", { className: "h-full w-24 text-center", children: /* @__PURE__ */ w(
        en,
        {
          value: r,
          disabled: e.disabled,
          onChange: x,
          children: ({ open: C }) => /* @__PURE__ */ ae(on, { children: [
            /* @__PURE__ */ w(en.Button, { className: b(C), children: /* @__PURE__ */ ae("div", { className: "h-full w-full inline-flex justify-between items-center", children: [
              /* @__PURE__ */ w("div", { className: "w-[22px] h-[16px] mr-3", children: (r == null ? void 0 : r.flag) && /* @__PURE__ */ w(
                "img",
                {
                  src: r == null ? void 0 : r.flag,
                  alt: r == null ? void 0 : r.prefix,
                  className: g
                }
              ) }),
              /* @__PURE__ */ w("div", { className: u(C), children: /* @__PURE__ */ w(xi, {}) })
            ] }) }),
            /* @__PURE__ */ w("div", { className: "relative", children: /* @__PURE__ */ w(en.Options, { className: "absolute border border-gray-light bg-white-light w-72 -top-px left-0 z-50 max-h-52 scroll-auto overflow-auto no-scrollbar", children: e.items.map((M) => /* @__PURE__ */ ae(
              en.Option,
              {
                value: M,
                className: d,
                children: [
                  /* @__PURE__ */ w(
                    "img",
                    {
                      src: M == null ? void 0 : M.flag,
                      alt: M == null ? void 0 : M.prefix,
                      className: g
                    }
                  ),
                  /* @__PURE__ */ w("div", { className: "max-w-[170px] h-6 leading-6 ml-4 overflow-hidden whitespace-nowrap text-ellipsis", children: M.name }),
                  /* @__PURE__ */ w("span", { className: h, children: M.prefix })
                ]
              },
              M.flag
            )) }) })
          ] })
        }
      ) }),
      /* @__PURE__ */ w("span", { className: c }),
      /* @__PURE__ */ w("span", { className: "w-14 pl-2 pr-1 text-right relative -top-[0.5px]", children: r == null ? void 0 : r.prefix })
    ] }),
    /* @__PURE__ */ w(
      jf,
      {
        type: "text",
        id: e.id,
        name: e.name,
        mask: c4,
        value: n,
        maskChar: "_",
        placeholder: e.placeholder,
        disabled: e.disabled,
        onChange: p,
        className: o
      }
    )
  ] });
}
var gr = (t) => t.type === "checkbox", ni = (t) => t instanceof Date, it = (t) => t == null;
const zf = (t) => typeof t == "object";
var Ue = (t) => !it(t) && !Array.isArray(t) && zf(t) && !ni(t), u4 = (t) => Ue(t) && t.target ? gr(t.target) ? t.target.checked : t.target.value : t, d4 = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, h4 = (t, e) => t.has(d4(e)), f4 = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return Ue(e) && e.hasOwnProperty("isPrototypeOf");
}, pl = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ze(t) {
  let e;
  const n = Array.isArray(t);
  if (t instanceof Date)
    e = new Date(t);
  else if (t instanceof Set)
    e = new Set(t);
  else if (!(pl && (t instanceof Blob || t instanceof FileList)) && (n || Ue(t)))
    if (e = n ? [] : {}, !n && !f4(t))
      e = t;
    else
      for (const i in t)
        t.hasOwnProperty(i) && (e[i] = Ze(t[i]));
  else
    return t;
  return e;
}
var Ei = (t) => Array.isArray(t) ? t.filter(Boolean) : [], Ie = (t) => t === void 0, ue = (t, e, n) => {
  if (!e || !Ue(t))
    return n;
  const i = Ei(e.split(/[,[\].]+?/)).reduce((r, s) => it(r) ? r : r[s], t);
  return Ie(i) || i === t ? Ie(t[e]) ? n : t[e] : i;
}, $t = (t) => typeof t == "boolean";
const ld = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, bt = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Rt = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Uf = re.createContext(null), Ks = () => re.useContext(Uf), g4 = (t) => {
  const { children: e, ...n } = t;
  return re.createElement(Uf.Provider, { value: n }, e);
};
var m4 = (t, e, n, i = !0) => {
  const r = {
    defaultValues: e._defaultValues
  };
  for (const s in t)
    Object.defineProperty(r, s, {
      get: () => {
        const a = s;
        return e._proxyFormState[a] !== bt.all && (e._proxyFormState[a] = !i || bt.all), t[a];
      }
    });
  return r;
}, at = (t) => Ue(t) && !Object.keys(t).length, p4 = (t, e, n, i) => {
  n(t);
  const { name: r, ...s } = t;
  return at(s) || Object.keys(s).length >= Object.keys(e).length || Object.keys(s).find((a) => e[a] === bt.all);
}, vt = (t) => Array.isArray(t) ? t : [t];
function Qf(t) {
  const e = re.useRef(t);
  e.current = t, re.useEffect(() => {
    const n = !t.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [t.disabled]);
}
var Ft = (t) => typeof t == "string", b4 = (t, e, n, i, r) => Ft(t) ? (i && e.watch.add(t), ue(n, t, r)) : Array.isArray(t) ? t.map((s) => (i && e.watch.add(s), ue(n, s))) : (i && (e.watchAll = !0), n), bl = (t) => /^\w*$/.test(t), Kf = (t) => Ei(t.replace(/["|']|\]/g, "").split(/\.|\[/)), Me = (t, e, n) => {
  let i = -1;
  const r = bl(e) ? [e] : Kf(e), s = r.length, a = s - 1;
  for (; ++i < s; ) {
    const o = r[i];
    let l = n;
    if (i !== a) {
      const c = t[o];
      l = Ue(c) || Array.isArray(c) ? c : isNaN(+r[i + 1]) ? {} : [];
    }
    t[o] = l, t = t[o];
  }
  return t;
}, Gf = (t, e, n, i, r) => e ? {
  ...n[t],
  types: {
    ...n[t] && n[t].types ? n[t].types : {},
    [i]: r || !0
  }
} : {}, Gt = () => {
  const t = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
    const n = (Math.random() * 16 + t) % 16 | 0;
    return (e == "x" ? n : n & 3 | 8).toString(16);
  });
}, Ra = (t, e, n = {}) => n.shouldFocus || Ie(n.shouldFocus) ? n.focusName || `${t}.${Ie(n.focusIndex) ? e : n.focusIndex}.` : "", Zi = (t) => ({
  isOnSubmit: !t || t === bt.onSubmit,
  isOnBlur: t === bt.onBlur,
  isOnChange: t === bt.onChange,
  isOnAll: t === bt.all,
  isOnTouch: t === bt.onTouched
}), Mo = (t, e, n) => !n && (e.watchAll || e.watch.has(t) || [...e.watch].some((i) => t.startsWith(i) && /^\.\w+/.test(t.slice(i.length))));
const ui = (t, e, n, i) => {
  for (const r of n || Object.keys(t)) {
    const s = ue(t, r);
    if (s) {
      const { _f: a, ...o } = s;
      if (a) {
        if (a.refs && a.refs[0] && e(a.refs[0], r) && !i)
          break;
        if (a.ref && e(a.ref, a.name) && !i)
          break;
        ui(o, e);
      } else
        Ue(o) && ui(o, e);
    }
  }
};
var qf = (t, e, n) => {
  const i = Ei(ue(t, n));
  return Me(i, "root", e[n]), Me(t, n, i), t;
}, vl = (t) => t.type === "file", an = (t) => typeof t == "function", Es = (t) => {
  if (!pl)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, ts = (t) => Ft(t), yl = (t) => t.type === "radio", ks = (t) => t instanceof RegExp;
const cd = {
  value: !1,
  isValid: !1
}, ud = { value: !0, isValid: !0 };
var Zf = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !Ie(t[0].attributes.value) ? Ie(t[0].value) || t[0].value === "" ? ud : { value: t[0].value, isValid: !0 } : ud
    ) : cd;
  }
  return cd;
};
const dd = {
  isValid: !1,
  value: null
};
var Jf = (t) => Array.isArray(t) ? t.reduce((e, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : e, dd) : dd;
function hd(t, e, n = "validate") {
  if (ts(t) || Array.isArray(t) && t.every(ts) || $t(t) && !t)
    return {
      type: n,
      message: ts(t) ? t : "",
      ref: e
    };
}
var Jn = (t) => Ue(t) && !ks(t) ? t : {
  value: t,
  message: ""
}, Oo = async (t, e, n, i, r) => {
  const { ref: s, refs: a, required: o, maxLength: l, minLength: c, min: u, max: d, pattern: h, validate: g, name: b, valueAsNumber: m, mount: p, disabled: x } = t._f, C = ue(e, b);
  if (!p || x)
    return {};
  const M = a ? a[0] : s, _ = (Y) => {
    i && M.reportValidity && (M.setCustomValidity($t(Y) ? "" : Y || ""), M.reportValidity());
  }, A = {}, E = yl(s), P = gr(s), I = E || P, U = (m || vl(s)) && Ie(s.value) && Ie(C) || Es(s) && s.value === "" || C === "" || Array.isArray(C) && !C.length, Q = Gf.bind(null, b, n, A), T = (Y, q, $, N = Rt.maxLength, R = Rt.minLength) => {
    const B = Y ? q : $;
    A[b] = {
      type: Y ? N : R,
      message: B,
      ref: s,
      ...Q(Y ? N : R, B)
    };
  };
  if (r ? !Array.isArray(C) || !C.length : o && (!I && (U || it(C)) || $t(C) && !C || P && !Zf(a).isValid || E && !Jf(a).isValid)) {
    const { value: Y, message: q } = ts(o) ? { value: !!o, message: o } : Jn(o);
    if (Y && (A[b] = {
      type: Rt.required,
      message: q,
      ref: M,
      ...Q(Rt.required, q)
    }, !n))
      return _(q), A;
  }
  if (!U && (!it(u) || !it(d))) {
    let Y, q;
    const $ = Jn(d), N = Jn(u);
    if (!it(C) && !isNaN(C)) {
      const R = s.valueAsNumber || C && +C;
      it($.value) || (Y = R > $.value), it(N.value) || (q = R < N.value);
    } else {
      const R = s.valueAsDate || new Date(C), B = (v) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + v), j = s.type == "time", y = s.type == "week";
      Ft($.value) && C && (Y = j ? B(C) > B($.value) : y ? C > $.value : R > new Date($.value)), Ft(N.value) && C && (q = j ? B(C) < B(N.value) : y ? C < N.value : R < new Date(N.value));
    }
    if ((Y || q) && (T(!!Y, $.message, N.message, Rt.max, Rt.min), !n))
      return _(A[b].message), A;
  }
  if ((l || c) && !U && (Ft(C) || r && Array.isArray(C))) {
    const Y = Jn(l), q = Jn(c), $ = !it(Y.value) && C.length > +Y.value, N = !it(q.value) && C.length < +q.value;
    if (($ || N) && (T($, Y.message, q.message), !n))
      return _(A[b].message), A;
  }
  if (h && !U && Ft(C)) {
    const { value: Y, message: q } = Jn(h);
    if (ks(Y) && !C.match(Y) && (A[b] = {
      type: Rt.pattern,
      message: q,
      ref: s,
      ...Q(Rt.pattern, q)
    }, !n))
      return _(q), A;
  }
  if (g) {
    if (an(g)) {
      const Y = await g(C, e), q = hd(Y, M);
      if (q && (A[b] = {
        ...q,
        ...Q(Rt.validate, q.message)
      }, !n))
        return _(q.message), A;
    } else if (Ue(g)) {
      let Y = {};
      for (const q in g) {
        if (!at(Y) && !n)
          break;
        const $ = hd(await g[q](C, e), M, q);
        $ && (Y = {
          ...$,
          ...Q(q, $.message)
        }, _($.message), n && (A[b] = Y));
      }
      if (!at(Y) && (A[b] = {
        ref: M,
        ...Y
      }, !n))
        return A;
    }
  }
  return _(!0), A;
}, Ba = (t, e) => [
  ...t,
  ...vt(e)
], La = (t) => Array.isArray(t) ? t.map(() => {
}) : void 0;
function Na(t, e, n) {
  return [
    ...t.slice(0, e),
    ...vt(n),
    ...t.slice(e)
  ];
}
var Va = (t, e, n) => Array.isArray(t) ? (Ie(t[n]) && (t[n] = void 0), t.splice(n, 0, t.splice(e, 1)[0]), t) : [], Ha = (t, e) => [
  ...vt(e),
  ...vt(t)
];
function v4(t, e) {
  let n = 0;
  const i = [...t];
  for (const r of e)
    i.splice(r - n, 1), n++;
  return Ei(i).length ? i : [];
}
var ja = (t, e) => Ie(e) ? [] : v4(t, vt(e).sort((n, i) => n - i)), $a = (t, e, n) => {
  [t[e], t[n]] = [t[n], t[e]];
};
function y4(t, e) {
  const n = e.slice(0, -1).length;
  let i = 0;
  for (; i < n; )
    t = Ie(t) ? i++ : t[e[i++]];
  return t;
}
function x4(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !Ie(t[e]))
      return !1;
  return !0;
}
function $e(t, e) {
  const n = Array.isArray(e) ? e : bl(e) ? [e] : Kf(e), i = n.length === 1 ? t : y4(t, n), r = n.length - 1, s = n[r];
  return i && delete i[s], r !== 0 && (Ue(i) && at(i) || Array.isArray(i) && x4(i)) && $e(t, n.slice(0, -1)), t;
}
var fd = (t, e, n) => (t[e] = n, t);
function A4(t) {
  const e = Ks(), { control: n = e.control, name: i, keyName: r = "id", shouldUnregister: s } = t, [a, o] = re.useState(n._getFieldArray(i)), l = re.useRef(n._getFieldArray(i).map(Gt)), c = re.useRef(a), u = re.useRef(i), d = re.useRef(!1);
  u.current = i, c.current = a, n._names.array.add(i), t.rules && n.register(i, t.rules), Qf({
    next: ({ values: A, name: E }) => {
      if (E === u.current || !E) {
        const P = ue(A, u.current);
        Array.isArray(P) && (o(P), l.current = P.map(Gt));
      }
    },
    subject: n._subjects.array
  });
  const h = re.useCallback((A) => {
    d.current = !0, n._updateFieldArray(i, A);
  }, [n, i]), g = (A, E) => {
    const P = vt(Ze(A)), I = Ba(n._getFieldArray(i), P);
    n._names.focus = Ra(i, I.length - 1, E), l.current = Ba(l.current, P.map(Gt)), h(I), o(I), n._updateFieldArray(i, I, Ba, {
      argA: La(A)
    });
  }, b = (A, E) => {
    const P = vt(Ze(A)), I = Ha(n._getFieldArray(i), P);
    n._names.focus = Ra(i, 0, E), l.current = Ha(l.current, P.map(Gt)), h(I), o(I), n._updateFieldArray(i, I, Ha, {
      argA: La(A)
    });
  }, m = (A) => {
    const E = ja(n._getFieldArray(i), A);
    l.current = ja(l.current, A), h(E), o(E), n._updateFieldArray(i, E, ja, {
      argA: A
    });
  }, p = (A, E, P) => {
    const I = vt(Ze(E)), U = Na(n._getFieldArray(i), A, I);
    n._names.focus = Ra(i, A, P), l.current = Na(l.current, A, I.map(Gt)), h(U), o(U), n._updateFieldArray(i, U, Na, {
      argA: A,
      argB: La(E)
    });
  }, x = (A, E) => {
    const P = n._getFieldArray(i);
    $a(P, A, E), $a(l.current, A, E), h(P), o(P), n._updateFieldArray(i, P, $a, {
      argA: A,
      argB: E
    }, !1);
  }, C = (A, E) => {
    const P = n._getFieldArray(i);
    Va(P, A, E), Va(l.current, A, E), h(P), o(P), n._updateFieldArray(i, P, Va, {
      argA: A,
      argB: E
    }, !1);
  }, M = (A, E) => {
    const P = Ze(E), I = fd(n._getFieldArray(i), A, P);
    l.current = [...I].map((U, Q) => !U || Q === A ? Gt() : l.current[Q]), h(I), o([...I]), n._updateFieldArray(i, I, fd, {
      argA: A,
      argB: P
    }, !0, !1);
  }, _ = (A) => {
    const E = vt(Ze(A));
    l.current = E.map(Gt), h([...E]), o([...E]), n._updateFieldArray(i, [...E], (P) => P, {}, !0, !1);
  };
  return re.useEffect(() => {
    if (n._state.action = !1, Mo(i, n._names) && n._subjects.state.next({
      ...n._formState
    }), d.current && (!Zi(n._options.mode).isOnSubmit || n._formState.isSubmitted))
      if (n._options.resolver)
        n._executeSchema([i]).then((A) => {
          const E = ue(A.errors, i), P = ue(n._formState.errors, i);
          (P ? !E && P.type || E && (P.type !== E.type || P.message !== E.message) : E && E.type) && (E ? Me(n._formState.errors, i, E) : $e(n._formState.errors, i), n._subjects.state.next({
            errors: n._formState.errors
          }));
        });
      else {
        const A = ue(n._fields, i);
        A && A._f && !(Zi(n._options.reValidateMode).isOnSubmit && Zi(n._options.mode).isOnSubmit) && Oo(A, n._formValues, n._options.criteriaMode === bt.all, n._options.shouldUseNativeValidation, !0).then((E) => !at(E) && n._subjects.state.next({
          errors: qf(n._formState.errors, E, i)
        }));
      }
    n._subjects.values.next({
      name: i,
      values: { ...n._formValues }
    }), n._names.focus && ui(n._fields, (A, E) => {
      if (n._names.focus && E.startsWith(n._names.focus) && A.focus)
        return A.focus(), 1;
    }), n._names.focus = "", n._updateValid(), d.current = !1;
  }, [a, i, n]), re.useEffect(() => (!ue(n._formValues, i) && n._updateFieldArray(i), () => {
    (n._options.shouldUnregister || s) && n.unregister(i);
  }), [i, n, r, s]), {
    swap: re.useCallback(x, [h, i, n]),
    move: re.useCallback(C, [h, i, n]),
    prepend: re.useCallback(b, [h, i, n]),
    append: re.useCallback(g, [h, i, n]),
    remove: re.useCallback(m, [h, i, n]),
    insert: re.useCallback(p, [h, i, n]),
    update: re.useCallback(M, [h, i, n]),
    replace: re.useCallback(_, [h, i, n]),
    fields: re.useMemo(() => a.map((A, E) => ({
      ...A,
      [r]: l.current[E] || Gt()
    })), [a, r])
  };
}
var Wa = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (r) => {
      for (const s of t)
        s.next && s.next(r);
    },
    subscribe: (r) => (t.push(r), {
      unsubscribe: () => {
        t = t.filter((s) => s !== r);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, _s = (t) => it(t) || !zf(t);
function kn(t, e) {
  if (_s(t) || _s(e))
    return t === e;
  if (ni(t) && ni(e))
    return t.getTime() === e.getTime();
  const n = Object.keys(t), i = Object.keys(e);
  if (n.length !== i.length)
    return !1;
  for (const r of n) {
    const s = t[r];
    if (!i.includes(r))
      return !1;
    if (r !== "ref") {
      const a = e[r];
      if (ni(s) && ni(a) || Ue(s) && Ue(a) || Array.isArray(s) && Array.isArray(a) ? !kn(s, a) : s !== a)
        return !1;
    }
  }
  return !0;
}
var Xf = (t) => t.type === "select-multiple", C4 = (t) => yl(t) || gr(t), Ya = (t) => Es(t) && t.isConnected, e1 = (t) => {
  for (const e in t)
    if (an(t[e]))
      return !0;
  return !1;
};
function Ms(t, e = {}) {
  const n = Array.isArray(t);
  if (Ue(t) || n)
    for (const i in t)
      Array.isArray(t[i]) || Ue(t[i]) && !e1(t[i]) ? (e[i] = Array.isArray(t[i]) ? [] : {}, Ms(t[i], e[i])) : it(t[i]) || (e[i] = !0);
  return e;
}
function t1(t, e, n) {
  const i = Array.isArray(t);
  if (Ue(t) || i)
    for (const r in t)
      Array.isArray(t[r]) || Ue(t[r]) && !e1(t[r]) ? Ie(e) || _s(n[r]) ? n[r] = Array.isArray(t[r]) ? Ms(t[r], []) : { ...Ms(t[r]) } : t1(t[r], it(e) ? {} : e[r], n[r]) : n[r] = !kn(t[r], e[r]);
  return n;
}
var Nr = (t, e) => t1(t, e, Ms(e)), n1 = (t, { valueAsNumber: e, valueAsDate: n, setValueAs: i }) => Ie(t) ? t : e ? t === "" ? NaN : t && +t : n && Ft(t) ? new Date(t) : i ? i(t) : t;
function za(t) {
  const e = t.ref;
  if (!(t.refs ? t.refs.every((n) => n.disabled) : e.disabled))
    return vl(e) ? e.files : yl(e) ? Jf(t.refs).value : Xf(e) ? [...e.selectedOptions].map(({ value: n }) => n) : gr(e) ? Zf(t.refs).value : n1(Ie(e.value) ? t.ref.value : e.value, t);
}
var w4 = (t, e, n, i) => {
  const r = {};
  for (const s of t) {
    const a = ue(e, s);
    a && Me(r, s, a._f);
  }
  return {
    criteriaMode: n,
    names: [...t],
    fields: r,
    shouldUseNativeValidation: i
  };
}, Ri = (t) => Ie(t) ? t : ks(t) ? t.source : Ue(t) ? ks(t.value) ? t.value.source : t.value : t, S4 = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate);
function gd(t, e, n) {
  const i = ue(t, n);
  if (i || bl(n))
    return {
      error: i,
      name: n
    };
  const r = n.split(".");
  for (; r.length; ) {
    const s = r.join("."), a = ue(e, s), o = ue(t, s);
    if (a && !Array.isArray(a) && n !== s)
      return { name: n };
    if (o && o.type)
      return {
        name: s,
        error: o
      };
    r.pop();
  }
  return {
    name: n
  };
}
var E4 = (t, e, n, i, r) => r.isOnAll ? !1 : !n && r.isOnTouch ? !(e || t) : (n ? i.isOnBlur : r.isOnBlur) ? !t : (n ? i.isOnChange : r.isOnChange) ? t : !0, k4 = (t, e) => !Ei(ue(t, e)).length && $e(t, e);
const _4 = {
  mode: bt.onSubmit,
  reValidateMode: bt.onChange,
  shouldFocusError: !0
};
function M4(t = {}) {
  let e = {
    ..._4,
    ...t
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: an(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, i = {}, r = Ue(e.defaultValues) || Ue(e.values) ? Ze(e.defaultValues || e.values) || {} : {}, s = e.shouldUnregister ? {} : Ze(r), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, o = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, d = {
    values: Wa(),
    array: Wa(),
    state: Wa()
  }, h = Zi(e.mode), g = Zi(e.reValidateMode), b = e.criteriaMode === bt.all, m = (O) => (F) => {
    clearTimeout(c), c = setTimeout(O, F);
  }, p = async (O) => {
    if (u.isValid || O) {
      const F = e.resolver ? at((await I()).errors) : await Q(i, !0);
      F !== n.isValid && d.state.next({
        isValid: F
      });
    }
  }, x = (O, F) => {
    (u.isValidating || u.validatingFields) && ((O || Array.from(o.mount)).forEach((L) => {
      L && (F ? Me(n.validatingFields, L, F) : $e(n.validatingFields, L));
    }), d.state.next({
      validatingFields: n.validatingFields,
      isValidating: !at(n.validatingFields)
    }));
  }, C = (O, F = [], L, se, te = !0, ee = !0) => {
    if (se && L) {
      if (a.action = !0, ee && Array.isArray(ue(i, O))) {
        const he = L(ue(i, O), se.argA, se.argB);
        te && Me(i, O, he);
      }
      if (ee && Array.isArray(ue(n.errors, O))) {
        const he = L(ue(n.errors, O), se.argA, se.argB);
        te && Me(n.errors, O, he), k4(n.errors, O);
      }
      if (u.touchedFields && ee && Array.isArray(ue(n.touchedFields, O))) {
        const he = L(ue(n.touchedFields, O), se.argA, se.argB);
        te && Me(n.touchedFields, O, he);
      }
      u.dirtyFields && (n.dirtyFields = Nr(r, s)), d.state.next({
        name: O,
        isDirty: Y(O, F),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      Me(s, O, F);
  }, M = (O, F) => {
    Me(n.errors, O, F), d.state.next({
      errors: n.errors
    });
  }, _ = (O) => {
    n.errors = O, d.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, A = (O, F, L, se) => {
    const te = ue(i, O);
    if (te) {
      const ee = ue(s, O, Ie(L) ? ue(r, O) : L);
      Ie(ee) || se && se.defaultChecked || F ? Me(s, O, F ? ee : za(te._f)) : N(O, ee), a.mount && p();
    }
  }, E = (O, F, L, se, te) => {
    let ee = !1, he = !1;
    const ve = {
      name: O
    }, Le = !!(ue(i, O) && ue(i, O)._f.disabled);
    if (!L || se) {
      u.isDirty && (he = n.isDirty, n.isDirty = ve.isDirty = Y(), ee = he !== ve.isDirty);
      const tt = Le || kn(ue(r, O), F);
      he = !!(!Le && ue(n.dirtyFields, O)), tt || Le ? $e(n.dirtyFields, O) : Me(n.dirtyFields, O, !0), ve.dirtyFields = n.dirtyFields, ee = ee || u.dirtyFields && he !== !tt;
    }
    if (L) {
      const tt = ue(n.touchedFields, O);
      tt || (Me(n.touchedFields, O, L), ve.touchedFields = n.touchedFields, ee = ee || u.touchedFields && tt !== L);
    }
    return ee && te && d.state.next(ve), ee ? ve : {};
  }, P = (O, F, L, se) => {
    const te = ue(n.errors, O), ee = u.isValid && $t(F) && n.isValid !== F;
    if (t.delayError && L ? (l = m(() => M(O, L)), l(t.delayError)) : (clearTimeout(c), l = null, L ? Me(n.errors, O, L) : $e(n.errors, O)), (L ? !kn(te, L) : te) || !at(se) || ee) {
      const he = {
        ...se,
        ...ee && $t(F) ? { isValid: F } : {},
        errors: n.errors,
        name: O
      };
      n = {
        ...n,
        ...he
      }, d.state.next(he);
    }
  }, I = async (O) => {
    x(O, !0);
    const F = await e.resolver(s, e.context, w4(O || o.mount, i, e.criteriaMode, e.shouldUseNativeValidation));
    return x(O), F;
  }, U = async (O) => {
    const { errors: F } = await I(O);
    if (O)
      for (const L of O) {
        const se = ue(F, L);
        se ? Me(n.errors, L, se) : $e(n.errors, L);
      }
    else
      n.errors = F;
    return F;
  }, Q = async (O, F, L = {
    valid: !0
  }) => {
    for (const se in O) {
      const te = O[se];
      if (te) {
        const { _f: ee, ...he } = te;
        if (ee) {
          const ve = o.array.has(ee.name);
          x([se], !0);
          const Le = await Oo(te, s, b, e.shouldUseNativeValidation && !F, ve);
          if (x([se]), Le[ee.name] && (L.valid = !1, F))
            break;
          !F && (ue(Le, ee.name) ? ve ? qf(n.errors, Le, ee.name) : Me(n.errors, ee.name, Le[ee.name]) : $e(n.errors, ee.name));
        }
        he && await Q(he, F, L);
      }
    }
    return L.valid;
  }, T = () => {
    for (const O of o.unMount) {
      const F = ue(i, O);
      F && (F._f.refs ? F._f.refs.every((L) => !Ya(L)) : !Ya(F._f.ref)) && z(O);
    }
    o.unMount = /* @__PURE__ */ new Set();
  }, Y = (O, F) => (O && F && Me(s, O, F), !kn(k(), r)), q = (O, F, L) => b4(O, o, {
    ...a.mount ? s : Ie(F) ? r : Ft(O) ? { [O]: F } : F
  }, L, F), $ = (O) => Ei(ue(a.mount ? s : r, O, t.shouldUnregister ? ue(r, O, []) : [])), N = (O, F, L = {}) => {
    const se = ue(i, O);
    let te = F;
    if (se) {
      const ee = se._f;
      ee && (!ee.disabled && Me(s, O, n1(F, ee)), te = Es(ee.ref) && it(F) ? "" : F, Xf(ee.ref) ? [...ee.ref.options].forEach((he) => he.selected = te.includes(he.value)) : ee.refs ? gr(ee.ref) ? ee.refs.length > 1 ? ee.refs.forEach((he) => (!he.defaultChecked || !he.disabled) && (he.checked = Array.isArray(te) ? !!te.find((ve) => ve === he.value) : te === he.value)) : ee.refs[0] && (ee.refs[0].checked = !!te) : ee.refs.forEach((he) => he.checked = he.value === te) : vl(ee.ref) ? ee.ref.value = "" : (ee.ref.value = te, ee.ref.type || d.values.next({
        name: O,
        values: { ...s }
      })));
    }
    (L.shouldDirty || L.shouldTouch) && E(O, te, L.shouldTouch, L.shouldDirty, !0), L.shouldValidate && v(O);
  }, R = (O, F, L) => {
    for (const se in F) {
      const te = F[se], ee = `${O}.${se}`, he = ue(i, ee);
      (o.array.has(O) || !_s(te) || he && !he._f) && !ni(te) ? R(ee, te, L) : N(ee, te, L);
    }
  }, B = (O, F, L = {}) => {
    const se = ue(i, O), te = o.array.has(O), ee = Ze(F);
    Me(s, O, ee), te ? (d.array.next({
      name: O,
      values: { ...s }
    }), (u.isDirty || u.dirtyFields) && L.shouldDirty && d.state.next({
      name: O,
      dirtyFields: Nr(r, s),
      isDirty: Y(O, ee)
    })) : se && !se._f && !it(ee) ? R(O, ee, L) : N(O, ee, L), Mo(O, o) && d.state.next({ ...n }), d.values.next({
      name: a.mount ? O : void 0,
      values: { ...s }
    });
  }, j = async (O) => {
    a.mount = !0;
    const F = O.target;
    let L = F.name, se = !0;
    const te = ue(i, L), ee = () => F.type ? za(te._f) : u4(O), he = (ve) => {
      se = Number.isNaN(ve) || ve === ue(s, L, ve);
    };
    if (te) {
      let ve, Le;
      const tt = ee(), zn = O.type === ld.BLUR || O.type === ld.FOCUS_OUT, S1 = !S4(te._f) && !e.resolver && !ue(n.errors, L) && !te._f.deps || E4(zn, ue(n.touchedFields, L), n.isSubmitted, g, h), ta = Mo(L, o, zn);
      Me(s, L, tt), zn ? (te._f.onBlur && te._f.onBlur(O), l && l(0)) : te._f.onChange && te._f.onChange(O);
      const na = E(L, tt, zn, !1), E1 = !at(na) || ta;
      if (!zn && d.values.next({
        name: L,
        type: O.type,
        values: { ...s }
      }), S1)
        return u.isValid && p(), E1 && d.state.next({ name: L, ...ta ? {} : na });
      if (!zn && ta && d.state.next({ ...n }), e.resolver) {
        const { errors: Tl } = await I([L]);
        if (he(tt), se) {
          const k1 = gd(n.errors, i, L), Il = gd(Tl, i, k1.name || L);
          ve = Il.error, L = Il.name, Le = at(Tl);
        }
      } else
        x([L], !0), ve = (await Oo(te, s, b, e.shouldUseNativeValidation))[L], x([L]), he(tt), se && (ve ? Le = !1 : u.isValid && (Le = await Q(i, !0)));
      se && (te._f.deps && v(te._f.deps), P(L, Le, ve, na));
    }
  }, y = (O, F) => {
    if (ue(n.errors, F) && O.focus)
      return O.focus(), 1;
  }, v = async (O, F = {}) => {
    let L, se;
    const te = vt(O);
    if (e.resolver) {
      const ee = await U(Ie(O) ? O : te);
      L = at(ee), se = O ? !te.some((he) => ue(ee, he)) : L;
    } else
      O ? (se = (await Promise.all(te.map(async (ee) => {
        const he = ue(i, ee);
        return await Q(he && he._f ? { [ee]: he } : he);
      }))).every(Boolean), !(!se && !n.isValid) && p()) : se = L = await Q(i);
    return d.state.next({
      ...!Ft(O) || u.isValid && L !== n.isValid ? {} : { name: O },
      ...e.resolver || !O ? { isValid: L } : {},
      errors: n.errors
    }), F.shouldFocus && !se && ui(i, y, O ? te : o.mount), se;
  }, k = (O) => {
    const F = {
      ...a.mount ? s : r
    };
    return Ie(O) ? F : Ft(O) ? ue(F, O) : O.map((L) => ue(F, L));
  }, S = (O, F) => ({
    invalid: !!ue((F || n).errors, O),
    isDirty: !!ue((F || n).dirtyFields, O),
    isTouched: !!ue((F || n).touchedFields, O),
    isValidating: !!ue((F || n).validatingFields, O),
    error: ue((F || n).errors, O)
  }), f = (O) => {
    O && vt(O).forEach((F) => $e(n.errors, F)), d.state.next({
      errors: O ? n.errors : {}
    });
  }, D = (O, F, L) => {
    const se = (ue(i, O, { _f: {} })._f || {}).ref;
    Me(n.errors, O, {
      ...F,
      ref: se
    }), d.state.next({
      name: O,
      errors: n.errors,
      isValid: !1
    }), L && L.shouldFocus && se && se.focus && se.focus();
  }, V = (O, F) => an(O) ? d.values.subscribe({
    next: (L) => O(q(void 0, F), L)
  }) : q(O, F, !0), z = (O, F = {}) => {
    for (const L of O ? vt(O) : o.mount)
      o.mount.delete(L), o.array.delete(L), F.keepValue || ($e(i, L), $e(s, L)), !F.keepError && $e(n.errors, L), !F.keepDirty && $e(n.dirtyFields, L), !F.keepTouched && $e(n.touchedFields, L), !F.keepIsValidating && $e(n.validatingFields, L), !e.shouldUnregister && !F.keepDefaultValue && $e(r, L);
    d.values.next({
      values: { ...s }
    }), d.state.next({
      ...n,
      ...F.keepDirty ? { isDirty: Y() } : {}
    }), !F.keepIsValid && p();
  }, H = ({ disabled: O, name: F, field: L, fields: se, value: te }) => {
    if ($t(O)) {
      const ee = O ? void 0 : Ie(te) ? za(L ? L._f : ue(se, F)._f) : te;
      Me(s, F, ee), E(F, ee, !1, !1, !0);
    }
  }, K = (O, F = {}) => {
    let L = ue(i, O);
    const se = $t(F.disabled);
    return Me(i, O, {
      ...L || {},
      _f: {
        ...L && L._f ? L._f : { ref: { name: O } },
        name: O,
        mount: !0,
        ...F
      }
    }), o.mount.add(O), L ? H({
      field: L,
      disabled: F.disabled,
      name: O,
      value: F.value
    }) : A(O, !0, F.value), {
      ...se ? { disabled: F.disabled } : {},
      ...e.progressive ? {
        required: !!F.required,
        min: Ri(F.min),
        max: Ri(F.max),
        minLength: Ri(F.minLength),
        maxLength: Ri(F.maxLength),
        pattern: Ri(F.pattern)
      } : {},
      name: O,
      onChange: j,
      onBlur: j,
      ref: (te) => {
        if (te) {
          K(O, F), L = ue(i, O);
          const ee = Ie(te.value) && te.querySelectorAll && te.querySelectorAll("input,select,textarea")[0] || te, he = C4(ee), ve = L._f.refs || [];
          if (he ? ve.find((Le) => Le === ee) : ee === L._f.ref)
            return;
          Me(i, O, {
            _f: {
              ...L._f,
              ...he ? {
                refs: [
                  ...ve.filter(Ya),
                  ee,
                  ...Array.isArray(ue(r, O)) ? [{}] : []
                ],
                ref: { type: ee.type, name: O }
              } : { ref: ee }
            }
          }), A(O, !1, void 0, ee);
        } else
          L = ue(i, O, {}), L._f && (L._f.mount = !1), (e.shouldUnregister || F.shouldUnregister) && !(h4(o.array, O) && a.action) && o.unMount.add(O);
      }
    };
  }, Z = () => e.shouldFocusError && ui(i, y, o.mount), G = (O) => {
    $t(O) && (d.state.next({ disabled: O }), ui(i, (F, L) => {
      let se = O;
      const te = ue(i, L);
      te && $t(te._f.disabled) && (se || (se = te._f.disabled)), F.disabled = se;
    }, 0, !1));
  }, X = (O, F) => async (L) => {
    let se;
    L && (L.preventDefault && L.preventDefault(), L.persist && L.persist());
    let te = Ze(s);
    if (d.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: ee, values: he } = await I();
      n.errors = ee, te = he;
    } else
      await Q(i);
    if ($e(n.errors, "root"), at(n.errors)) {
      d.state.next({
        errors: {}
      });
      try {
        await O(te, L);
      } catch (ee) {
        se = ee;
      }
    } else
      F && await F({ ...n.errors }, L), Z(), setTimeout(Z);
    if (d.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: at(n.errors) && !se,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), se)
      throw se;
  }, W = (O, F = {}) => {
    ue(i, O) && (Ie(F.defaultValue) ? B(O, Ze(ue(r, O))) : (B(O, F.defaultValue), Me(r, O, Ze(F.defaultValue))), F.keepTouched || $e(n.touchedFields, O), F.keepDirty || ($e(n.dirtyFields, O), n.isDirty = F.defaultValue ? Y(O, Ze(ue(r, O))) : Y()), F.keepError || ($e(n.errors, O), u.isValid && p()), d.state.next({ ...n }));
  }, ie = (O, F = {}) => {
    const L = O ? Ze(O) : r, se = Ze(L), te = at(O), ee = te ? r : se;
    if (F.keepDefaultValues || (r = L), !F.keepValues) {
      if (F.keepDirtyValues)
        for (const he of o.mount)
          ue(n.dirtyFields, he) ? Me(ee, he, ue(s, he)) : B(he, ue(ee, he));
      else {
        if (pl && Ie(O))
          for (const he of o.mount) {
            const ve = ue(i, he);
            if (ve && ve._f) {
              const Le = Array.isArray(ve._f.refs) ? ve._f.refs[0] : ve._f.ref;
              if (Es(Le)) {
                const tt = Le.closest("form");
                if (tt) {
                  tt.reset();
                  break;
                }
              }
            }
          }
        i = {};
      }
      s = t.shouldUnregister ? F.keepDefaultValues ? Ze(r) : {} : Ze(ee), d.array.next({
        values: { ...ee }
      }), d.values.next({
        values: { ...ee }
      });
    }
    o = {
      mount: F.keepDirtyValues ? o.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !u.isValid || !!F.keepIsValid || !!F.keepDirtyValues, a.watch = !!t.shouldUnregister, d.state.next({
      submitCount: F.keepSubmitCount ? n.submitCount : 0,
      isDirty: te ? !1 : F.keepDirty ? n.isDirty : !!(F.keepDefaultValues && !kn(O, r)),
      isSubmitted: F.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: te ? [] : F.keepDirtyValues ? F.keepDefaultValues && s ? Nr(r, s) : n.dirtyFields : F.keepDefaultValues && O ? Nr(r, O) : {},
      touchedFields: F.keepTouched ? n.touchedFields : {},
      errors: F.keepErrors ? n.errors : {},
      isSubmitSuccessful: F.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, J = (O, F) => ie(an(O) ? O(s) : O, F);
  return {
    control: {
      register: K,
      unregister: z,
      getFieldState: S,
      handleSubmit: X,
      setError: D,
      _executeSchema: I,
      _getWatch: q,
      _getDirty: Y,
      _updateValid: p,
      _removeUnmounted: T,
      _updateFieldArray: C,
      _updateDisabledField: H,
      _getFieldArray: $,
      _reset: ie,
      _resetDefaultValues: () => an(e.defaultValues) && e.defaultValues().then((O) => {
        J(O, e.resetOptions), d.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (O) => {
        n = {
          ...n,
          ...O
        };
      },
      _disableForm: G,
      _subjects: d,
      _proxyFormState: u,
      _setErrors: _,
      get _fields() {
        return i;
      },
      get _formValues() {
        return s;
      },
      get _state() {
        return a;
      },
      set _state(O) {
        a = O;
      },
      get _defaultValues() {
        return r;
      },
      get _names() {
        return o;
      },
      set _names(O) {
        o = O;
      },
      get _formState() {
        return n;
      },
      set _formState(O) {
        n = O;
      },
      get _options() {
        return e;
      },
      set _options(O) {
        e = {
          ...e,
          ...O
        };
      }
    },
    trigger: v,
    register: K,
    handleSubmit: X,
    watch: V,
    setValue: B,
    getValues: k,
    reset: J,
    resetField: W,
    clearErrors: f,
    unregister: z,
    setError: D,
    setFocus: (O, F = {}) => {
      const L = ue(i, O), se = L && L._f;
      if (se) {
        const te = se.refs ? se.refs[0] : se.ref;
        te.focus && (te.focus(), F.shouldSelect && te.select());
      }
    },
    getFieldState: S
  };
}
function O4(t = {}) {
  const e = re.useRef(), n = re.useRef(), [i, r] = re.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: an(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1,
    defaultValues: an(t.defaultValues) ? void 0 : t.defaultValues
  });
  e.current || (e.current = {
    ...M4(t),
    formState: i
  });
  const s = e.current.control;
  return s._options = t, Qf({
    subject: s._subjects.state,
    next: (a) => {
      p4(a, s._proxyFormState, s._updateFormState) && r({ ...s._formState });
    }
  }), re.useEffect(() => s._disableForm(t.disabled), [s, t.disabled]), re.useEffect(() => {
    if (s._proxyFormState.isDirty) {
      const a = s._getDirty();
      a !== i.isDirty && s._subjects.state.next({
        isDirty: a
      });
    }
  }, [s, i.isDirty]), re.useEffect(() => {
    t.values && !kn(t.values, n.current) ? (s._reset(t.values, s._options.resetOptions), n.current = t.values, r((a) => ({ ...a }))) : s._resetDefaultValues();
  }, [t.values, s]), re.useEffect(() => {
    t.errors && s._setErrors(t.errors);
  }, [t.errors, s]), re.useEffect(() => {
    s._state.mount || (s._updateValid(), s._state.mount = !0), s._state.watch && (s._state.watch = !1, s._subjects.state.next({ ...s._formState })), s._removeUnmounted();
  }), re.useEffect(() => {
    t.shouldUnregister && s._subjects.values.next({
      values: s._getWatch()
    });
  }, [t.shouldUnregister, s]), e.current.formState = m4(i, s), e.current;
}
var D4 = Array.isArray, xl = D4, P4 = typeof ei == "object" && ei && ei.Object === Object && ei, F4 = P4, T4 = F4, I4 = typeof self == "object" && self && self.Object === Object && self, R4 = T4 || I4 || Function("return this")(), Al = R4, B4 = Al, L4 = B4.Symbol, Cl = L4, md = Cl, i1 = Object.prototype, N4 = i1.hasOwnProperty, V4 = i1.toString, Bi = md ? md.toStringTag : void 0;
function H4(t) {
  var e = N4.call(t, Bi), n = t[Bi];
  try {
    t[Bi] = void 0;
    var i = !0;
  } catch {
  }
  var r = V4.call(t);
  return i && (e ? t[Bi] = n : delete t[Bi]), r;
}
var j4 = H4, $4 = Object.prototype, W4 = $4.toString;
function Y4(t) {
  return W4.call(t);
}
var z4 = Y4, pd = Cl, U4 = j4, Q4 = z4, K4 = "[object Null]", G4 = "[object Undefined]", bd = pd ? pd.toStringTag : void 0;
function q4(t) {
  return t == null ? t === void 0 ? G4 : K4 : bd && bd in Object(t) ? U4(t) : Q4(t);
}
var r1 = q4;
function Z4(t) {
  return t != null && typeof t == "object";
}
var J4 = Z4, X4 = r1, e8 = J4, t8 = "[object Symbol]";
function n8(t) {
  return typeof t == "symbol" || e8(t) && X4(t) == t8;
}
var wl = n8, i8 = xl, r8 = wl, s8 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a8 = /^\w*$/;
function o8(t, e) {
  if (i8(t))
    return !1;
  var n = typeof t;
  return n == "number" || n == "symbol" || n == "boolean" || t == null || r8(t) ? !0 : a8.test(t) || !s8.test(t) || e != null && t in Object(e);
}
var l8 = o8;
function c8(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Sl = c8, u8 = r1, d8 = Sl, h8 = "[object AsyncFunction]", f8 = "[object Function]", g8 = "[object GeneratorFunction]", m8 = "[object Proxy]";
function p8(t) {
  if (!d8(t))
    return !1;
  var e = u8(t);
  return e == f8 || e == g8 || e == h8 || e == m8;
}
var b8 = p8, v8 = Al, y8 = v8["__core-js_shared__"], x8 = y8, Ua = x8, vd = function() {
  var t = /[^.]+$/.exec(Ua && Ua.keys && Ua.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function A8(t) {
  return !!vd && vd in t;
}
var C8 = A8, w8 = Function.prototype, S8 = w8.toString;
function E8(t) {
  if (t != null) {
    try {
      return S8.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var k8 = E8, _8 = b8, M8 = C8, O8 = Sl, D8 = k8, P8 = /[\\^$.*+?()[\]{}|]/g, F8 = /^\[object .+?Constructor\]$/, T8 = Function.prototype, I8 = Object.prototype, R8 = T8.toString, B8 = I8.hasOwnProperty, L8 = RegExp(
  "^" + R8.call(B8).replace(P8, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function N8(t) {
  if (!O8(t) || M8(t))
    return !1;
  var e = _8(t) ? L8 : F8;
  return e.test(D8(t));
}
var V8 = N8;
function H8(t, e) {
  return t == null ? void 0 : t[e];
}
var j8 = H8, $8 = V8, W8 = j8;
function Y8(t, e) {
  var n = W8(t, e);
  return $8(n) ? n : void 0;
}
var El = Y8, z8 = El, U8 = z8(Object, "create"), Gs = U8, yd = Gs;
function Q8() {
  this.__data__ = yd ? yd(null) : {}, this.size = 0;
}
var K8 = Q8;
function G8(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var q8 = G8, Z8 = Gs, J8 = "__lodash_hash_undefined__", X8 = Object.prototype, eb = X8.hasOwnProperty;
function tb(t) {
  var e = this.__data__;
  if (Z8) {
    var n = e[t];
    return n === J8 ? void 0 : n;
  }
  return eb.call(e, t) ? e[t] : void 0;
}
var nb = tb, ib = Gs, rb = Object.prototype, sb = rb.hasOwnProperty;
function ab(t) {
  var e = this.__data__;
  return ib ? e[t] !== void 0 : sb.call(e, t);
}
var ob = ab, lb = Gs, cb = "__lodash_hash_undefined__";
function ub(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = lb && e === void 0 ? cb : e, this;
}
var db = ub, hb = K8, fb = q8, gb = nb, mb = ob, pb = db;
function ki(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
ki.prototype.clear = hb;
ki.prototype.delete = fb;
ki.prototype.get = gb;
ki.prototype.has = mb;
ki.prototype.set = pb;
var bb = ki;
function vb() {
  this.__data__ = [], this.size = 0;
}
var yb = vb;
function xb(t, e) {
  return t === e || t !== t && e !== e;
}
var s1 = xb, Ab = s1;
function Cb(t, e) {
  for (var n = t.length; n--; )
    if (Ab(t[n][0], e))
      return n;
  return -1;
}
var qs = Cb, wb = qs, Sb = Array.prototype, Eb = Sb.splice;
function kb(t) {
  var e = this.__data__, n = wb(e, t);
  if (n < 0)
    return !1;
  var i = e.length - 1;
  return n == i ? e.pop() : Eb.call(e, n, 1), --this.size, !0;
}
var _b = kb, Mb = qs;
function Ob(t) {
  var e = this.__data__, n = Mb(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var Db = Ob, Pb = qs;
function Fb(t) {
  return Pb(this.__data__, t) > -1;
}
var Tb = Fb, Ib = qs;
function Rb(t, e) {
  var n = this.__data__, i = Ib(n, t);
  return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
}
var Bb = Rb, Lb = yb, Nb = _b, Vb = Db, Hb = Tb, jb = Bb;
function _i(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
_i.prototype.clear = Lb;
_i.prototype.delete = Nb;
_i.prototype.get = Vb;
_i.prototype.has = Hb;
_i.prototype.set = jb;
var $b = _i, Wb = El, Yb = Al, zb = Wb(Yb, "Map"), Ub = zb, xd = bb, Qb = $b, Kb = Ub;
function Gb() {
  this.size = 0, this.__data__ = {
    hash: new xd(),
    map: new (Kb || Qb)(),
    string: new xd()
  };
}
var qb = Gb;
function Zb(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var Jb = Zb, Xb = Jb;
function e9(t, e) {
  var n = t.__data__;
  return Xb(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var Zs = e9, t9 = Zs;
function n9(t) {
  var e = t9(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var i9 = n9, r9 = Zs;
function s9(t) {
  return r9(this, t).get(t);
}
var a9 = s9, o9 = Zs;
function l9(t) {
  return o9(this, t).has(t);
}
var c9 = l9, u9 = Zs;
function d9(t, e) {
  var n = u9(this, t), i = n.size;
  return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
}
var h9 = d9, f9 = qb, g9 = i9, m9 = a9, p9 = c9, b9 = h9;
function Mi(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var i = t[e];
    this.set(i[0], i[1]);
  }
}
Mi.prototype.clear = f9;
Mi.prototype.delete = g9;
Mi.prototype.get = m9;
Mi.prototype.has = p9;
Mi.prototype.set = b9;
var v9 = Mi, a1 = v9, y9 = "Expected a function";
function kl(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(y9);
  var n = function() {
    var i = arguments, r = e ? e.apply(this, i) : i[0], s = n.cache;
    if (s.has(r))
      return s.get(r);
    var a = t.apply(this, i);
    return n.cache = s.set(r, a) || s, a;
  };
  return n.cache = new (kl.Cache || a1)(), n;
}
kl.Cache = a1;
var x9 = kl, A9 = x9, C9 = 500;
function w9(t) {
  var e = A9(t, function(i) {
    return n.size === C9 && n.clear(), i;
  }), n = e.cache;
  return e;
}
var S9 = w9, E9 = S9, k9 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, _9 = /\\(\\)?/g, M9 = E9(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(k9, function(n, i, r, s) {
    e.push(r ? s.replace(_9, "$1") : i || n);
  }), e;
}), O9 = M9;
function D9(t, e) {
  for (var n = -1, i = t == null ? 0 : t.length, r = Array(i); ++n < i; )
    r[n] = e(t[n], n, t);
  return r;
}
var P9 = D9, Ad = Cl, F9 = P9, T9 = xl, I9 = wl, R9 = 1 / 0, Cd = Ad ? Ad.prototype : void 0, wd = Cd ? Cd.toString : void 0;
function o1(t) {
  if (typeof t == "string")
    return t;
  if (T9(t))
    return F9(t, o1) + "";
  if (I9(t))
    return wd ? wd.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -R9 ? "-0" : e;
}
var B9 = o1, L9 = B9;
function N9(t) {
  return t == null ? "" : L9(t);
}
var V9 = N9, H9 = xl, j9 = l8, $9 = O9, W9 = V9;
function Y9(t, e) {
  return H9(t) ? t : j9(t, e) ? [t] : $9(W9(t));
}
var l1 = Y9, z9 = wl, U9 = 1 / 0;
function Q9(t) {
  if (typeof t == "string" || z9(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -U9 ? "-0" : e;
}
var c1 = Q9, K9 = l1, G9 = c1;
function q9(t, e) {
  e = K9(e, t);
  for (var n = 0, i = e.length; t != null && n < i; )
    t = t[G9(e[n++])];
  return n && n == i ? t : void 0;
}
var Z9 = q9, J9 = Z9;
function X9(t, e, n) {
  var i = t == null ? void 0 : J9(t, e);
  return i === void 0 ? n : i;
}
var ev = X9;
const tv = /* @__PURE__ */ Ut(ev);
var nv = El, iv = function() {
  try {
    var t = nv(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), rv = iv, Sd = rv;
function sv(t, e, n) {
  e == "__proto__" && Sd ? Sd(t, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : t[e] = n;
}
var av = sv, ov = av, lv = s1, cv = Object.prototype, uv = cv.hasOwnProperty;
function dv(t, e, n) {
  var i = t[e];
  (!(uv.call(t, e) && lv(i, n)) || n === void 0 && !(e in t)) && ov(t, e, n);
}
var hv = dv, fv = 9007199254740991, gv = /^(?:0|[1-9]\d*)$/;
function mv(t, e) {
  var n = typeof t;
  return e = e ?? fv, !!e && (n == "number" || n != "symbol" && gv.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var pv = mv, bv = hv, vv = l1, yv = pv, Ed = Sl, xv = c1;
function Av(t, e, n, i) {
  if (!Ed(t))
    return t;
  e = vv(e, t);
  for (var r = -1, s = e.length, a = s - 1, o = t; o != null && ++r < s; ) {
    var l = xv(e[r]), c = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return t;
    if (r != a) {
      var u = o[l];
      c = i ? i(u, l, o) : void 0, c === void 0 && (c = Ed(u) ? u : yv(e[r + 1]) ? [] : {});
    }
    bv(o, l, c), o = o[l];
  }
  return t;
}
var Cv = Av, wv = Cv;
function Sv(t, e, n) {
  return t == null ? t : wv(t, e, n);
}
var Ev = Sv;
const kv = /* @__PURE__ */ Ut(Ev);
function Wn(t) {
  this._maxSize = t, this.clear();
}
Wn.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Wn.prototype.get = function(t) {
  return this._values[t];
};
Wn.prototype.set = function(t, e) {
  return this._size >= this._maxSize && this.clear(), t in this._values || this._size++, this._values[t] = e;
};
var _v = /[^.^\]^[]+|(?=\[\]|\.\.)/g, u1 = /^\d+$/, Mv = /^\d/, Ov = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, Dv = /^\s*(['"]?)(.*?)(\1)\s*$/, _l = 512, kd = new Wn(_l), _d = new Wn(_l), Md = new Wn(_l), Fn = {
  Cache: Wn,
  split: Do,
  normalizePath: Qa,
  setter: function(t) {
    var e = Qa(t);
    return _d.get(t) || _d.set(t, function(i, r) {
      for (var s = 0, a = e.length, o = i; s < a - 1; ) {
        var l = e[s];
        if (l === "__proto__" || l === "constructor" || l === "prototype")
          return i;
        o = o[e[s++]];
      }
      o[e[s]] = r;
    });
  },
  getter: function(t, e) {
    var n = Qa(t);
    return Md.get(t) || Md.set(t, function(r) {
      for (var s = 0, a = n.length; s < a; )
        if (r != null || !e)
          r = r[n[s++]];
        else
          return;
      return r;
    });
  },
  join: function(t) {
    return t.reduce(function(e, n) {
      return e + (Ml(n) || u1.test(n) ? "[" + n + "]" : (e ? "." : "") + n);
    }, "");
  },
  forEach: function(t, e, n) {
    Pv(Array.isArray(t) ? t : Do(t), e, n);
  }
};
function Qa(t) {
  return kd.get(t) || kd.set(
    t,
    Do(t).map(function(e) {
      return e.replace(Dv, "$2");
    })
  );
}
function Do(t) {
  return t.match(_v) || [""];
}
function Pv(t, e, n) {
  var i = t.length, r, s, a, o;
  for (s = 0; s < i; s++)
    r = t[s], r && (Iv(r) && (r = '"' + r + '"'), o = Ml(r), a = !o && /^\d+$/.test(r), e.call(n, r, o, a, s, t));
}
function Ml(t) {
  return typeof t == "string" && t && ["'", '"'].indexOf(t.charAt(0)) !== -1;
}
function Fv(t) {
  return t.match(Mv) && !t.match(u1);
}
function Tv(t) {
  return Ov.test(t);
}
function Iv(t) {
  return !Ml(t) && (Fv(t) || Tv(t));
}
const Rv = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, Js = (t) => t.match(Rv) || [], Xs = (t) => t[0].toUpperCase() + t.slice(1), Ol = (t, e) => Js(t).join(e).toLowerCase(), d1 = (t) => Js(t).reduce(
  (e, n) => `${e}${e ? n[0].toUpperCase() + n.slice(1).toLowerCase() : n.toLowerCase()}`,
  ""
), Bv = (t) => Xs(d1(t)), Lv = (t) => Ol(t, "_"), Nv = (t) => Ol(t, "-"), Vv = (t) => Xs(Ol(t, " ")), Hv = (t) => Js(t).map(Xs).join(" ");
var Ka = {
  words: Js,
  upperFirst: Xs,
  camelCase: d1,
  pascalCase: Bv,
  snakeCase: Lv,
  kebabCase: Nv,
  sentenceCase: Vv,
  titleCase: Hv
}, Dl = { exports: {} };
Dl.exports = function(t) {
  return h1(jv(t), t);
};
Dl.exports.array = h1;
function h1(t, e) {
  var n = t.length, i = new Array(n), r = {}, s = n, a = $v(e), o = Wv(t);
  for (e.forEach(function(c) {
    if (!o.has(c[0]) || !o.has(c[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); s--; )
    r[s] || l(t[s], s, /* @__PURE__ */ new Set());
  return i;
  function l(c, u, d) {
    if (d.has(c)) {
      var h;
      try {
        h = ", node was:" + JSON.stringify(c);
      } catch {
        h = "";
      }
      throw new Error("Cyclic dependency" + h);
    }
    if (!o.has(c))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(c));
    if (!r[u]) {
      r[u] = !0;
      var g = a.get(c) || /* @__PURE__ */ new Set();
      if (g = Array.from(g), u = g.length) {
        d.add(c);
        do {
          var b = g[--u];
          l(b, o.get(b), d);
        } while (u);
        d.delete(c);
      }
      i[--n] = c;
    }
  }
}
function jv(t) {
  for (var e = /* @__PURE__ */ new Set(), n = 0, i = t.length; n < i; n++) {
    var r = t[n];
    e.add(r[0]), e.add(r[1]);
  }
  return Array.from(e);
}
function $v(t) {
  for (var e = /* @__PURE__ */ new Map(), n = 0, i = t.length; n < i; n++) {
    var r = t[n];
    e.has(r[0]) || e.set(r[0], /* @__PURE__ */ new Set()), e.has(r[1]) || e.set(r[1], /* @__PURE__ */ new Set()), e.get(r[0]).add(r[1]);
  }
  return e;
}
function Wv(t) {
  for (var e = /* @__PURE__ */ new Map(), n = 0, i = t.length; n < i; n++)
    e.set(t[n], n);
  return e;
}
var Yv = Dl.exports;
const zv = /* @__PURE__ */ Ut(Yv), Uv = Object.prototype.toString, Qv = Error.prototype.toString, Kv = RegExp.prototype.toString, Gv = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", qv = /^Symbol\((.*)\)(.*)$/;
function Zv(t) {
  return t != +t ? "NaN" : t === 0 && 1 / t < 0 ? "-0" : "" + t;
}
function Od(t, e = !1) {
  if (t == null || t === !0 || t === !1)
    return "" + t;
  const n = typeof t;
  if (n === "number")
    return Zv(t);
  if (n === "string")
    return e ? `"${t}"` : t;
  if (n === "function")
    return "[Function " + (t.name || "anonymous") + "]";
  if (n === "symbol")
    return Gv.call(t).replace(qv, "Symbol($1)");
  const i = Uv.call(t).slice(8, -1);
  return i === "Date" ? isNaN(t.getTime()) ? "" + t : t.toISOString(t) : i === "Error" || t instanceof Error ? "[" + Qv.call(t) + "]" : i === "RegExp" ? Kv.call(t) : null;
}
function hn(t, e) {
  let n = Od(t, e);
  return n !== null ? n : JSON.stringify(t, function(i, r) {
    let s = Od(this[i], e);
    return s !== null ? s : r;
  }, 2);
}
function f1(t) {
  return t == null ? [] : [].concat(t);
}
let g1, m1, p1, Jv = /\$\{\s*(\w+)\s*\}/g;
g1 = Symbol.toStringTag;
class Dd {
  constructor(e, n, i, r) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[g1] = "Error", this.name = "ValidationError", this.value = n, this.path = i, this.type = r, this.errors = [], this.inner = [], f1(e).forEach((s) => {
      if (ot.isError(s)) {
        this.errors.push(...s.errors);
        const a = s.inner.length ? s.inner : [s];
        this.inner.push(...a);
      } else
        this.errors.push(s);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
m1 = Symbol.hasInstance;
p1 = Symbol.toStringTag;
class ot extends Error {
  static formatError(e, n) {
    const i = n.label || n.path || "this";
    return i !== n.path && (n = Object.assign({}, n, {
      path: i
    })), typeof e == "string" ? e.replace(Jv, (r, s) => hn(n[s])) : typeof e == "function" ? e(n) : e;
  }
  static isError(e) {
    return e && e.name === "ValidationError";
  }
  constructor(e, n, i, r, s) {
    const a = new Dd(e, n, i, r);
    if (s)
      return a;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[p1] = "Error", this.name = a.name, this.message = a.message, this.type = a.type, this.value = a.value, this.path = a.path, this.errors = a.errors, this.inner = a.inner, Error.captureStackTrace && Error.captureStackTrace(this, ot);
  }
  static [m1](e) {
    return Dd[Symbol.hasInstance](e) || super[Symbol.hasInstance](e);
  }
}
let Ht = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: t,
    type: e,
    value: n,
    originalValue: i
  }) => {
    const r = i != null && i !== n ? ` (cast from the value \`${hn(i, !0)}\`).` : ".";
    return e !== "mixed" ? `${t} must be a \`${e}\` type, but the final value was: \`${hn(n, !0)}\`` + r : `${t} must match the configured type. The validated value was: \`${hn(n, !0)}\`` + r;
  }
}, Xv = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, ey = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Po = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, ty = {
  isValue: "${path} field must be ${value}"
}, Fo = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, ny = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, iy = {
  notType: (t) => {
    const {
      path: e,
      value: n,
      spec: i
    } = t, r = i.types.length;
    if (Array.isArray(n)) {
      if (n.length < r)
        return `${e} tuple value has too few items, expected a length of ${r} but got ${n.length} for value: \`${hn(n, !0)}\``;
      if (n.length > r)
        return `${e} tuple value has too many items, expected a length of ${r} but got ${n.length} for value: \`${hn(n, !0)}\``;
    }
    return ot.formatError(Ht.notType, t);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Ht,
  string: Xv,
  number: ey,
  date: Po,
  object: Fo,
  array: ny,
  boolean: ty,
  tuple: iy
});
const Pl = (t) => t && t.__isYupSchema__;
class Os {
  static fromOptions(e, n) {
    if (!n.then && !n.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: i,
      then: r,
      otherwise: s
    } = n, a = typeof i == "function" ? i : (...o) => o.every((l) => l === i);
    return new Os(e, (o, l) => {
      var c;
      let u = a(...o) ? r : s;
      return (c = u == null ? void 0 : u(l)) != null ? c : l;
    });
  }
  constructor(e, n) {
    this.fn = void 0, this.refs = e, this.refs = e, this.fn = n;
  }
  resolve(e, n) {
    let i = this.refs.map((s) => (
      // TODO: ? operator here?
      s.getValue(n == null ? void 0 : n.value, n == null ? void 0 : n.parent, n == null ? void 0 : n.context)
    )), r = this.fn(i, e, n);
    if (r === void 0 || // @ts-ignore this can be base
    r === e)
      return e;
    if (!Pl(r))
      throw new TypeError("conditions must return a schema object");
    return r.resolve(n);
  }
}
const Vr = {
  context: "$",
  value: "."
};
class Yn {
  constructor(e, n = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string")
      throw new TypeError("ref must be a string, got: " + e);
    if (this.key = e.trim(), e === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === Vr.context, this.isValue = this.key[0] === Vr.value, this.isSibling = !this.isContext && !this.isValue;
    let i = this.isContext ? Vr.context : this.isValue ? Vr.value : "";
    this.path = this.key.slice(i.length), this.getter = this.path && Fn.getter(this.path, !0), this.map = n.map;
  }
  getValue(e, n, i) {
    let r = this.isContext ? i : this.isValue ? e : n;
    return this.getter && (r = this.getter(r || {})), this.map && (r = this.map(r)), r;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(e, n) {
    return this.getValue(e, n == null ? void 0 : n.parent, n == null ? void 0 : n.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(e) {
    return e && e.__isYupRef;
  }
}
Yn.prototype.__isYupRef = !0;
const b1 = (t) => t == null;
function Xn(t) {
  function e({
    value: n,
    path: i = "",
    options: r,
    originalValue: s,
    schema: a
  }, o, l) {
    const {
      name: c,
      test: u,
      params: d,
      message: h,
      skipAbsent: g
    } = t;
    let {
      parent: b,
      context: m,
      abortEarly: p = a.spec.abortEarly,
      disableStackTrace: x = a.spec.disableStackTrace
    } = r;
    function C(T) {
      return Yn.isRef(T) ? T.getValue(n, b, m) : T;
    }
    function M(T = {}) {
      const Y = Object.assign({
        value: n,
        originalValue: s,
        label: a.spec.label,
        path: T.path || i,
        spec: a.spec,
        disableStackTrace: T.disableStackTrace || x
      }, d, T.params);
      for (const $ of Object.keys(Y))
        Y[$] = C(Y[$]);
      const q = new ot(ot.formatError(T.message || h, Y), n, Y.path, T.type || c, Y.disableStackTrace);
      return q.params = Y, q;
    }
    const _ = p ? o : l;
    let A = {
      path: i,
      parent: b,
      type: c,
      from: r.from,
      createError: M,
      resolve: C,
      options: r,
      originalValue: s,
      schema: a
    };
    const E = (T) => {
      ot.isError(T) ? _(T) : T ? l(null) : _(M());
    }, P = (T) => {
      ot.isError(T) ? _(T) : o(T);
    };
    if (g && b1(n))
      return E(!0);
    let U;
    try {
      var Q;
      if (U = u.call(A, n, A), typeof ((Q = U) == null ? void 0 : Q.then) == "function") {
        if (r.sync)
          throw new Error(`Validation test of type: "${A.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(U).then(E, P);
      }
    } catch (T) {
      P(T);
      return;
    }
    E(U);
  }
  return e.OPTIONS = t, e;
}
function v1(t, e, n, i = n) {
  let r, s, a;
  return e ? (Fn.forEach(e, (o, l, c) => {
    let u = l ? o.slice(1, o.length - 1) : o;
    t = t.resolve({
      context: i,
      parent: r,
      value: n
    });
    let d = t.type === "tuple", h = c ? parseInt(u, 10) : 0;
    if (t.innerType || d) {
      if (d && !c)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${a}" must contain an index to the tuple element, e.g. "${a}[0]"`);
      if (n && h >= n.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${o}, in the path: ${e}. because there is no value at that index. `);
      r = n, n = n && n[h], t = d ? t.spec.types[h] : t.innerType;
    }
    if (!c) {
      if (!t.fields || !t.fields[u])
        throw new Error(`The schema does not contain the path: ${e}. (failed at: ${a} which is a type: "${t.type}")`);
      r = n, n = n && n[u], t = t.fields[u];
    }
    s = u, a = l ? "[" + o + "]" : "." + o;
  }), {
    schema: t,
    parent: r,
    parentPath: s
  }) : {
    parent: r,
    parentPath: e,
    schema: t
  };
}
function ry(t, e, n, i) {
  return v1(t, e, n, i).schema;
}
class Ds extends Set {
  describe() {
    const e = [];
    for (const n of this.values())
      e.push(Yn.isRef(n) ? n.describe() : n);
    return e;
  }
  resolveAll(e) {
    let n = [];
    for (const i of this.values())
      n.push(e(i));
    return n;
  }
  clone() {
    return new Ds(this.values());
  }
  merge(e, n) {
    const i = this.clone();
    return e.forEach((r) => i.add(r)), n.forEach((r) => i.delete(r)), i;
  }
}
function ii(t, e = /* @__PURE__ */ new Map()) {
  if (Pl(t) || !t || typeof t != "object")
    return t;
  if (e.has(t))
    return e.get(t);
  let n;
  if (t instanceof Date)
    n = new Date(t.getTime()), e.set(t, n);
  else if (t instanceof RegExp)
    n = new RegExp(t), e.set(t, n);
  else if (Array.isArray(t)) {
    n = new Array(t.length), e.set(t, n);
    for (let i = 0; i < t.length; i++)
      n[i] = ii(t[i], e);
  } else if (t instanceof Map) {
    n = /* @__PURE__ */ new Map(), e.set(t, n);
    for (const [i, r] of t.entries())
      n.set(i, ii(r, e));
  } else if (t instanceof Set) {
    n = /* @__PURE__ */ new Set(), e.set(t, n);
    for (const i of t)
      n.add(ii(i, e));
  } else if (t instanceof Object) {
    n = {}, e.set(t, n);
    for (const [i, r] of Object.entries(t))
      n[i] = ii(r, e);
  } else
    throw Error(`Unable to clone ${t}`);
  return n;
}
class Yt {
  constructor(e) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new Ds(), this._blacklist = new Ds(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Ht.notType);
    }), this.type = e.type, this._typeCheck = e.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, e == null ? void 0 : e.spec), this.withMutation((n) => {
      n.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(e) {
    if (this._mutate)
      return e && Object.assign(this.spec, e), this;
    const n = Object.create(Object.getPrototypeOf(this));
    return n.type = this.type, n._typeCheck = this._typeCheck, n._whitelist = this._whitelist.clone(), n._blacklist = this._blacklist.clone(), n.internalTests = Object.assign({}, this.internalTests), n.exclusiveTests = Object.assign({}, this.exclusiveTests), n.deps = [...this.deps], n.conditions = [...this.conditions], n.tests = [...this.tests], n.transforms = [...this.transforms], n.spec = ii(Object.assign({}, this.spec, e)), n;
  }
  label(e) {
    let n = this.clone();
    return n.spec.label = e, n;
  }
  meta(...e) {
    if (e.length === 0)
      return this.spec.meta;
    let n = this.clone();
    return n.spec.meta = Object.assign(n.spec.meta || {}, e[0]), n;
  }
  withMutation(e) {
    let n = this._mutate;
    this._mutate = !0;
    let i = e(this);
    return this._mutate = n, i;
  }
  concat(e) {
    if (!e || e === this)
      return this;
    if (e.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);
    let n = this, i = e.clone();
    const r = Object.assign({}, n.spec, i.spec);
    return i.spec = r, i.internalTests = Object.assign({}, n.internalTests, i.internalTests), i._whitelist = n._whitelist.merge(e._whitelist, e._blacklist), i._blacklist = n._blacklist.merge(e._blacklist, e._whitelist), i.tests = n.tests, i.exclusiveTests = n.exclusiveTests, i.withMutation((s) => {
      e.tests.forEach((a) => {
        s.test(a.OPTIONS);
      });
    }), i.transforms = [...n.transforms, ...i.transforms], i;
  }
  isType(e) {
    return e == null ? !!(this.spec.nullable && e === null || this.spec.optional && e === void 0) : this._typeCheck(e);
  }
  resolve(e) {
    let n = this;
    if (n.conditions.length) {
      let i = n.conditions;
      n = n.clone(), n.conditions = [], n = i.reduce((r, s) => s.resolve(r, e), n), n = n.resolve(e);
    }
    return n;
  }
  resolveOptions(e) {
    var n, i, r, s;
    return Object.assign({}, e, {
      from: e.from || [],
      strict: (n = e.strict) != null ? n : this.spec.strict,
      abortEarly: (i = e.abortEarly) != null ? i : this.spec.abortEarly,
      recursive: (r = e.recursive) != null ? r : this.spec.recursive,
      disableStackTrace: (s = e.disableStackTrace) != null ? s : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(e, n = {}) {
    let i = this.resolve(Object.assign({
      value: e
    }, n)), r = n.assert === "ignore-optionality", s = i._cast(e, n);
    if (n.assert !== !1 && !i.isType(s)) {
      if (r && b1(s))
        return s;
      let a = hn(e), o = hn(s);
      throw new TypeError(`The value of ${n.path || "field"} could not be cast to a value that satisfies the schema type: "${i.type}". 

attempted value: ${a} 
` + (o !== a ? `result of cast: ${o}` : ""));
    }
    return s;
  }
  _cast(e, n) {
    let i = e === void 0 ? e : this.transforms.reduce((r, s) => s.call(this, r, e, this), e);
    return i === void 0 && (i = this.getDefault(n)), i;
  }
  _validate(e, n = {}, i, r) {
    let {
      path: s,
      originalValue: a = e,
      strict: o = this.spec.strict
    } = n, l = e;
    o || (l = this._cast(l, Object.assign({
      assert: !1
    }, n)));
    let c = [];
    for (let u of Object.values(this.internalTests))
      u && c.push(u);
    this.runTests({
      path: s,
      value: l,
      originalValue: a,
      options: n,
      tests: c
    }, i, (u) => {
      if (u.length)
        return r(u, l);
      this.runTests({
        path: s,
        value: l,
        originalValue: a,
        options: n,
        tests: this.tests
      }, i, r);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(e, n, i) {
    let r = !1, {
      tests: s,
      value: a,
      originalValue: o,
      path: l,
      options: c
    } = e, u = (m) => {
      r || (r = !0, n(m, a));
    }, d = (m) => {
      r || (r = !0, i(m, a));
    }, h = s.length, g = [];
    if (!h)
      return d([]);
    let b = {
      value: a,
      originalValue: o,
      path: l,
      options: c,
      schema: this
    };
    for (let m = 0; m < s.length; m++) {
      const p = s[m];
      p(b, u, function(C) {
        C && (Array.isArray(C) ? g.push(...C) : g.push(C)), --h <= 0 && d(g);
      });
    }
  }
  asNestedTest({
    key: e,
    index: n,
    parent: i,
    parentPath: r,
    originalParent: s,
    options: a
  }) {
    const o = e ?? n;
    if (o == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const l = typeof o == "number";
    let c = i[o];
    const u = Object.assign({}, a, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: i,
      value: c,
      originalValue: s[o],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [l ? "index" : "key"]: o,
      path: l || o.includes(".") ? `${r || ""}[${l ? o : `"${o}"`}]` : (r ? `${r}.` : "") + e
    });
    return (d, h, g) => this.resolve(u)._validate(c, u, h, g);
  }
  validate(e, n) {
    var i;
    let r = this.resolve(Object.assign({}, n, {
      value: e
    })), s = (i = n == null ? void 0 : n.disableStackTrace) != null ? i : r.spec.disableStackTrace;
    return new Promise((a, o) => r._validate(e, n, (l, c) => {
      ot.isError(l) && (l.value = c), o(l);
    }, (l, c) => {
      l.length ? o(new ot(l, c, void 0, void 0, s)) : a(c);
    }));
  }
  validateSync(e, n) {
    var i;
    let r = this.resolve(Object.assign({}, n, {
      value: e
    })), s, a = (i = n == null ? void 0 : n.disableStackTrace) != null ? i : r.spec.disableStackTrace;
    return r._validate(e, Object.assign({}, n, {
      sync: !0
    }), (o, l) => {
      throw ot.isError(o) && (o.value = l), o;
    }, (o, l) => {
      if (o.length)
        throw new ot(o, e, void 0, void 0, a);
      s = l;
    }), s;
  }
  isValid(e, n) {
    return this.validate(e, n).then(() => !0, (i) => {
      if (ot.isError(i))
        return !1;
      throw i;
    });
  }
  isValidSync(e, n) {
    try {
      return this.validateSync(e, n), !0;
    } catch (i) {
      if (ot.isError(i))
        return !1;
      throw i;
    }
  }
  _getDefault(e) {
    let n = this.spec.default;
    return n == null ? n : typeof n == "function" ? n.call(this, e) : ii(n);
  }
  getDefault(e) {
    return this.resolve(e || {})._getDefault(e);
  }
  default(e) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: e
    });
  }
  strict(e = !0) {
    return this.clone({
      strict: e
    });
  }
  nullability(e, n) {
    const i = this.clone({
      nullable: e
    });
    return i.internalTests.nullable = Xn({
      message: n,
      name: "nullable",
      test(r) {
        return r === null ? this.schema.spec.nullable : !0;
      }
    }), i;
  }
  optionality(e, n) {
    const i = this.clone({
      optional: e
    });
    return i.internalTests.optionality = Xn({
      message: n,
      name: "optionality",
      test(r) {
        return r === void 0 ? this.schema.spec.optional : !0;
      }
    }), i;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(e = Ht.defined) {
    return this.optionality(!1, e);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(e = Ht.notNull) {
    return this.nullability(!1, e);
  }
  required(e = Ht.required) {
    return this.clone().withMutation((n) => n.nonNullable(e).defined(e));
  }
  notRequired() {
    return this.clone().withMutation((e) => e.nullable().optional());
  }
  transform(e) {
    let n = this.clone();
    return n.transforms.push(e), n;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...e) {
    let n;
    if (e.length === 1 ? typeof e[0] == "function" ? n = {
      test: e[0]
    } : n = e[0] : e.length === 2 ? n = {
      name: e[0],
      test: e[1]
    } : n = {
      name: e[0],
      message: e[1],
      test: e[2]
    }, n.message === void 0 && (n.message = Ht.default), typeof n.test != "function")
      throw new TypeError("`test` is a required parameters");
    let i = this.clone(), r = Xn(n), s = n.exclusive || n.name && i.exclusiveTests[n.name] === !0;
    if (n.exclusive && !n.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return n.name && (i.exclusiveTests[n.name] = !!n.exclusive), i.tests = i.tests.filter((a) => !(a.OPTIONS.name === n.name && (s || a.OPTIONS.test === r.OPTIONS.test))), i.tests.push(r), i;
  }
  when(e, n) {
    !Array.isArray(e) && typeof e != "string" && (n = e, e = ".");
    let i = this.clone(), r = f1(e).map((s) => new Yn(s));
    return r.forEach((s) => {
      s.isSibling && i.deps.push(s.key);
    }), i.conditions.push(typeof n == "function" ? new Os(r, n) : Os.fromOptions(r, n)), i;
  }
  typeError(e) {
    let n = this.clone();
    return n.internalTests.typeError = Xn({
      message: e,
      name: "typeError",
      skipAbsent: !0,
      test(i) {
        return this.schema._typeCheck(i) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), n;
  }
  oneOf(e, n = Ht.oneOf) {
    let i = this.clone();
    return e.forEach((r) => {
      i._whitelist.add(r), i._blacklist.delete(r);
    }), i.internalTests.whiteList = Xn({
      message: n,
      name: "oneOf",
      skipAbsent: !0,
      test(r) {
        let s = this.schema._whitelist, a = s.resolveAll(this.resolve);
        return a.includes(r) ? !0 : this.createError({
          params: {
            values: Array.from(s).join(", "),
            resolved: a
          }
        });
      }
    }), i;
  }
  notOneOf(e, n = Ht.notOneOf) {
    let i = this.clone();
    return e.forEach((r) => {
      i._blacklist.add(r), i._whitelist.delete(r);
    }), i.internalTests.blacklist = Xn({
      message: n,
      name: "notOneOf",
      test(r) {
        let s = this.schema._blacklist, a = s.resolveAll(this.resolve);
        return a.includes(r) ? this.createError({
          params: {
            values: Array.from(s).join(", "),
            resolved: a
          }
        }) : !0;
      }
    }), i;
  }
  strip(e = !0) {
    let n = this.clone();
    return n.spec.strip = e, n;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(e) {
    const n = (e ? this.resolve(e) : this).clone(), {
      label: i,
      meta: r,
      optional: s,
      nullable: a
    } = n.spec;
    return {
      meta: r,
      label: i,
      optional: s,
      nullable: a,
      default: n.getDefault(e),
      type: n.type,
      oneOf: n._whitelist.describe(),
      notOneOf: n._blacklist.describe(),
      tests: n.tests.map((l) => ({
        name: l.OPTIONS.name,
        params: l.OPTIONS.params
      })).filter((l, c, u) => u.findIndex((d) => d.name === l.name) === c)
    };
  }
}
Yt.prototype.__isYupSchema__ = !0;
for (const t of ["validate", "validateSync"])
  Yt.prototype[`${t}At`] = function(e, n, i = {}) {
    const {
      parent: r,
      parentPath: s,
      schema: a
    } = v1(this, e, n, i.context);
    return a[t](r && r[s], Object.assign({}, i, {
      parent: r,
      path: e
    }));
  };
for (const t of ["equals", "is"])
  Yt.prototype[t] = Yt.prototype.oneOf;
for (const t of ["not", "nope"])
  Yt.prototype[t] = Yt.prototype.notOneOf;
const sy = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function ay(t) {
  const e = oy(t);
  if (!e)
    return Date.parse ? Date.parse(t) : Number.NaN;
  if (e.z === void 0 && e.plusMinus === void 0)
    return new Date(e.year, e.month, e.day, e.hour, e.minute, e.second, e.millisecond).valueOf();
  let n = 0;
  return e.z !== "Z" && e.plusMinus !== void 0 && (n = e.hourOffset * 60 + e.minuteOffset, e.plusMinus === "+" && (n = 0 - n)), Date.UTC(e.year, e.month, e.day, e.hour, e.minute + n, e.second, e.millisecond);
}
function oy(t) {
  var e, n;
  const i = sy.exec(t);
  return i ? {
    year: Bt(i[1]),
    month: Bt(i[2], 1) - 1,
    day: Bt(i[3], 1),
    hour: Bt(i[4]),
    minute: Bt(i[5]),
    second: Bt(i[6]),
    millisecond: i[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      Bt(i[7].substring(0, 3))
    ) : 0,
    precision: (e = (n = i[7]) == null ? void 0 : n.length) != null ? e : void 0,
    z: i[8] || void 0,
    plusMinus: i[9] || void 0,
    hourOffset: Bt(i[10]),
    minuteOffset: Bt(i[11])
  } : null;
}
function Bt(t, e = 0) {
  return Number(t) || e;
}
let ly = /* @__PURE__ */ new Date(""), cy = (t) => Object.prototype.toString.call(t) === "[object Date]";
class ea extends Yt {
  constructor() {
    super({
      type: "date",
      check(e) {
        return cy(e) && !isNaN(e.getTime());
      }
    }), this.withMutation(() => {
      this.transform((e, n, i) => !i.spec.coerce || i.isType(e) || e === null ? e : (e = ay(e), isNaN(e) ? ea.INVALID_DATE : new Date(e)));
    });
  }
  prepareParam(e, n) {
    let i;
    if (Yn.isRef(e))
      i = e;
    else {
      let r = this.cast(e);
      if (!this._typeCheck(r))
        throw new TypeError(`\`${n}\` must be a Date or a value that can be \`cast()\` to a Date`);
      i = r;
    }
    return i;
  }
  min(e, n = Po.min) {
    let i = this.prepareParam(e, "min");
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(r) {
        return r >= this.resolve(i);
      }
    });
  }
  max(e, n = Po.max) {
    let i = this.prepareParam(e, "max");
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(r) {
        return r <= this.resolve(i);
      }
    });
  }
}
ea.INVALID_DATE = ly;
ea.prototype;
function uy(t, e = []) {
  let n = [], i = /* @__PURE__ */ new Set(), r = new Set(e.map(([a, o]) => `${a}-${o}`));
  function s(a, o) {
    let l = Fn.split(a)[0];
    i.add(l), r.has(`${o}-${l}`) || n.push([o, l]);
  }
  for (const a of Object.keys(t)) {
    let o = t[a];
    i.add(a), Yn.isRef(o) && o.isSibling ? s(o.path, a) : Pl(o) && "deps" in o && o.deps.forEach((l) => s(l, a));
  }
  return zv.array(Array.from(i), n).reverse();
}
function Pd(t, e) {
  let n = 1 / 0;
  return t.some((i, r) => {
    var s;
    if ((s = e.path) != null && s.includes(i))
      return n = r, !0;
  }), n;
}
function y1(t) {
  return (e, n) => Pd(t, e) - Pd(t, n);
}
const dy = (t, e, n) => {
  if (typeof t != "string")
    return t;
  let i = t;
  try {
    i = JSON.parse(t);
  } catch {
  }
  return n.isType(i) ? i : t;
};
function ns(t) {
  if ("fields" in t) {
    const e = {};
    for (const [n, i] of Object.entries(t.fields))
      e[n] = ns(i);
    return t.setFields(e);
  }
  if (t.type === "array") {
    const e = t.optional();
    return e.innerType && (e.innerType = ns(e.innerType)), e;
  }
  return t.type === "tuple" ? t.optional().clone({
    types: t.spec.types.map(ns)
  }) : "optional" in t ? t.optional() : t;
}
const hy = (t, e) => {
  const n = [...Fn.normalizePath(e)];
  if (n.length === 1)
    return n[0] in t;
  let i = n.pop(), r = Fn.getter(Fn.join(n), !0)(t);
  return !!(r && i in r);
};
let Fd = (t) => Object.prototype.toString.call(t) === "[object Object]";
function fy(t, e) {
  let n = Object.keys(t.fields);
  return Object.keys(e).filter((i) => n.indexOf(i) === -1);
}
const gy = y1([]);
function x1(t) {
  return new A1(t);
}
class A1 extends Yt {
  constructor(e) {
    super({
      type: "object",
      check(n) {
        return Fd(n) || typeof n == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = gy, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      e && this.shape(e);
    });
  }
  _cast(e, n = {}) {
    var i;
    let r = super._cast(e, n);
    if (r === void 0)
      return this.getDefault(n);
    if (!this._typeCheck(r))
      return r;
    let s = this.fields, a = (i = n.stripUnknown) != null ? i : this.spec.noUnknown, o = [].concat(this._nodes, Object.keys(r).filter((d) => !this._nodes.includes(d))), l = {}, c = Object.assign({}, n, {
      parent: l,
      __validating: n.__validating || !1
    }), u = !1;
    for (const d of o) {
      let h = s[d], g = d in r;
      if (h) {
        let b, m = r[d];
        c.path = (n.path ? `${n.path}.` : "") + d, h = h.resolve({
          value: m,
          context: n.context,
          parent: l
        });
        let p = h instanceof Yt ? h.spec : void 0, x = p == null ? void 0 : p.strict;
        if (p != null && p.strip) {
          u = u || d in r;
          continue;
        }
        b = !n.__validating || !x ? (
          // TODO: use _cast, this is double resolving
          h.cast(r[d], c)
        ) : r[d], b !== void 0 && (l[d] = b);
      } else
        g && !a && (l[d] = r[d]);
      (g !== d in l || l[d] !== r[d]) && (u = !0);
    }
    return u ? l : r;
  }
  _validate(e, n = {}, i, r) {
    let {
      from: s = [],
      originalValue: a = e,
      recursive: o = this.spec.recursive
    } = n;
    n.from = [{
      schema: this,
      value: a
    }, ...s], n.__validating = !0, n.originalValue = a, super._validate(e, n, i, (l, c) => {
      if (!o || !Fd(c)) {
        r(l, c);
        return;
      }
      a = a || c;
      let u = [];
      for (let d of this._nodes) {
        let h = this.fields[d];
        !h || Yn.isRef(h) || u.push(h.asNestedTest({
          options: n,
          key: d,
          parent: c,
          parentPath: n.path,
          originalParent: a
        }));
      }
      this.runTests({
        tests: u,
        value: c,
        originalValue: a,
        options: n
      }, i, (d) => {
        r(d.sort(this._sortErrors).concat(l), c);
      });
    });
  }
  clone(e) {
    const n = super.clone(e);
    return n.fields = Object.assign({}, this.fields), n._nodes = this._nodes, n._excludedEdges = this._excludedEdges, n._sortErrors = this._sortErrors, n;
  }
  concat(e) {
    let n = super.concat(e), i = n.fields;
    for (let [r, s] of Object.entries(this.fields)) {
      const a = i[r];
      i[r] = a === void 0 ? s : a;
    }
    return n.withMutation((r) => (
      // XXX: excludes here is wrong
      r.setFields(i, [...this._excludedEdges, ...e._excludedEdges])
    ));
  }
  _getDefault(e) {
    if ("default" in this.spec)
      return super._getDefault(e);
    if (!this._nodes.length)
      return;
    let n = {};
    return this._nodes.forEach((i) => {
      var r;
      const s = this.fields[i];
      let a = e;
      (r = a) != null && r.value && (a = Object.assign({}, a, {
        parent: a.value,
        value: a.value[i]
      })), n[i] = s && "getDefault" in s ? s.getDefault(a) : void 0;
    }), n;
  }
  setFields(e, n) {
    let i = this.clone();
    return i.fields = e, i._nodes = uy(e, n), i._sortErrors = y1(Object.keys(e)), n && (i._excludedEdges = n), i;
  }
  shape(e, n = []) {
    return this.clone().withMutation((i) => {
      let r = i._excludedEdges;
      return n.length && (Array.isArray(n[0]) || (n = [n]), r = [...i._excludedEdges, ...n]), i.setFields(Object.assign(i.fields, e), r);
    });
  }
  partial() {
    const e = {};
    for (const [n, i] of Object.entries(this.fields))
      e[n] = "optional" in i && i.optional instanceof Function ? i.optional() : i;
    return this.setFields(e);
  }
  deepPartial() {
    return ns(this);
  }
  pick(e) {
    const n = {};
    for (const i of e)
      this.fields[i] && (n[i] = this.fields[i]);
    return this.setFields(n, this._excludedEdges.filter(([i, r]) => e.includes(i) && e.includes(r)));
  }
  omit(e) {
    const n = [];
    for (const i of Object.keys(this.fields))
      e.includes(i) || n.push(i);
    return this.pick(n);
  }
  from(e, n, i) {
    let r = Fn.getter(e, !0);
    return this.transform((s) => {
      if (!s)
        return s;
      let a = s;
      return hy(s, e) && (a = Object.assign({}, s), i || delete a[e], a[n] = r(s)), a;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(dy);
  }
  noUnknown(e = !0, n = Fo.noUnknown) {
    typeof e != "boolean" && (n = e, e = !0);
    let i = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: n,
      test(r) {
        if (r == null)
          return !0;
        const s = fy(this.schema, r);
        return !e || s.length === 0 || this.createError({
          params: {
            unknown: s.join(", ")
          }
        });
      }
    });
    return i.spec.noUnknown = e, i;
  }
  unknown(e = !0, n = Fo.noUnknown) {
    return this.noUnknown(!e, n);
  }
  transformKeys(e) {
    return this.transform((n) => {
      if (!n)
        return n;
      const i = {};
      for (const r of Object.keys(n))
        i[e(r)] = n[r];
      return i;
    });
  }
  camelCase() {
    return this.transformKeys(Ka.camelCase);
  }
  snakeCase() {
    return this.transformKeys(Ka.snakeCase);
  }
  constantCase() {
    return this.transformKeys((e) => Ka.snakeCase(e).toUpperCase());
  }
  describe(e) {
    const n = (e ? this.resolve(e) : this).clone(), i = super.describe(e);
    i.fields = {};
    for (const [s, a] of Object.entries(n.fields)) {
      var r;
      let o = e;
      (r = o) != null && r.value && (o = Object.assign({}, o, {
        parent: o.value,
        value: o.value[s]
      })), i.fields[s] = a.describe(o);
    }
    return i;
  }
}
x1.prototype = A1.prototype;
var Td = function(t, e, n) {
  if (t && "reportValidity" in t) {
    var i = ue(n, e);
    t.setCustomValidity(i && i.message || ""), t.reportValidity();
  }
}, C1 = function(t, e) {
  var n = function(r) {
    var s = e.fields[r];
    s && s.ref && "reportValidity" in s.ref ? Td(s.ref, r, t) : s.refs && s.refs.forEach(function(a) {
      return Td(a, r, t);
    });
  };
  for (var i in e.fields)
    n(i);
}, my = function(t, e) {
  e.shouldUseNativeValidation && C1(t, e);
  var n = {};
  for (var i in t) {
    var r = ue(e.fields, i), s = Object.assign(t[i] || {}, { ref: r && r.ref });
    if (py(e.names || Object.keys(t), i)) {
      var a = Object.assign({}, ue(n, i));
      Me(a, "root", s), Me(n, i, a);
    } else
      Me(n, i, s);
  }
  return n;
}, py = function(t, e) {
  return t.some(function(n) {
    return n.startsWith(e + ".");
  });
};
function by(t, e, n) {
  return e === void 0 && (e = {}), n === void 0 && (n = {}), function(i, r, s) {
    try {
      return Promise.resolve(function(a, o) {
        try {
          var l = (e.context && process.env.NODE_ENV === "development" && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(t[n.mode === "sync" ? "validateSync" : "validate"](i, Object.assign({ abortEarly: !1 }, e, { context: r }))).then(function(c) {
            return s.shouldUseNativeValidation && C1({}, s), { values: n.raw ? i : c, errors: {} };
          }));
        } catch (c) {
          return o(c);
        }
        return l && l.then ? l.then(void 0, o) : l;
      }(0, function(a) {
        if (!a.inner)
          throw a;
        return { values: {}, errors: my((o = a, l = !s.shouldUseNativeValidation && s.criteriaMode === "all", (o.inner || []).reduce(function(c, u) {
          if (c[u.path] || (c[u.path] = { message: u.message, type: u.type }), l) {
            var d = c[u.path].types, h = d && d[u.type];
            c[u.path] = Gf(u.path, l, c, u.type, h ? [].concat(h, u.message) : u.message);
          }
          return c;
        }, {})), s) };
        var o, l;
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
}
const Fl = zt({
  schema: void 0,
  mode: "onSubmit"
});
function Gy({
  onSubmit: t,
  schema: e = x1({}),
  children: n,
  resolver: i,
  mode: r,
  ...s
}) {
  const a = O4({
    ...s,
    mode: r,
    resolver: by(e)
  });
  return /* @__PURE__ */ w(Fl.Provider, { value: { schema: e, mode: r }, children: /* @__PURE__ */ w(g4, { ...a, children: /* @__PURE__ */ w("form", { onSubmit: a.handleSubmit(t), children: typeof n == "function" ? n(a) : n }) }) });
}
const w1 = function(t, e) {
  const { schema: n } = Et(Fl), { watch: i, formState: r } = Ks(), s = ne(() => tv(r.errors, t), [r, t, i(t)]), a = le(
    (l) => {
      const c = kv({}, t, l);
      n == null || n.validateSyncAt(t, c, { recursive: e });
    },
    [n, t, i(t)]
  ), o = ne(() => {
    var m, p, x, C;
    if (!n)
      return {};
    const l = ry(n, t, i(t)), c = l == null ? void 0 : l.describe({
      value: i(t),
      parent: i()
    }), { tests: u, label: d, optional: h, type: g } = c, b = (M) => (_) => _.name === M;
    return {
      type: g,
      label: d,
      required: !h,
      min: (p = (m = u == null ? void 0 : u.find(b("min"))) == null ? void 0 : m.params) == null ? void 0 : p.min,
      max: (C = (x = u == null ? void 0 : u.find(b("max"))) == null ? void 0 : x.params) == null ? void 0 : C.max
    };
  }, [n, t, i()]);
  return ne(
    () => ({
      ...o,
      validate: a,
      error: s
    }),
    [s, a, o]
  );
};
function qy({
  children: t,
  onChange: e,
  as: n,
  ...i
}) {
  const { mode: r } = Et(Fl), {
    register: s,
    setValue: a,
    resetField: o,
    setError: l,
    clearErrors: c,
    watch: u,
    formState: { isSubmitted: d }
  } = Ks(), { label: h, type: g, min: b, max: m, required: p, error: x, validate: C } = w1(
    i.name
  ), M = ne(
    () => de("inline-flex flex-col", {
      "w-full": i.fullWidth
    }),
    [i.fullWidth]
  ), _ = le(
    (E, P) => {
      try {
        C(E), c(i.name);
      } catch (I) {
        P && l(i.name, { ...I });
      }
    },
    [i.name, C, c, l]
  ), A = le(
    (E) => {
      a(i.name, E.target.value), _(E.target.value, d || r === "onChange"), e == null || e(E);
    },
    [r, i.name, _, e]
  );
  return Fe(() => (s(i.name), _(u(i.name), d), () => {
    o(i.name), c(i.name);
  }), []), /* @__PURE__ */ ae("div", { className: M, children: [
    (i.label || h) && /* @__PURE__ */ w(
      G5,
      {
        light: i.light,
        fullWidth: i.fullWidth,
        required: p,
        htmlFor: i.id || i.name,
        helpText: i.helpText,
        label: i.label || h
      }
    ),
    /* @__PURE__ */ w(
      n,
      {
        ...i,
        ...["number", "date"].includes(g) ? { min: b, max: m } : {},
        fullWidth: i.fullWidth,
        error: !!x,
        value: u(i.name),
        onChange: A
      }
    ),
    (x == null ? void 0 : x.message) && /* @__PURE__ */ w(K5, { message: x.message })
  ] });
}
function Zy(t) {
  const { register: e, setValue: n } = Ks();
  return Fe(() => {
    e(t.name), n(t.name, t.value ?? "");
  }, [t.name, t.value]), /* @__PURE__ */ w(on, {});
}
function Jy(t) {
  const e = A4({
    name: t.name
  }), { error: n } = w1(t.name, !1);
  return t.children({
    error: n,
    ...e
  });
}
const vy = function({ onChangeSort: t, ...e }) {
  const n = le(
    (a) => {
      var c, u;
      const o = ((c = e.sort) == null ? void 0 : c.replace("-", "")) === a.field, l = (u = e.sort) != null && u.startsWith("-") ? "desc" : "asc";
      return { active: o, direction: l };
    },
    [e.sort]
  ), i = ne(
    () => de({
      "bg-gray-lighter": e.light,
      "bg-gray-darker": e.dark,
      "bg-gray-dark text-white": !e.light && !e.dark
    }),
    [e.light, e.dark]
  ), r = le(
    (a) => {
      const { active: o, direction: l } = n(a);
      return de("-mt-0.5 cursor-pointer", {
        hidden: !a.sortable,
        "opacity-40": !o,
        "rotate-180": o && l === "desc"
      });
    },
    [e.sort, n]
  ), s = le(
    (a) => {
      if (!a.sortable)
        return;
      const { active: o, direction: l } = n(a);
      o ? t == null || t(l === "asc" ? `-${a.field}` : a.field) : t == null || t(a.field);
    },
    [e.sort, t, n]
  );
  return /* @__PURE__ */ w("thead", { children: /* @__PURE__ */ w("tr", { className: i, children: e.columns.map((a) => /* @__PURE__ */ w("th", { className: "table-cell p-4 font-normal text-left whitespace-nowrap", children: /* @__PURE__ */ ae("div", { className: "flex gap-6", children: [
    /* @__PURE__ */ w("div", { children: a.label }),
    /* @__PURE__ */ w("div", { onClick: () => s(a), className: r(a), children: /* @__PURE__ */ w(X2, {}) })
  ] }) }, a.label)) }) });
}, yy = function(t) {
  var i;
  const e = ne(
    () => de({
      "bg-white-light": t.light,
      "bg-black-light text-white": t.dark,
      "bg-gray-darker text-white": !t.light && !t.dark
    }),
    [t.light, t.dark]
  ), n = le(
    (r) => de("p-4 border-b", {
      "text-center": r.align === "center",
      "text-right": r.align === "right",
      "text-left": r.align === "left",
      "w-full": r.grow,
      "whitespace-nowrap": r.nowrap,
      "border-gray-lighter": t.light,
      "border-gray-light": t.dark,
      "border-gray-dark": !t.light && !t.dark
    }),
    [t.light, t.dark]
  );
  return /* @__PURE__ */ w("tbody", { children: t.items && t.items.length > 0 ? (i = t.items) == null ? void 0 : i.map((r, s) => /* @__PURE__ */ w("tr", { className: e, children: t.columns.map((a) => /* @__PURE__ */ w("td", { className: n(a), children: a.render ? a.render(r, s) : r[a.field] }, a.field)) }, (r == null ? void 0 : r.id) ?? s)) : /* @__PURE__ */ w("tr", { className: e, children: /* @__PURE__ */ w("td", { colSpan: t.columns.length, className: "p-4 border-b border-gray-lighter", children: t.isLoading ? "Loading..." : "No items found" }) }) });
}, xy = [
  {
    label: "10",
    value: "10"
  },
  {
    label: "50",
    value: "50"
  },
  {
    label: "100",
    value: "100"
  }
], Ay = function({ onChangeLimit: t, onChangeOffset: e, ...n }) {
  const i = le(
    (M) => {
      t(parseInt(M.target.value)), e(0);
    },
    [t, e]
  ), r = le(
    (M) => {
      e((parseInt(M.target.value) - 1) * n.limit);
    },
    [e]
  ), s = le(
    () => r({
      target: {
        value: String(n.offset / n.limit)
      }
    }),
    [n.offset, n.limit, r]
  ), a = le(
    () => r({
      target: {
        value: String(n.offset / n.limit + 2)
      }
    }),
    [n.offset, n.limit, r]
  ), o = ne(() => n.count > 0 ? n.offset + 1 : 0, [n.offset, n.count]), l = ne(
    () => n.offset + n.limit > n.count ? n.count : n.offset + n.limit,
    [n.offset, n.limit, n.count]
  ), c = ne(() => String(n.offset / n.limit + 1), [n.offset, n.limit]), u = ne(() => String(n.limit), [n.limit]), d = ne(() => Math.ceil(n.count / n.limit) || 1, [n.count, n.limit]), h = ne(
    () => Array.from({ length: d }).map((M, _) => ({
      label: String(_ + 1),
      value: String(_ + 1)
    })),
    [d]
  ), g = ne(() => n.offset / n.limit === 0, [n.offset, n.limit]), b = ne(
    () => n.offset / n.limit + 1 === h.length,
    [h, n.offset, n.limit]
  ), m = ne(
    () => de("appearance-none px-5 py-4 border-l", {
      "cursor-pointer": !g,
      "cursor-default text-gray-lighter": g,
      "border-gray-lighter": n.light,
      "border-gray-light": n.dark,
      "border-gray-dark": !n.light && !n.dark
    }),
    [g, n.light, n.dark]
  ), p = ne(
    () => de("appearance-none px-5 py-4 border-l", {
      "cursor-pointer": !b,
      "cursor-default text-gray-lighter": b,
      "border-gray-lighter": n.light,
      "border-gray-light": n.dark,
      "border-gray-dark": !n.light && !n.dark
    }),
    [b, n.light, n.dark]
  ), x = ne(
    () => de({
      "bg-white-light": n.light,
      "bg-black-light text-white": n.dark,
      "bg-gray-darker text-white": !n.light && !n.dark
    }),
    [n.light, n.dark]
  ), C = le(
    (M) => de("py-1 inline-flex gap-1 items-center", {
      "pl-4 pr-1 border-r": M === "right",
      "pr-4 pl-1 border-l": M === "left",
      "border-gray-lighter": n.light,
      "border-gray-light": n.dark,
      "border-gray-dark": !n.light && !n.dark
    }),
    [n.light, n.dark]
  );
  return /* @__PURE__ */ w("tfoot", { children: /* @__PURE__ */ w("tr", { className: x, children: /* @__PURE__ */ w("td", { colSpan: n.columns.length, children: /* @__PURE__ */ ae("div", { className: "flex items-center -my-px", children: [
    /* @__PURE__ */ ae("div", { className: C("right"), children: [
      /* @__PURE__ */ w("div", { children: "Items per page:" }),
      /* @__PURE__ */ w(
        Hu,
        {
          plain: !0,
          name: "limit",
          light: n.light,
          value: u,
          onChange: i,
          items: xy
        }
      )
    ] }),
    /* @__PURE__ */ w("div", { className: "p-4 flex-grow", children: `${o}-${l} of ${n.count} items` }),
    /* @__PURE__ */ ae("div", { className: C("left"), children: [
      /* @__PURE__ */ w(
        Hu,
        {
          plain: !0,
          name: "offset",
          light: n.light,
          value: c,
          onChange: r,
          items: h
        }
      ),
      /* @__PURE__ */ ae("div", { children: [
        "of ",
        d,
        " pages"
      ] })
    ] }),
    /* @__PURE__ */ w("button", { type: "button", disabled: g, className: m, onClick: s, children: /* @__PURE__ */ w(Rs, {}) }),
    /* @__PURE__ */ w("button", { type: "button", disabled: b, className: p, onClick: a, children: /* @__PURE__ */ w(xi, {}) })
  ] }) }) }) });
}, Cy = function(t) {
  const e = ne(
    () => de({
      "bg-white-light": t.light,
      "bg-black-light text-white": t.dark,
      "bg-gray-darker text-white": !t.light && !t.dark
    }),
    [t.light, t.dark]
  );
  return /* @__PURE__ */ w("tfoot", { children: /* @__PURE__ */ w("tr", { className: e, children: /* @__PURE__ */ w("td", { colSpan: t.columns.length, children: t.children }) }) });
}, Xy = function(t) {
  return /* @__PURE__ */ w("div", { className: "max-w-full overflow-x-auto no-scrollbar", children: /* @__PURE__ */ ae("table", { className: "table-auto w-full font-light", children: [
    /* @__PURE__ */ w(
      vy,
      {
        light: t.light,
        dark: t.dark,
        columns: t.columns,
        sort: t.sort,
        onChangeSort: t.onChangeSort
      }
    ),
    /* @__PURE__ */ w(
      yy,
      {
        light: t.light,
        dark: t.dark,
        columns: t.columns,
        items: t.items,
        isLoading: t.isLoading
      }
    ),
    "children" in t ? /* @__PURE__ */ w(Cy, { columns: t.columns, light: t.light, dark: t.dark, children: t.children }) : /* @__PURE__ */ w(
      Ay,
      {
        light: t.light,
        dark: t.dark,
        count: t.count,
        limit: t.limit,
        offset: t.offset,
        columns: t.columns,
        onChangeLimit: t.onChangeLimit,
        onChangeOffset: t.onChangeOffset
      }
    )
  ] }) });
};
function ex({
  tabs: t,
  activeTab: e,
  lastTab: n,
  onTabChange: i,
  tooltips: r
}) {
  const s = ne(
    () => t.findIndex((l) => n === l.id),
    [t, e]
  ), a = le(
    (l) => de(
      "has-tooltip pl-2.5 pb-8 h-14 border-l-2 items-center gap-2 inline-flex cursor-pointer",
      {
        "text-white border-primary-light": s >= l,
        "text-gray border-gray cursor-default": s < l
      }
    ),
    [s, e]
  ), o = le(
    (l, c) => de("contents text-xl", {
      "text-primary-light": s === c,
      "text-gray": s < c,
      "text-green-light": s > c
    }),
    [s, e]
  );
  return /* @__PURE__ */ w("aside", { className: "flex flex-col justify-start w-fit", children: t.map((l, c) => /* @__PURE__ */ ae(
    "div",
    {
      className: a(c),
      onClick: () => i == null ? void 0 : i(l.id),
      "data-testid": `tab-${l.id}`,
      children: [
        r && r.completed && s > c && /* @__PURE__ */ w("span", { className: "tooltip", children: r.completed }),
        r && r.disabled && s < c && /* @__PURE__ */ w("span", { className: "tooltip", children: r.disabled }),
        r && r.current && s === c && /* @__PURE__ */ w("span", { className: "tooltip", children: r.current }),
        /* @__PURE__ */ w("span", { className: o(l, c), children: !l.hideCheckMark && s > c ? /* @__PURE__ */ w(ig, {}) : l.icon }),
        /* @__PURE__ */ w("h4", { className: "ml-2 text-sm leading-tight m-0", children: l.name })
      ]
    },
    `tab-${l.id}`
  )) });
}
async function wy(t, e) {
  try {
    const n = await fetch(t, {
      headers: {
        Authorization: `Api-Key ${e}`
      }
    });
    if (!n.ok)
      throw new Error(`Response status: ${n.status}`);
    return n.json();
  } catch (n) {
    throw new Error(`Error: ${n}`);
  }
}
const tx = ({
  switchName: t,
  switchesUrl: e,
  monolithApiKey: n
}) => {
  const [i, r] = Be(
    () => !!sessionStorage.getItem(t)
  ), [s, a] = Be(null);
  Fe(() => {
    wy(e, n).then((c) => {
      var u, d;
      (u = c.switches) != null && u[t] && a((d = c.switches) == null ? void 0 : d[t]);
    }).catch((c) => {
      console.error(c);
    });
  }, []);
  const o = le(() => {
    r(!0), sessionStorage.setItem(t, "true");
  }, [t]);
  return { bannerMessage: ne(() => s != null && s.is_active && !i ? s.note : null, [s, i]), closeBanner: o };
};
export {
  Vy as BarChart,
  B1 as Button,
  Ny as DoughnutChart,
  qy as Field,
  Jy as FieldArray,
  Zy as FieldReset,
  fg as Footer,
  Gy as Form,
  Fl as FormContext,
  ex as FormTab,
  hg as Header,
  jy as InputCheck,
  Yy as InputCheckBox,
  Qy as InputDate,
  Hu as InputDropdown,
  K5 as InputError,
  G5 as InputLabel,
  Hy as InputNumber,
  Ky as InputPhone,
  $y as InputRadio,
  Wy as InputRadioBox,
  zy as InputText,
  Uy as InputTextarea,
  Ry as LineChart,
  Dy as Loader,
  Ty as MaintenanceBanner,
  Py as Mentions,
  Xy as Table,
  Iy as Tabs,
  Fy as UnbhLoader,
  U5 as options,
  tx as useBanner
};
